(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
(function (global){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });
var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);

var _appLayout = require('./core/views/layouts/app-layout');var _appLayout2 = _interopRequireDefault(_appLayout);
var _modal = require('./framework/modal');var _modal2 = _interopRequireDefault(_modal);
var _cookie = require('./framework/cookie');var _cookie2 = _interopRequireDefault(_cookie);
var _mapInitializer = require('./framework/map-initializer');var _mapInitializer2 = _interopRequireDefault(_mapInitializer);



var _searchModalView = require('./core/views/items/search-modal-view');var _searchModalView2 = _interopRequireDefault(_searchModalView);
var _videoModalView = require('./core/views/items/video-modal-view');var _videoModalView2 = _interopRequireDefault(_videoModalView);
var _newsletterModalView = require('./core/views/items/newsletter-modal-view');var _newsletterModalView2 = _interopRequireDefault(_newsletterModalView);
var _callMeModalView = require('./core/views/items/call-me-modal-view');var _callMeModalView2 = _interopRequireDefault(_callMeModalView);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Setup
// import Router from './core/router';
// Views
// import modalView from './core/views/partials/partial-modal-view';
var App = new _backbone4.default.Application(); // Require globals
window.App = App;
App.initializeMap = function (center, zoom, markers) {
	(0, _mapInitializer2.default)(center, zoom, markers);
};
App.color = global.appTheme === 'elnet' ? '005eb8' : '84bd00';

App.on('start', function () {
	App.layout = new _appLayout2.default();
	// App.router = new Router();
	_backbone2.default.history.start();

	App.Modal = new _modal2.default({
		frame: '#modal-frame' });


	function closestByClass(el, clazz) {
		if (typeof el.classList == 'undefined') {
			return null;
		}
		while (el.classList && !el.classList.contains(clazz)) {
			el = el.parentNode;
			if (!el) {
				return null;
			}
		}
		return el;
	}

	// Writing this in "reverse" order with dom and el so vue won't remove eventlistener on init
	(0, _jquery2.default)(document).on('click', '.js-single-product-modal, .js-modal, .js-product-modal', function (e) {
		e.preventDefault();

		(0, _jquery2.default)('.js-modal__close').on('click', function (e) {
			(0, _jquery2.default)('body').removeClass('modal--open');
			(0, _jquery2.default)('.price-overlay-modal').removeClass('modal--opened');
		});
		(0, _jquery2.default)(document).on('keyup', function (e) {
			if (e.keyCode === 27) {
				(0, _jquery2.default)('body').removeClass('modal--open');
				(0, _jquery2.default)('.price-overlay-modal').removeClass('modal--opened');
			}
		});

		(0, _jquery2.default)('body').addClass('modal--open');

		var modalId = (0, _jquery2.default)(this).attr("data-variantoverlayid");
		(0, _jquery2.default)('#' + modalId).addClass("modal--opened");

		if (!modalId || modalId == '') {
			var closest = closestByClass(this, "grid-wrapper");
			closest.getElementsByClassName("price-overlay-modal")[0].classList.add("modal--opened");
		}


		(0, _jquery2.default)('.js-modal__close').on('click', function (e) {
			(0, _jquery2.default)('body').removeClass('modal--open');
			(0, _jquery2.default)('.price-overlay-modal').removeClass('modal--opened');
		});
		(0, _jquery2.default)(document).on('keyup', function (e) {
			if (e.keyCode === 27) {
				(0, _jquery2.default)('body').removeClass('modal--open');
				(0, _jquery2.default)('.price-overlay-modal').removeClass('modal--opened');
			}
		});
	});

	var closestByClass = function closestByClass(el, clazz) {
		if (typeof el.classList == 'undefined') {
			return null;
		}
		while (el.classList && !el.classList.contains(clazz)) {
			el = el.parentNode;
			if (!el) {
				return null;
			}
		}
		return el;
	};




	(0, _jquery2.default)('.js-search-modal').on('click', function (e) {
		e.preventDefault();

		App.Modal.create({
			view: _searchModalView2.default,
			model: new _backbone2.default.Model({
				postAdress: (0, _jquery2.default)(e.currentTarget).attr('href'),
				searchLabel: window.pageOptions && window.pageOptions.searchString ? window.pageOptions.searchString : 'Søg og du skal finde' }) });


	});

	if (window.pageOptions) {
		if (!_cookie2.default.readCookie('nsl-popup') && window.pageOptions.newsletterPopupAllow !== false) {
			setTimeout(function () {
				App.Modal.create({
					view: _newsletterModalView2.default });


				// Set cookie that popup has shown
				_cookie2.default.createCookie('nsl-popup', 'true', 30);
			}, 20000);
		}
	}

	// Call me modal -- Triggered from Specialist module
	(0, _jquery2.default)('.slider').each(function (i, e) {
		var $item = (0, _jquery2.default)(e);

		$item.on('click', '.js-call-me', function (callUpElement) {
			callUpElement.preventDefault();

			App.Modal.create({
				view: _callMeModalView2.default,
				model: new _backbone2.default.Model({
					specialistMail: (0, _jquery2.default)(callUpElement.target).closest('.specialistbox').find('.employee-card__item__contacts__mail span').text() }) });


		});
	});

	// Call me modal -- Triggered from specialist page in the hero area
	(0, _jquery2.default)('.hero-box').each(function (i, e) {
		var $item = (0, _jquery2.default)(e);

		$item.find('.js-call-me').on('click', function (callUpElement) {
			callUpElement.preventDefault();

			App.Modal.create({
				view: _callMeModalView2.default,
				model: new _backbone2.default.Model({
					specialistMail: $item.find('.employee-card__item__contacts__mail span').text() || "" }) });


		});
	});

	// Call me modal -- Triggered from specialist page in the hero area
	(0, _jquery2.default)('.hero .hero__headline').each(function (i, e) {
		var $item = (0, _jquery2.default)(e);

		$item.find('.js-call-me').on('click', function (callUpElement) {
			callUpElement.preventDefault();

			App.Modal.create({
				view: _callMeModalView2.default,
				model: new _backbone2.default.Model({
					specialistMail: (0, _jquery2.default)(callUpElement).attr('target').getAttribute('href') || "" }) });


		});
	});

	App.Modal.create({
		selector: '.js-video',
		view: _videoModalView2.default,
		model: new _backbone2.default.Model() });

});exports.default =

App;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"./core/views/items/call-me-modal-view":8,"./core/views/items/newsletter-modal-view":9,"./core/views/items/search-modal-view":11,"./core/views/items/video-modal-view":12,"./core/views/layouts/app-layout":13,"./framework/cookie":18,"./framework/map-initializer":24,"./framework/modal":26,"backbone":"backbone","backbone.marionette":"backbone.marionette","jquery":"jquery"}],2:[function(require,module,exports){
module.exports = "<div class=\"container\">\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n\r\n\t\t\t<a href=\"#\" class=\"modal__close js-modal__close\"></a>\r\n\r\n\t\t\t<section class=\"wall-to-wall\" style=\"background-image:url('/dist/assets/images/wall-to-wall.jpg');\">\r\n\t\t\t\t<article class=\"wall-to-wall__box\">\r\n\t\t\t\t\t<div class=\"container\">\r\n\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n\t\t\t\t\t\t\t\t<h3 class=\"wall-to-wall__box__headline\">Ring mig <strong>op!</strong></h3>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t<form action=\"#\" method=\"POST\">\r\n\t\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t\t\t<span>Dit navn</span>\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"FirstName\" data-required=\"true\" data-error-message=\"Indtast navn\" novalidate>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t\t\t<span>Din virksomhed</span>\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"Company\" data-required=\"true\" data-error-message=\"Indtast virksomhed\" novalidate>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t\t\t<span>Din email</span>\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"email\" name=\"Email\" data-required=\"true\" data-error-message=\"Indtast en korrekt email\" novalidate>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t\t\t<span>Dit telefonnummer</span>\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"number\" name=\"Phone\" data-required=\"true\" data-error-message=\"Indtast telefonnummer\" novalidate>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n\t\t\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t\t\t<span>Din Besked/interesse</span>\r\n\t\t\t\t\t\t\t\t\t\t<textarea type=\"text\" name=\"Message\"></textarea>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n\t\t\t\t\t\t\t\t\t<label class=\"checkbox-label\">\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"NewsletterSignup\" data-required=\"true\" novalidate>\r\n\t\t\t\t\t\t\t\t\t\t<span>Jeg accepterer de <a href=\"#/\">gældende betingelser</a></span>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"VisitorKey\" hidden>\r\n\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"Context\" value=\"{{specialistMail}}\" hidden>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12 text-center\">\r\n\t\t\t\t\t\t\t\t\t<button type=\"submit\" class=\"btn btn--link\">Ring mig op<span class=\"btn__icon\"></span></button>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t</form>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</article>\r\n\t\t\t</section>\r\n\r\n\t\t</div>\r\n\t</div>\r\n</div>";

},{}],3:[function(require,module,exports){
module.exports = "<div class=\"container\">\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n\r\n\t\t\t<a href=\"#\" class=\"modal__close js-modal__close\"></a>\r\n\r\n\t\t\t<section class=\"wall-to-wall\" style=\"background-image:url('./../assets/images/wall-to-wall.jpg');\">\r\n\t\t\t\t<article class=\"wall-to-wall__box\">\r\n\r\n\t\t\t\t\t<form action=\"#\" method=\"POST\">\r\n\t\t\t\t\t\t<div class=\"container\">\r\n\r\n\t\t\t\t\t\t\t<div class=\"row\">\r\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n\t\t\t\t\t\t\t\t\t<h3 class=\"wall-to-wall__box__headline\">Bliv opdateret med de <strong>seneste nyheder</strong><br>fra Verdo</h3>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t\t\t\t\t\t\t\t<p>Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eveniet ipsam ducimus reprehenderit assumenda ipsum deleniti quisquam iure corrupti impedit ipsa blanditiis et sed eaque sint beatae ad architecto distinctio perferendis neque sapiente autem!</p>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t\t<div class=\"col-xs-12 col-sm-12 col-md-6\">\r\n\t\t\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t\t\t<span>Dit navn</span>\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"FirstName\" data-required=\"true\" data-error-message=\"Indtast navn\" novalidate>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t\t\t<span>Din email</span>\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"email\" name=\"Email\" data-required=\"true\" data-error-message=\"Indtast en korrekt email\" novalidate>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t\t\t\t<span>Din firma</span>\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"Company\" data-required=\"true\" data-error-message=\"Indtast firma\" novalidate>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\t\t\t\t\t\t\t\t\t<label class=\"checkbox-label\">\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"Terms\" data-required=\"true\" novalidate>\r\n\t\t\t\t\t\t\t\t\t\t<span>\r\n\t\t\t\t\t\t\t\t\t\t\t<a href=\"#/\">Gældende vilkår</a>\r\n\t\t\t\t\t\t\t\t\t\t</span>\r\n\t\t\t\t\t\t\t\t\t</label>\r\n\r\n\t\t\t\t\t\t\t\t\t<input type=\"text\" name=\"VisitorKey\" hidden novalidate>\r\n\t\t\t\t\t\t\t\t</div>\r\n\t\t\t\t\t\t\t</div>\r\n\r\n\t\t\t\t\t\t\t<div class=\"row\">\r\n                        \t\t<div class=\"col-xs-12 col-sm-12 col-md-12 text-center\">\r\n                            \t\t<button type=\"submit\" name=\"submit\" class=\"btn btn--small btn--link\">Tilmeld nyhedsbrev<span class=\"btn__icon\"></span></button>\r\n                        \t\t</div>\r\n                    \t\t</div>\r\n\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</form>\r\n\r\n\t\t\t\t</article>\r\n\t\t\t</section>\r\n\r\n\t\t</div>\r\n\t</div>\r\n</div>";

},{}],4:[function(require,module,exports){
module.exports = "<div class=\"request-box\" data-status=\"{{status}}\">\r\n\t<div class=\"request-box__status\"></div>\r\n\r\n\t<header>\r\n\t\t<h6 class=\"request-box__headline\">{{{statusHeadline}}}</h6>\r\n\t</header>\r\n\r\n\t<p class=\"request-box__paragraph\">{{{statusText}}}</p>\r\n\r\n\t{{#if status}}\r\n\t\t<button class=\"btn modal__close js-modal__close\">Ok</button>\r\n\t{{/if}}\r\n</div>";

},{}],5:[function(require,module,exports){
module.exports = "<div class=\"container\">\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-xs-12 col-md-10 col-md-offset-1\">\r\n\r\n\t\t\t<div class=\"modal__body\">\r\n\t\t\t\t<div class=\"modal__inner\">\r\n\t\t\t\t\t<a href=\"#\" class=\"modal__close js-modal__close\"></a>\r\n\r\n\t\t\t\t\t<form action=\"/soeg\" id=\"overlay-search\">\r\n\t\t\t\t\t\t<label>\r\n\t\t\t\t\t\t\t<span>{{searchLabel}}</span>\r\n\t\t\t\t\t\t\t<input type=\"text\">\r\n\t\t\t\t\t\t\t<span class=\"icon-search\"\r\n\t\t\t\t\t\t\t\tstyle=\"background-image:url('./../assets/images/search-icon.svg');\"></span>\r\n\t\t\t\t\t\t</label>\r\n\t\t\t\t\t</form>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t</div>\r\n\t</div>\r\n</div>";

},{}],6:[function(require,module,exports){
module.exports = "<div class=\"container\">\r\n\t<div class=\"row\">\r\n\t\t<div class=\"col-xs-12 col-md-10 col-md-offset-1\">\r\n\r\n\t\t\t<div class=\"modal__body\">\r\n\t\t\t\t<div class=\"modal__inner\">\r\n\t\t\t\t\t<a href=\"#\" class=\"modal__close js-modal__close\"></a>\r\n\r\n\t\t\t\t\t<div id=\"video-insert\" class=\"video-aspect-container\"></div>\r\n\r\n\t\t\t\t\t<div class=\"loader-spinner\"></div>\r\n\t\t\t\t</div>\r\n\t\t\t</div>\r\n\r\n\t\t</div>\r\n\t</div>\r\n</div>";

},{}],7:[function(require,module,exports){
module.exports = "<div class=\"modal__body\">\r\n\t<div class=\"modal__inner\">\r\n\t\t<a href=\"#\" class=\"modal__close js-modal__close\"></a>\r\n\r\n\t\t<header class=\"modal__body__header\">\r\n\t\t\t<h1>\r\n\t\t\t\t<span>This is a modal</span>\r\n\t\t\t</h1>\r\n\r\n\t\t\t<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. At ut maiores magni, recusandae totam provident nisi, quas suscipit laudantium esse nam excepturi tenetur qui, rem delectus dolorem! Hic, veniam non?</p>\r\n\t\t</header>\r\n\t</div>\r\n</div>\r\n";

},{}],8:[function(require,module,exports){
/**
* Call me Modal View
*
* @author nnielsen <nnielsen@vertic.com>
*/

/**
       * jslint plusplus: true, vars: true, browser: true, white:true
       * global require: true
       */

'use strict';

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _underscore = require('underscore');var _underscore2 = _interopRequireDefault(_underscore);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);
var _handlebars = require('handlebars');var _handlebars2 = _interopRequireDefault(_handlebars);

var _cookie = require('./../../../framework/cookie');var _cookie2 = _interopRequireDefault(_cookie);
var _formValidation = require('./../../../framework/form-validation');var _formValidation2 = _interopRequireDefault(_formValidation);
var _tracking = require('./../../../framework/tracking');var _tracking2 = _interopRequireDefault(_tracking);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Views
var requestModalView = require('./request-modal-view');

// Templates
var template = require('./../../templates/items/call-me-modal-tmpl.hbs');

module.exports = _backbone4.default.View.extend({

    tagName: 'div',

    className: 'modal-call-me',

    template: _handlebars2.default.compile(template),

    onRender: function onRender() {var _this = this;
        var specialistMail = this.model.get('specialistMail') || "";

        // If in CMS - Continue
        if (window.umbracoData) {
            var ApiUrl = "/umbraco/surface/form/GetCallMeForm?landingPageId=" + window.umbracoData.RootId;

            this.$el.empty();

            _jquery2.default.ajax({
                type: 'GET',
                url: ApiUrl,
                cache: false }).
            done(function (result) {
                _this.$el.append(result);

                // Setting VisitorKey on input
                _this.$el.find('input[name="VisitorKey"]').attr('value', _cookie2.default.readCookie('cuvid'));
                _this.$el.find('input[name="Context"]').attr('value', specialistMail);

                _this.$el.find('form').on('submit', function (e) {
                    e.preventDefault();

                    var $form = (0, _jquery2.default)(e.currentTarget);

                    // Lets do a validation check
                    var validation = new _formValidation2.default({
                        element: $form });

                    if ($form.hasClass('has-validation-errors')) {
                        return false;
                    }

                    var formData = $form.serializeArray().reduce(function (obj, item) {
                        obj[item.name] = item.value;
                        return obj;
                    }, {});

                    var modelData = new _backbone2.default.Model({
                        form: $form });


                    _jquery2.default.ajax({
                        type: 'POST',
                        url: '/umbraco/api/FormCapture/SubmitSpecialistCallMe',
                        cache: false,
                        data: JSON.stringify(formData),
                        contentType: 'application/json',
                        beforeSend: function beforeSend() {
                            App.Modal.create({
                                view: requestModalView,
                                model: modelData });

                        },
                        error: function error(err) {
                            modelData.set({
                                status: 'error' });

                        },
                        complete: function complete(successMessage) {
                            modelData.set({
                                status: 'destroy' });


                            var trackingName = 'Call me: ' + $form.find('input[name="Context"]').val() || '';
                            (0, _tracking2.default)('submit', 'form', trackingName);
                        } });

                });
            });
        }
    } });

},{"./../../../framework/cookie":18,"./../../../framework/form-validation":20,"./../../../framework/tracking":45,"./../../templates/items/call-me-modal-tmpl.hbs":2,"./request-modal-view":10,"backbone":"backbone","backbone.marionette":"backbone.marionette","handlebars":"handlebars","jquery":"jquery","underscore":"underscore"}],9:[function(require,module,exports){
/**
* Newsletter Modal View
*
* @author nnielsen <nnielsen@vertic.com>
*/

/**
       * jslint plusplus: true, vars: true, browser: true, white:true
       * global require: true
       */

'use strict';

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _underscore = require('underscore');var _underscore2 = _interopRequireDefault(_underscore);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);
var _handlebars = require('handlebars');var _handlebars2 = _interopRequireDefault(_handlebars);

var _cookie = require('./../../../framework/cookie');var _cookie2 = _interopRequireDefault(_cookie);
var _tracking = require('./../../../framework/tracking');var _tracking2 = _interopRequireDefault(_tracking);
var _formValidation = require('./../../../framework/form-validation');var _formValidation2 = _interopRequireDefault(_formValidation);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Views
var requestModalView = require('./request-modal-view');

// Templates
var template = require('./../../templates/items/newsletter-modal-tmpl.hbs');

module.exports = _backbone4.default.View.extend({

    tagName: 'div',

    className: 'modal-newsletter',

    template: _handlebars2.default.compile(template),

    onRender: function onRender() {var _this = this;
        if (window.umbracoData) {
            var ApiUrl = "/umbraco/surface/form/GetNewsletterSignupForm?landingPageId=" + window.umbracoData.RootId;

            this.$el.empty();

            _jquery2.default.ajax({
                type: 'GET',
                url: ApiUrl,
                cache: false }).
            done(function (result) {
                _this.$el.append(result);

                // Form submission
                _this.$el.find('form').on('submit', function (e) {
                    e.preventDefault();

                    var $form = (0, _jquery2.default)(e.currentTarget);

                    _this.$el.find('input[name="VisitorKey"]').attr('value', _cookie2.default.readCookie('cuvid'));

                    // Lets do a validation check
                    var validation = new _formValidation2.default({
                        element: $form });

                    if ($form.hasClass('has-validation-errors')) {
                        return false;
                    }

                    var formData = $form.serializeArray().reduce(function (obj, item) {
                        obj[item.name] = item.value;
                        return obj;
                    }, {});

                    // If multiple newsletters available to sign up for. Please the backenders by adjusting data
                    if ($form.find('input[name="NewsletterSites"]').length > 0) {
                        var multipleNewslettersData = [];

                        $form.find('input[name="NewsletterSites"]').each(function (i, e) {
                            var $el = (0, _jquery2.default)(e);

                            if ($el.prop('checked') === true) {
                                multipleNewslettersData.push($el.val());
                            }
                        });

                        formData.NewsletterSites = multipleNewslettersData.toString();
                    }

                    var modelData = new _backbone2.default.Model({
                        form: $form });


                    // Default URL Endpoint
                    var apiUrl = '/umbraco/api/FormCapture/SubmitNewsletterSignupForm';

                    if ((0, _jquery2.default)('body').attr('data-layout').toLowerCase() === 'group') {
                        apiUrl = '/umbraco/api/FormCapture/SubmitGroupNewsletterSignupForm';
                    }

                    _jquery2.default.ajax({
                        type: 'POST',
                        url: apiUrl,
                        cache: false,
                        data: JSON.stringify(formData),
                        contentType: 'application/json',
                        beforeSend: function beforeSend() {
                            App.Modal.create({
                                view: requestModalView,
                                model: modelData });

                        },
                        error: function error(err) {
                            modelData.set({
                                status: 'error' });

                        },
                        success: function success() {
                            modelData.set({
                                status: 'destroy' });

                        },
                        complete: function complete(successMessage) {
                            if (successMessage.status == 200) {
                                // GA tracking
                                var trackingName = $form.data('tracking') || 'Newsletter modal';
                                var trackingResponse = (0, _tracking2.default)('submit', 'form', trackingName);

                                window.location.replace(successMessage.responseJSON['redirectPage']);
                            }
                        } });

                    return false;
                });
            });
        }
    },

    initialize: function initialize(e) {
    } });

},{"./../../../framework/cookie":18,"./../../../framework/form-validation":20,"./../../../framework/tracking":45,"./../../templates/items/newsletter-modal-tmpl.hbs":3,"./request-modal-view":10,"backbone":"backbone","backbone.marionette":"backbone.marionette","handlebars":"handlebars","jquery":"jquery","underscore":"underscore"}],10:[function(require,module,exports){
/**
* Request Modal View
*
* @author nnielsen <nnielsen@vertic.com>
*/

/**
       * jslint plusplus: true, vars: true, browser: true, white:true
       * global require: true
       */

'use strict';

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _underscore = require('underscore');var _underscore2 = _interopRequireDefault(_underscore);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);
var _handlebars = require('handlebars');var _handlebars2 = _interopRequireDefault(_handlebars);

var _modal = require('./../../../framework/modal');var _modal2 = _interopRequireDefault(_modal);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Templates
var template = require('./../../templates/items/request-modal-tmpl.hbs');

module.exports = _backbone4.default.View.extend({

    tagName: 'div',

    className: 'modal-request',

    template: _handlebars2.default.compile(template),

    initialize: function initialize() {
        this._updateContent();

        this.model.on('change', this._updateContent.bind(this));
    },

    _updateContent: function _updateContent() {
        this.status = this.model.get('status') || 'loading';

        this.form = this.model.get('form');
        this.successHeader = this.form ? this.form.data('success-header') : '<strong>Tak</strong> for din besked';
        this.successText = this.form ? this.form.data('success-text') : 'Vi har modtaget din besked og vender tilbage så hurtigt som muligt.';
        this.errorHeader = this.form ? this.form.data('error-header') : '<strong>Noget</strong> gik galt...';
        this.errorText = this.form ? this.form.data('error-text') : 'Der er opstået en teknisk fejl. Prøv igen senere eller kontakt os på: <a href="mailto:info@verdo.dk">info@verdo.dk</a>';
        this.processingHeader = this.form ? this.form.data('success-header') : '<strong>Vi er igang</strong> med at sende din besked';
        this.processingText = this.form ? this.form.data('success-text') : 'Vidste du at Verdo er et af Danmarks førende energiselskaber';

        console.info(this);

        switch (this.status) {
            case 'success':
                this.model.set({
                    statusHeadline: this.successHeader,
                    statusText: this.successText });

                break;
            case 'error':
                this.model.set({
                    statusHeadline: this.errorHeader,
                    statusText: this.errorText });

                break;
            case 'destroy':
                this.destroy();
                this.options.instance.modal.layout.close();
                break;
            default:
                this.model.set({
                    statusHeadline: this.processingHeader,
                    statusText: this.processingText });

                break;}


        this.render();
    } });

},{"./../../../framework/modal":26,"./../../templates/items/request-modal-tmpl.hbs":4,"backbone":"backbone","backbone.marionette":"backbone.marionette","handlebars":"handlebars","jquery":"jquery","underscore":"underscore"}],11:[function(require,module,exports){
'use strict';










var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _backbone = require('backbone.marionette');var _backbone2 = _interopRequireDefault(_backbone);
var _handlebars = require('handlebars');var _handlebars2 = _interopRequireDefault(_handlebars);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Templates
var template = require('./../../templates/items/search-modal-tmpl.hbs'); /**
                                                                         * Search Modal View
                                                                         *
                                                                         * @author nnielsen <nnielsen@vertic.com>
                                                                         */ /**
                                                                             * jslint plusplus: true, vars: true, browser: true, white:true
                                                                             * global require: true
                                                                             */module.exports = _backbone2.default.View.extend({ tagName: 'div', className: 'modal-search', template: _handlebars2.default.compile(template),

	onRender: function onRender() {var _this = this;
		var fakeTimeout = setInterval(function () {
			clearInterval(fakeTimeout);

			// Setup focus on modal open
			_this.$el.find('input').focus();
		}, 10);

		// On submission
		this.$el.find('form').on('submit', function (e) {
			e.preventDefault();

			var $form = (0, _jquery2.default)(e.currentTarget);
			var value = $form.find('input').val();

			// Redirect
			window.location.href = _this.model.get('postAdress') + '?Query=' + value;
		});
	} });

},{"./../../templates/items/search-modal-tmpl.hbs":5,"backbone.marionette":"backbone.marionette","handlebars":"handlebars","jquery":"jquery"}],12:[function(require,module,exports){
'use strict';










var _backbone = require('backbone.marionette');var _backbone2 = _interopRequireDefault(_backbone);
var _handlebars = require('handlebars');var _handlebars2 = _interopRequireDefault(_handlebars);
var _player = require('@vimeo/player');var _player2 = _interopRequireDefault(_player);
var _youtubePlayer = require('youtube-player');var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);
var _tracking = require('../../../framework/tracking');var _tracking2 = _interopRequireDefault(_tracking);


var _videoModalTmpl = require('../../templates/items/video-modal-tmpl.hbs');var _videoModalTmpl2 = _interopRequireDefault(_videoModalTmpl);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                                                         * Video Modal View
                                                                                                                                                                                                                                         *
                                                                                                                                                                                                                                         * @author nnielsen <nnielsen@vertic.com>
                                                                                                                                                                                                                                         */ /**
                                                                                                                                                                                                                                             * jslint plusplus: true, vars: true, browser: true, white:true
                                                                                                                                                                                                                                             * global require: true
                                                                                                                                                                                                                                             */module.exports = _backbone2.default.View.extend({ tagName: 'div', className: 'modal-video', template: _handlebars2.default.compile(_videoModalTmpl2.default),

	ui: {
		videoContainer: '.video-aspect-container' },


	onRender: function onRender() {
		this.$el.addClass('loading');

		var $element = this.$el.find('#video-insert').get(0);
		var video = this.model.get('selector').data('video');
		var provider = this.model.get('selector').data('provider');

		if (provider === 'vimeo') {
			this.vimeoPlayer($element, video);
		} else if (provider === 'youtube') {
			this.ytPlayer($element, video);
		} else {
			console.error('Video-Model: Error! - Incorrect or no data-provider specified');
		}
	},

	ytPlayer: function ytPlayer($element, video) {var _this = this;
		var iframePlayer = document.createElement('DIV');
		$element.appendChild(iframePlayer);
		console.log('test fest hest');
		var player = (0, _youtubePlayer2.default)(iframePlayer, {
			videoId: video,
			playerVars: { autoplay: 1, rel: 0 } });

		//player.loadVideoById(video);

		player.on('ready', function () {
			_this.$el.removeClass('loading');
			player.playVideo();
		});

		// Note: Tracking not available on YouTube videos.
	},

	vimeoPlayer: function vimeoPlayer($element, video) {var _this2 = this;
		var videoTitle = '';

		// Video options
		var options = {
			url: video,
			byline: false,
			color: App.color,
			autoplay: true };


		// Create video
		var player = new _player2.default($element, options);

		player.on('loaded', function () {
			_this2.$el.removeClass('loading');
		});

		// Google Analytics Tracking [only allowed if attribute is set]
		if (!this.model.get('selector').data('tracking')) {
			return;
		}

		var playStateSent = {
			play: false,
			'20%': false,
			'50%': false,
			'80%': false,
			complete: false };


		player.getVideoTitle().then(function (title) {
			videoTitle = title;
		});

		player.on('play', function () {
			if (!playStateSent.play) {
				(0, _tracking2.default)('play', 'video', videoTitle);
				playStateSent.play = true;
			}
		});

		player.on('timeupdate', function (data) {
			if (data.percent > 0.2 && !playStateSent['20%']) {
				(0, _tracking2.default)('20%', 'video', videoTitle);
				playStateSent['20%'] = true;
			} else if (data.percent > 0.5 && !playStateSent['50%']) {
				(0, _tracking2.default)('50%', 'video', videoTitle);
				playStateSent['50%'] = true;
			} else if (data.percent > 0.8 && !playStateSent['80%']) {
				(0, _tracking2.default)('80%', 'video', videoTitle);
				playStateSent['80%'] = true;
			} else if (data.seconds === data.duration && !playStateSent.complete) {
				(0, _tracking2.default)('complete', 'video', videoTitle);
				playStateSent.complete = true;
			}
		});
	} }); // Templates

},{"../../../framework/tracking":45,"../../templates/items/video-modal-tmpl.hbs":6,"@vimeo/player":"@vimeo/player","backbone.marionette":"backbone.marionette","handlebars":"handlebars","youtube-player":"youtube-player"}],13:[function(require,module,exports){
/**
* Application layout and controller
*
* @author nnielsen <nnielsen@vertic.com>
*/

'use strict';

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _underscore = require('underscore');var _underscore2 = _interopRequireDefault(_underscore);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var AppLayout = _backbone4.default.View.extend({
    el: 'body',

    regions: {
        pageContent: '.page-region' },


    initialize: function initialize() {} });


module.exports = AppLayout;

},{"backbone":"backbone","backbone.marionette":"backbone.marionette","jquery":"jquery","underscore":"underscore"}],14:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var accordion = function accordion() {
	(0, _jquery2.default)('.accordion').each(function (i, e) {
		var $item = (0, _jquery2.default)(e);

		$item.find('.accordion__item--button').on('click', function (e) {
			var $currentItem = (0, _jquery2.default)(e.currentTarget);
			var $content = $currentItem.next('.accordion__item--content');

			$currentItem.toggleClass('active');
			$content.slideToggle();
		});
	});
}; /**
   * Accordion
   *
   * author: NNielsen <NNielsen@vertic.com>
   */module.exports = accordion;

},{"jquery":"jquery"}],15:[function(require,module,exports){
'use strict';var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {return typeof obj;} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;};var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {return typeof obj === "undefined" ? "undefined" : _typeof2(obj);} : function (obj) {return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);};var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * Slider module
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                     */

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _underscore = require('underscore');var _underscore2 = _interopRequireDefault(_underscore);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);
var _handlebars = require('handlebars');var _handlebars2 = _interopRequireDefault(_handlebars);
var _velocityAnimate = require('velocity-animate');var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
var _hammerjs = require('hammerjs');var _hammerjs2 = _interopRequireDefault(_hammerjs);
var _tracking = require('./tracking');var _tracking2 = _interopRequireDefault(_tracking);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

var template = require('./../core/templates/partials/partial-modal-tmpl.hbs');var

SliderModule = function () {
    function SliderModule(opt) {var _this = this;_classCallCheck(this, SliderModule);
        this.options = opt;
        this.$el = opt.element instanceof _jquery2.default ? opt.element : (0, _jquery2.default)(opt.element);
        this.container = opt.container || this.$el.parent();
        this.el = this.$el.get(0);

        this.$track = this.$el.find('.slider__track');
        this.$trackItem = this.$el.find('.slider__track__item');
        this.$trackItemWidth = this.$trackItem.outerWidth();

        this.$sliderItem = (0, _jquery2.default)(this.$el).find('.slider__item');
        this.itemAmount = this.$sliderItem.length;

        this.touch = opt.touch;

        this.paginationIsInitiated = false;
        this.paginationClassPrefix = opt.paginationPrefix || 'slider__pagination';

        // The index of the active element
        this.activeIndex = 0;
        // Amount the track has been translated
        this.$trackTranslation = 0;
        this.duration = 200;

        this.videoPlaying = false;

        //touch sensitivity in percentage
        this.sensitivity = 25; // horizontal % needed to trigger swipe

        if (this.itemAmount === 1) {
            this.$el.addClass('no-slide');
            return false;
        }

        // Update slider sizing
        (0, _jquery2.default)(window).on('resize', function () {
            _this.resize();
            _this.prepare();
        });

        this.prepare();
    }_createClass(SliderModule, [{ key: 'resize', value: function resize()

        {
            this.clearSlider();

            // Resizing from mobile to desktop will trigger following functions
            if (this.options.pagination) {
                this.setupPagination(this.$sliderItem.length);
            }
            this.setSlideWidth();
            this.createClone();
            this.setActiveItem();
        } }, { key: 'setUpTouch', value: function setUpTouch()

        {var _this2 = this;
            if (!this.touch) {
                return false;
            } else if ((0, _jquery2.default)(this.el).hasClass('single-item')) {
                // If only one item in the slider - dont setup drag
                return false;
            }

            if (this.hammer) {
                this.hammer.destroy();
            }

            // 4d. Set up HammerJS
            // Disable dragging to better enable HammerJS panning
            this.$el.find('a').add('img').attr('draggable', false);

            setTimeout(function () {
                this.$el.on('click', function (e) {
                    if (this.$track.hasClass('velocity-animating')) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }.bind(this));
            }.bind(this), 0);

            this.hammer = new _hammerjs2.default(this.el, {
                dragLockToAxis: true,
                dragBlockHorizontal: true });


            this.hammer.on('release dragleft dragright swipeleft swiperight', function (e) {
                // Show that we are sliding
                if (!_this2.$track.hasClass('is-sliding')) {
                    _this2.$track.addClass('is-sliding');
                }

                // 4e. Calculate pixel movements into 1:1 screen percents so gestures track with motion
                var percentage = 100 / _this2.itemAmount * e.deltaX / window.innerWidth;

                // 4f. Multiply percent by # of slide we’re on
                var percentageCalculated = percentage - 100 / _this2.itemAmount * _this2.activeSlide;

                // 4g. Apply transformation
                _this2.el.style.transform = 'translateX( ' + percentageCalculated + '% )';

                // 4h. Snap to slide when done
                // rotateSlider(direction)
                if (e.isFinal) {
                    if (e.velocityX > 1) {
                        _this2.rotateSlider('prev');
                    } else if (e.velocityX < -1) {
                        _this2.rotateSlider('next');
                    } else
                    {
                        if (percentage <= -(_this2.sensitivity / _this2.itemAmount))
                        _this2.rotateSlider('next');else
                        if (percentage >= _this2.sensitivity / _this2.itemAmount)
                        _this2.rotateSlider('prev');
                    }

                    _this2.$track.removeClass('is-sliding');
                }
            });
        } }, { key: 'prepare', value: function prepare()

        {var _this3 = this;
            // Buttons
            this.$el.find('button.next').on('click', function () {
                _this3.rotateSlider('next');
            });
            this.$el.find('button.prev').on('click', function () {
                _this3.rotateSlider('prev');
            });

            // Custom events
            this.$el.on('setSlideWidth', function () {
                _this3.setSlideWidth();
                _this3.rotateSlider();
            });

            if (this.options.pagination) {
                this.setupPagination(this.$sliderItem.length);
            }


            this.setSlideWidth();
            this.createClone();

            this.setupVideo();
            this.setActiveItem();

            if (this.touch) {
                this.setUpTouch();
            }
        } }, { key: 'setSlideWidth', value: function setSlideWidth()

        {
            // Resetting width
            this.$trackItem.width('');
            this.$sliderItem.width('');

            // Store width of track item
            this.$trackItemWidth = this.$el.innerWidth() * this.itemAmount;

            // Adding width to track items & slide items
            this.$el.find('.slider__track__item').width(this.$trackItemWidth);
            this.$el.find('.slider__item').width(this.$el.width() / this.itemAmount / this.$el.width() * 100 + '%');
        } }, { key: 'createClone', value: function createClone()

        {
            // Create clones
            this.$cloneTrackBefore = this.$trackItem.clone();
            this.$cloneTrackAfter = this.$trackItem.clone();

            // Append clones to DOM
            this.$trackItem.before(this.$cloneTrackBefore);
            this.$trackItem.after(this.$cloneTrackAfter);

            // Update translation value on track
            this.$trackTranslation = parseInt(this.$trackItem.outerWidth() * -1);

            // Translate slidertrack equal to the "before" clone
            this.$track.css({
                transform: 'translateX(' + this.$trackTranslation + 'px)' });

        } }, { key: 'setActiveItem', value: function setActiveItem(

        direction) {
            // Set active index
            if (direction === 'prev') {
                this.activeIndex--;
                if (this.activeIndex === -1) this.activeIndex = this.itemAmount - 1;
            } else if (direction === 'next') {
                this.activeIndex++;
                if (this.activeIndex === this.itemAmount) this.activeIndex = 0;
            } else {
                this.activeIndex = 0;
            }

            // Pagination update
            if (this.options.pagination) {
                this.container.find('.' + this.paginationClassPrefix + '__item').removeClass('active').eq(this.activeIndex).addClass('active');
            }

            // Update text
            this.updateContent();
        } }, { key: 'rotateSlider', value: function rotateSlider(

        direction) {var _this4 = this;
            var slideWidth = this.$sliderItem.outerWidth();

            if (direction === 'prev') {
                this.setActiveItem('prev');

                this.$trackTranslation = this.$trackTranslation + slideWidth;

                // Check for stepping into a clone item
                if (-this.$trackItemWidth < this.$trackTranslation) {
                    // Update track translation value
                    this.$trackTranslation = (this.$trackItemWidth + slideWidth * (this.itemAmount - 1)) * -1;

                    // Slide to new value inside cloned area
                    _velocityAnimate2.default.animate(this.$track, {
                        translateX: this.$trackItemWidth * 2 * -1 },
                    {
                        duration: 0,
                        complete: function complete() {
                            _velocityAnimate2.default.animate(_this4.$track, {
                                translateX: (_this4.$trackItemWidth + slideWidth * (_this4.itemAmount - 1)) * -1 },
                            {
                                duration: _this4.duration });

                        } });


                } else {
                    // Translate to new value
                    _velocityAnimate2.default.animate(this.$track, {
                        translateX: this.$trackTranslation },
                    {
                        duration: this.duration });

                }

                (0, _tracking2.default)('click', 'slider ' + this.$el.data('tracking-name') + '', 'backwards');
            } else if (direction === 'next') {
                this.setActiveItem('next');

                // Check for stepping into a clone item
                if (this.$trackTranslation < (this.$trackItemWidth + (slideWidth * this.itemAmount - 1)) * -1) {
                    // Update track translation value
                    this.$trackTranslation = parseInt(this.$trackItemWidth * -1);

                    // Jump back to original no. 1 before translating to new value
                    _velocityAnimate2.default.animate(this.$track, {
                        translateX: this.$trackItemWidth * -1 },
                    {
                        duration: 0,
                        complete: function complete() {
                            _velocityAnimate2.default.animate(_this4.$track, {
                                translateX: _this4.$trackTranslation },
                            {
                                duration: _this4.duration });

                        } });

                } else {
                    // Translate to new value
                    _velocityAnimate2.default.animate(this.$track, {
                        translateX: [this.$trackTranslation - slideWidth, this.$trackTranslation] },
                    {
                        duration: this.duration });

                }

                this.$trackTranslation = this.$trackTranslation - slideWidth;

                (0, _tracking2.default)('click', 'slider: ' + this.$el.data('tracking-name') + '', 'forward');
            } else {
                this.$trackTranslation = (this.$trackItemWidth + this.activeIndex * slideWidth) * -1;

                // Rotate back to active slide
                _velocityAnimate2.default.animate(this.$track, {
                    translateX: this.$trackTranslation },
                {
                    duration: 0 });

            }

            // Pause all videos
            this.$sliderItem.find('video').each(function (i, e) {
                _this4.toggleVideo(e, 'reload');
            });
        } }, { key: 'updateContent', value: function updateContent()

        {
            var data = _typeof(this.$sliderItem.eq(this.activeIndex).data('content')) === 'object' ? this.$sliderItem.eq(this.activeIndex).data('content') : JSON.parse(this.$sliderItem.eq(this.activeIndex).data('content'));
            var markup = '\n        <header>\n            <p class="case-slider__item__box__category">' +

            data.category + '</p>\n            <h4 class="case-slider__item__box__headline">' +
            data.headline + '</h4>\n            <p class="case-slider__item__box__date">' +
            data.date + '</p>\n        </header>\n        <p>' +

            data.text + '</p>\n\n        <a href="' +

            data.link + '" class="btn btn--link">' + data.linkLabel + '<span class="btn__icon"></span></a>\n        ';


            this.container.find('.js-content').html(markup);
        } }, { key: 'setupPagination', value: function setupPagination(

        count) {
            if (this.paginationIsInitiated) {
                return false;
            }

            var itemPrefix = this.paginationClassPrefix + '__item';
            var $paginationEl = '';

            if (this.container.find('.' + this.paginationClassPrefix)) {
                this.$pagination = this.container.find('.' + this.paginationClassPrefix);
                $paginationEl = this.$pagination;
            } else {
                this.$pagination = (0, _jquery2.default)('<nav class="' + this.paginationClassPrefix + '"><ul></ul></div>');

                this.$pagination.insertAfter(this.$el);
                $paginationEl = this.container.find('.' + this.paginationClassPrefix);
            }


            var i = 0;
            while (i < count) {
                if (i === this.activeIndex) {
                    $paginationEl.find('ul').append('<li><button class="' + itemPrefix + ' active"></button></li>');
                } else {
                    $paginationEl.find('ul').append('<li><button class="' + itemPrefix + '"></button></li>');
                }
                i++;
            }

            this.paginationIsInitiated = true;
        } }, { key: 'clearSlider', value: function clearSlider()

        {
            this.$track.removeAttr('style');
            this.$trackItem.removeAttr('style').siblings().remove();
            this.$sliderItem.removeAttr('style');

            this.$el.find('button.slider__control').off('click');
        } }, { key: 'setupVideo', value: function setupVideo()

        {var _this5 = this;
            this.$el.find('video').each(function (i, e) {
                e.addEventListener('click', function () {
                    if (_this5.videoPlaying) {
                        _this5.toggleVideo(e, 'off');
                    } else {
                        _this5.toggleVideo(e, 'on');
                    }
                });

                e.addEventListener('ended', function () {
                    _this5.toggleVideo(e, 'reload');
                });
            });
        } }, { key: 'toggleVideo', value: function toggleVideo(

        e, state) {
            if (state === 'on') {
                e.play();
                this.videoPlaying = true;

                this.$el.addClass('video-playing');
            } else if (state === 'reload') {
                e.load();
                this.videoPlaying = false;

                this.$el.removeClass('video-playing');
            } else {
                e.pause();
                this.videoPlaying = false;

                this.$el.removeClass('video-playing');
            }
        } }]);return SliderModule;}();


module.exports = SliderModule;

},{"./../core/templates/partials/partial-modal-tmpl.hbs":7,"./tracking":45,"backbone":"backbone","backbone.marionette":"backbone.marionette","hammerjs":393,"handlebars":"handlebars","jquery":"jquery","underscore":"underscore","velocity-animate":"velocity-animate"}],16:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);

var _cookie = require('./cookie');var _cookie2 = _interopRequireDefault(_cookie);
var _formValidation = require('./form-validation');var _formValidation2 = _interopRequireDefault(_formValidation);
var _tracking = require('./tracking');var _tracking2 = _interopRequireDefault(_tracking);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                        * Contact form
                                                                                                                                                                                        *
                                                                                                                                                                                        * author: MBramming <MBramming@vertic.com>
                                                                                                                                                                                        */var requestModalView = require('./../core/views/items/request-modal-view');var contactForm = function contactForm() {

    (0, _jquery2.default)('#contact-form').each(function (i, e) {
        // If no backend hookup, stop here!
        if (!window.umbracoData) {
            return false;
        }

        var $form = (0, _jquery2.default)(e);

        $form.on('submit', function (e) {
            e.preventDefault();

            $form.find('input[name="VisitorKey"]').attr('value', _cookie2.default.readCookie('cuvid'));

            // Lets do a validation check
            var validation = new _formValidation2.default({
                element: $form });


            if ($form.hasClass('has-validation-errors')) {
                return false;
            }

            var formData = $form.serializeArray().reduce(function (obj, item) {
                obj[item.name] = item.value;
                return obj;
            }, {});

            var modelData = new _backbone2.default.Model({
                form: $form });


            _jquery2.default.ajax({
                type: 'POST',
                url: '/umbraco/api/FormCapture/SubmitContact',
                cache: false,
                data: JSON.stringify(formData),
                contentType: 'application/json',
                beforeSend: function beforeSend() {
                    App.Modal.create({
                        view: requestModalView,
                        model: modelData });

                },
                error: function error(err) {
                    modelData.set({
                        status: 'error' });

                },
                complete: function complete(successMessage) {
                    var trackingName = $form.data('tracking') || 'Contact';

                    // set timeout to remove modal automatically
                    setTimeout(function () {
                        modelData.set({
                            status: 'destroy' });

                    }, 5000);

                    $form[0].reset();
                    // GA tracking
                    (0, _tracking2.default)('submit', 'form', trackingName);
                } });

        });
    });
};

module.exports = contactForm;

},{"./../core/views/items/request-modal-view":10,"./cookie":18,"./form-validation":20,"./tracking":45,"backbone":"backbone","backbone.marionette":"backbone.marionette","jquery":"jquery"}],17:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _cookie = require('./cookie');var _cookie2 = _interopRequireDefault(_cookie);
var _velocityAnimate = require('velocity-animate');var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var cookieDisclaimer = function cookieDisclaimer() {
    var $cookie = (0, _jquery2.default)('.cookie-disclaimer');
    var $body = (0, _jquery2.default)('body');
    var $appFrame = (0, _jquery2.default)('.application-frame');

    (0, _jquery2.default)(window).on('load resize', function () {
        // Reset cookie height
        $cookie.css({ height: 'auto' });

        // Translate cookie disclaimer equal to its height
        _velocityAnimate2.default.animate($cookie, {
            marginTop: $cookie.height() * -1 },
        {
            duration: 0 });

    });

    // Show CookieDisclaimer
    if (!_cookie2.default.readCookie('cookie-accept')) {
        setTimeout(function () {
            $body.addClass('show-cookie');
        }, 5000);
    }

    // Set CookieDisclaimer Click events
    if ($cookie.length !== 0) {
        (0, _jquery2.default)('.js-cookie-accept').on('click', function () {
            $body.removeClass('show-cookie');

            _cookie2.default.createCookie('cookie-accept', 'true', 60);
        });
    }
}; /**
   * Cookie disclaimer module
   *
   * author: NNielsen <NNielsen@vertic.com>
   */module.exports = cookieDisclaimer;

},{"./cookie":18,"jquery":"jquery","velocity-animate":"velocity-animate"}],18:[function(require,module,exports){
"use strict";





var _jquery = require("jquery");var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var cookieScript = {
    createCookie: function createCookie(name, value, days) {
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
            var expires = "; expires=" + date.toGMTString();
        } else
        var expires = "";
        document.cookie = name + "=" + value + expires + "; path=/";
    },

    readCookie: function readCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') {c = c.substring(1, c.length);}
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },

    eraseCookie: function eraseCookie(name) {
        createCookie(name, "", -1);
    } }; /**
         * Filtering module
         *
         * author: NNielsen <NNielsen@vertic.com>
         */module.exports = cookieScript;

},{"jquery":"jquery"}],19:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var JsFilter = function JsFilter() {

    (0, _jquery2.default)('.filter').each(function (i, e) {
        var $item = (0, _jquery2.default)(e);
        var $buttons = $item.find('.filter__nav__item');

        // Main filter navigation
        $buttons.on('click', function (e) {
            var $currentItem = (0, _jquery2.default)(e.currentTarget);

            // Remove class from all
            $buttons.removeClass('active');
            // Add class to active element
            $currentItem.addClass('active');
        });

        $item.find('.filter__nav__chosen').on('click', function (e) {
            if ((0, _jquery2.default)(e.currentTarget).hasClass('active')) {
                (0, _jquery2.default)(e.currentTarget).removeClass('active');
            } else {
                $item.find('.filter__nav__chosen').removeClass('active');
                (0, _jquery2.default)(e.currentTarget).addClass('active');
            }
        });
    });

}; /**
   * Filter Module
   *
   * author: NNielsen <NNielsen@vertic.com>
   */module.exports = JsFilter;

},{"jquery":"jquery"}],20:[function(require,module,exports){
'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Form validation
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

'use strict';var

FormValidator = function () {
    function FormValidator(opt) {_classCallCheck(this, FormValidator);
        this.$el = opt.element;

        this.init();
    }_createClass(FormValidator, [{ key: 'init', value: function init()

        {var _this = this;
            this.$el.find('input').each(function (i, e) {
                var $item = (0, _jquery2.default)(e);

                if ($item.data('required')) {
                    switch ($item.attr('type')) {
                        case 'text':
                        case 'number':
                            (function () {
                                // Checks
                                if ($item.val().trim().length === 0) {
                                    _this.wrapItem($item);
                                } else {
                                    _this.clearErrMessage($item);
                                }

                                $item.on('keyup', function () {
                                    if ($item.val().trim().length !== 0) {
                                        // Removed error wrapper and message and set focus on input again
                                        _this.clearErrMessage($item);
                                        $item.focus();
                                    }
                                });
                            })();
                            break;

                        case 'email':
                            (function () {
                                var regex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/g;

                                // Checks
                                if (!$item.val().trim().match(regex)) {
                                    _this.wrapItem($item);
                                } else {
                                    _this.clearErrMessage($item);
                                }

                                $item.on('keyup', function () {
                                    if ($item.val().trim().length !== 0) {
                                        // Removed error wrapper and message and set focus on input again
                                        _this.clearErrMessage($item);
                                        $item.focus();
                                    }
                                });
                            })();
                            break;

                        case 'checkbox':
                            (function () {
                                if (!$item[0].checked) {
                                    _this.wrapItem($item.parents('label'));
                                } else {
                                    _this.clearErrMessage($item.parents('label'));
                                }

                                $item.on('click', function (e) {
                                    if ((0, _jquery2.default)(e.currentTarget)[0].checked) {
                                        _this.clearErrMessage($item.parents('label'));
                                    }
                                });
                            })();
                            break;}

                }
            });

            this.$el.find('textarea').each(function (i, e) {
                var $item = (0, _jquery2.default)(e);

                if ($item.data('required')) {
                    // Checks
                    if ($item.val().trim().length === 0) {
                        _this.wrapItem($item);
                    } else {
                        _this.clearErrMessage($item);
                    }

                    $item.on('keyup', function () {
                        if ($item.val().trim().length !== 0) {
                            // Removed error wrapper and message and set focus on input again
                            _this.clearErrMessage($item);
                            $item.focus();
                        }
                    });
                }
            });
        } }, { key: 'wrapItem', value: function wrapItem(

        $item) {
            console.log('form validatin - wrap item');
            // Only wrap in error container if not already in DOM
            if ($item.parents('.error-wrapper').length === 0) {
                var $errorwrapper = (0, _jquery2.default)('<div class="error-wrapper"></div>');
                $item.wrap($errorwrapper);

                // Insert error message
                if ($item.data('error-message')) {
                    $item.closest('.error-wrapper').append('<span class="error-wrapper__message">' + $item.data('error-message') + '</div>');
                }

                if (!this.$el.hasClass('has-validation-errors')) {
                    this.$el.addClass('has-validation-errors');
                }
            }
        } }, { key: 'clearErrMessage', value: function clearErrMessage(

        $input) {
            // Remove wrapper is present
            $input.unwrap('.error-wrapper').siblings('.error-wrapper__message').remove();

            // Remove errors class on form element once last error fixed
            if (this.$el.find('.error-wrapper').length === 0) {
                this.$el.removeClass('has-validation-errors');
            }
        } }]);return FormValidator;}();
;

module.exports = FormValidator;

},{"jquery":"jquery"}],21:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _touchSlider = require('./touch-slider');var _touchSlider2 = _interopRequireDefault(_touchSlider);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                    * Accordion
                                                                                                                                                                                                    *
                                                                                                                                                                                                    * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                    */var Thumbnails = function Thumbnails() {var breakpoints = {
		'mobile': 480,
		'tablet': 768,
		'desktop': 1200 };


	function heroThumbnails() {
		(0, _jquery2.default)('.hero-cards').each(function (i, e) {
			if (window.innerWidth <= breakpoints.tablet) {
				var touchSlider = new _touchSlider2.default({
					container: e,
					element: '.hero-cards__track',
					item: '.hero-cards__item',
					pagination: '.mb-pagination' });

			}
		});
	}

	(0, _jquery2.default)(window).on('resize load', function () {
		heroThumbnails();
	});
};

module.exports = Thumbnails;

},{"./touch-slider":44,"jquery":"jquery"}],22:[function(require,module,exports){
'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Inline video (Does not open in a modal)
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

var _player = require('@vimeo/player');var _player2 = _interopRequireDefault(_player);
var _youtubePlayer = require('youtube-player');var _youtubePlayer2 = _interopRequireDefault(_youtubePlayer);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var

InlineVideo = function () {
	function InlineVideo(opt) {_classCallCheck(this, InlineVideo);
		this.url = opt.element ? opt.element.getAttribute('data-video') : null;
		var provider = InlineVideo.getProviderFromUrl(this.url);

		this.options = opt;
		this.element = opt.element;
		this.cleanPlayer = opt.cleanPlayer || false;

		if (provider === 'youtube') {
			this.setupYoutube();
		} else {
			this.setupVimeo();
		}
	}_createClass(InlineVideo, [{ key: 'setupYoutube', value: function setupYoutube()

		{
			var youtubeId = InlineVideo.getYoutubeIdFromUrl(this.url);
			var iframePlayer = document.createElement('div');
			this.element.appendChild(iframePlayer);

			var playerVars = {};

			if (this.cleanPlayer) {
				playerVars = {
					autoplay: 1,
					controls: 0,
					loop: 1,
					playlist: youtubeId // needed for loop to work
				};
			}

			var player = (0, _youtubePlayer2.default)(iframePlayer, {
				videoId: youtubeId,
				playerVars: playerVars });


			if (this.cleanPlayer) {
				player.setLoop(true);
				player.mute();
			}
		} }, { key: 'setupVimeo', value: function setupVimeo()

		{
			// Video options
			var options = {
				url: this.url,
				byline: false,
				color: App.color };


			// Stopping if we don't have a video url
			if (!options.url) {
				return;
			}

			// Variant specific video options
			if (this.cleanPlayer) {
				options.autoplay = true;
				options.loop = true;
				options.portrait = false;
			} else {
				options.autoplay = false;
			}

			// Create video
			var player = new _player2.default(this.element, options);

			if (this.cleanPlayer) {
				player.setVolume(0);
			}
		} }], [{ key: 'getYoutubeIdFromUrl', value: function getYoutubeIdFromUrl(

		url) {
			var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
			var match = url.match(regExp);
			return match && match[7].length === 11 ? match[7] : false;
		} }, { key: 'getProviderFromUrl', value: function getProviderFromUrl(

		url) {
			// Regex to get domain from url
			var regex = /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/\n]+)/im;
			var domain = regex.exec(url)[1];
			var provider = 'vimeo';

			if (domain.indexOf('youtu') >= 0) {
				provider = 'youtube';
			}

			return provider;
		} }]);return InlineVideo;}();


module.exports = InlineVideo;

},{"@vimeo/player":"@vimeo/player","youtube-player":"youtube-player"}],23:[function(require,module,exports){
"use strict";





var _jquery = require("jquery");var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var JsSorting = function JsSorting() {
    var $filterOpen = false;

    function onSortingFilterClose(element) {
        element.removeClass("active");
        $filterOpen = false;
    }

    (0, _jquery2.default)(".sorting").each(function (i, e) {
        var $item = (0, _jquery2.default)(e);
        var $filterBtn = $item.find(".sorting__nav");
        var activeFilters = "";

        $filterBtn.find(".js-sorting").on("click", function () {
            if (!$filterOpen) {
                $filterBtn.addClass("active");
                $filterOpen = true;
            } else {
                onSortingFilterClose($filterBtn);
            }
        });

        if (window.umbracoData) {
            $filterBtn.find(".sorting__nav__item").click(function (element) {
                var $this = (0, _jquery2.default)(element.currentTarget);

                // Start loading icon
                $item.addClass("loading");

                if (!activeFilters.includes(element.currentTarget.dataset.id)) {
                    activeFilters = "";
                    activeFilters = activeFilters.concat(element.currentTarget.dataset.id);
                } else {
                    activeFilters = "";
                }

                $filterBtn.find(".sorting__nav__item").each(function (index, btn) {
                    var $btn = (0, _jquery2.default)(btn);
                    if (btn.dataset.id === activeFilters) {
                        $btn.addClass("active");
                    } else {
                        $btn.removeClass("active");
                    }
                });

                _jquery2.default.ajax({
                    url: "/umbraco/api/article/GetArticles",
                    type: "post",
                    data: {
                        NewsCount: $item.data("limit") || 12,
                        SortOrder: "desc",
                        CurrentCulture: window.umbracoData.CurrentCulture,
                        RootId: window.umbracoData.RootId,
                        TagReferences: activeFilters },

                    traditional: true,
                    cache: false,
                    error: function error(errMessage) {
                        console.error("Sorting error", errMessage);
                    } }).
                done(function (result) {
                    // Insert content
                    var htmlToInsert = "";
                    _jquery2.default.each(result, function (index, data) {
                        htmlToInsert +=
                        '<a href="' +
                        data.Url +
                        '" class="newscard__item"><article><span class="newscard__item__date">' +
                        data.PublishDate +
                        "</span><header><h6>" +
                        data.Title +
                        '</h6></header><img src="' +
                        data.ImageUrl +
                        '" alt="lorem ipsum"><div class="newscard__item__footer"><span class="btn btn--link btn--inline">Læs mere</span></div></article></a>';
                    });
                    (0, _jquery2.default)(".sorting__result").
                    find(".newscard__track").
                    html(htmlToInsert);

                    // Close filter dropdown and reset filters
                    onSortingFilterClose($filterBtn);
                    $item.removeClass("loading");
                });
            });
        }

        // Close filter when clicking outside
        (0, _jquery2.default)(document).on("click", function (e) {
            if ($filterOpen) {
                // Prevent closing if clicked item is the filter dropdown
                if (
                (0, _jquery2.default)(e.target).hasClass(".sorting__nav") ||
                (0, _jquery2.default)(e.target).parents(".sorting__nav").length !== 0)
                {
                    return false;
                }

                onSortingFilterClose($filterBtn);
            }
        });
    });
}; /**
    * Sorting Module
    *
    * author: NNielsen <NNielsen@vertic.com>
    */module.exports = JsSorting;

},{"jquery":"jquery"}],24:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var mapInitializer = function mapInitializer(center, zoom, markers) {
    (0, _jquery2.default)(document).ready(function () {
        var geocoder = new google.maps.Geocoder();
        var map = new google.maps.Map(document.getElementById('map'), {
            zoom: zoom,
            center: center,
            disableDefaultUI: true,
            styles: [
            {
                "stylers": [
                {
                    "visibility": "simplified" }] },



            {
                "elementType": "geometry",
                "stylers": [
                {
                    "color": "#f5f5f5" }] },



            {
                "elementType": "labels",
                "stylers": [
                {
                    "visibility": "off" }] },



            {
                "elementType": "labels.icon",
                "stylers": [
                {
                    "visibility": "off" }] },



            {
                "elementType": "labels.text.fill",
                "stylers": [
                {
                    "color": "#616161" }] },



            {
                "elementType": "labels.text.stroke",
                "stylers": [
                {
                    "color": "#f5f5f5" }] },



            {
                "featureType": "administrative",
                "elementType": "geometry",
                "stylers": [
                {
                    "visibility": "off" }] },



            {
                "featureType": "administrative.land_parcel",
                "stylers": [
                {
                    "visibility": "off" }] },



            {
                "featureType": "administrative.land_parcel",
                "elementType": "labels.text.fill",
                "stylers": [
                {
                    "color": "#bdbdbd" }] },



            {
                "featureType": "administrative.neighborhood",
                "stylers": [
                {
                    "visibility": "off" }] },



            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                {
                    "color": "#d8d7d8" }] },



            {
                "featureType": "poi",
                "stylers": [
                {
                    "visibility": "off" }] },



            {
                "featureType": "poi",
                "elementType": "geometry",
                "stylers": [
                {
                    "color": "#eeeeee" }] },



            {
                "featureType": "poi",
                "elementType": "labels.text.fill",
                "stylers": [
                {
                    "color": "#757575" }] },



            {
                "featureType": "poi.park",
                "elementType": "geometry",
                "stylers": [
                {
                    "color": "#e5e5e5" }] },



            {
                "featureType": "poi.park",
                "elementType": "labels.text.fill",
                "stylers": [
                {
                    "color": "#9e9e9e" }] },



            {
                "featureType": "road",
                "elementType": "geometry",
                "stylers": [
                {
                    "color": "#ffffff" }] },



            {
                "featureType": "road",
                "elementType": "labels.icon",
                "stylers": [
                {
                    "visibility": "off" }] },



            {
                "featureType": "road.arterial",
                "elementType": "geometry.fill",
                "stylers": [
                {
                    "color": "#e0e0e0" },

                {
                    "lightness": 5 },

                {
                    "weight": 1.5 }] },



            {
                "featureType": "road.arterial",
                "elementType": "labels.text.fill",
                "stylers": [
                {
                    "color": "#757575" }] },



            {
                "featureType": "road.highway",
                "elementType": "geometry",
                "stylers": [
                {
                    "color": "#dadada" }] },



            {
                "featureType": "road.highway",
                "elementType": "geometry.fill",
                "stylers": [
                {
                    "color": "#b3b2b4" },

                {
                    "weight": 1.5 }] },



            {
                "featureType": "road.highway",
                "elementType": "labels.text.fill",
                "stylers": [
                {
                    "color": "#616161" }] },



            {
                "featureType": "road.local",
                "elementType": "labels.text.fill",
                "stylers": [
                {
                    "color": "#9e9e9e" }] },



            {
                "featureType": "transit",
                "stylers": [
                {
                    "visibility": "off" }] },



            {
                "featureType": "transit.line",
                "elementType": "geometry",
                "stylers": [
                {
                    "color": "#e5e5e5" }] },



            {
                "featureType": "transit.station",
                "elementType": "geometry",
                "stylers": [
                {
                    "color": "#eeeeee" }] },



            {
                "featureType": "water",
                "elementType": "geometry",
                "stylers": [
                {
                    "color": "#c9c9c9" }] },



            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                {
                    "color": "#a6a6a6" }] },



            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                {
                    "color": "#9e9e9e" }] }] });





        var markerIcon = {
            url: '/dist/assets/images/location-icon-medium.svg',
            scaledSize: new google.maps.Size(20, 32) };

        var infoWindows = [];
        var bounds = new google.maps.LatLngBounds();

        var closeWindows = function closeWindows() {
            for (var i = 0; i < infoWindows.length; i++) {
                infoWindows[i].close();
            }
        };
        markers.forEach(function (marker) {
            var contentString = '<div class="map-info-box"><h3>' + marker.header + '</h3><p>' + marker.text + '</p></div>';
            var infowindow = new google.maps.InfoWindow({
                content: contentString });

            infoWindows.push(infowindow);

            geocoder.geocode({ 'address': marker.address }, function (results, status) {
                if (status === 'OK') {
                    var markerObject = new google.maps.Marker({
                        position: results[0].geometry.location,
                        map: map,
                        icon: markerIcon,
                        optimized: false,
                        title: marker.title,
                        infowindow: infowindow });


                    markerObject.addListener('click', function () {
                        closeWindows();
                        this.infowindow.open(map, this);
                    });

                    google.maps.event.addListener(infowindow, 'domready', function () {
                        var iwOuter = (0, _jquery2.default)('.gm-style-iw');
                        var iwBackground = iwOuter.prev();
                        iwBackground.children().css({ 'display': 'none' });
                        iwOuter.parent().parent().css({ 'left': '127px', 'top': '50px' });

                        var iwParent = iwOuter.parent();
                        var iwCloseBtn = iwOuter.next();
                        iwCloseBtn.css({ 'display': 'none' });
                    });

                    // Fit map
                    bounds.extend(results[0].geometry.location);
                    map.fitBounds(bounds);
                } else {
                    console.log('Geocode was not successful for the following reason: ' + status);
                    return "";
                }
            });
        });

        google.maps.event.addListener(map, 'click', function () {
            closeWindows();
        });

    });

}; /**
   * Google Maps Initializer
   *
   * author: MBramming <MBramming@vertic.com>
   */module.exports = mapInitializer;

},{"jquery":"jquery"}],25:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var MobileMenu = function MobileMenu() {
    var $body = (0, _jquery2.default)('body');
    var $header = (0, _jquery2.default)('header.header');
    var $nav = (0, _jquery2.default)('.header__nav');
    var $mbMenu = (0, _jquery2.default)('.js-mobile-menu');
    var breakpoints = {
        mobile: 480,
        tablet: 768,
        desktop: 1200,
        mobileMenuActive: 1024 };


    var mbMenuOpen = false;
    var firstLevelOpen = false;

    function setMenuPosition() {
        $nav.css({
            top: $header.outerHeight() });

    }

    function toggleNav(reset) {
        if (reset) {
            // $body.removeClass('mb-menu-open');
            (0, _jquery2.default)('html, body').removeClass('mb-menu-open');
        } else {
            // $body.addClass('mb-menu-open');
            (0, _jquery2.default)('html, body').addClass('mb-menu-open');
        }
    }

    $mbMenu.on('click', function () {
        if (document.body.clientWidth <= breakpoints.mobileMenuActive && !mbMenuOpen) {
            toggleNav();
            setMenuPosition();
            mbMenuOpen = true;
        } else {
            toggleNav(true);
            mbMenuOpen = false;
        }
    });

    (0, _jquery2.default)(window).on('resize', function (e) {
        $nav.css('top', '');

        if (mbMenuOpen && breakpoints.mobileMenuActive < e.currentTarget.innerWidth) {
            toggleNav(true);
        } else if (mbMenuOpen && e.currentTarget.innerWidth <= breakpoints.mobileMenuActive) {
            toggleNav();
            setMenuPosition();
        }
    });

    // OnClick Footer items
    (0, _jquery2.default)('.footer__container__list').each(function (i, e) {
        var $this = (0, _jquery2.default)(e);

        // Do not look inside the social container
        if ($this.parents('.footer__container--social').length >= 1) {
            return false;
        }

        $this.find('.footer__container__list__item--headline').eq(0).on('click', function (e) {
            // Prevent opening at first click
            if (!(0, _jquery2.default)(e.currentTarget).hasClass('active')) {
                e.preventDefault();
            }

            (0, _jquery2.default)(e.currentTarget).addClass('active');
        });
    });

    // OnClick Header items
    (0, _jquery2.default)('.header__nav__item').each(function (i, e) {
        var $this = (0, _jquery2.default)(e);

        $this.on('click', function (e) {
            var $element = (0, _jquery2.default)(e.currentTarget);

            if ($element.hasClass('mb-only')) {
                e.preventDefault();

                return false;
            }

            if (document.body.clientWidth <= breakpoints.mobileMenuActive) {
                $this.siblings('.header__nav__item').removeClass('active');

                // Prevent opening at first click
                if ($element.hasClass('active') === false) {
                    e.preventDefault();
                }

                $this.addClass('active');
            }
        });
    });
}; /**
   * Slider module
   *
   * author: NNielsen <NNielsen@vertic.com>
   */module.exports = MobileMenu;

},{"jquery":"jquery"}],26:[function(require,module,exports){
'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Modal
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * @author rkalms <rkalms@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _underscore = require('underscore');var _underscore2 = _interopRequireDefault(_underscore);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);
var _handlebars = require('handlebars');var _handlebars2 = _interopRequireDefault(_handlebars);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

var template = require('./../core/templates/partials/partial-modal-tmpl.hbs');

var defaults = {
	className: 'modal--show',
	frame: '#modal-frame',

	// Optionally pass a different view to the CoreObject
	view: _backbone4.default.View.extend({
		template: _handlebars2.default.compile(template),

		onShow: function onShow() {var _this = this;
			// Needs a timeout wrapper for animation. Sigh.
			setTimeout(function () {
				_this.$el.addClass(_this.options.modal.className);
			}, 20);
		} }) };var



Instance = function () {
	function Instance(options) {var _this2 = this;_classCallCheck(this, Instance);
		this.options = options;

		this.modal = options.scope;

		this.className = options.className;

		this.eventtype = 'click';

		// Assign event if selector present
		if (options.selector) {
			(0, _jquery2.default)('body').on(this.eventtype, options.selector, this.open.bind(this));
		}

		// No selector? We just open the modal view.
		else {
				if (this.modal.layout.getChildView('content')) {
					this.modal.layout.close(false, function () {
						_this2.open();
					}, true);
				} else {
					this.open();
				}
			}
	}_createClass(Instance, [{ key: 'open', value: function open(

		e) {
			if (e) {
				e.preventDefault();

				// If currently panning with between items when clicking
				if ((0, _jquery2.default)(e.currentTarget).parents('.is-animating').length !== 0) {
					return false;
				}
			}

			var View = this.options.view;

			// TODO: Does not work when clicking on search
			if (e) {
				this.options.model.set('selector', (0, _jquery2.default)(e.currentTarget));
			}

			this.view = new View({ instance: this, model: this.options.model });

			this.modal.layout.showChildView('content', this.view);

			(0, _jquery2.default)('body').addClass('modal--open');
			(0, _jquery2.default)(this.options.frame).addClass('modal--opened');
		} }, { key: 'getEventType', value: function getEventType()

		{
			var check = false;
			(function (a) {if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;})(navigator.userAgent || navigator.vendor || window.opera);
			return check;
		} }]);return Instance;}();var


Modal = function () {
	function Modal(options) {_classCallCheck(this, Modal);
		this.modals = [];
		this.options = _underscore2.default.extend({}, defaults, options);

		// Assign moving parts
		var View = this.options.view;

		var Layout = _backbone4.default.View.extend({
			el: this.options.frame,

			events: {
				'click .modal__close': 'close' },


			regions: {
				content: '.modal__content' },


			initialize: function initialize() {var _this3 = this;
				this.$el.on('click', function (e) {
					var $content = _this3.$el.find('.modal__content .container');

					// if the target of the click isn't the container nor a descendant of the container
					if (!$content.is(e.target) && $content.has(e.target).length === 0) {
						_this3.close();
					}
				});
			},

			close: function close(e, cb, preventFrameClose) {var _this4 = this;

				/**
                                                                                                                                           * IE(11) Fix
                                                                                                                                           * The iFrame must be blurred (if focused) and eliminated from the DOM
                                                                                                                                           * If not input fields may stop working
                                                                                                                                           */
				var $frame = this.$el.find('iframe');
				var $replacement = (0, _jquery2.default)(document.createElement('div'));

				if ($frame.length) {
					$replacement.height($frame.height()).width('100%');
					$frame.parent().prepend($replacement);
					$frame.blur();
					$frame.remove();
				}
				// IE(11) Fix END 

				if (e) {
					e.preventDefault();

					if (this.$el.find('.modal--access').length) {
						return false;
					}
				}

				this.$el.removeClass(this.options.modal.className);
				if (preventFrameClose !== true) (0, _jquery2.default)(this.options.modal.frame).removeClass('modal--opened');
				if ((0, _jquery2.default)('.modal--opened').length === 0) {
					(0, _jquery2.default)('body').removeClass('modal--open');
				}

				setTimeout(function () {
					_this4.getRegion('content').empty();

					if (cb && typeof cb === 'function') cb();
				}, 250);
			} });


		this.layout = new Layout({ modal: this.options });
	}_createClass(Modal, [{ key: 'create', value: function create(

		options) {
			var settings = this.options || {};

			var instance = _underscore2.default.extend(new Instance({
				selector: options.selector ? options.selector : false,
				view: options.view ? options.view : this.options.view,
				model: options.model ? options.model : new _backbone2.default.Model(),
				defaultModel: options.model ? false : true,
				className: this.options.className,
				frame: this.options.frame,
				scope: this }),
			settings);

			this.modals.push(instance);
		} }, { key: 'close', value: function close(

		cb) {
			this.layout.close();

			if (cb && typeof cb === 'function') cb();

			this.modals.splice(0, 1);
		} }]);return Modal;}();


module.exports = Modal;

},{"./../core/templates/partials/partial-modal-tmpl.hbs":7,"backbone":"backbone","backbone.marionette":"backbone.marionette","handlebars":"handlebars","jquery":"jquery","underscore":"underscore"}],27:[function(require,module,exports){
'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Mosaic module
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _velocityAnimate = require('velocity-animate');var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var

Mosaic = function () {
    function Mosaic(opt) {_classCallCheck(this, Mosaic);
        this.options = opt;
        this.$el = opt.element instanceof _jquery2.default ? opt.element : (0, _jquery2.default)(opt.element);
        this.el = this.$el.get(0);

        this.transition = this.$el.data('transition-speed') || 2000;
        this.input = this.$el.find('.mosaic__puzzle__input');
        this.inputsTaken = [];
        this.hasNoBlendMode = (0, _jquery2.default)('html').hasClass('no-backgroundblendmode');

        this.tilesWrapper = this.$el.find('.mosaic__puzzle__tiles');
        this.tiles = this.tilesWrapper.find('.mosaic__puzzle__tiles__tile');
        this.pics = this.$el.find('.mosaic__pic');

        this.tileSizes = [];
        this.interval;
        this.mobileInterval;

        this.currentScreen = 'desktop';

        this.prepare();
    }_createClass(Mosaic, [{ key: 'prepare', value: function prepare()

        {var _this = this;
            // Log the tile sizes for desktop before everything else
            this.tiles.each(function (i, e) {
                _this.tileSizes.push(parseInt((0, _jquery2.default)(e).attr('data-tile-size'), 10));
            });

            this.setupMarkup();

            this.adaptAccordingToScreenSize();
            this.setupEvents();

            if (this.currentScreen !== 'mobile') {
                this.initiateMosiac();
            }
        } }, { key: 'setupEvents', value: function setupEvents()

        {var _this2 = this;
            this.$el.on('mouseenter', function () {
                if (_this2.currentScreen !== 'mobile') {
                    clearInterval(_this2.interval);
                }
            });
            this.$el.on('mouseleave', function () {
                if (_this2.currentScreen !== 'mobile') {
                    _this2.initiateMosiac();
                }
            });

            var t = void 0;
            (0, _jquery2.default)(window).on('resize', function () {
                clearInterval(t);
                clearInterval(_this2.interval);
                clearInterval(_this2.mobileInterval);

                t = setInterval(function () {
                    _this2.adaptAccordingToScreenSize();

                    clearInterval(t);
                }, 200);
            });
        } }, { key: 'adaptAccordingToScreenSize', value: function adaptAccordingToScreenSize()

        {
            if (window.innerWidth <= 480 && this.currentScreen !== 'mobile') {
                this.currentScreen = 'mobile';
                this.updateForScreenSize('mobile');

                this.runMobile();
            } else if (window.innerWidth <= 768 && this.currentScreen !== 'tablet') {
                this.currentScreen = 'tablet';
                this.updateForScreenSize('tablet');

                this.initiateMosiac();
            } else if (window.innerWidth > 768 && this.currentScreen !== 'desktop') {
                this.currentScreen = 'desktop';
                this.updateForScreenSize('desktop');

                this.initiateMosiac();
            }
        } }, { key: 'setupMarkup', value: function setupMarkup()

        {var _this3 = this;
            this.tiles.each(function (i, e) {
                var $element = (0, _jquery2.default)(e);
                var tileSize = parseInt($element.attr('data-tile-size'), 10);

                // Get and append images into column
                var pictures = [];
                var picturesHTML = '';
                if (tileSize === 1) {
                    // Tilesize type 1 allows 2 images
                    pictures = _this3.pickupInputImage(2);
                } else {
                    pictures = _this3.pickupInputImage();
                }

                for (var _i = 0; _i < pictures.length; _i += 1) {
                    picturesHTML += '<figure class="mosaic__pic">' + pictures[_i][0].innerHTML + '</figure>';
                }

                // Throw in new elements
                $element.html(picturesHTML);

                for (var _i2 = 0; _i2 < pictures.length; _i2 += 1) {
                    $element.children().eq(_i2).attr('data-id', pictures[_i2].index());


                    // this.hasNoBlendMode
                }
            });

            // Update variable after manipulating DOM
            this.pics = this.$el.find('.mosaic__pic');
        } }, { key: 'pickupInputImage', value: function pickupInputImage(

        amount, specific) {
            var arr = [];
            var toPick = amount ? amount : 1;

            if (specific !== undefined) {
                var el = this.input.children().eq(specific);

                this.inputsTaken.length = 0;

                arr.push(el);
            } else {
                do {
                    var randomIndex = this.getRandomInt(0, this.input.children().length - 1);
                    var $element = (0, _jquery2.default)(this.input.children()[randomIndex]);

                    if (_jquery2.default.inArray($element.index(), this.inputsTaken) === -1) {
                        // Mark image as taken
                        this.inputsTaken.push($element.index());

                        arr.push($element);
                    }
                } while (arr.length < toPick);
            }

            return arr;
        } }, { key: 'initiateMosiac', value: function initiateMosiac()

        {var _this4 = this;
            clearInterval(this.interval);
            this.interval = setInterval(function () {
                var $randomPicture = (0, _jquery2.default)(_this4.pics[_this4.getRandomInt(0, _this4.pics.length - 1)]);
                var $tile = $randomPicture.parent();

                var obj = _this4.pickupInputImage()[0];
                var newObject = (0, _jquery2.default)('<div class="new-tile">' + obj[0].innerHTML + '</div>');

                // Append new image
                $randomPicture.append(newObject);

                // Make old image and make available again
                var index = _this4.inputsTaken.indexOf(parseInt($randomPicture.attr('data-id'), 10));
                if (index > -1) {
                    _this4.inputsTaken.splice(index, 1);
                }

                // Change ID on image element
                $randomPicture.attr('data-id', obj.index());

                _velocityAnimate2.default.animate(newObject, 'fadeIn', {
                    duration: 500,
                    easing: 'linear',
                    complete: function complete() {
                        // Remove "new-tile" wrapper and delete old element
                        newObject.find('> *').unwrap('.new-tile').siblings().remove();
                    } });

            }, this.transition);
        } }, { key: 'updateForScreenSize', value: function updateForScreenSize(

        screen) {
            // Resetting tiles and inputs
            this.tiles.remove();
            this.inputsTaken.length = 0;

            // Apply new tiles
            switch (screen) {
                case 'mobile':
                    this.tilesWrapper.append('<div class="mosaic__puzzle__tiles__tile" data-tile-size="4"></div>');
                    break;

                case 'tablet':
                    for (var i = 0; i < 2; i += 1) {
                        this.tilesWrapper.append('<div class="mosaic__puzzle__tiles__tile" data-tile-size="2"></div>');
                    }
                    break;

                case 'desktop':
                    for (var _i3 = 0; _i3 < this.tileSizes.length; _i3 += 1) {
                        this.tilesWrapper.append('<div class="mosaic__puzzle__tiles__tile" data-tile-size="' + this.tileSizes[_i3] + '"></div>');
                    }
                    break;

                default:
                    break;}


            // Update tiles variable and create markup
            this.tiles = this.$el.find('.mosaic__puzzle__tiles__tile');
            this.setupMarkup();

            if (screen === 'mobile') {
                // Wrap the image to make them all equal height
                this.tiles.find('img').wrap('<div class="mosaic__pic__image"></div>');
            }
        } }, { key: 'runMobile', value: function runMobile()

        {var _this5 = this;
            var currentEl = 0;

            this.mobileInterval = setInterval(function () {
                var obj = void 0;
                if (currentEl > _this5.input.children().length - 1) {
                    currentEl = 0;
                    obj = _this5.pickupInputImage(1, currentEl)[0];
                } else {
                    obj = _this5.pickupInputImage(1, currentEl)[0];
                    currentEl += 1;
                }

                _this5.tiles.find('img').attr('src', obj.find('img').attr('src'));
                _this5.tiles.find('.mosaic__pic__text').html(obj.find('.mosaic__pic__text').html());
            }, 5000);
        } }, { key: 'getRandomInt', value: function getRandomInt(

        min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        } }]);return Mosaic;}();


module.exports = Mosaic;


/*
                                                          let spacingFilled = 0; // percentage of available width
                                                  
                                                          while (spacingFilled < 100) {
                                                              const tileSize = this.getRandomInt(this.possibilities[0], this.possibilities[this.possibilities.length - 1]);
                                                  
                                                              // Create and append new column
                                                              let newObject = $(`
                                                                  <div class="mosaic__puzzle__tiles__tile"
                                                                      data-tile-size="${tileSize}"
                                                                      style="left:${spacingFilled}%; opacity: 1;">
                                                                  </div>`
                                                              );
                                                              this.$el.append(newObject);
                                                  
                                                              // Get and append images into column
                                                              let pictures;
                                                              let picturesHTML = '';
                                                              if (tileSize === 1) {
                                                                  // Tilesize type 1 allows 2 images
                                                                  pictures = this.pickupInputImage(2)
                                                              } else {
                                                                  pictures = this.pickupInputImage()
                                                              }
                                                  
                                                              for (let i = 0; i < pictures.length; i += 1) {
                                                                  picturesHTML += `<figure class="mosaic__pic">${pictures[i][0].innerHTML}</figure>`;
                                                              }
                                                  
                                                              newObject.html(picturesHTML);
                                                  
                                                              // console.log(spacingFilled);
                                                              spacingFilled += Math.floor(newObject.width() / this.$el.width() * 100);
                                                          }
                                                  
                                                  
                                                          */

},{"jquery":"jquery","velocity-animate":"velocity-animate"}],28:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var Navigation = function Navigation() {
	var nav = document.querySelector('.header');
	if (!nav) {
		return false;
	}
	var breadCrumb = document.querySelector('.header__breadcrumb');
	var prevScrollTop = window.pageYOffset;

	window.addEventListener('scroll', onStickyScroll);

	var resizeDebounce = debounce(setBodyPadding, 100);
	window.addEventListener('resize', resizeDebounce);
	setBodyPadding();


	function debounce(func) {var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
		var timeout = void 0;
		return function () {var _this = this;for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
			clearTimeout(timeout);
			timeout = setTimeout(function () {
				func.apply(_this, args);
			}, wait);
		};
	}

	function setBodyPadding() {
		var elHeight = nav.offsetHeight;
		document.body.style.paddingTop = elHeight + 'px';
	}

	function onStickyScroll() {
		var scrollTop = window.pageYOffset;
		var elHeight = nav.offsetHeight;


		// When scrolling to the top of the page we want to show the menu quickly (by setting the first parameter to true)
		if (scrollTop <= 10) {
			showSticky(true);
		} else if (!nav.classList.contains('not-in-top')) {
			nav.classList.add('not-in-top');
		}

		// Buffer so it doesn't necessarily animates up and down all the time and with the slightest changes
		if (Math.abs(prevScrollTop - scrollTop) < 5) {
			prevScrollTop = scrollTop;
			return;
		}

		if (scrollTop < prevScrollTop) {
			showSticky();
		} else if (scrollTop > prevScrollTop) {
			if (scrollTop > elHeight) {
				hideSticky();
			}
		}

		prevScrollTop = scrollTop;
	};

	function showSticky(topScroll) {
		if (topScroll) {
			unsetSticky();
		}

		if (nav.classList.contains('is-shown')) {
			return;
		}

		nav.classList.add('is-shown');
		nav.classList.remove('is-hidden');
		nav.style.transform = 'translateY(0)';
	};

	function hideSticky() {
		var elHeight = nav.offsetHeight;

		if (nav.classList.contains('is-hidden') || nav.classList.contains('has-search-open')) {
			return;
		}

		nav.classList.remove('is-shown');
		nav.classList.add('is-hidden');
		nav.style.transform = 'translateY(-' + elHeight + 'px)';
	};

	function unsetSticky() {
		nav.classList.remove('not-in-top');
		nav.style.transform = 'translateY(0)';

		setTimeout(function () {
			nav.style.transition = '';
		}, 0);
	};


	// Navigation inspection (sub menus)
	if (document.querySelector('.header__nav') && document.querySelector('.header__nav').length !== 0) {(function () {
			var navItems = document.querySelectorAll('.header__nav__item');
			var body = document.querySelector('body');
			var inspectSubmenu = false;

			for (var i = 0; i < navItems.length; i += 1) {
				navItems[i].addEventListener('mouseenter', function (e) {
					e.target.classList.contains('no-submenu') === false ? inspectSubmenu = true : inspectSubmenu = false;

					if (inspectSubmenu) {
						body.classList.add('menu-inspect');
					} else {
						body.classList.remove('menu-inspect');
					}
				});

				navItems[i].addEventListener('mouseleave', function (e) {
					body.classList.remove('menu-inspect');
				});
			}})();

	}
}; /**
   * Navigation
   *
   * author: NNielsen <nnielsen@vertic.com>
   */module.exports = Navigation;

},{"jquery":"jquery"}],29:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var News = function News() {

    // If running in Umbraco
    if (window.umbracoData) {
        (0, _jquery2.default)('.newscard .newscard__track').each(function (i, e) {
            _jquery2.default.ajax({
                url: '/umbraco/api/article/GetArticles',
                type: 'post',
                data: {
                    "NewsCount": (0, _jquery2.default)(e).data('limit') || 12,
                    "SortOrder": 'desc',
                    "CurrentCulture": window.umbracoData.CurrentCulture,
                    "RootId": window.umbracoData.RootId,
                    "Tags": (0, _jquery2.default)(e).data('tags') },
                cache: false,
                error: function error(errMessage) {
                    console.error('news fetch error', errMessage);
                } }).
            done(function (result) {
                var htmlToInsert = "";
                _jquery2.default.each(result, function (index, data) {
                    htmlToInsert += '<a href="' + data.Url + '" class="newscard__item"><article><span class="newscard__item__date">' + data.PublishDate + '</span><header><h6>' + data.Title + '</h6></header><img src="' + data.ImageUrl + "?anchor=center&mode=crop&quality=50" + '" alt="lorem ipsum"><div class="newscard__item__footer"><span class="btn btn--link btn--inline">' + data.CallToActionText + '</span></div></article></a>';
                });
                (0, _jquery2.default)(e).html(htmlToInsert);
            });
        });
    }
}; /**
   * News list
   *
   * author: NNielsen <NNielsen@vertic.com>
   */module.exports = News;

},{"jquery":"jquery"}],30:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);

var _cookie = require('./cookie');var _cookie2 = _interopRequireDefault(_cookie);
var _formValidation = require('./form-validation');var _formValidation2 = _interopRequireDefault(_formValidation);
var _tracking = require('./tracking');var _tracking2 = _interopRequireDefault(_tracking);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Views
/**
 * Search forms
 *
 * author: NNielsen <NNielsen@vertic.com>
 */var requestModalView = require('./../core/views/items/request-modal-view');var SignUp = function SignUp() {(0, _jquery2.default)('.newsletter-signup').each(function (i, e) {var $form = (0, _jquery2.default)(e);

		// If no backend hookup, stop here!
		if (!window.umbracoData) {
			return false;
		}

		// Setting VisitorKey on input
		$form.find('input[name="VisitorKey"]').attr('value', _cookie2.default.readCookie('cuvid'));

		$form.on('submit', function (e) {
			e.preventDefault();

			var $form = (0, _jquery2.default)(e.currentTarget);

			// Lets do a validation check
			var validation = new _formValidation2.default({
				element: $form });

			if ($form.hasClass('has-validation-errors')) {
				return false;
			}
			var formData = $form.serializeArray().reduce(function (obj, item) {
				obj[item.name] = item.value;
				return obj;
			}, {});

			// If multiple newsletters available to sign up for. Please the backenders by adjusting data
			if ($form.find('input[name="NewsletterSites"]').length > 0) {
				var multipleNewslettersData = [];

				$form.find('input[name="NewsletterSites"]').each(function (i, e) {
					var $el = (0, _jquery2.default)(e);

					if ($el.prop('checked') === true) {
						multipleNewslettersData.push($el.val());
					}
				});

				formData.NewsletterSites = multipleNewslettersData.toString();
			}

			// Default URL Endpoint
			var apiUrl = '/umbraco/api/FormCapture/SubmitNewsletterSignupForm';

			var modelData = new _backbone2.default.Model({
				form: $form });

			if ((0, _jquery2.default)('body').attr('data-layout').toLowerCase() === 'group') {
				apiUrl = '/umbraco/api/FormCapture/SubmitGroupNewsletterSignupForm';
			}
			if ($form.parents('footer.footer').length !== 0) {
				apiUrl = '/umbraco/api/FormCapture/SubmitFooterNewsletterSignupForm';
			}

			_jquery2.default.ajax({
				type: 'POST',
				url: apiUrl,
				cache: false,
				data: JSON.stringify(formData),
				contentType: 'application/json',
				beforeSend: function beforeSend() {
					App.Modal.create({
						view: requestModalView,
						model: modelData });

				},
				error: function error(err) {
					modelData.set({
						status: 'error' });

				},
				success: function success() {
					modelData.set({
						status: 'destroy' });

				},
				complete: function complete(successMessage) {
					$form[0].reset();

					if (successMessage.status == 200) {
						// GA tracking
						var trackingName = $form.data('tracking') || 'Newsletter signup';
						var trackingResponse = (0, _tracking2.default)('submit', 'form', trackingName);

						window.location.replace(successMessage.responseJSON['redirectPage']);
					}

				} });


			return false;
		});
	});
};

module.exports = SignUp;

},{"./../core/views/items/request-modal-view":10,"./cookie":18,"./form-validation":20,"./tracking":45,"backbone":"backbone","backbone.marionette":"backbone.marionette","jquery":"jquery"}],31:[function(require,module,exports){
'use strict'; /**
              * Operating status checker
              *
              * author: Emil Østervig <ems@novicell.dk>
              */



var OperatingStatusBar = function OperatingStatusBar() {
    var self = {};

    self.route = '/umbraco/api/OperatingStatus/HasOperatingStatusAlerts';
    self.messageEl;
    self.messageElWrapper;
    self.intervalObj;
    self.intervalTime = 10 * 1000; // 60 seconds in milliseconds
    self.isOpen = false;


    self.init = function () {
        var messageEl = document.querySelector('.header-operation-status-alerts');
        // we need to message div to be on page to go further
        if (!messageEl) {
            return;
        }
        self.messageEl = messageEl;
        self.messageElWrapper = document.querySelector('.header-operation-status-alerts__wrapper');

        var closeEl = document.querySelector('.header-operation-status-alerts__close');
        closeEl.addEventListener('click', self.onCloseClick);

        // store interval in case we need to stop checking at some point
        self.intervalObj = setInterval(self.checkStatus, self.intervalTime);
        window.checkStatus = self.checkStatus;
        self.checkStatus();

        // resize debounce for element sizing
        var resizeDebounce = self.debounce(self.resizeHeight, 100);
        window.addEventListener('resize', resizeDebounce);
    };

    self.debounce = function (func) {var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
        var timeout = void 0;
        return function () {var _this = this;for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                func.apply(_this, args);
            }, wait);
        };
    };
    self.resizeHeight = function () {
        if (self.isOpen) {
            var innerHeight = self.messageElWrapper.offsetHeight;
            self.messageEl.style.maxHeight = innerHeight + 'px';
        }
    };

    self.onCloseClick = function () {
        self.hideStatus();
        clearInterval(self.intervalObj);
    };

    self.checkStatus = function () {
        self.fetchData().
        then(function (data) {
            if (data == false) {
                self.hideStatus();
            }
            if ('Success' in data && 'Result' in data) {
                if (data.Result == true || data.Result == 'true') {
                    self.showStatus();
                    return true;
                }
            }
            self.hideStatus();
        });
    };

    self.fetchData = function () {
        var response = fetch(self.route).
        then(function (data) {
            if (data.status !== 200) {
                return false;
            }
            return data.json();
        });
        return response;
    };


    self.hideStatus = function () {
        var innerHeight = self.messageElWrapper.offsetHeight;
        var nav = document.querySelector('.header');
        self.messageEl.style.maxHeight = '0px';
        self.messageEl.classList.remove('show');
        if (self.isOpen) {
            if (nav) {
                document.body.style.transition = "padding 300ms";
                document.body.style.paddingTop = nav.offsetHeight - innerHeight + "px";
            }
        }

        self.isOpen = false;


    };
    self.showStatus = function () {
        var innerHeight = self.messageElWrapper.offsetHeight;
        var nav = document.querySelector('.header');
        var navHeight = 0;
        if (nav) {
            navHeight = nav.offsetHeight;
        }

        self.messageEl.style.maxHeight = innerHeight + "px";
        self.messageEl.classList.add('show');

        if (self.isOpen) {
            document.body.style.transition = "padding 300ms";
            document.body.style.paddingTop = navHeight + "px";
        } else {
            document.body.style.transition = "padding 300ms";
            document.body.style.paddingTop = navHeight + innerHeight + "px";
        }
        self.isOpen = true;

    };

    self.init();
};

module.exports = OperatingStatusBar;

},{}],32:[function(require,module,exports){
'use strict'; /**
              * Operating status list
              *
              * author: Emil Østervig <ems@novicell.dk>
              */



var OperatingStatusList = function OperatingStatusList() {
    var self = {};

    self.timeout;
    self.timeoutTime = 1000 * 60 * 1; // millisecond * second * minute
    self.anchor = "operating-status-list";

    self.construct = function () {
        var target = document.getElementById(self.anchor);
        if (!target) {
            return;
        }
        // check if we have reloaded
        self.onReloaded();

        window.setTimeout(self.refresh, self.timeoutTime);
    };
    self.refresh = function () {
        var scrollDistance = document.all ? iebody.scrollTop : pageYOffset; // get currently scrolled distance
        var nav = document.querySelector('.header');
        if (nav && nav.classList.contains('is-hidden')) {
            scrollDistance -= nav.offsetHeight; // adjust for header hidden. Header will be shown on reload
        }
        sessionStorage.setItem('operating-scrolled', scrollDistance); // save it for after reload

        var timestamp = Date.now();

        // Clear and set hash
        window.location.hash = "";
        window.location.hash = self.anchor;

        // set timestamp on new url and reload
        var newUrl = self.updateQueryStringParameter(window.location.toString(), 'refresh-time', timestamp);
        window.location.href = newUrl;
        window.location.reload();
    };
    self.onReloaded = function () {
        // check if we reloaded the page via script
        if (window.location.href.indexOf("refresh-time") !== -1) {
            //window.dispatchEvent(new CustomEvent("scroll"))
            var prevScroll = sessionStorage.getItem('operating-scrolled');
            sessionStorage.removeItem('operating-scrolled');
            window.scrollTo(0, prevScroll);
        }
    };
    self.updateQueryStringParameter = function (uri, key, value) {
        var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
        var separator = uri.indexOf("?") !== -1 ? "&" : "?";
        if (uri.match(re)) {
            return uri.replace(re, "$1" + key + "=" + value + '$2');
        } else
        {
            return uri + separator + key + "=" + value;
        }
    };

    self.construct(); // run custom constructor
};

module.exports = OperatingStatusList;

},{}],33:[function(require,module,exports){
'use strict';var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var JsProductGroup = function JsProductGroup() {
    function awaitFlickity() {
        if (typeof Flickity !== 'undefined') {
            setTimeout(function () {
                initializeFlickity();
            }, 300);
        } else {
            setTimeout(function () {
                awaitFlickity();
            }, 100);
        }
    }

    var appendArrowLabels = function appendArrowLabels($item) {
        var nextLabel = $item.data('next-value');
        var prevLabel = $item.data('prev-value');

        if (!$item.find('.flickity-button').find('.flickity-button-text').length) {
            $item.find('.flickity-button.next').prepend('<span class="flickity-button-text">' + nextLabel + '</span>');
            $item.find('.flickity-button.previous').append('<span class="flickity-button-text">' + prevLabel + '</span>');
        }
    };

    var checkVisibility = function checkVisibility($item, index) {
        var cellsWidth = 0;
        $item.find('.carousel-cell').each(function (i, cell) {
            cellsWidth += (0, _jquery2.default)(cell).outerWidth();
        });

        if (cellsWidth <= $item.innerWidth()) {
            var flkty = $item.data('flickity');
            flkty.destroy();
        }
    };

    (0, _jquery2.default)(window).resize(function () {
        initializeFlickity();
    });

    function initializeFlickity() {
        (0, _jquery2.default)('.js-product-group').each(function (i, e) {
            var $item = (0, _jquery2.default)(e);
            var nextLabel = $item.data('next-value');
            var prevLabel = $item.data('prev-value');

            // Make sure we have labels
            if (!nextLabel && !prevLabel) {
                return;
            }

            // Check screen size
            var isSmallScreen = window.matchMedia('(max-width: 1024px)').matches;

            if (isSmallScreen) {
                // Destroy existing Flickity instances if already initialized
                if ($item.hasClass('flickity-enabled')) {
                    var flkty = $item.data('flickity');
                    flkty.destroy();
                }

                // Initialize Flickity and append labels
                new Flickity($item[0], { freeScroll: true, cellAlign: 'left', pageDots: false });
                appendArrowLabels($item);


                $item.on('ready', function () {
                    appendArrowLabels($item);
                    checkVisibility($item, i);
                });
            } else {
                // Destroy existing Flickity instances if not on a small screen
                if ($item.hasClass('flickity-enabled')) {
                    var _flkty = $item.data('flickity');
                    _flkty.destroy();
                }
            }
        });
    }


    awaitFlickity();
};

module.exports = JsProductGroup;

},{"jquery":"jquery"}],34:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);

var _cookie = require('./cookie');var _cookie2 = _interopRequireDefault(_cookie);
var _formValidation = require('./form-validation');var _formValidation2 = _interopRequireDefault(_formValidation);
var _tracking = require('./tracking');var _tracking2 = _interopRequireDefault(_tracking);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// Views
/**
* Quiz || Poll
*
* author: NNielsen <NNielsen@vertic.com>
*/var requestModalView = require('./../core/views/items/request-modal-view');var Quiz = function Quiz() {var $quiz = (0, _jquery2.default)('#energi-poll');var pollId = $quiz.find('.poll__quiz').attr('id');
    var $quizWrapper = $quiz.find('.poll__quiz-container');
    var $quizResultWrapper = $quiz.find('.poll__result-container');

    var itemSelected = false;
    var activeElement = void 0;

    function postResult($update) {
        // Remove poll and start loading
        $quizWrapper.hide();
        $quiz.addClass('loading');

        var modelData = new _backbone2.default.Model();

        var formData = {
            "pollid": pollId,
            "answerid": $update ? activeElement : 0,
            "updatePoll": $update,
            "rootId": window.umbracoData.RootId


            // Only show loader if the poll hasn't been answered before
        };if ($update) {
            // Create loader modal
            App.Modal.create({
                view: requestModalView,
                model: modelData });


            var answer = void 0;
            switch (activeElement) {
                case 0:
                    answer = 'a';
                    break;
                case 1:
                    answer = 'b';
                    break;
                case 2:
                    answer = 'c';
                    break;}


            (0, _tracking2.default)('click', 'answer', answer);
        }

        _jquery2.default.ajax({
            type: 'post',
            url: '/umbraco/surface/poll/answerpoll',
            cache: false,
            contentType: 'application/x-www-form-urlencoded',
            data: formData,
            error: function error(err) {
                modelData.set({
                    status: 'error' });

            },
            complete: function complete(result) {
                modelData.set({
                    status: 'destroy' });


                $quizResultWrapper.html(result.responseText);

                // Add poll result and stop loading
                $quiz.removeClass('loading');
                $quizResultWrapper.show(0, function () {
                    $quizResultWrapper.find('.poll__result__item').each(function (index, item) {
                        var val = (0, _jquery2.default)(item).find('.poll__result__item__percentage').text();
                        (0, _jquery2.default)(item).find('.poll__result__item__graph span').css('height', val);
                    });
                });

                _cookie2.default.createCookie('poll-' + pollId, 'answered', 365);

                // Initiate the newsletter signup
                signUpForm($quizResultWrapper.find('form'));
            } });

    }

    function signUpForm(element) {
        element.find('input[name="VisitorKey"]').attr('value', _cookie2.default.readCookie('cuvid'));

        element.on('submit', function (e) {
            e.preventDefault();

            var $form = (0, _jquery2.default)(e.currentTarget);

            // Lets do a validation check
            var validation = new _formValidation2.default({
                element: $form });

            if ($form.hasClass('has-validation-errors')) {
                return false;
            }

            var formData = element.serializeArray().reduce(function (obj, item) {
                obj[item.name] = item.value;
                return obj;
            }, {});

            var modelData = new _backbone2.default.Model();

            _jquery2.default.ajax({
                type: 'POST',
                url: '/umbraco/api/FormCapture/SubmitNewsletterSignupForm',
                cache: false,
                data: JSON.stringify(formData),
                contentType: 'application/json',
                beforeSend: function beforeSend() {
                    App.Modal.create({
                        view: requestModalView,
                        model: modelData });

                },
                error: function error(err) {
                    modelData.set({
                        status: 'error' });

                },
                complete: function complete(successMessage) {
                    modelData.set({
                        status: 'destroy' });


                    $form[0].reset();

                    // GA tracking
                    var trackingName = $form.data('tracking') || 'Newsletter signup after poll submit';
                    (0, _tracking2.default)('submit', 'form', trackingName);

                    window.location.replace(successMessage.responseJSON['redirectPage']);
                } });

            return false;
        });
    }

    // Select an item
    $quiz.find('.js-quiz-item').on('click', function (e) {
        var $el = (0, _jquery2.default)(e.currentTarget);

        if ($el.hasClass('active')) {
            (0, _jquery2.default)('.js-quiz-item').removeClass('active');
            $quiz.removeClass('active');

            activeElement = '';
            itemSelected = false;
        } else {
            $el.addClass('active').siblings().removeClass('active');
            $quiz.addClass('active');

            activeElement = $el.index();
            itemSelected = true;
        }
    });

    // If poll have been answered before
    if (_cookie2.default.readCookie('poll-' + pollId)) {
        postResult(false);

        return false;
    }

    // Send your response
    $quiz.find('.js-quiz-result').on('click', function () {
        // Fetch poll figures and append to DOM
        if (!itemSelected || pollId !== undefined) {
            postResult(true);
        } else {
            // Remove poll and show result
            $quizWrapper.hide();
            $quizResultWrapper.show();
        }
    });
};

module.exports = Quiz;

},{"./../core/views/items/request-modal-view":10,"./cookie":18,"./form-validation":20,"./tracking":45,"backbone":"backbone","backbone.marionette":"backbone.marionette","jquery":"jquery"}],35:[function(require,module,exports){
"use strict"; /**
              * Redirect notice modal (grid element)
              *
              * Usage:
              * Element to show/hide: .js-redirect-modal  
              * Element to trigger close: .js-redirect-modal-close
              * That's all
              *
              * author: Emil Østervig <ems@novicell.dk>
              */



var RedirectNotice = function RedirectNotice() {
    var self = {};

    self.modalEl;
    self.isOpen = false;
    self.modalDelay = 1500;
    self.storageKey = "RedirectNoticeVisited";
    self.classes = {
        selectors: {
            modal: ".js-redirect-modal",
            close: ".js-redirect-modal-close" },

        modifiers: {
            open: 'is-open' } };



    self.init = function () {
        var modalEl = document.querySelector(self.classes.selectors.modal);
        self.modalEl = modalEl;

        var closeEl = document.querySelectorAll(self.classes.selectors.close);
        for (var index = 0; index < closeEl.length; index++) {
            var element = closeEl[index];
            element.addEventListener('click', self.hideNotice);
        }

        // check if we should show the modal
        if (!modalEl || !self.supports_html5_storage() || self.wasVisited()) {
            return;
        }

        if (self.wasVisited() == false) {
            window.setTimeout(function () {
                self.showNotice();
                window.addEventListener('keyup', self.onEscapeKey);
            }, self.modalDelay);
        }
    };

    self.supports_html5_storage = function () {
        try {
            return 'localStorage' in window && window['localStorage'] !== null;
        } catch (e) {
            return false;
        }
    };

    self.onEscapeKey = function (e) {
        if (e.key == "Escape" || e.keyCode == 27) {
            self.hideNotice();
            // Remove event again
            window.removeEventListener('keyup', self.onEscapeKey);
        }
    };

    self.hideNotice = function () {
        self.setVisited();
        self.modalEl.classList.remove(self.classes.modifiers.open);
    };

    self.showNotice = function () {
        self.modalEl.classList.add(self.classes.modifiers.open);
    };

    self.setVisited = function () {
        window.localStorage.setItem(self.storageKey, 'true');
    };

    self.wasVisited = function () {
        var wasVisited = window.localStorage.getItem(self.storageKey);
        return wasVisited == 'true';
    };

    self.init();
};

module.exports = RedirectNotice;

},{}],36:[function(require,module,exports){
'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Search forms
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _underscore = require('underscore');var _underscore2 = _interopRequireDefault(_underscore);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var

Searcher = function () {
    function Searcher(opt) {_classCallCheck(this, Searcher);
        this.$el = opt.container;

        this.$resultContainer = (0, _jquery2.default)('#main-search-result');
        this.$resultItems = this.$resultContainer.find('#main-search-result__items');
        this.$resultAmount = this.$resultContainer.find('.search-results__amount span');
        this.$templateTag = this.$resultContainer.find('#js-search-result-template');

        this.template = this.$templateTag ? this.$templateTag.text() : "";
        this.searchItemIndex = 1;
        this.lastSearch = '';

        // If no backend hookup - stop here
        if (!window.umbracoData) {
            return false;
        }

        // If search parameter on DOCUMENT ready, start search immediatly
        if (this.getQueryVariable('Query')) {
            this.clearSearchList();

            var searchOnDomReady = this.getQueryVariable('Query');
            this.getMoreItems(searchOnDomReady);
            this.$el.find('input').attr('value', searchOnDomReady);
        }

        // initialize
        this.init();
    }_createClass(Searcher, [{ key: 'init', value: function init(

        searchParam) {var _this = this;
            this.$el.on('submit', function (e) {
                e.preventDefault();

                var searchRequest = _this.$el.find('input').val();

                // Validate input before going on
                if (_this.validateInput(searchRequest) === false) {
                    return false;
                }

                // If new searching, clear before moving on.
                if (searchRequest !== _this.lastSearch) {
                    _this.clearSearchList();
                }

                // Get searched items
                _this.getMoreItems(searchRequest);
            });

            // Load more items
            this.$resultContainer.find('.search-more a').on('click', function (e) {
                e.preventDefault();

                _this.getMoreItems(_this.lastSearch);
            });
        } }, { key: 'validateInput', value: function validateInput(

        request) {
            // If no seach text found
            if (request.trim().length === 0) {
                return false;
            }
        } }, { key: 'parseTemplate', value: function parseTemplate(
        data) {
            var template = this.template;
            // Replace keys from object
            Object.keys(data).forEach(function (key, index) {
                template = template.replace('{{' + key + '}}', data[key]);
            });

            // cleanup remaining template tags that wasn't found in data
            var regex = /({{\w*}})/gm;
            template.replace(regex, '');
            return template;
        } }, { key: 'getMoreItems', value: function getMoreItems(

        request) {var _this2 = this;
            // API endpoint
            var searchUrl = '/umbraco/api/search/getsearchresults?';

            // Adding search query
            searchUrl += 'Query=' + request;
            searchUrl += '&RootId=' + window.umbracoData.RootId;
            searchUrl += '&Index=' + this.searchItemIndex;
            searchUrl += '&Count=' + 10;

            _jquery2.default.ajax({
                type: 'GET',
                url: searchUrl,
                cache: false,
                error: function error(err) {
                    console.error('error on search request', err);
                },
                complete: function complete(successMessage) {
                    // Update indexing for next search
                    _this2.searchItemIndex += successMessage.responseJSON.Results.length;

                    // Update last search
                    _this2.lastSearch = request;

                    // Append search to DOM
                    _this2.$resultContainer.find('.search-results__headline').text(request);
                    _jquery2.default.each(successMessage.responseJSON.Results, function (i, obj) {
                        var resultItem = _this2.parseTemplate(obj);
                        _this2.$resultItems.append(resultItem);
                    });

                    // Set search results amount
                    _this2.$resultAmount.text(successMessage.responseJSON.ResultCount);

                    // Hide show more button
                    if (successMessage.responseJSON.HasNext === false) {
                        _this2.$resultContainer.addClass('no-more');
                    }
                } });

        } }, { key: 'clearSearchList', value: function clearSearchList()

        {
            // Reset search index and empty container
            this.searchItemIndex = 1;
            this.$resultItems.empty();

            // Show show-more button
            this.$resultContainer.removeClass('no-more');
        } }, { key: 'getQueryVariable', value: function getQueryVariable(

        variable) {
            var query = window.location.search.substring(1);
            var vars = query.split("&");

            for (var i = 0; i < vars.length; i++) {
                var pair = vars[i].split("=");
                if (pair[0] == variable) {
                    return decodeURIComponent(pair[1]);
                }
            }

            return false;
        } }]);return Searcher;}();


module.exports = Searcher;

},{"jquery":"jquery","underscore":"underscore"}],37:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var shareButton = function shareButton() {

     (0, _jquery2.default)('.share-this > button').each(function (i, e) {
          var $item = (0, _jquery2.default)(e);
          $item.on('click', function () {
               $item.addClass('active');
          });
     });

}; /**
   * Share button
   *
   * author: NNielsen <NNielsen@vertic.com>
   */module.exports = shareButton;

},{"jquery":"jquery"}],38:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _searchModalView = require('../core/views/items/search-modal-view');var _searchModalView2 = _interopRequireDefault(_searchModalView);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var JsSingleProduct = function JsSingleProduct() {
	if ((0, _jquery2.default)('.js-single-product').length > 0) {
		(0, _jquery2.default)('.js-single-product').each(function (i, e) {
			var $item = (0, _jquery2.default)(e);
			var $button = $item.find('.js-price-toggle-input');
			$button.change(function (btnE) {
				var $btn = (0, _jquery2.default)(btnE.currentTarget);
				var isEast = $btn.is(':checked');
				var activeProductType = isEast ? "east" : "west";
				var inactiveProductType = !isEast ? "east" : "west";

				$item.find('.js-product-type--' + activeProductType).show();
				$item.find('.js-product-type--' + inactiveProductType).hide();
			});
		});

	}
}; /**
    * Filter Module
    *
    * author: NNielsen <NNielsen@vertic.com>
    */(0, _jquery2.default)('.selectall').click(function () {var sectionWrapper = (0, _jquery2.default)(this).closest('.js-single-product');if ((0, _jquery2.default)(this).is(':checked')) {
		sectionWrapper.find('.product-group__price-toggle-input').attr('checked', true);
	} else {
		sectionWrapper.find('.product-group__price-toggle-input').attr('checked', false);
	}
});
module.exports = JsSingleProduct;

},{"../core/views/items/search-modal-view":11,"backbone":"backbone","jquery":"jquery"}],39:[function(require,module,exports){
'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Slider module
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _underscore = require('underscore');var _underscore2 = _interopRequireDefault(_underscore);
var _backbone = require('backbone');var _backbone2 = _interopRequireDefault(_backbone);
var _backbone3 = require('backbone.marionette');var _backbone4 = _interopRequireDefault(_backbone3);
var _handlebars = require('handlebars');var _handlebars2 = _interopRequireDefault(_handlebars);
var _velocityAnimate = require('velocity-animate');var _velocityAnimate2 = _interopRequireDefault(_velocityAnimate);
var _hammerjs = require('hammerjs');var _hammerjs2 = _interopRequireDefault(_hammerjs);
var _tracking = require('./tracking');var _tracking2 = _interopRequireDefault(_tracking);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

var template = require('./../core/templates/partials/partial-modal-tmpl.hbs');var

SliderModule = function () {
    function SliderModule(opt) {var _this = this;_classCallCheck(this, SliderModule);
        this.options = opt;
        this.$el = opt.element instanceof _jquery2.default ? opt.element : (0, _jquery2.default)(opt.element);
        this.el = this.$el.get(0);

        this.$track = this.$el.find('.slider__track');
        this.$trackItem = this.$el.find('.slider__track__item');
        this.$trackItemWidth = this.$trackItem.outerWidth();

        this.$sliderItem = (0, _jquery2.default)(this.$el).find('.slider__item');
        this.itemAmount = this.$sliderItem.length;

        this.touch = opt.touch;

        // The index of the active element
        this.activeIndex = 0;
        // Amount the track has been translated
        this.$trackTranslation = 0;
        this.duration = 200;
        //touch
        this.sensitivity = 25; // horizontal % needed to trigger swipe
        //touch end

        // Check the slider is for desktop only...
        (0, _jquery2.default)(window).on('load resize', function () {
            if (window.innerWidth <= 768 && _this.options.desktopOnly) {
                return false;
            } else {
                _this.resize();
                _this.prepare();
            }
        });
    }_createClass(SliderModule, [{ key: 'resize', value: function resize()

        {
            this.clearSlider();
            /*if (this.touch) {
                                                        this.hammer.destroy();
                                                    }
                                                    */

            // Resizing from mobile to desktop will trigger following functions
            if (this.options.pagination) {
                this.setupPagination(this.$sliderItem.length);
            }
            this.setSlideWidth();
            this.createClone();
            this.setActiveItem();
        } }, { key: 'setUpTouch', value: function setUpTouch()

        {var _this2 = this;
            if (!this.touch) {
                return false;
            } else if ((0, _jquery2.default)(this.el).hasClass('single-item')) {
                // If only one item in the slider - dont setup drag
                return false;
            }

            if (this.hammer) {
                this.hammer.destroy();
            }

            // 4d. Set up HammerJS
            // Disable dragging to better enable HammerJS panning
            this.$el.find('a').add('img').attr('draggable', false);

            setTimeout(function () {
                this.$el.on('click', function (e) {
                    if (this.$track.hasClass('velocity-animating')) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }.bind(this));
            }.bind(this), 0);

            this.hammer = new _hammerjs2.default(this.el, {
                dragLockToAxis: true,
                dragBlockHorizontal: true });


            this.hammer.on('release dragleft dragright swipeleft swiperight', function (e) {
                // Show that we are sliding
                if (!_this2.$track.hasClass('is-sliding')) {
                    _this2.$track.addClass('is-sliding');
                }

                // 4e. Calculate pixel movements into 1:1 screen percents so gestures track with motion
                var percentage = 100 / _this2.itemAmount * e.deltaX / window.innerWidth;

                // 4f. Multiply percent by # of slide we’re on
                var percentageCalculated = percentage - 100 / _this2.itemAmount * _this2.activeSlide;

                // 4g. Apply transformation
                _this2.el.style.transform = 'translateX( ' + percentageCalculated + '% )';

                // 4h. Snap to slide when done
                // rotateSlider(direction)
                if (e.isFinal) {
                    if (e.velocityX > 1) {
                        _this2.rotateSlider('prev');
                    } else if (e.velocityX < -1) {
                        _this2.rotateSlider('next');
                    } else
                    {
                        if (percentage <= -(_this2.sensitivity / _this2.itemAmount))
                        _this2.rotateSlider('next');else
                        if (percentage >= _this2.sensitivity / _this2.itemAmount)
                        _this2.rotateSlider('prev');
                    }

                    _this2.$track.removeClass('is-sliding');
                }
            });
        } }, { key: 'prepare', value: function prepare()

        {var _this3 = this;
            // Buttons
            this.$el.find('button.next').on('click', function () {
                _this3.rotateSlider('next');
            });
            this.$el.find('button.prev').on('click', function () {
                _this3.rotateSlider('prev');
            });

            // Custom events
            this.$el.on('setSlideWidth', function () {
                _this3.setSlideWidth();
                _this3.rotateSlider();
            });

            if (this.options.pagination) {
                this.setupPagination(this.$sliderItem.length);
            }

            this.setSlideWidth();
            this.createClone();

            this.setActiveItem();

            if (this.touch) {
                this.setUpTouch();
            }
        } }, { key: 'setSlideWidth', value: function setSlideWidth()

        {
            // Resetting width
            this.$trackItem.width('');
            this.$sliderItem.width('');

            // Store width of track item
            this.$trackItemWidth = this.$el.find('.sizer').innerWidth() * this.itemAmount;

            // If desktop only and window not a desktop
            /*if (this.options.desktopOnly && window.innerWidth <= 768) {
                return false;
            } */
            // Adding width to track items & slide items
            this.$el.find('.slider__track__item').width(this.$trackItemWidth);
            this.$el.find('.slider__item').width(this.$el.width() / this.itemAmount / this.$el.width() * 100 + '%');
        } }, { key: 'createClone', value: function createClone()

        {
            // Create clones
            this.$cloneTrackBefore = this.$trackItem.clone();
            this.$cloneTrackAfter = this.$trackItem.clone();

            // Append clones to DOM
            this.$trackItem.before(this.$cloneTrackBefore);
            this.$trackItem.after(this.$cloneTrackAfter);

            // Update translation value on track
            this.$trackTranslation = parseInt(this.$trackItem.outerWidth() * -1);

            // Translate slidertrack equal to the "before" clone
            this.$track.css({
                transform: 'translateX(' + this.$trackTranslation + 'px)' });

        } }, { key: 'setActiveItem', value: function setActiveItem(

        direction) {
            // Set active index
            if (direction === 'prev') {
                this.activeIndex--;
                if (this.activeIndex === -1) this.activeIndex = this.itemAmount - 1;
            } else if (direction === 'next') {
                this.activeIndex++;
                if (this.activeIndex === this.itemAmount) this.activeIndex = 0;
            } else {
                this.activeIndex = 0;
            }

            // Pagination update
            if (this.options.pagination) {
                this.$el.find('.slider__pagination__item').removeClass('active');
                this.$el.find('.slider__pagination__item').eq(this.activeIndex).addClass('active');
            }
        } }, { key: 'rotateSlider', value: function rotateSlider(

        direction) {var _this4 = this;
            var slideWidth = this.$sliderItem.outerWidth();

            if (direction === 'prev') {
                this.setActiveItem('prev');

                this.$trackTranslation = this.$trackTranslation + slideWidth;

                // Check for stepping into a clone item
                if (-this.$trackItemWidth < this.$trackTranslation) {
                    // Update track translation value
                    this.$trackTranslation = (this.$trackItemWidth + slideWidth * (this.itemAmount - 1)) * -1;

                    // Slide to new value inside cloned area
                    _velocityAnimate2.default.animate(this.$track, {
                        translateX: this.$trackItemWidth * 2 * -1 },
                    {
                        duration: 0,
                        complete: function complete() {
                            _velocityAnimate2.default.animate(_this4.$track, {
                                translateX: (_this4.$trackItemWidth + slideWidth * (_this4.itemAmount - 1)) * -1 },
                            {
                                duration: _this4.duration });

                        } });


                } else {
                    // Translate to new value
                    _velocityAnimate2.default.animate(this.$track, {
                        translateX: this.$trackTranslation },
                    {
                        duration: this.duration });

                }

                (0, _tracking2.default)('click', 'slider ' + this.$el.data('tracking-name') + '', 'backwards');
            } else if (direction === 'next') {
                this.setActiveItem('next');

                // Check for stepping into a clone item
                if (this.$trackTranslation < (this.$trackItemWidth + (slideWidth * this.itemAmount - 1)) * -1) {
                    // Update track translation value
                    this.$trackTranslation = parseInt(this.$trackItemWidth * -1);

                    // Jump back to original no. 1 before translating to new value
                    _velocityAnimate2.default.animate(this.$track, {
                        translateX: this.$trackItemWidth * -1 },
                    {
                        duration: 0,
                        complete: function complete() {
                            _velocityAnimate2.default.animate(_this4.$track, {
                                translateX: _this4.$trackTranslation },
                            {
                                duration: _this4.duration });

                        } });

                } else {
                    // Translate to new value
                    _velocityAnimate2.default.animate(this.$track, {
                        translateX: [this.$trackTranslation - slideWidth, this.$trackTranslation] },
                    {
                        duration: this.duration });

                }

                this.$trackTranslation = this.$trackTranslation - slideWidth;

                (0, _tracking2.default)('click', 'slider: ' + this.$el.data('tracking-name') + '', 'forward');
            } else {
                this.$trackTranslation = (this.$trackItemWidth + this.activeIndex * slideWidth) * -1;

                // Rotate back to active slide
                _velocityAnimate2.default.animate(this.$track, {
                    translateX: this.$trackTranslation },
                {
                    duration: 0 });

            }
        } }, { key: 'setupPagination', value: function setupPagination(

        count) {
            var paginationName = 'slider__pagination';

            if (this.$el.find('.' + paginationName).length > 0) {
                return;
            }

            var $pagination = (0, _jquery2.default)('<nav class="' + paginationName + '"><ul></ul></div>');

            this.$el.append($pagination);
            var $paginationEl = this.$el.find('.' + paginationName);

            var i = 0;
            while (i < count) {
                $paginationEl.children().append('<li><button class="slider__pagination__item"></button></li>');

                if (i === this.activeIndex) {
                    this.$el.find('.slider__pagination__item').eq(i).addClass('active');
                }

                i++;
            }
        } }, { key: 'clearSlider', value: function clearSlider()

        {
            this.$el.find('.slider__pagination').remove();

            this.$track.removeAttr('style');
            this.$trackItem.removeAttr('style').siblings().remove();
            this.$sliderItem.removeAttr('style');

            this.$el.find('button.slider__control').off('click');
        } }]);return SliderModule;}();


module.exports = SliderModule;

},{"./../core/templates/partials/partial-modal-tmpl.hbs":7,"./tracking":45,"backbone":"backbone","backbone.marionette":"backbone.marionette","hammerjs":393,"handlebars":"handlebars","jquery":"jquery","underscore":"underscore","velocity-animate":"velocity-animate"}],40:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var Specialist = function Specialist() {
    var breakpoint = 768;
    setTimeout(function () {

        (0, _jquery2.default)('.slider').each(function (i, e) {

            (0, _jquery2.default)(e).delegate('.specialistbox__box', 'click', function (element) {
                var $element = (0, _jquery2.default)(element.target);

                // If currently panning between items
                if ($element.parents('.is-animating').length !== 0) {
                    return false;
                }

                if (window.innerWidth <= breakpoint) {
                    // Stop if clicking a link
                    if ($element[0].hasAttribute("href") || 0 < $element.parents('a').length) {
                        return;
                    } else {
                        (0, _jquery2.default)(element.currentTarget).parents('.specialistbox').toggleClass('active');
                    }
                }
            });

        });
    }, 0);
}; /**
   * Specialist-module
   *
   * author: NNielsen <nnielsen@vertic.com>
   */module.exports = Specialist;

},{"jquery":"jquery"}],41:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var JsFilter = function JsFilter() {
	(0, _jquery2.default)('.tab-component').each(function (i, e) {
		var $item = (0, _jquery2.default)(e);
		var $buttons = $item.find('.tab-component__nav__button');
		var $chosen = $item.find('.tab-component__nav__chosen');
		var $slides = $item.find('.tab-component__box');

		var dropdownOpen = false;

		// Main filter navigation
		$buttons.on('click', function (e) {
			var $currentItem = (0, _jquery2.default)(e.currentTarget);

			// Remove class from all
			$buttons.removeClass('active');
			// Add class to active element
			$currentItem.addClass('active');

			// Close dropdown if open
			if (dropdownOpen) {
				$chosen.removeClass('active');
				$chosen.text($currentItem.text());
			}

			setActiveSlide($currentItem.parent().index());
		});

		$chosen.on('click', function (e) {
			var $element = (0, _jquery2.default)(e.currentTarget);

			if ($element.hasClass('active')) {
				$element.removeClass('active');

				dropdownOpen = false;
			} else {
				$chosen.removeClass('active');
				$element.addClass('active');

				dropdownOpen = true;
			}
		});

		function setActiveSlide(i) {
			$slides.removeClass('active').eq(i).addClass('active');
		}
	});
}; /**
   * Filter Module
   *
   * author: NNielsen <NNielsen@vertic.com>
   */module.exports = JsFilter;

},{"jquery":"jquery"}],42:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var Table = function Table() {

    (0, _jquery2.default)('table').each(function () {
        (0, _jquery2.default)(this).parent().css('overflow-x', 'auto');
    });
}; /**
   * Fix table overflow on mobile devices
   *
   * author: MBramming <MBramming@vertic.com>
   */module.exports = Table;

},{"jquery":"jquery"}],43:[function(require,module,exports){
'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Filtering module
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}var

TogglerNavigation = function () {
	function TogglerNavigation(opt) {_classCallCheck(this, TogglerNavigation);
		this.options = opt;
		this.$el = opt.element instanceof _jquery2.default ? opt.element : (0, _jquery2.default)(opt.element);

		this.$button = this.$el.find('.toggler__nav__item');
		this.$item = this.$el.find('.toggler__item');

		this.slideLength = this.$item.length;

		this.createDom();
		this.setEvents();
		this.init();
	}_createClass(TogglerNavigation, [{ key: 'createDom', value: function createDom()

		{
			for (var i = 0; i < this.slideLength; i++) {
				var $btn = this.$button.eq(i);
				var $slide = this.$item.eq(i);

				if (i === 0) {
					$slide.add($btn).addClass('active');
				}

				$btn.attr('data-filter', i);
				$slide.attr('data-item', i);
			}
		} }, { key: 'setEvents', value: function setEvents()

		{var _this = this;
			this.$button.on('click', function (e) {
				var targetNumb = (0, _jquery2.default)(e.currentTarget).data('filter');

				_this.$item.add(_this.$button).removeClass('active');

				_this.$item.eq(targetNumb).addClass('active');
				_this.$button.eq(targetNumb).addClass('active');

				// If containing a slider. Calculate slider items width on button click
				if (_this.$el.find('.slider').length !== 0) {
					_this.$el.find('.slider').trigger('setSlideWidth');
				}
			});

			(0, _jquery2.default)(window).on('load resize', function () {
				if (window.innerWidth <= 768) {
					_this.$el.width(_this.slideLength * 100 + '%');
				} else {
					_this.$el.width('');
				}
			});
		} }, { key: 'init', value: function init()

		{
			this.$item.removeClass('active');
			this.$item.first().addClass('active');

			// If containing a slider. Calculate slider items width
			if (this.$el.find('.slider').length !== 0) {
				this.$el.find('.slider').trigger('setSlideWidth');
			}
		} }, { key: 'destroy', value: function destroy()

		{
			this.$item.show();
			this.$item.add(this.$button).removeClass('active');
		} }]);return TogglerNavigation;}();


module.exports = TogglerNavigation;

},{"jquery":"jquery"}],44:[function(require,module,exports){
'use strict';var _createClass = function () {function defineProperties(target, props) {for (var i = 0; i < props.length; i++) {var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);}}return function (Constructor, protoProps, staticProps) {if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;};}(); /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * Touch slider
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   * author: NNielsen <NNielsen@vertic.com>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                   */

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _hammerjs = require('hammerjs');var _hammerjs2 = _interopRequireDefault(_hammerjs);
var _tracking = require('./tracking');var _tracking2 = _interopRequireDefault(_tracking);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}

'use strict';var

TouchSlider = function () {
    function TouchSlider(opt) {var _this = this;_classCallCheck(this, TouchSlider);
        this.$el = opt.container instanceof _jquery2.default ? opt.container : (0, _jquery2.default)(opt.container);
        this.$track = opt.element ? this.$el.find(opt.element) : this.$el;
        this.$touchItem = opt.item ? this.$el.find(opt.item) : this.$track.children()[0];
        this.$pagination = opt.pagination ? this.$el.find(opt.pagination) : this.$track.next();

        this.$sliderPanelSelector = this.$touchItem;
        this.$sliderPaginationSelector = this.$pagination;

        this.sensitivity = 25; // horizontal % needed to trigger swipe

        this.SliderActive = false;

        // 2. Placeholder to remember which slide we’re on
        this.activeSlide = 0;

        // 3. Slide counter
        this.slideCount = 0;

        (0, _jquery2.default)(window).on('load resize', function () {
            _this.onSliderResize();
        });

        // Disable dragging to better enable HammerJS panning
        this.$el.find('a').add('img').attr('draggable', false);

        // Custom controls for Specialist Slider
        if (this.$el.find('.custom-control').length !== 0) {
            this.$el.on('click', '.custom-control.prev', function () {
                _this.goTo(_this.activeSlide - 1);
            });

            this.$el.on('click', '.custom-control.next', function () {
                _this.goTo(_this.activeSlide + 1);
            });
        }

        // Initialize
        this.init(this.$track);
    }

    // 4. Initialization + event listener
    _createClass(TouchSlider, [{ key: 'init', value: function init(selector) {var _this2 = this;
            if (this.SliderActive) {
                return false;
            }
            this.SliderActive = true;

            // 4a. Find the container
            this.sliderEl = selector.get(0);

            // 4b. Count stuff
            this.slideCount = this.$sliderPanelSelector.length;

            // 4c. Populate pagination
            this.$sliderPaginationSelector.html('');

            this.$track.css({
                "width": this.slideCount * 100 + '%' });


            var n = 0;
            for (n; n < this.slideCount; n++) {
                var activeStatus = n == this.activeSlide ? ' class="is-active"' : '';
                this.$sliderPaginationSelector.append('<div ' + activeStatus + '></div>');
            }

            setTimeout(function () {
                this.$el.on('click.slider', function (e) {
                    if (this.$track.hasClass('velocity-animating')) {
                        e.preventDefault();
                        e.stopPropagation();
                    }
                }.bind(this));
            }.bind(this), 0);

            this.sliderManager = new _hammerjs2.default(this.sliderEl, {
                touchAction: 'pan-y',
                domEvents: false });

            this.sliderManager.add(new _hammerjs2.default.Pan({
                threshold: 0,
                pointers: 0 }));


            var startTranslateX = null;

            // HammerJS panstart event listener
            this.sliderManager.on('panstart', function (e) {
                // Show that we are sliding
                if (!_this2.$track.hasClass('is-sliding')) {
                    _this2.$track.addClass('is-sliding');
                }
                var transform = _this2.sliderEl.style.transform;
                var transformSplitted = transform ? transform.split('(')[1].split(',') : [0];

                startTranslateX = parseFloat(transformSplitted[0]) + e.deltaX;
            });

            // HammerJS pan event listener
            this.sliderManager.on('pan', function (e) {

                var transform = _this2.sliderEl.style.transform;
                var transformSplitted = transform ? transform.split('(')[1].split(',') : [0];
                var currentTranslateX = parseFloat(transformSplitted[0]);

                if (e.additionalEvent === 'panup' || e.additionalEvent === 'pandown' || e.velocity === 0) {
                    if (e.isFinal && Math.abs(startTranslateX - currentTranslateX) > 0) {
                        // let slideIndex = this.current;

                        if (currentTranslateX > startTranslateX) {
                            // slideIndex = Math.max(0, this.current - 1);
                        } else if (currentTranslateX < startTranslateX) {

                        } // slideIndex = Math.min(this.totalSlides - 1, this.current + 1);

                        // this.goToSlide(slideIndex, e.distance < 20);
                    }

                    return;
                }

                // 4e. Calculate pixel movements into 1:1 screen percents so gestures track with motion
                var percentage = 100 / _this2.slideCount * e.deltaX / window.innerWidth;

                // 4f. Multiply percent by # of slide we’re on
                var percentageCalculated = percentage - 100 / _this2.slideCount * _this2.activeSlide;

                // 4g. Apply transformation
                _this2.sliderEl.style.transform = 'translateX( ' + percentageCalculated + '% )';

                // 4h. Snap to slide when done
                if (e.isFinal) {
                    if (e.velocityX > 1) {
                        _this2.goTo(_this2.activeSlide - 1);
                    } else if (e.velocityX < -1) {
                        _this2.goTo(_this2.activeSlide + 1);
                    } else {
                        if (percentage <= -(_this2.sensitivity / _this2.slideCount))
                        {_this2.goTo(_this2.activeSlide + 1);} else
                        if (percentage >= _this2.sensitivity / _this2.slideCount)
                        {_this2.goTo(_this2.activeSlide - 1);} else

                        {_this2.goTo(_this2.activeSlide);}
                    }

                    _this2.$track.removeClass('is-sliding');
                }
            });
        } }, { key: 'onSliderResize', value: function onSliderResize()

        {
            if (window.innerWidth <= 768) {
                this.init(this.$track);
            } else {
                this.break();
            }
        } }, { key: 'break', value: function _break()

        {
            if (this.sliderManager) {
                this.sliderManager.destroy();
                this.SliderActive = false;
                this.activeSlide = 0;
                this.$track.removeClass('is-animating').attr('style', '');
            }
        } }, { key: 'goTo',

        // 5. Update current slide
        value: function goTo(number) {var _this3 = this;
            // Get direction 
            if (this.activeSlide < number) {
                (0, _tracking2.default)('click', 'slider: ' + this.$track.data('tracking-name') + '', 'forward');
            } else if (this.activeSlide > number) {
                (0, _tracking2.default)('click', 'slider: ' + this.$track.data('tracking-name') + '', 'backwards');
            }

            // 5a. Stop it from doing weird things like moving to slides that don’t exist
            if (number < 0) {
                this.activeSlide = 0;
            } else if (number > this.slideCount - 1) {
                this.activeSlide = this.slideCount - 1;
            } else {
                this.activeSlide = number;
            }

            // 5b. Apply transformation & smoothly animate via .is-animating CSS
            this.sliderEl.classList.add('is-animating');

            var percentage = -(100 / this.slideCount) * this.activeSlide;
            this.sliderEl.style.transform = 'translateX( ' + percentage + '% )';

            clearTimeout(this.timer);
            this.timer = setTimeout(function () {
                _this3.sliderEl.classList.remove('is-animating');
            }, 400);

            // 5c. Update the counters
            var pagination = this.$sliderPaginationSelector.find(' > *');
            var n = 0;
            for (n; n < pagination.length; n++) {
                var className = n == this.activeSlide ? 'is-active' : '';
                pagination[n].className = className;
            }
        } }]);return TouchSlider;}();
;

module.exports = TouchSlider;

},{"./tracking":45,"hammerjs":393,"jquery":"jquery"}],45:[function(require,module,exports){
'use strict';





var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var Tracking = function Tracking(action, category, label) {
	function sendTrackingEvent(tAction, tCategory, tLabel) {
		if (window.pageOptions && window.gtag) {
			window.gtag('event', tAction, {
				event_category: tCategory,
				event_label: tLabel });

		}
	}

	if (action && category && label) {
		sendTrackingEvent(action, category, label);
	}

	// Events

	// Types of social items (as part of the class ga-social--[socialItems])
	var socialItems = ['facebook', 'linkedin', 'twitter', 'vimeo'];
	(0, _jquery2.default)('.ga-social').on('click', function (e) {
		e.preventDefault();
		var $this = (0, _jquery2.default)(e.currentTarget);

		var str = $this.attr('class').toLowerCase();

		socialItems.forEach(function (item) {
			if (str.indexOf(item) >= 0) {
				switch (item) {
					case 'facebook':
						sendTrackingEvent('click', 'social', 'facebook');
						break;

					case 'youtube':
						sendTrackingEvent('click', 'social', 'youtube');
						break;

					case 'linkedin':
						sendTrackingEvent('click', 'social', 'linkedin');
						break;

					case 'vimeo':
						sendTrackingEvent('click', 'social', 'vimeo');
						break;

					default:
						break;}

			}
		});

		// If a link - open link in a new window
		if ($this.is('[href]')) {
			window.open($this.attr('href'), '_blank');
		}
	});

	// Specialist contacts
	(0, _jquery2.default)('.ga-specialist-tracking').on('click', function (e) {
		var $this = (0, _jquery2.default)(e.currentTarget);

		var trackingType = $this.data('tracking').toLowerCase();
		var specialist = $this.data('tracking-specialist') || 'unknown';

		switch (trackingType) {
			case 'phone':
				sendTrackingEvent('click', 'contact phone', specialist);
				break;

			case 'email':
				sendTrackingEvent('click', 'contact email', specialist);
				break;

			case 'cellphone':
				sendTrackingEvent('click', 'contact cellphone', specialist);
				break;

			case 'linkedin':
				sendTrackingEvent('click', 'contact linkedin', specialist);
				break;

			default:
				break;}

	});

	// File download
	(0, _jquery2.default)('.pdf-download a').on('click', function (e) {
		sendTrackingEvent('click', 'File download', e.currentTarget.getAttribute('data-fileName'));
	});

	// M34 Business puzzle
	(0, _jquery2.default)('.business__puzzle__item').on('click', function (e) {
		sendTrackingEvent('click', 'M34 Business tiles', e.currentTarget.getElementsByTagName('h5')[0].innerText);
	});

	// Outbound links
	(0, _jquery2.default)('a').on('click', function (e) {
		var $this = (0, _jquery2.default)(e.currentTarget);
		var eTarget = $this.attr('href');

		if (
		eTarget && (
		eTarget.includes(window.location.host) ||
		eTarget.charAt(0) === '/' ||
		eTarget.charAt(0) === '#' ||
		eTarget.indexOf('tel:') !== -1 ||
		eTarget.indexOf('mailto:') !== -1))
		{
			return;
		}

		sendTrackingEvent('click', 'outbound link', eTarget);
	});
}; /**
   * Google analytics tracking
   *
   * author: NNielsen <NNielsen@vertic.com>
   */module.exports = Tracking;

},{"jquery":"jquery"}],46:[function(require,module,exports){
'use strict';

















require('babel-polyfill');

var _jquery = require('jquery');var _jquery2 = _interopRequireDefault(_jquery);
var _vue = require('vue');var _vue2 = _interopRequireDefault(_vue);
var _veeValidate = require('vee-validate/dist/vee-validate.full');var VeeValidate = _interopRequireWildcard(_veeValidate);
var _rules = require('vee-validate/dist/rules.umd');





var _veeValidate2 = require('vee-validate');var _veeValidate3 = _interopRequireDefault(_veeValidate2);

var _app = require('./app');var _app2 = _interopRequireDefault(_app);
var _tracking = require('./framework/tracking');var _tracking2 = _interopRequireDefault(_tracking);
var _dawaAutocomplete = require('dawa-autocomplete2');var _dawaAutocomplete2 = _interopRequireDefault(_dawaAutocomplete);


var _mobileMenu = require('./framework/mobile-menu');var _mobileMenu2 = _interopRequireDefault(_mobileMenu);
var _navigation = require('./framework/navigation');var _navigation2 = _interopRequireDefault(_navigation);
var _cookieDisclaimer = require('./framework/cookie-disclaimer');var _cookieDisclaimer2 = _interopRequireDefault(_cookieDisclaimer);

var _quiz = require('./framework/quiz');var _quiz2 = _interopRequireDefault(_quiz);
var _news = require('./framework/news');var _news2 = _interopRequireDefault(_news);
var _sharebutton = require('./framework/sharebutton');var _sharebutton2 = _interopRequireDefault(_sharebutton);
var _specialistModule = require('./framework/specialist-module');var _specialistModule2 = _interopRequireDefault(_specialistModule);
var _inlineVideo = require('./framework/inline-video');var _inlineVideo2 = _interopRequireDefault(_inlineVideo);
var _table = require('./framework/table');var _table2 = _interopRequireDefault(_table);
var _mosaic = require('./framework/mosaic');var _mosaic2 = _interopRequireDefault(_mosaic);
var _accordion = require('./framework/accordion');var _accordion2 = _interopRequireDefault(_accordion);
var _filter = require('./framework/filter');var _filter2 = _interopRequireDefault(_filter);
var _tabComponent = require('./framework/tab-component');var _tabComponent2 = _interopRequireDefault(_tabComponent);
var _jsSorting = require('./framework/js-sorting');var _jsSorting2 = _interopRequireDefault(_jsSorting);
var _togglerNav = require('./framework/toggler-nav');var _togglerNav2 = _interopRequireDefault(_togglerNav);
var _heroThumbnails = require('./framework/hero-thumbnails');var _heroThumbnails2 = _interopRequireDefault(_heroThumbnails);
var _singleProduct = require('./framework/single-product');var _singleProduct2 = _interopRequireDefault(_singleProduct);
var _productGroup = require('./framework/product-group');var _productGroup2 = _interopRequireDefault(_productGroup);

var _slider = require('./framework/slider');var _slider2 = _interopRequireDefault(_slider);
var _touchSlider = require('./framework/touch-slider');var _touchSlider2 = _interopRequireDefault(_touchSlider);
var _caseSlider = require('./framework/case-slider');var _caseSlider2 = _interopRequireDefault(_caseSlider);

var _contactForm = require('./framework/contact-form');var _contactForm2 = _interopRequireDefault(_contactForm);
var _searchForm = require('./framework/search-form');var _searchForm2 = _interopRequireDefault(_searchForm);
var _newsletterForm = require('./framework/newsletter-form');var _newsletterForm2 = _interopRequireDefault(_newsletterForm);

var _operatingStatusBar = require('./framework/operating-status-bar');var _operatingStatusBar2 = _interopRequireDefault(_operatingStatusBar);
var _operatingStatusList = require('./framework/operating-status-list');var _operatingStatusList2 = _interopRequireDefault(_operatingStatusList);

var _cloakHiddenDirective = require('./vueDirectives/cloakHiddenDirective');var _cloakHiddenDirective2 = _interopRequireDefault(_cloakHiddenDirective);
var _VeProductOrderApp = require('./vueComponents/VeProductOrderApp');var _VeProductOrderApp2 = _interopRequireDefault(_VeProductOrderApp);
var _VeCallMeFormApp = require('./vueComponents/VeCallMeFormApp');var _VeCallMeFormApp2 = _interopRequireDefault(_VeCallMeFormApp);
var _VeCallMeForm = require('./vueComponents/VeCallMeForm');var _VeCallMeForm2 = _interopRequireDefault(_VeCallMeForm);


var _VeInput = require('./vueComponents/VeInput');var _VeInput2 = _interopRequireDefault(_VeInput);
var _VeAddressInput = require('./vueComponents/VeAddressInput');var _VeAddressInput2 = _interopRequireDefault(_VeAddressInput);
var _VeInputComment = require('./vueComponents/VeInputComment');var _VeInputComment2 = _interopRequireDefault(_VeInputComment);
var _VeInputTooltip = require('./vueComponents/VeInputTooltip');var _VeInputTooltip2 = _interopRequireDefault(_VeInputTooltip);
var _VeRadio = require('./vueComponents/VeRadio');var _VeRadio2 = _interopRequireDefault(_VeRadio);
var _VeCheck = require('./vueComponents/VeCheck');var _VeCheck2 = _interopRequireDefault(_VeCheck);
var _VeRadioGroup = require('./vueComponents/VeRadioGroup');var _VeRadioGroup2 = _interopRequireDefault(_VeRadioGroup);
var _VeButton = require('./vueComponents/VeButton');var _VeButton2 = _interopRequireDefault(_VeButton);
var _VeDatepicker = require('./vueComponents/VeDatepicker');var _VeDatepicker2 = _interopRequireDefault(_VeDatepicker);
var _VeForm = require('./vueComponents/VeForm');var _VeForm2 = _interopRequireDefault(_VeForm);
var _VeFormStep = require('./vueComponents/VeFormStep');var _VeFormStep2 = _interopRequireDefault(_VeFormStep);
var _VeSectionPlaceholder = require('./vueComponents/VeSectionPlaceholder');var _VeSectionPlaceholder2 = _interopRequireDefault(_VeSectionPlaceholder);
var _VeTooltip = require('./vueComponents/VeTooltip');var _VeTooltip2 = _interopRequireDefault(_VeTooltip);
var _VeRadioListValidator = require('./vueComponents/VeRadioListValidator');var _VeRadioListValidator2 = _interopRequireDefault(_VeRadioListValidator);


var _redirectNotice = require('./framework/redirect-notice');var _redirectNotice2 = _interopRequireDefault(_redirectNotice);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

// import Parallax from './framework/parallax';

// Override the default messages.

//VeeValidate.localize('da', da);
// import * as VeeRules from 'vee-validate/dist/rules.umd.js';
/*
 * Vertic JS - Site functional wrapper
 * http://labs.vertic.com
 *
 * Copyright 2015, Vertic A/S
 *
 *
 * NAMING CONVENTIONS:
 * -------------------
 * Singleton-literals and prototype objects:  PascalCase
 *
 * Functions and public variables:            camelCase
 *
 * Global variables and constants:            UPPERCASE
 *
 * Private variables:                         _underscorePrefix
 */_vue2.default.component('ValidationObserver', VeeValidate.ValidationObserver);_vue2.default.component('ValidationProvider', VeeValidate.ValidationProvider);(0, _jquery2.default)(function () {_app2.default.start();(0, _tracking2.default)(); // Navigation
	(0, _navigation2.default)();(0, _mobileMenu2.default)();(0, _cookieDisclaimer2.default)(); // Filtering
	(0, _filter2.default)();(0, _tabComponent2.default)();(0, _jsSorting2.default)();(0, _accordion2.default)();(0, _heroThumbnails2.default)();

	// Elements
	(0, _specialistModule2.default)();
	(0, _quiz2.default)();
	(0, _news2.default)();
	(0, _sharebutton2.default)();
	(0, _table2.default)();
	(0, _singleProduct2.default)();
	(0, _productGroup2.default)();
	(0, _redirectNotice2.default)();

	// Submissions
	(0, _contactForm2.default)();
	(0, _newsletterForm2.default)();

	(0, _cloakHiddenDirective2.default)();
	(0, _VeInput2.default)();
	(0, _VeAddressInput2.default)();
	(0, _VeInputComment2.default)();
	(0, _VeInputTooltip2.default)();
	(0, _VeRadio2.default)();
	(0, _VeCheck2.default)();
	(0, _VeRadioGroup2.default)();
	(0, _VeButton2.default)();
	(0, _VeDatepicker2.default)();
	(0, _VeForm2.default)();
	(0, _VeFormStep2.default)();
	(0, _VeSectionPlaceholder2.default)();
	(0, _VeTooltip2.default)();
	(0, _VeRadioListValidator2.default)();

	// Operating status
	(0, _operatingStatusBar2.default)();
	(0, _operatingStatusList2.default)();

	(0, _VeProductOrderApp2.default)();

	//Call me
	(0, _VeCallMeForm2.default)();

	(0, _VeCallMeFormApp2.default)();


	// Main search page
	(0, _jquery2.default)('#main-search').each(function (i, e) {
		new _searchForm2.default({ // eslint-disable-line no-new
			container: (0, _jquery2.default)(e) });

	});

	(0, _jquery2.default)('.js-mosaic').each(function (i, e) {
		new _mosaic2.default({ // eslint-disable-line no-new
			element: (0, _jquery2.default)(e) });

	});

	(0, _jquery2.default)('.js-slider').each(function (i, e) {
		new _slider2.default({ // eslint-disable-line no-new
			element: e,
			pagination: true,
			touch: true });

	});

	(0, _jquery2.default)('.js-case-slider').each(function (i, e) {
		new _caseSlider2.default({ // eslint-disable-line no-new
			element: e,
			touch: true,
			pagination: true,
			paginationPrefix: 'case-slider__pagination' });

	});

	// Slide on both desktop and mobile (touch)
	(0, _jquery2.default)('.js-allslide').each(function (i, e) {
		new _slider2.default({ // eslint-disable-line no-new
			element: e,
			pagination: true,
			touch: true });

	});

	(0, _jquery2.default)('.inline-video').each(function (i, e) {
		new _inlineVideo2.default({ // eslint-disable-line no-new
			element: e });

	});

	(0, _jquery2.default)('.hero__video').each(function (i, e) {
		if (!e.hasAttribute('data-video')) {
			return;
		}

		new _inlineVideo2.default({ // eslint-disable-line no-new
			element: e,
			cleanPlayer: true });

	});

	/**
          * Specialist slider
          * (Desktop normal - mobile with new controls)
          */

	(0, _jquery2.default)('.js-slider-desktop').each(function (i, e) {
		new _slider2.default({ // eslint-disable-line no-new
			element: e,
			pagination: true,
			touch: true,
			desktopOnly: true });

	});

	(0, _jquery2.default)('.js-toggler').each(function (i, e) {
		new _togglerNav2.default({ // eslint-disable-line no-new
			element: e });


		if ((0, _jquery2.default)(e).closest('.toggler-wrapper').length !== 0) {
			// Initialize mobile slider
			new _touchSlider2.default({ // eslint-disable-line no-new
				container: (0, _jquery2.default)(e).closest('.toggler-wrapper'),
				element: e,
				item: '.toggler__item',
				pagination: '.mb-pagination' });

		}
	});

	// Remove titles from internal links
	(0, _jquery2.default)('a[data-udi][title]').each(function (i, e) {
		(0, _jquery2.default)(e).removeAttr('title');
	});

	(0, _jquery2.default)('#navbar-search').submit(function (e) {
		e.preventDefault();
		var $form = (0, _jquery2.default)(this);
		var value = $form.find('input').val();

		// Redirect
		window.location.href = this.action + '?Query=' + value;
	});
});

},{"./app":1,"./framework/accordion":14,"./framework/case-slider":15,"./framework/contact-form":16,"./framework/cookie-disclaimer":17,"./framework/filter":19,"./framework/hero-thumbnails":21,"./framework/inline-video":22,"./framework/js-sorting":23,"./framework/mobile-menu":25,"./framework/mosaic":27,"./framework/navigation":28,"./framework/news":29,"./framework/newsletter-form":30,"./framework/operating-status-bar":31,"./framework/operating-status-list":32,"./framework/product-group":33,"./framework/quiz":34,"./framework/redirect-notice":35,"./framework/search-form":36,"./framework/sharebutton":37,"./framework/single-product":38,"./framework/slider":39,"./framework/specialist-module":40,"./framework/tab-component":41,"./framework/table":42,"./framework/toggler-nav":43,"./framework/touch-slider":44,"./framework/tracking":45,"./vueComponents/VeAddressInput":47,"./vueComponents/VeButton":48,"./vueComponents/VeCallMeForm":49,"./vueComponents/VeCallMeFormApp":50,"./vueComponents/VeCheck":51,"./vueComponents/VeDatepicker":52,"./vueComponents/VeForm":54,"./vueComponents/VeFormStep":55,"./vueComponents/VeInput":56,"./vueComponents/VeInputComment":57,"./vueComponents/VeInputTooltip":58,"./vueComponents/VeProductOrderApp":59,"./vueComponents/VeRadio":60,"./vueComponents/VeRadioGroup":61,"./vueComponents/VeRadioListValidator":62,"./vueComponents/VeSectionPlaceholder":63,"./vueComponents/VeTooltip":64,"./vueDirectives/cloakHiddenDirective":66,"babel-polyfill":67,"dawa-autocomplete2":392,"jquery":"jquery","vee-validate":400,"vee-validate/dist/rules.umd":398,"vee-validate/dist/vee-validate.full":399,"vue":"vue"}],47:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var dawaAutocomplete = require('dawa-autocomplete2'); /**
                                                       * Vue Address input using DAWA autocomplete API
                                                       */var VeInput = function VeInput() {_vue2.default.component("ve-address-input", {
		template: "\n\t\t\t<ValidationProvider v-slot=\"v\" rules=\"required\" ref=\"provider\" :disabled=\"isDisabled\" mode=\"eager\">\n\t\t\t\t<div class=\"ve-form-group\" :class=\"v.classes\">\n                    <label class=\"ve-form-group__label\" :for=\"id\"> {{ label }} </label>\n                    <div class=\"ve-form-group__dawa-autocomplete-container\">\n\t\t\t\t\t\t<input class=\"ve-form-group__input\" v-model=\"text\" @input=\"onInput\" type=\"text\" :id=\"id\" :title=\"title\" :ref=\"id\" @blur=\"onInputBlur\">\n                    </div>\n\t\t\t\t\t<span class=\"require-label\">{{ v.errors[0] }}</span>\n\t\t\t\t\t<slot name=\"tooltip\"/></slot>\n\t\t\t\t\t<slot name=\"link\"></slot>\n\t\t\t\t</div>\n\t\t\t\t<slot name=\"after-group\"></slot>\n\t\t\t</ValidationProvider>",












		data: function data() {
			return {
				text: '',
				addressValid: false,
				addressObj: {},
				isDisabled: false };

		},
		props: {
			id: {
				type: String,
				default: "" },

			title: {
				type: String,
				default: "" },


			label: {
				type: String,
				default: "" } },


		methods: {
			onAddressSelect: function onAddressSelect(selected) {
				// This is when a full address get's selected
				var data = selected.data;
				this.addressValid = true;

				this.text = selected.tekst;
				this.addressObj.Postnr = data.postnr;
				this.addressObj.PostDistrikt = data.postnrnavn;
				this.addressObj.KommuneKode = data.kommunekode;
				this.addressObj.Vejnavn = data.vejnavn;
				this.addressObj.Vejkode = data.vejkode;
				this.addressObj.Husnummer = data.husnr;
				this.addressObj.Etage = data.etage;
				this.addressObj.LejlighedsID = data.dør;
				this.addressObj.tekst = selected.tekst;
				this.addressObj.Id = data.id;
				this.$refs.provider.validate();
				this.$emit('input', this.addressObj);
				this.addressValid = true;
			},
			clearInput: function clearInput() {
				this.$refs[this.id].value = '';
				this.text = '';
				this.addressValid = false;
			},
			onInputBlur: function onInputBlur(e) {
				if (!this.addressValid && !this.addressObj.tekst) {
					this.clearInput();
				}

			},
			onInput: function onInput() {
				if (this.addressValid && this.text == this.addressObj.tekst) {
					this.addressValid = false;
				}
			} },

		mounted: function mounted() {var _this = this;
			var provider = this.$refs.provider;
			dawaAutocomplete.dawaAutocomplete(this.$refs[this.id], {
				select: function select(selected) {
					_this.onAddressSelect(selected);

				} });

		},
		deactivated: function deactivated() {
			this.isDisabled = true;
		},
		activated: function activated() {
			this.isDisabled = false;
		},
		beforeDestroy: function beforeDestroy() {
			this.$emit('input', null);
		} });


};


module.exports = VeInput;

},{"dawa-autocomplete2":392,"vue":"vue"}],48:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeButton = function VeButton() {
	_vue2.default.component("ve-button", {
		template: "\n\t\t\t<button :type=\"type\" class=\"continue-button\" @click=\"$emit('click')\" >\n\t\t\t\t<span class=\"btn btn--link\">{{label}}\n\t\t\t\t\t<span class=\"btn__icon\"></span>\n\t\t\t\t</span>\n\t\t\t</button>\n\t\t\t",






		data: function data() {
			return {
				text: '' };

		},
		props: {
			label: {
				type: String,
				default: "" },

			type: {
				type: String,
				default: "button" } } });





}; /**
    * Vue Button
    */module.exports = VeButton;

},{"vue":"vue"}],49:[function(require,module,exports){
"use strict";


var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var VeCallMeForm = function VeCallMeForm() {
  _vue2.default.component("ve-call-me-form", {
    template: "\n    <ValidationObserver v-slot=\"{ handleSubmit }\" ref=\"obs\" tag='div' class='call-me-form-slideout'>\n      <form action=\"https://api.puzzel.com/contactcentre/cow.aspx\" ref=\"puzzelForm\" method=\"post\" @submit.prevent=\"handleSubmit(onSubmit)\">\n        <slot/>\n        </slot>\n      </form>\n    </ValidationObserver>",






    data: function data() {
      return {
        text: '' };

    },
    methods: {
      onSubmit: function onSubmit() {
        if (this.$refs.puzzelForm) {
          this.$refs.puzzelForm.submit();
        }

      } } });


}; /**
   * Vue Form
   */
module.exports = VeCallMeForm;

},{"vue":"vue"}],50:[function(require,module,exports){
'use strict';var _vue = require('vue');var _vue2 = _interopRequireDefault(_vue);

var _da = require('vee-validate/dist/locale/da.json');var _da2 = _interopRequireDefault(_da);
var _en = require('vee-validate/dist/locale/en.json');var _en2 = _interopRequireDefault(_en);
var _pl = require('vee-validate/dist/locale/pl.json');var _pl2 = _interopRequireDefault(_pl);

var _veeValidate = require('vee-validate/dist/vee-validate.full');var VeeValidate = _interopRequireWildcard(_veeValidate);





var _veeValidate2 = require('vee-validate');





var _VeEventBus = require('./VeEventBus.js');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}if ("production" != 'development') {_vue2.default.config.devtools = false;}var ValidationObserver = VeeValidate.ValidationObserver;(0, _veeValidate2.setInteractionMode)('lazy');_vue2.default.component('ValidationObserver', ValidationObserver);

var VeCallMeFormApp = function VeCallMeFormApp() {
  var callmeID = "#js-call-me-form-app";
  var appDiv = document.querySelector(callmeID);
  if (appDiv) {
    var dataLang = appDiv.getAttribute("data-lang") || 'da';
    var translations = appDiv.getAttribute("data-translations") || false;
    var translationsObj = translations ? JSON.parse(translations) : {};

    // Set default language from Umbraco Culture first
    switch (dataLang) {
      case "en":
        VeeValidate.localize('en', _en2.default);
        break;
      case "da":
        VeeValidate.localize('da', _da2.default);
        break;
      case "pl":
        VeeValidate.localize('pl', _pl2.default);
        break;
      default:
        VeeValidate.localize('da', _da2.default);
        break;}


    // update custom translations from dictionary
    if (translations) {
      var dictionary = _defineProperty({},
      dataLang, {
        messages: translationsObj });


      VeeValidate.localize(dictionary);

    }
    var app = new _vue2.default({
      el: callmeID,
      data: function data() {
        return {
          lang: dataLang,
          translations: translationsObj,
          submitError: false,
          errorCode: false,
          isToggled: false,
          formData: {
            currentCulture: dataLang },

          appLoaded: false,
          submitLoading: false };

      },

      mounted: function mounted() {
        this.appLoaded = true;
        this.updateDefaults();

      },

      components: {
        ValidationObserver: ValidationObserver },

      methods: {
        toggleForm: function toggleForm() {
          this.isToggled = !this.isToggled;

        },
        updateDefaults: function updateDefaults() {
          var hiddenAttr = this.$el.querySelectorAll('input[type="hidden"]');
          for (var index = 0; index < hiddenAttr.length; index++) {
            var element = hiddenAttr[index];
            this.formData[element.getAttribute('name')] = element.getAttribute('value');
          }
        } } });


  }
};

module.exports = VeCallMeFormApp;

},{"./VeEventBus.js":53,"vee-validate":400,"vee-validate/dist/locale/da.json":395,"vee-validate/dist/locale/en.json":396,"vee-validate/dist/locale/pl.json":397,"vee-validate/dist/vee-validate.full":399,"vue":"vue"}],51:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeCheck = function VeCheck() {
	_vue2.default.component("ve-check", {
		template: "\n\t\t<ValidationProvider v-slot=\"v\" :rules=\"{required: {allowFalse: optional} }\" :disabled=\"isDisabled\" mode=\"eager\">\n\t\t\t<div class=\"ve-checkbox\" :class=\"v.classes\">\n\t\t\t\t<div class=\"ve-checkbox__wrapper\">\n\t\t\t\t\t<input v-model=\"checked\" type=\"checkbox\" class=\"ve-checkbox__input\" :name=\"name\" @change=\"onCheckboxChange\" :id=\"id\" :value=\"emitValue\" :checked=\"checked\">\n\t\t\t\t\t<label class=\"ve-checkbox__label\" :for=\"id\">\n\t\t\t\t\t\t<slot />\n\t\t\t\t\t\t<span v-if=\"!optional && v.errors\" class=\"ve-checkbox__label__required\"></span>\n\t\t\t\t\t</label>\n\t\t\t\t\t<span class=\"require-label\" v-if=\"v.errors\">{{ errormessage(v.errors[0]) }}</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</ValidationProvider>",












		data: function data() {
			return {
				checked: false,
				isDisabled: false };

		},
		props: {
			id: {
				type: String,
				default: "" },

			name: {
				type: String,
				default: "" },

			icon: {
				type: String,
				default: "" },

			errorLabel: {
				type: String,
				default: "" },

			optional: {
				type: Boolean,
				default: false },

			emitValue: {
				type: [String, Boolean],
				default: true } },



		methods: {
			errormessage: function errormessage(msg) {
				if (!msg) return '';
				if (this.errorLabel) {
					return this.errorLabel;
				}
				return msg;
			},
			onCheckboxChange: function onCheckboxChange($event) {
				var checked = $event.target.checked;
				var value = checked ? this.emitValue : false;
				this.$emit('input', value);
			} },

		deactivated: function deactivated() {
			this.isDisabled = true;
		},
		activated: function activated() {
			this.isDisabled = false;
		} });


}; /**
    * Vue Checkbox
    */module.exports = VeCheck;

},{"vue":"vue"}],52:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);
var _vue2Datepicker = require("vue2-datepicker");var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                                                                                               * Vue Radio button
                                                                                                                                                                                                               */var self = undefined;
var VeDatePicker = function VeDatePicker() {
	_vue2.default.component("ve-date-picker", {
		template: "\n\t\t\t<ValidationProvider v-slot=\"v\" rules=\"required\" :disabled=\"isDisabled\" mode=\"eager\">\n\t\t\t\t<component :is=\"'style'\" type=\"text/css\">\n\t\t\t\t\t{{ firstAvailableDateStyle() }}\n\t\t\t\t</component>\n\n\t\t\t\t<div class=\"ve-form-group\" :class=\"v.classes\">\n\t\t\t\t\t<label class=\"ve-form-group__label\" :for=\"id\"> {{ label }} </label> \n\t\t\t\t\t<date-picker \n\t\t\t\t\t\tv-model=\"date\" \n\t\t\t\t\t\tvalue-type=\"YYYY-MM-DD\" \n\t\t\t\t\t\tformat=\"DD-MM-YYYY\" \n\t\t\t\t\t\tlabel=\"Startdato\"\n            :business-order=\"businessOrder\"\n\t\t\t\t\t\t:default-value=\"getDefaultValueComputed\"\n\t\t\t\t\t\t:disabled-date=\"disabledDateCheck\" \n\t\t\t\t\t\t@input=\"$emit('input', date)\" >\n\t\t\t\t\t</date-picker>\n\t\t\t\t\t<span class=\"require-label\">{{ errormessage(v.errors[0]) }}</span>\n\t\t\t\t</div>\n\t\t\t</ValidationProvider>\n\t\t",





















		components: {
			DatePicker: _vue2Datepicker2.default },

		data: function data() {
			return {
				text: '',
				date: '',
				format: '',
				isDisabled: false };

		},

		props: {
			label: {
				type: String,
				default: "" },

			title: {
				type: String,
				default: "" },

			id: {
				type: String,
				default: "" },

			futureOnly: {
				type: Boolean,
				deafult: false },

			fraflytning: {
				type: [String, Number, Boolean],
				default: null },

			businessOrder: {
				type: Boolean,
				default: false } },



		computed: {
			// Important, datepicker will only update default-value if it receives it from computed prop. Passing a method directly will not work.
			getDefaultValueComputed: function getDefaultValueComputed() {
				var date = this.getFirstAvailableDate();
				return this.formatDate(date);
			} },

		methods: {
			test: function test() {
				return "2020-12-15";
			},
			errormessage: function errormessage(msg) {
				if (!msg) return '';
				return msg.replace("{field}", this.label);
			},
			addDays: function addDays() {var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;var days = arguments[1];
				if (!date) {
					date = new Date();
					date.setHours(0, 0, 0, 0);
				}
				var newDate = date.getDate() + days;
				date.setDate(newDate);
				return date;
			},
			subtractDays: function subtractDays() {var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;var days = arguments[1];
				if (!date) {
					date = new Date();
					date.setHours(0, 0, 0, 0);
				}
				date.setDate(date.getDate() - days);
				return date;
			},
			formatDate: function formatDate(date) {
				var d = new Date(date),
				month = '' + (d.getMonth() + 1),
				day = '' + d.getDate(),
				year = d.getFullYear();

				if (month.length < 2)
				month = '0' + month;
				if (day.length < 2)
				day = '0' + day;

				return [year, month, day].join('-');
			},
			// Very dirt fix to vue2-datepicker not allowing custom classes to day cells.
			// This just adds bold font to the first available date in the calender.
			firstAvailableDateStyle: function firstAvailableDateStyle() {
				var today = new Date();
				if (this.fraflytning == true && this.businessOrder == true) {
					today = this.addDays(today, 14);
				} else
				if (this.fraflytning == false) {
					today = this.addDays(today, 4);
				}
				return ".mx-calendar table td.cell[title=\"" + this.formatDate(today) + "\"]{\n\t\t\t\t\tfont-weight: bold;\n\t\t\t\t};";


			},
			getFirstAvailableDate: function getFirstAvailableDate() {
				var today = new Date();
				today.setHours(0, 0, 0, 0);

				if (this.fraflytning == true && this.businessOrder == true) {
					today = this.addDays(today, 14);
				} else

				if (this.fraflytning == false) {
					return this.addDays(today, 4);
				}
				return today;
			},
			disabledDateCheck: function disabledDateCheck(date) {
				var today = new Date();
				today.setHours(0, 0, 0, 0);


				if (this.fraflytning == true && this.businessOrder === false) {
					return date < today;
				} else if (this.businessOrder === true) {
					return date < this.addDays(today, 14);
				} else
				if (this.fraflytning == false && this.businessOrder === false) {
					return date < this.addDays(today, 4);
				} else
				if (this.futureOnly == true) {
					return date < today;
				}
				return false;
			} },

		watch: {
			/* This function checks if the conditions of the date is changed and clears input */
			fraflytning: function fraflytning(newVal, oldVal) {
				if (this.date == '') {
					return;
				}
				var dateObj = new Date(this.date);
				dateObj.setHours(0, 0, 0, 0);

				if (this.disabledDateCheck(dateObj) == true) {
					this.date = '';
				}
			} },

		deactivated: function deactivated() {
			this.isDisabled = true;
		},
		activated: function activated() {
			this.isDisabled = false;
		},
		beforeDestroy: function beforeDestroy() {
			// This handles removing old data if this field is destroyed due to conditional rendering.
			this.$emit('input', null);
		} });


};


module.exports = VeDatePicker;

},{"vue":"vue","vue2-datepicker":"vue2-datepicker"}],53:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.EventBus = undefined;var _vue = require('vue');var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}
var EventBus = exports.EventBus = new _vue2.default();

},{"vue":"vue"}],54:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);
var _bookingHandler = require("./bookingHandler");var _bookingHandler2 = _interopRequireDefault(_bookingHandler);
var _VeEventBus = require("./VeEventBus.js");function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeForm = function VeForm() {
	_vue2.default.component("ve-form", {
		template: "\n\t\t\t<ValidationObserver v-slot=\"{ handleSubmit }\" submit.prevent ref=\"obs\">\n\t\t\t\t<form @submit.prevent=\"handleSubmit(onSubmit)\">\n\t\t\t\t\t<slot name=\"orderform\"/>\n\t\t\t\t\t</slot>\n\t\t\t\t</form>\n\t\t\t</ValidationObserver>",






		data: function data() {
			return {
				text: '' };

		},
		methods: {
			onSubmit: function onSubmit() {
				if (this.$parent.step === 1 && this.$parent.isFlowStarted == false) {
					this.$parent.isFlowStarted = true;
				}
				if (this.$parent.step === 5) {
					this.submitData();
					return;
				} else {
					this.$parent.step++;
					// If mobile, scroll to new step
					if (window.innerWidth <= 768) {
						setTimeout(function () {
							var step = document.querySelector('.checkout-step');
							if (step) {
								var windowScroll = window.scrollY;
								var y = step.getBoundingClientRect().top + window.scrollY - 10;
								if (windowScroll > y) {
									// We are scrolling upwards. need to compensate for header
									y -= 90;
								}
								window.scrollTo({
									top: y,
									left: 0,
									behavior: 'smooth' });

							}
						}, 100);
					}
				}
			},
			submitData: function submitData() {var _this = this;
				this.$root.submitLoading = true; // show spinner

				var BookingHandlerInstance = (0, _bookingHandler2.default)(this.formData);
				BookingHandlerInstance.submit().
				then(function (res) {

					// If we hit an error
					if (!"Url" in res || "ErrorCode" in res && res.ErrorCode !== "") {
						_this.$root.submitError = true;
						if ("ErrorCode" in res && res.ErrorCode !== "") {
							_this.root.errorCode = res.ErrorCode;
						}
					}

					if ("Url" in res) {
						window.location.href = res.Url;

					} else {
						// all other posibilites didn't trigger. Must be an error.
						_this.$root.submitError = true;
						// Hide spinner
						_this.$root.submitLoading = false;
					}


				});

			} },

		props: {
			formData: {
				type: Object,
				default: function _default() {
					return {};

				} } },


		created: function created() {var _this2 = this;
			window.refTest = this.$refs.obs;
			// Listen for the i-got-clicked event and its payload.
			_VeEventBus.EventBus.$on('resetobserver', function (val) {
				_this2.$refs.obs.reset();
			});
		} });


}; /**
    * Vue Form
    */
module.exports = VeForm;

},{"./VeEventBus.js":53,"./bookingHandler":65,"vue":"vue"}],55:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);
var _VeEventBus = require("./VeEventBus.js");function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                            * Vue From step
                                                                                                                                            */var VeFormStep = function VeFormStep() {
	_vue2.default.component("ve-formstep", {
		template: "\n\t\t<KeepAlive>\n\t\t\t<ValidationProvider :name=\"step\" :disabled=\"isDisabled\" :mode=\"dynamicMode\" :key=\"step\" >\n\t\t\t\t<legend>{{legendHeading}}</legend>\n\t\t\t\t<div class=\"checkout-step__header\">\n\t\t\t\t\t<h3 v-if=\"headline\" class=\"checkout-step__heading\">{{headline}}</h3>\n\t\t\t\t\t<p v-if=\"subheadline\" class=\"checkout-step__subheading\">\n\t\t\t\t\t\t{{subheadline}}\n\t\t\t\t\t</p>\n\t\t\t\t</div>\n\t\t\t\t<slot name=\"orderformstep\"/>\n\t\t\t\t</slot>\n\t\t\t</ValidationProvider>\n\t\t</KeepAlive>\n\t\t\t",














		data: function data() {
			return {
				text: '' };

		},
		computed: {
			uKey: function uKey() {
				return "step_" + this.step;
			},
			isDisabled: function isDisabled() {
				return this.step !== this.currentStep;
			},
			dynamicMode: function dynamicMode() {
				return this.step == this.currentStep ? "eager" : "lazy";
			},
			legendHeading: function legendHeading() {
				var trans = this.$root.translations;
				if (trans && "stepProgressTemplate" in trans) {
					trans = trans.stepProgressTemplate;
					trans = trans.replace("{current}", this.step).replace("{total}", this.totalstep);
					return trans;
				}
				return "";
			} },

		props: {
			step: {
				type: String,
				default: "" },

			totalstep: {
				type: String,
				default: "" },

			currentStep: {
				type: Number,
				default: 1 },

			headline: {
				type: String,
				default: "" },

			subheadline: {
				type: String,
				default: "" },

			skipOnInit: {
				type: Boolean,
				default: false } },


		watch: {
			skipOnInit: function skipOnInit(val) {
				if (val == true) {
					_VeEventBus.EventBus.$emit('skip-step', true);
				}
			} } });



};


module.exports = VeFormStep;

},{"./VeEventBus.js":53,"vue":"vue"}],56:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeInput = function VeInput() {
  _vue2.default.component("ve-input", {
    template: "\n    <ValidationProvider  v-slot=\"v\" :rules=\"rules\" :vid=\"id\" :disabled=\"isDisabled\" mode=\"eager\">\n      <div class=\"ve-form-group\" :class=\"v.classes\">\n        <label class=\"ve-form-group__label\" :class=\"optional ? 'optional' : ''\" :for=\"id\"> {{ label }} </label> \n        <input \n          class=\"ve-form-group__input\" \n          v-model=\"text\" \n          @input=\"onInput($event)\"\n          @change=\"filterData\"\n          :type=\"type\" \n          :title=\"title\" \n          :autocomplete=\"autocomplete\"\n          :inputmode=\"inputmode\"\n          :name=\"name\"\n          :placeholder=\"placeholder\">\n        <span class=\"require-label\">{{ errormessage(v.errors[0]) }}</span>\n        <slot name=\"tooltip\"/></slot>\n        <slot name=\"link\"></slot>\n      </div>\n    </ValidationProvider>",



















    data: function data() {
      return {
        text: '',
        isDisabled: false };

    },
    props: {
      id: {
        type: String,
        default: "" },

      title: {
        type: String,
        default: "" },

      label: {
        type: String,
        default: "" },

      type: {
        type: String,
        default: "text" },

      optional: {
        type: Boolean,
        default: false },

      rules: {
        type: String,
        default: "required" },

      name: {
        type: String,
        default: "" },

      autocomplete: {
        type: String,
        defualt: "on" },

      inputmode: {
        type: String,
        default: "" },

      pattern: {
        type: String,
        default: "" },

      filter: {
        type: String,
        default: "" },

      placeholder: {
        type: String,
        default: "" } },


    methods: {
      errormessage: function errormessage(msg) {
        if (!msg) return '';
        return msg.replace("{field}", this.title);
      },
      filterData: function filterData() {
        if (this.filter.length) {
          var regex = new RegExp(this.filter, 'gi');
          this.text = this.text.replace(regex, '');
        }
      },
      onInput: function onInput(e) {
        this.filterData();
        this.$emit('input', this.text);
      } },

    deactivated: function deactivated() {
      this.isDisabled = true;
    },
    activated: function activated() {
      this.isDisabled = false;
    },
    beforeDestroy: function beforeDestroy() {
      // This handles removing old data if this field is destroyed due to conditional rendering.
      this.$emit('input', null);
    } });


}; /**
   * Vue Text input
   */
module.exports = VeInput;

},{"vue":"vue"}],57:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeInputComment = function VeInputComment() {
	_vue2.default.component("ve-input-comment", {
		template: "\n\t\t<ValidationProvider v-slot=\"v\" :rules=\"computedRules\" :disabled=\"isDisabled\" mode=\"eager\">\n\t\t\t<div class=\"ve-form-group\" :class=\"v.classes\">\n\t\t\t\t<label class=\"ve-form-group__label\" style=\"max-width: 90%\" :class=\"optional ? 'optional' : ''\" :for=\"id\">{{ label }}</label>\n\t\t\t\t<span v-if=\"maxlength\" class=\"ve-form-group__input-counter\" v-bind:class=\"[textLength > maxlength ? 'invalid' : '']\">{{textLength}} / {{ maxlength }}</span>\n\t\t\t\t<textarea \n\t\t\t\t\tclass=\"ve-form-group__input\" \n\t\t\t\t\tv-model=\"text\" \n\t\t\t\t\t@input=\"onInput($event)\" \n\t\t\t\t\t@change=\"filterData\"\n\t\t\t\t\ttype=\"text\" \n\t\t\t\t\t:id=\"id\" \n\t\t\t\t\t:title=\"title\" \n\t\t\t\t\t:autocomplete=\"autocomplete\"\n\t\t\t\t\t:inputmode=\"inputmode\"\n\t\t\t\t\t:maxlength=\"maxlength\"> \n\t\t\t\t</textarea>\n\t\t\t\t<span class=\"require-label\">{{ v.errors[0] }}</span>\n\t\t\t</div>\n\t\t</ValidationProvider>\n\t\t\t\t\t\n\t\t\t\t",





















		data: function data() {
			return {
				text: "",
				isDisabled: false };

		},
		props: {
			id: {
				type: String,
				default: "" },

			title: {
				type: String,
				default: "" },

			label: {
				type: String,
				default: "" },

			maxlength: {
				type: Number,
				default: 300 },

			optional: {
				type: Boolean,
				default: false },

			rules: {
				type: String,
				default: "required" },

			name: {
				type: String,
				default: "" },

			autocomplete: {
				type: String,
				default: "on" },

			inputmode: {
				type: String,
				default: "" },

			filter: {
				type: String,
				default: "" } },


		computed: {
			computedRules: function computedRules() {
				if (this.maxlength && this.rules) {
					return this.rules + "|max:" + this.maxlength;
				} else if (this.maxlength) {
					return "max:" + this.maxlength;
				}
				return this.rules;
			},
			textLength: function textLength() {
				return this.text ? this.text.length : 0;
			} },

		methods: {
			filterData: function filterData() {
				if (this.filter.length) {
					var regex = new RegExp(this.filter, 'gi');
					this.text = this.text.replace(regex, '');
				}
			},
			onInput: function onInput(e) {
				this.filterData();
				this.$emit('input', this.text);
			} },

		deactivated: function deactivated() {
			this.isDisabled = true;
		},
		activated: function activated() {
			this.isDisabled = false;
		},
		beforeDestroy: function beforeDestroy() {
			// This handles removing old data if this field is destroyed due to conditional rendering.
			this.$emit('input', null);
		} });


}; /**
    * Vue Textarea 
    */
module.exports = VeInputComment;

},{"vue":"vue"}],58:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeInputTooltip = function VeInputTooltip() {
	_vue2.default.component("ve-input-tooltip", {
		template: "\n\t\t<ValidationProvider v-slot=\"v\" :rules=\"rules\" :disabled=\"isDisabled\" mode=\"eager\">\n\t\t\t<div class=\"ve-form-group ve-form-group--tooltip\" :class=\"v.classes\">\n\t\t\t\t<label class=\"ve-form-group__label\" :class=\"optional ? 'optional' : ''\" :for=\"id\">{{ label }}</label>\n\t\t\t\t<div class=\"ve-form-group__tooltip-wrap\">\n\t\t\t\t\t<input \n\t\t\t\t\t\tclass=\"ve-form-group__input ve-form-group__input--tooltip\" \n\t\t\t\t\t\tv-model=\"text\" \n\t\t\t\t\t\t@input=\"onInput($event)\" \n\t\t\t\t\t\t@change=\"filterData\"\n\t\t\t\t\t\t:type=\"type\" \n\t\t\t\t\t\t:id=\"id\" \n\t\t\t\t\t\t:title=\"title\" \n\t\t\t\t\t\t:autocomplete=\"autocomplete\"\n\t\t\t\t\t\t:inputmode=\"inputmode\"\n\t\t\t\t\t\t:name=\"name\">\n\n\t\t\t\t\t<slot name=\"tooltip\">\n\t\t\t\t\t</slot>\n\t\t\t\t\t\n\t\t\t\t</div>\n\t\t\t\t<span class=\"require-label\">{{ v.errors[0] }}</span>\n\t\t\t</div>\n\t\t</ValidationProvider>\n\t\t",
























		data: function data() {
			return {
				text: '',
				isDisabled: false };

		},
		props: {
			id: {
				type: String,
				default: "" },

			title: {
				type: String,
				default: "" },

			label: {
				type: String,
				default: "" },

			pattern: {
				type: String,
				default: null },

			filter: {
				type: String,
				default: "" },

			optional: {
				type: Boolean,
				default: false },

			rules: {
				type: String,
				default: "required" },

			type: {
				type: String,
				default: "text" },

			name: {
				type: String,
				default: "" },

			autocomplete: {
				type: String,
				default: "on" },

			inputmode: {
				type: String,
				default: "" } },


		methods: {
			filterData: function filterData() {
				if (this.filter.length) {
					var regex = new RegExp(this.filter, 'gi');
					this.text = this.text.replace(regex, '');
				}
			},
			onInput: function onInput(e) {
				this.filterData();
				this.$emit('input', this.text);
			} },

		deactivated: function deactivated() {
			this.isDisabled = true;
		},
		activated: function activated() {
			this.isDisabled = false;
		},
		beforeDestroy: function beforeDestroy() {
			// This handles removing old data if this field is destroyed due to conditional rendering.
			this.$emit('input', null);
		} });


}; /**
    * Vue Text input with tooltip slot
    */
module.exports = VeInputTooltip;

},{"vue":"vue"}],59:[function(require,module,exports){
'use strict';var _slicedToArray = function () {function sliceIterator(arr, i) {var _arr = [];var _n = true;var _d = false;var _e = undefined;try {for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {_arr.push(_s.value);if (i && _arr.length === i) break;}} catch (err) {_d = true;_e = err;} finally {try {if (!_n && _i["return"]) _i["return"]();} finally {if (_d) throw _e;}}return _arr;}return function (arr, i) {if (Array.isArray(arr)) {return arr;} else if (Symbol.iterator in Object(arr)) {return sliceIterator(arr, i);} else {throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _vue = require('vue');var _vue2 = _interopRequireDefault(_vue);

var _da = require('vee-validate/dist/locale/da.json');var _da2 = _interopRequireDefault(_da);
var _en = require('vee-validate/dist/locale/en.json');var _en2 = _interopRequireDefault(_en);
var _pl = require('vee-validate/dist/locale/pl.json');var _pl2 = _interopRequireDefault(_pl);

var _veeValidate = require('vee-validate/dist/vee-validate.full');var VeeValidate = _interopRequireWildcard(_veeValidate);





var _veeValidate2 = require('vee-validate');





var _VeEventBus = require('./VeEventBus.js');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}if ("production" != 'development') {_vue2.default.config.devtools = false;}var ValidationObserver = VeeValidate.ValidationObserver;(0, _veeValidate2.setInteractionMode)('lazy');_vue2.default.component('ValidationObserver', ValidationObserver);

var VeProductOrderApp = function VeProductOrderApp() {
	var appDiv = document.getElementById('product-order-app');
	if (appDiv) {
		var dataLang = appDiv.getAttribute("data-lang") || 'da';
		var productSku = appDiv.getAttribute("data-productsku") || false;
		var selectedVariant = appDiv.getAttribute("data-productvariantid") || false;
		var orderPageID = appDiv.getAttribute("data-orderpageid") || false;
		var translations = appDiv.getAttribute("data-translations") || false;
		var translationsObj = translations ? JSON.parse(translations) : {};
		var rootId = "umbracoData" in window && "RootId" in window.umbracoData ? window.umbracoData.RootId : false;
		var initialProduct = appDiv.getAttribute("data-initialproduct") || false;
		var initialProductObj = initialProduct ? JSON.parse(initialProduct) : {};

		// Set default language from Umbraco Culture first
		switch (dataLang) {
			case "en":
				VeeValidate.localize('en', _en2.default);
				break;
			case "da":
				VeeValidate.localize('da', _da2.default);
				break;
			case "pl":
				VeeValidate.localize('pl', _pl2.default);
				break;
			default:
				VeeValidate.localize('da', _da2.default);
				break;}


		// update custom translations from dictionary
		if (translations) {
			var dictionary = _defineProperty({},
			dataLang, {
				messages: translationsObj });


			VeeValidate.localize(dictionary);

		}
		var app = new _vue2.default({
			el: '#product-order-app',
			data: function data() {
				return {
					lang: dataLang,
					translations: translationsObj,
					initialProduct: initialProductObj,
					product: initialProductObj,
					productSku: productSku,
					submitError: false,
					errorCode: false,
					invoiceHidden: false,
					extraPerson: false,
					isFlowStarted: false,
					formData: {
						rootId: rootId,
						currentCulture: dataLang,
						orderPageId: orderPageID,
						selectedProductVariantId: selectedVariant },

					step: 1,
					currentStep: 1,
					appLoaded: false,
					submitLoading: false,
					isMobile: false,
					mobileBoxOpen: false };

			},

			mounted: function mounted() {var _this = this;
				this.isMobile = window.innerWidth <= 768;
				window.addEventListener('resize', this.throttle(
				function () {
					_this.isMobile = window.innerWidth <= 768;
					if (_this.isMobile == false) {
						_this.mobileBoxOpen = false;
					}
				}, 50));



				var storageObj = false; // localStorage.productOrderData; - This breaks a lot of logic, and is not implemente yet.
				if (storageObj) {
					storageObj = JSON.parse(storageObj);
					for (var key in storageObj) {
						if (storageObj.hasOwnProperty(key)) {
							var value = storageObj[key];
							this.formData[key] = value;
						}
					}
				}

				this.appLoaded = true;

			},
			created: function created() {var _this2 = this;
				_VeEventBus.EventBus.$on('skip-step', function (val) {
					_this2.step++;
				});

			},
			watch: {
				/* 
                  For saving formdata so you can return to form. Currently not implemented.
                  formData(value) {
                  	const jsonValue = JSON.stringify(value);
                    	localStorage.productOrderData = jsonValue;
                  } 
                  */},

			components: {
				ValidationObserver: ValidationObserver },

			methods: {
				formatDate: function formatDate(dateString) {var _dateString$split =
					dateString.split("-"),_dateString$split2 = _slicedToArray(_dateString$split, 3),day = _dateString$split2[0],month = _dateString$split2[1],year = _dateString$split2[2];
					var dateObj = new Date(year, month - 1, day);
					return day + '.' + month + '.' + year;
				},
				formatCpr: function formatCpr(cpr) {
					cpr = cpr || "";
					return cpr.substring(0, 6) + '-' + cpr.substring(6);
				},
				updateProduct: function updateProduct(product) {
					if (product && product.id !== this.product.id) {
						this.product = product;
					}
				},
				resetProduct: function resetProduct() {
					if (this.product.id != this.initialProduct.id) {
						this.product = this.initialProduct;
					}
				},
				setType: function setType(type) {
					if (type == 'Privat') {
						this.formData.type = 'Privat';
					} else if (type == 'Virksomhed') {
						this.formData.type = 'Virksomhed';
					}
				},
				debounce: function debounce(func) {var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
					var timeout = void 0;
					return function () {var _this3 = this;for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}
						clearTimeout(timeout);
						timeout = setTimeout(function () {
							func.apply(_this3, args);
						}, wait);
					};
				},
				throttle: function throttle(callback, limit) {
					var waiting = false;
					return function () {
						if (!waiting) {
							callback.apply(this, arguments);
							waiting = true;
							setTimeout(function () {
								waiting = false;
							}, limit);
						}
					};
				} } });



	}
};

module.exports = VeProductOrderApp;

},{"./VeEventBus.js":53,"vee-validate":400,"vee-validate/dist/locale/da.json":395,"vee-validate/dist/locale/en.json":396,"vee-validate/dist/locale/pl.json":397,"vee-validate/dist/vee-validate.full":399,"vue":"vue"}],60:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeRadio = function VeRadio() {
	_vue2.default.component("ve-radio", {
		template: "\n\t\t\t<div class=\"radio--border\" :class=\"errorClass\">\n\t\t\t\t<div class=\"radio--wrapper\">\n\t\t\t\t\t<input type=\"radio\" v-model=\"selected\" :value=\"valueProp\" class=\"radio\" :name=\"name\" @change=\"$emit('input', valueProp)\" :id=\"id\" :required=\"required ? true : false\" />\n\t\t\t\t\t<label :for=\"id\">{{ label }} </label>\n\t\t\t\t\t<img v-if=\"icon\" :src=\"icon\">\n\t\t\t\t\t<p v-if=\"price && price.length\"> {{price}} </p>\n\t\t\t\t\t<slot name=\"tooltip\"> </slot>\n\t\t\t\t</div>\n\t\t\t\t<span v-if=\"sublabel && sublabel.length\" class=\"radio__sublabel\"> {{sublabel}}</span>\n\t\t\t</div>\n\t\t",











		data: function data() {
			return {
				selected: '' };

		},
		props: {
			id: {
				type: String,
				default: "" },

			name: {
				type: String,
				default: "" },

			label: {
				type: String,
				default: "" },

			sublabel: {
				type: String,
				default: "" },

			icon: {
				type: String,
				default: "" },

			price: {
				type: String,
				default: "" },

			valueProp: {
				type: [String, Number, Boolean],
				default: "" },

			required: {
				type: Boolean,
				default: false },

			errorClass: {
				type: Object,
				default: function _default() {return {};} },

			isDefaultSelection: {
				type: String,
				default: 'false' } },


		beforeDestroy: function beforeDestroy() {
			// This handles removing old data if this field is destroyed due to conditional rendering.
			this.$emit('input', null);
		},
		mounted: function mounted() {
			if (!this.selected && this.isDefaultSelection === 'true') {
				this.selected = this.valueProp;
				this.$emit("input", this.valueProp);
			}
		} });


}; /**
    * Vue Radio button
    */module.exports = VeRadio;

},{"vue":"vue"}],61:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeRadioGroup = function VeRadioGroup() {
	_vue2.default.component("ve-radio-group", {
		template: "\n\t\t<ValidationProvider v-slot=\"{ errors, classes }\" rules=\"required\" ref=\"valProvider\" :disabled=\"isDisabled\" mode=\"eager\">\n\t\t\t<div class=\"radio-button-group ve-form-group\" :class=\"classes\">\n\t\t\t\t<div class=\"radio-button-group__title\" v-if=\"title && title.length\">{{title}}</div>\n\t\t\t\t<div class=\"radio-button-group__wrapper\">\n\t\t\t\t\t<ve-radio v-model=\"radioData\" :name=\"name\" :valueProp=\"valueLeft\" :id=\"idLeft\" :label=\"labelLeft\" @input=\"$emit('input', valueLeft)\"  />\n\t\t\t\t\t<ve-radio v-model=\"radioData\" :name=\"name\" :valueProp=\"valueRight\" :id=\"idRight\" :label=\"labelRight\" @input=\"$emit('input', valueRight)\"  />\n\t\t\t\t</div>\n\t\t\t\t<span v-if=\"errormessage(errors[0])\" class=\"require-label\">{{ errormessage(errors[0]) }}</span>\t\t\n\t\t\t</div>\n\t\t</ValidationProvider>",










		props: {
			idLeft: {
				type: String,
				default: "" },

			idRight: {
				type: String,
				default: "" },

			name: {
				type: String,
				default: "" },

			errorLabel: {
				type: String,
				default: "" },

			title: {
				type: String,
				default: "" },

			labelLeft: {
				type: String,
				default: "" },

			labelRight: {
				type: String,
				default: "" },

			valueLeft: {
				type: [String, Number, Boolean],
				default: "" },

			valueRight: {
				type: [String, Number, Boolean],
				default: "" } },


		data: function data() {
			return {
				radioData: '',
				isDisabled: false };

		},
		computed: {
			validationObjReq: function validationObjReq() {
				return {
					required: true };

			},
			validationObj: function validationObj() {
				return {
					required: true,
					included: [this.valueLeft, this.valueRight] };

			} },

		methods: {
			errormessage: function errormessage(msg) {
				if (!msg) return '';
				if (this.errorLabel) {
					return this.errorLabel;
				}
				return msg.replace("{field}", this.errorLabel);
			} },

		mounted: function mounted() {
			//this.$refs.valProvider.reset();
		},
		beforeDestroy: function beforeDestroy() {
			// This handles removing old data if this field is destroyed due to conditional rendering.
			this.$emit('input', null);
		},
		deactivated: function deactivated() {
			this.isDisabled = true;
		},
		activated: function activated() {
			this.isDisabled = false;
		} });



}; /**
    * Vue Radio button true/false
    */module.exports = VeRadioGroup;

},{"vue":"vue"}],62:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeRadioListValidator = function VeRadioListValidator() {
	_vue2.default.component("ve-radio-list-validator", {
		template: "\n\t\t\t<ValidationProvider v-slot=\"{ errors, classes }\" :rules=\"rules\" :name=\"name\" :mode=\"mode\" :disabled=\"isDisabled\">\n\t\t\t\t<div class=\"radio-validator\">\n\t\t\t\t\t<slot />\n\t\t\t\t\t<span v-if=\"errors\" class=\"require-label\">{{ errors[0] }}</span>\n\t\t\t\t</div>\n\t\t\t</ValidationProvider>\n\t\t",







		data: function data() {
			return {
				isDisabled: false };

		},
		props: {
			name: {
				type: String,
				default: "" },

			rules: {
				type: String,
				default: "" },

			mode: {
				type: String,
				default: "" } },



		beforeDestroy: function beforeDestroy() {

		},
		deactivated: function deactivated() {
			this.isDisabled = true;
		},
		activated: function activated() {
			this.isDisabled = false;
		} });


}; /**
    * Vue Radio list validator
    */module.exports = VeRadioListValidator;

},{"vue":"vue"}],63:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);
var _VeEventBus = require("./VeEventBus.js");function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };} /**
                                                                                                                                            * Vue Form Step placeholder
                                                                                                                                            */var VeSectionPlaceholder = function VeSectionPlaceholder() {_vue2.default.component("ve-section-placeholder", {
		template: "\n\t\t<span v-show=\"currentStep != step\" class=\"section-placeholder\" v-bind:class=\"[isValid ? 'section-placeholder--valid' : '']\"> \n\t\t\t<slot v-if=\"isValid\" name=\"filledout\">\n\t\t\t\t<span class=\"checkmark-box\"></span>\n\t\t\t</slot>\n\t\t\t<span class=\"section-placeholder__title\">{{title}}</span>\n\t\t\t<button v-if=\"isValid\" type=\"button\" v-on:click=\"correct\" class=\"section-placeholder__edit edit-step-js\">{{editLabel}}</button>\n\t\t\t<div v-if=\"isValid\" class=\"section-placeholder__resume\">\n\t\t\t\t<slot name=\"resume\">\n\t\t\t\t</slot>\n\n\t\t\t</div>\n\n\t\t</span>",













		data: function data() {
			return {
				text: '' };

		},
		methods: {
			correct: function correct() {
				this.$root.step = this.step;
				_VeEventBus.EventBus.$emit('resetobserver', true);
			} },



		props: {
			title: {
				type: String,
				default: "" },

			valid: {
				type: Boolean,
				default: false },

			step: {
				type: Number,
				default: 1 },

			currentStep: {
				type: Number,
				default: 1 },

			editLabel: {
				type: String,
				default: "Ret" } },


		computed: {
			isValid: function isValid() {
				return this.currentStep > this.step;
			} } });



};


module.exports = VeSectionPlaceholder;

},{"./VeEventBus.js":53,"vue":"vue"}],64:[function(require,module,exports){
"use strict";



var _vue = require("vue");var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var VeTooltip = function VeTooltip() {
	_vue2.default.component("ve-tooltip", {
		template: "\n\t\t\t<div class=\"tooltip-comp\" v-bind:class=\"{ 'tooltip-comp--open': isOpen }\">\n                <span class=\"tooltip-comp__icon\" v-on:click=\"isOpen = true\">\n\t\t\t\t\t<img src=\"/dist/assets/images/info-icon.svg\" alt=\"info icon\">\n\t\t\t\t</span>\n\t\t\t\t<div class=\"tooltip-comp__wrapper\">\n\t\t\t\t\t<div class=\"tooltip-comp__overlay\" v-on:click=\"isOpen = false\"></div>\n\t\t\t\t\t<div class=\"tooltip-comp__text\" >\n\t\t\t\t\t\t<span class=\"tooltip-comp__close js-close\" v-on:click=\"isOpen = false\"></span>\n\t\t\t\t\t\t<slot name=\"content\"> </slot>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t",













		data: function data() {
			return {
				isOpen: false };

		},
		props: {} });




}; /**
    * Vue Tooltip box
    */module.exports = VeTooltip;

},{"vue":"vue"}],65:[function(require,module,exports){
"use strict";var BookingHandler = function BookingHandler(data) {

    var self = {};
    self.formData = data;
    self.route = "/umbraco/Api/ProductOrderApi/Submit";

    // Rename a key in an object
    self.renameObjKey = function (obj) {var oldKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "key";var newKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "key";
        obj[newKey] = obj[oldKey];
        delete obj[oldKey];

        return obj;
    };
    self.mapData = function (formData) {
        var isPrivate = formData.type == "Privat";

        if (formData.levAdresse) {
            formData.levPostnr = formData.levAdresse.Postnr;
            formData.levPostDistrikt = formData.levAdresse.PostDistrikt;
            formData.levKommuneKode = formData.levAdresse.KommuneKode;
            formData.levVejnavn = formData.levAdresse.Vejnavn;
            formData.levVejkode = formData.levAdresse.Vejkode;
            formData.levHusnummer = formData.levAdresse.Husnummer;
            formData.levEtage = formData.levAdresse.Etage;
            formData.levLejlighedsId = formData.levAdresse.LejlighedsID;
            formData.levUuid = formData.levAdresse.Id;

            delete formData.levAdresse;
        }
        if (formData.Debadresse) {
            formData.debPostnr = formData.Debadresse.Postnr;
            formData.debBy = formData.Debadresse.PostDistrikt;
            formData.debKommuneKode = formData.Debadresse.KommuneKode;
            formData.debVej = formData.Debadresse.Vejnavn;
            formData.debVejkode = formData.Debadresse.Vejkode;
            formData.debHusnr = formData.Debadresse.Husnummer;
            formData.debEtage = formData.Debadresse.Etage;
            formData.debDor = formData.Debadresse.LejlighedsID; // Note, Xellent has 'LejlighedsId' as 'Dor' when using deb address, but not the other addresses.
            formData.debUuid = formData.Debadresse.Id;

            delete formData.Debadresse;
        }

        // El aftale ifm. flytning
        if (formData.moveIn) {
            formData.aftAutoLev = "No";
            formData.aftAutoIndFlyt = "Yes";
        }

        if (formData.moveIn == false) {
            formData.aftAutoLev = "Yes";
            formData.aftAutoIndFlyt = "No";
        }
        if (formData.moveInSecondary == true) {
            formData.aftAutoLev = "No";
            formData.aftAutoIndFlyt = "Yes";
        } else {
            delete formData.moveInSecondary;
        }

        if (formData.Fraflytningsadresse) {
            formData.moveInSecondaryPostnr = formData.Fraflytningsadresse.Postnr;
            formData.moveInSecondaryPostDistrikt = formData.Fraflytningsadresse.PostDistrikt;
            formData.moveInSecondaryKommuneKode = formData.Fraflytningsadresse.KommuneKode;
            formData.moveInSecondaryVejnavn = formData.Fraflytningsadresse.Vejnavn;
            formData.moveInSecondaryVejkode = formData.Fraflytningsadresse.Vejkode;
            formData.moveInSecondaryHusnummer = formData.Fraflytningsadresse.Husnummer;
            formData.moveInSecondaryEtage = formData.Fraflytningsadresse.Etage;
            formData.moveInSecondaryLejlighedsId = formData.Fraflytningsadresse.LejlighedsID;
            formData.moveInSecondaryUuid = formData.Fraflytningsadresse.Id;

            delete formData.Fraflytningsadresse;
        }
        if (isPrivate) {
            formData = self.renameObjKey(formData, "cpr", "debCprCvr");
            if ("person2debNavn2" in formData && "person2cpr2" in formData) {
                formData = self.renameObjKey(formData, "person2debNavn2", "debNavn2");
                formData = self.renameObjKey(formData, "person2cpr2", "debCpr2");
            }
        } else {
            formData = self.renameObjKey(formData, "companyName", "debNavn");
            formData = self.renameObjKey(formData, "cvr", "debCprCvr");
        }

        // Clean up payment data
        switch (formData.payment) {
            case "mobilepay":
                delete formData.debBsReg;
                delete formData.debBsBank;
                delete formData.ean;
                delete formData.kontaktperson;
                delete formData.debRekv;
                break;
            case "kort":
                delete formData.debBsReg;
                delete formData.debBsBank;
                delete formData.ean;
                delete formData.kontaktperson;
                delete formData.debRekv;
                break;
            case "bs":
                delete formData.ean;
                delete formData.kontaktperson;
                delete formData.debRekv;
                break;
            case "mail":
                delete formData.debBsReg;
                delete formData.debBsBank;
                delete formData.ean;
                delete formData.kontaktperson;
                delete formData.debRekv;
                break;
            case "ean":
                delete formData.debBsReg;
                delete formData.debBsBank;
                break;
            default:
                break;}


        formData = self.renameObjKey(formData, "billing", "konAfregningsplan");

        return formData;
    };
    self.submit = function () {
        var requestBody = self.mapData(self.formData);
        return fetch(
        self.route,
        {
            method: "POST",
            headers: {
                "Content-type": "application/json" },

            body: JSON.stringify(requestBody) }).


        then(function (res) {
            return res.json();
        });
    };
    return self;
};


module.exports = BookingHandler;

},{}],66:[function(require,module,exports){
'use strict';Object.defineProperty(exports, "__esModule", { value: true });exports.default =

cloakHiddenDirective;var _vue = require('vue');var _vue2 = _interopRequireDefault(_vue);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function cloakHiddenDirective() {
  _vue2.default.directive('cloak-hidden', {
    inserted: function inserted(el) {
      // remove tag
      el.removeAttribute('v-cloak-hidden');
      el.classList.remove('v-cloak-hidden');
    } });

}

},{"vue":"vue"}],67:[function(require,module,exports){
(function (global){
"use strict";

require("core-js/shim");

require("regenerator-runtime/runtime");

require("core-js/fn/regexp/escape");

if (global._babelPolyfill) {
  throw new Error("only one instance of babel-polyfill is allowed");
}
global._babelPolyfill = true;

var DEFINE_PROPERTY = "defineProperty";
function define(O, key, value) {
  O[key] || Object[DEFINE_PROPERTY](O, key, {
    writable: true,
    configurable: true,
    value: value
  });
}

define(String.prototype, "padLeft", "".padStart);
define(String.prototype, "padRight", "".padEnd);

"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
  [][key] && define(Array, key, Function.call.bind([][key]));
});
}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"core-js/fn/regexp/escape":68,"core-js/shim":391,"regenerator-runtime/runtime":394}],68:[function(require,module,exports){
require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;

},{"../../modules/_core":89,"../../modules/core.regexp.escape":194}],69:[function(require,module,exports){
module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

},{}],70:[function(require,module,exports){
var cof = require('./_cof');
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};

},{"./_cof":84}],71:[function(require,module,exports){
// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = require('./_wks')('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) require('./_hide')(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};

},{"./_hide":108,"./_wks":192}],72:[function(require,module,exports){
module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

},{}],73:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

},{"./_is-object":117}],74:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};

},{"./_to-absolute-index":177,"./_to-length":181,"./_to-object":182}],75:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
'use strict';
var toObject = require('./_to-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

},{"./_to-absolute-index":177,"./_to-length":181,"./_to-object":182}],76:[function(require,module,exports){
var forOf = require('./_for-of');

module.exports = function (iter, ITERATOR) {
  var result = [];
  forOf(iter, false, result.push, result, ITERATOR);
  return result;
};

},{"./_for-of":105}],77:[function(require,module,exports){
// false -> Array#indexOf
// true  -> Array#includes
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');
var toAbsoluteIndex = require('./_to-absolute-index');
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

},{"./_to-absolute-index":177,"./_to-iobject":180,"./_to-length":181}],78:[function(require,module,exports){
// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = require('./_ctx');
var IObject = require('./_iobject');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var asc = require('./_array-species-create');
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};

},{"./_array-species-create":81,"./_ctx":91,"./_iobject":113,"./_to-length":181,"./_to-object":182}],79:[function(require,module,exports){
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var toLength = require('./_to-length');

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};

},{"./_a-function":69,"./_iobject":113,"./_to-length":181,"./_to-object":182}],80:[function(require,module,exports){
var isObject = require('./_is-object');
var isArray = require('./_is-array');
var SPECIES = require('./_wks')('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};

},{"./_is-array":115,"./_is-object":117,"./_wks":192}],81:[function(require,module,exports){
// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = require('./_array-species-constructor');

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};

},{"./_array-species-constructor":80}],82:[function(require,module,exports){
'use strict';
var aFunction = require('./_a-function');
var isObject = require('./_is-object');
var invoke = require('./_invoke');
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};

},{"./_a-function":69,"./_invoke":112,"./_is-object":117}],83:[function(require,module,exports){
// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = require('./_cof');
var TAG = require('./_wks')('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

},{"./_cof":84,"./_wks":192}],84:[function(require,module,exports){
var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

},{}],85:[function(require,module,exports){
'use strict';
var dP = require('./_object-dp').f;
var create = require('./_object-create');
var redefineAll = require('./_redefine-all');
var ctx = require('./_ctx');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var $iterDefine = require('./_iter-define');
var step = require('./_iter-step');
var setSpecies = require('./_set-species');
var DESCRIPTORS = require('./_descriptors');
var fastKey = require('./_meta').fastKey;
var validate = require('./_validate-collection');
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};

},{"./_an-instance":72,"./_ctx":91,"./_descriptors":95,"./_for-of":105,"./_iter-define":121,"./_iter-step":123,"./_meta":131,"./_object-create":136,"./_object-dp":137,"./_redefine-all":156,"./_set-species":163,"./_validate-collection":189}],86:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var classof = require('./_classof');
var from = require('./_array-from-iterable');
module.exports = function (NAME) {
  return function toJSON() {
    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
    return from(this);
  };
};

},{"./_array-from-iterable":76,"./_classof":83}],87:[function(require,module,exports){
'use strict';
var redefineAll = require('./_redefine-all');
var getWeak = require('./_meta').getWeak;
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var createArrayMethod = require('./_array-methods');
var $has = require('./_has');
var validate = require('./_validate-collection');
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};

},{"./_an-instance":72,"./_an-object":73,"./_array-methods":78,"./_for-of":105,"./_has":107,"./_is-object":117,"./_meta":131,"./_redefine-all":156,"./_validate-collection":189}],88:[function(require,module,exports){
'use strict';
var global = require('./_global');
var $export = require('./_export');
var redefine = require('./_redefine');
var redefineAll = require('./_redefine-all');
var meta = require('./_meta');
var forOf = require('./_for-of');
var anInstance = require('./_an-instance');
var isObject = require('./_is-object');
var fails = require('./_fails');
var $iterDetect = require('./_iter-detect');
var setToStringTag = require('./_set-to-string-tag');
var inheritIfRequired = require('./_inherit-if-required');

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};

},{"./_an-instance":72,"./_export":99,"./_fails":101,"./_for-of":105,"./_global":106,"./_inherit-if-required":111,"./_is-object":117,"./_iter-detect":122,"./_meta":131,"./_redefine":157,"./_redefine-all":156,"./_set-to-string-tag":164}],89:[function(require,module,exports){
var core = module.exports = { version: '2.5.3' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

},{}],90:[function(require,module,exports){
'use strict';
var $defineProperty = require('./_object-dp');
var createDesc = require('./_property-desc');

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

},{"./_object-dp":137,"./_property-desc":155}],91:[function(require,module,exports){
// optional / simple context binding
var aFunction = require('./_a-function');
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

},{"./_a-function":69}],92:[function(require,module,exports){
'use strict';
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = require('./_fails');
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;

},{"./_fails":101}],93:[function(require,module,exports){
'use strict';
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};

},{"./_an-object":73,"./_to-primitive":183}],94:[function(require,module,exports){
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

},{}],95:[function(require,module,exports){
// Thank's IE8 for his funny defineProperty
module.exports = !require('./_fails')(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_fails":101}],96:[function(require,module,exports){
var isObject = require('./_is-object');
var document = require('./_global').document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

},{"./_global":106,"./_is-object":117}],97:[function(require,module,exports){
// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

},{}],98:[function(require,module,exports){
// all enumerable object keys, includes symbols
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};

},{"./_object-gops":143,"./_object-keys":146,"./_object-pie":147}],99:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var hide = require('./_hide');
var redefine = require('./_redefine');
var ctx = require('./_ctx');
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

},{"./_core":89,"./_ctx":91,"./_global":106,"./_hide":108,"./_redefine":157}],100:[function(require,module,exports){
var MATCH = require('./_wks')('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};

},{"./_wks":192}],101:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

},{}],102:[function(require,module,exports){
'use strict';
var hide = require('./_hide');
var redefine = require('./_redefine');
var fails = require('./_fails');
var defined = require('./_defined');
var wks = require('./_wks');

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);
  var fns = exec(defined, SYMBOL, ''[KEY]);
  var strfn = fns[0];
  var rxfn = fns[1];
  if (fails(function () {
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  })) {
    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};

},{"./_defined":94,"./_fails":101,"./_hide":108,"./_redefine":157,"./_wks":192}],103:[function(require,module,exports){
'use strict';
// 21.2.5.3 get RegExp.prototype.flags
var anObject = require('./_an-object');
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

},{"./_an-object":73}],104:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = require('./_is-array');
var isObject = require('./_is-object');
var toLength = require('./_to-length');
var ctx = require('./_ctx');
var IS_CONCAT_SPREADABLE = require('./_wks')('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;

},{"./_ctx":91,"./_is-array":115,"./_is-object":117,"./_to-length":181,"./_wks":192}],105:[function(require,module,exports){
var ctx = require('./_ctx');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var anObject = require('./_an-object');
var toLength = require('./_to-length');
var getIterFn = require('./core.get-iterator-method');
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;

},{"./_an-object":73,"./_ctx":91,"./_is-array-iter":114,"./_iter-call":119,"./_to-length":181,"./core.get-iterator-method":193}],106:[function(require,module,exports){
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

},{}],107:[function(require,module,exports){
var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

},{}],108:[function(require,module,exports){
var dP = require('./_object-dp');
var createDesc = require('./_property-desc');
module.exports = require('./_descriptors') ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

},{"./_descriptors":95,"./_object-dp":137,"./_property-desc":155}],109:[function(require,module,exports){
var document = require('./_global').document;
module.exports = document && document.documentElement;

},{"./_global":106}],110:[function(require,module,exports){
module.exports = !require('./_descriptors') && !require('./_fails')(function () {
  return Object.defineProperty(require('./_dom-create')('div'), 'a', { get: function () { return 7; } }).a != 7;
});

},{"./_descriptors":95,"./_dom-create":96,"./_fails":101}],111:[function(require,module,exports){
var isObject = require('./_is-object');
var setPrototypeOf = require('./_set-proto').set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};

},{"./_is-object":117,"./_set-proto":162}],112:[function(require,module,exports){
// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};

},{}],113:[function(require,module,exports){
// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = require('./_cof');
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

},{"./_cof":84}],114:[function(require,module,exports){
// check on default Array iterator
var Iterators = require('./_iterators');
var ITERATOR = require('./_wks')('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

},{"./_iterators":124,"./_wks":192}],115:[function(require,module,exports){
// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

},{"./_cof":84}],116:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var isObject = require('./_is-object');
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};

},{"./_is-object":117}],117:[function(require,module,exports){
module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

},{}],118:[function(require,module,exports){
// 7.2.8 IsRegExp(argument)
var isObject = require('./_is-object');
var cof = require('./_cof');
var MATCH = require('./_wks')('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};

},{"./_cof":84,"./_is-object":117,"./_wks":192}],119:[function(require,module,exports){
// call something on iterator step with safe closing on error
var anObject = require('./_an-object');
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};

},{"./_an-object":73}],120:[function(require,module,exports){
'use strict';
var create = require('./_object-create');
var descriptor = require('./_property-desc');
var setToStringTag = require('./_set-to-string-tag');
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
require('./_hide')(IteratorPrototype, require('./_wks')('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

},{"./_hide":108,"./_object-create":136,"./_property-desc":155,"./_set-to-string-tag":164,"./_wks":192}],121:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var $export = require('./_export');
var redefine = require('./_redefine');
var hide = require('./_hide');
var has = require('./_has');
var Iterators = require('./_iterators');
var $iterCreate = require('./_iter-create');
var setToStringTag = require('./_set-to-string-tag');
var getPrototypeOf = require('./_object-gpo');
var ITERATOR = require('./_wks')('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

},{"./_export":99,"./_has":107,"./_hide":108,"./_iter-create":120,"./_iterators":124,"./_library":125,"./_object-gpo":144,"./_redefine":157,"./_set-to-string-tag":164,"./_wks":192}],122:[function(require,module,exports){
var ITERATOR = require('./_wks')('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};

},{"./_wks":192}],123:[function(require,module,exports){
module.exports = function (done, value) {
  return { value: value, done: !!done };
};

},{}],124:[function(require,module,exports){
module.exports = {};

},{}],125:[function(require,module,exports){
module.exports = false;

},{}],126:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;

},{}],127:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var sign = require('./_math-sign');
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};

},{"./_math-sign":130}],128:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};

},{}],129:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
  if (
    arguments.length === 0
      // eslint-disable-next-line no-self-compare
      || x != x
      // eslint-disable-next-line no-self-compare
      || inLow != inLow
      // eslint-disable-next-line no-self-compare
      || inHigh != inHigh
      // eslint-disable-next-line no-self-compare
      || outLow != outLow
      // eslint-disable-next-line no-self-compare
      || outHigh != outHigh
  ) return NaN;
  if (x === Infinity || x === -Infinity) return x;
  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
};

},{}],130:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};

},{}],131:[function(require,module,exports){
var META = require('./_uid')('meta');
var isObject = require('./_is-object');
var has = require('./_has');
var setDesc = require('./_object-dp').f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !require('./_fails')(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

},{"./_fails":101,"./_has":107,"./_is-object":117,"./_object-dp":137,"./_uid":187}],132:[function(require,module,exports){
var Map = require('./es6.map');
var $export = require('./_export');
var shared = require('./_shared')('metadata');
var store = shared.store || (shared.store = new (require('./es6.weak-map'))());

var getOrCreateMetadataMap = function (target, targetKey, create) {
  var targetMetadata = store.get(target);
  if (!targetMetadata) {
    if (!create) return undefined;
    store.set(target, targetMetadata = new Map());
  }
  var keyMetadata = targetMetadata.get(targetKey);
  if (!keyMetadata) {
    if (!create) return undefined;
    targetMetadata.set(targetKey, keyMetadata = new Map());
  } return keyMetadata;
};
var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
};
var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
  var metadataMap = getOrCreateMetadataMap(O, P, false);
  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
};
var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
};
var ordinaryOwnMetadataKeys = function (target, targetKey) {
  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
  var keys = [];
  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
  return keys;
};
var toMetaKey = function (it) {
  return it === undefined || typeof it == 'symbol' ? it : String(it);
};
var exp = function (O) {
  $export($export.S, 'Reflect', O);
};

module.exports = {
  store: store,
  map: getOrCreateMetadataMap,
  has: ordinaryHasOwnMetadata,
  get: ordinaryGetOwnMetadata,
  set: ordinaryDefineOwnMetadata,
  keys: ordinaryOwnMetadataKeys,
  key: toMetaKey,
  exp: exp
};

},{"./_export":99,"./_shared":166,"./es6.map":224,"./es6.weak-map":330}],133:[function(require,module,exports){
var global = require('./_global');
var macrotask = require('./_task').set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = require('./_cof')(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    var promise = Promise.resolve();
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};

},{"./_cof":84,"./_global":106,"./_task":176}],134:[function(require,module,exports){
'use strict';
// 25.4.1.5 NewPromiseCapability(C)
var aFunction = require('./_a-function');

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};

},{"./_a-function":69}],135:[function(require,module,exports){
'use strict';
// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = require('./_object-keys');
var gOPS = require('./_object-gops');
var pIE = require('./_object-pie');
var toObject = require('./_to-object');
var IObject = require('./_iobject');
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || require('./_fails')(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;

},{"./_fails":101,"./_iobject":113,"./_object-gops":143,"./_object-keys":146,"./_object-pie":147,"./_to-object":182}],136:[function(require,module,exports){
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = require('./_an-object');
var dPs = require('./_object-dps');
var enumBugKeys = require('./_enum-bug-keys');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = require('./_dom-create')('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  require('./_html').appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

},{"./_an-object":73,"./_dom-create":96,"./_enum-bug-keys":97,"./_html":109,"./_object-dps":138,"./_shared-key":165}],137:[function(require,module,exports){
var anObject = require('./_an-object');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var toPrimitive = require('./_to-primitive');
var dP = Object.defineProperty;

exports.f = require('./_descriptors') ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

},{"./_an-object":73,"./_descriptors":95,"./_ie8-dom-define":110,"./_to-primitive":183}],138:[function(require,module,exports){
var dP = require('./_object-dp');
var anObject = require('./_an-object');
var getKeys = require('./_object-keys');

module.exports = require('./_descriptors') ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

},{"./_an-object":73,"./_descriptors":95,"./_object-dp":137,"./_object-keys":146}],139:[function(require,module,exports){
'use strict';
// Forced replacement prototype accessors methods
module.exports = require('./_library') || !require('./_fails')(function () {
  var K = Math.random();
  // In FF throws only define methods
  // eslint-disable-next-line no-undef, no-useless-call
  __defineSetter__.call(null, K, function () { /* empty */ });
  delete require('./_global')[K];
});

},{"./_fails":101,"./_global":106,"./_library":125}],140:[function(require,module,exports){
var pIE = require('./_object-pie');
var createDesc = require('./_property-desc');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var has = require('./_has');
var IE8_DOM_DEFINE = require('./_ie8-dom-define');
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = require('./_descriptors') ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

},{"./_descriptors":95,"./_has":107,"./_ie8-dom-define":110,"./_object-pie":147,"./_property-desc":155,"./_to-iobject":180,"./_to-primitive":183}],141:[function(require,module,exports){
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = require('./_to-iobject');
var gOPN = require('./_object-gopn').f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

},{"./_object-gopn":142,"./_to-iobject":180}],142:[function(require,module,exports){
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = require('./_object-keys-internal');
var hiddenKeys = require('./_enum-bug-keys').concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

},{"./_enum-bug-keys":97,"./_object-keys-internal":145}],143:[function(require,module,exports){
exports.f = Object.getOwnPropertySymbols;

},{}],144:[function(require,module,exports){
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = require('./_has');
var toObject = require('./_to-object');
var IE_PROTO = require('./_shared-key')('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

},{"./_has":107,"./_shared-key":165,"./_to-object":182}],145:[function(require,module,exports){
var has = require('./_has');
var toIObject = require('./_to-iobject');
var arrayIndexOf = require('./_array-includes')(false);
var IE_PROTO = require('./_shared-key')('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

},{"./_array-includes":77,"./_has":107,"./_shared-key":165,"./_to-iobject":180}],146:[function(require,module,exports){
// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = require('./_object-keys-internal');
var enumBugKeys = require('./_enum-bug-keys');

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

},{"./_enum-bug-keys":97,"./_object-keys-internal":145}],147:[function(require,module,exports){
exports.f = {}.propertyIsEnumerable;

},{}],148:[function(require,module,exports){
// most Object methods by ES6 should accept primitives
var $export = require('./_export');
var core = require('./_core');
var fails = require('./_fails');
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};

},{"./_core":89,"./_export":99,"./_fails":101}],149:[function(require,module,exports){
var getKeys = require('./_object-keys');
var toIObject = require('./_to-iobject');
var isEnum = require('./_object-pie').f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) if (isEnum.call(O, key = keys[i++])) {
      result.push(isEntries ? [key, O[key]] : O[key]);
    } return result;
  };
};

},{"./_object-keys":146,"./_object-pie":147,"./_to-iobject":180}],150:[function(require,module,exports){
// all object keys, includes non-enumerable and symbols
var gOPN = require('./_object-gopn');
var gOPS = require('./_object-gops');
var anObject = require('./_an-object');
var Reflect = require('./_global').Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};

},{"./_an-object":73,"./_global":106,"./_object-gopn":142,"./_object-gops":143}],151:[function(require,module,exports){
var $parseFloat = require('./_global').parseFloat;
var $trim = require('./_string-trim').trim;

module.exports = 1 / $parseFloat(require('./_string-ws') + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;

},{"./_global":106,"./_string-trim":174,"./_string-ws":175}],152:[function(require,module,exports){
var $parseInt = require('./_global').parseInt;
var $trim = require('./_string-trim').trim;
var ws = require('./_string-ws');
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;

},{"./_global":106,"./_string-trim":174,"./_string-ws":175}],153:[function(require,module,exports){
module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};

},{}],154:[function(require,module,exports){
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var newPromiseCapability = require('./_new-promise-capability');

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};

},{"./_an-object":73,"./_is-object":117,"./_new-promise-capability":134}],155:[function(require,module,exports){
module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

},{}],156:[function(require,module,exports){
var redefine = require('./_redefine');
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};

},{"./_redefine":157}],157:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var has = require('./_has');
var SRC = require('./_uid')('src');
var TO_STRING = 'toString';
var $toString = Function[TO_STRING];
var TPL = ('' + $toString).split(TO_STRING);

require('./_core').inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});

},{"./_core":89,"./_global":106,"./_has":107,"./_hide":108,"./_uid":187}],158:[function(require,module,exports){
module.exports = function (regExp, replace) {
  var replacer = replace === Object(replace) ? function (part) {
    return replace[part];
  } : replace;
  return function (it) {
    return String(it).replace(regExp, replacer);
  };
};

},{}],159:[function(require,module,exports){
// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};

},{}],160:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');
var aFunction = require('./_a-function');
var ctx = require('./_ctx');
var forOf = require('./_for-of');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
    var mapFn = arguments[1];
    var mapping, A, n, cb;
    aFunction(this);
    mapping = mapFn !== undefined;
    if (mapping) aFunction(mapFn);
    if (source == undefined) return new this();
    A = [];
    if (mapping) {
      n = 0;
      cb = ctx(mapFn, arguments[2], 2);
      forOf(source, false, function (nextItem) {
        A.push(cb(nextItem, n++));
      });
    } else {
      forOf(source, false, A.push, A);
    }
    return new this(A);
  } });
};

},{"./_a-function":69,"./_ctx":91,"./_export":99,"./_for-of":105}],161:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-setmap-offrom/
var $export = require('./_export');

module.exports = function (COLLECTION) {
  $export($export.S, COLLECTION, { of: function of() {
    var length = arguments.length;
    var A = new Array(length);
    while (length--) A[length] = arguments[length];
    return new this(A);
  } });
};

},{"./_export":99}],162:[function(require,module,exports){
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = require('./_is-object');
var anObject = require('./_an-object');
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = require('./_ctx')(Function.call, require('./_object-gopd').f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

},{"./_an-object":73,"./_ctx":91,"./_is-object":117,"./_object-gopd":140}],163:[function(require,module,exports){
'use strict';
var global = require('./_global');
var dP = require('./_object-dp');
var DESCRIPTORS = require('./_descriptors');
var SPECIES = require('./_wks')('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};

},{"./_descriptors":95,"./_global":106,"./_object-dp":137,"./_wks":192}],164:[function(require,module,exports){
var def = require('./_object-dp').f;
var has = require('./_has');
var TAG = require('./_wks')('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

},{"./_has":107,"./_object-dp":137,"./_wks":192}],165:[function(require,module,exports){
var shared = require('./_shared')('keys');
var uid = require('./_uid');
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

},{"./_shared":166,"./_uid":187}],166:[function(require,module,exports){
var global = require('./_global');
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

},{"./_global":106}],167:[function(require,module,exports){
// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var SPECIES = require('./_wks')('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

},{"./_a-function":69,"./_an-object":73,"./_wks":192}],168:[function(require,module,exports){
'use strict';
var fails = require('./_fails');

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};

},{"./_fails":101}],169:[function(require,module,exports){
var toInteger = require('./_to-integer');
var defined = require('./_defined');
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

},{"./_defined":94,"./_to-integer":179}],170:[function(require,module,exports){
// helper for String#{startsWith, endsWith, includes}
var isRegExp = require('./_is-regexp');
var defined = require('./_defined');

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};

},{"./_defined":94,"./_is-regexp":118}],171:[function(require,module,exports){
var $export = require('./_export');
var fails = require('./_fails');
var defined = require('./_defined');
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};

},{"./_defined":94,"./_export":99,"./_fails":101}],172:[function(require,module,exports){
// https://github.com/tc39/proposal-string-pad-start-end
var toLength = require('./_to-length');
var repeat = require('./_string-repeat');
var defined = require('./_defined');

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};

},{"./_defined":94,"./_string-repeat":173,"./_to-length":181}],173:[function(require,module,exports){
'use strict';
var toInteger = require('./_to-integer');
var defined = require('./_defined');

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};

},{"./_defined":94,"./_to-integer":179}],174:[function(require,module,exports){
var $export = require('./_export');
var defined = require('./_defined');
var fails = require('./_fails');
var spaces = require('./_string-ws');
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;

},{"./_defined":94,"./_export":99,"./_fails":101,"./_string-ws":175}],175:[function(require,module,exports){
module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

},{}],176:[function(require,module,exports){
var ctx = require('./_ctx');
var invoke = require('./_invoke');
var html = require('./_html');
var cel = require('./_dom-create');
var global = require('./_global');
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (require('./_cof')(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};

},{"./_cof":84,"./_ctx":91,"./_dom-create":96,"./_global":106,"./_html":109,"./_invoke":112}],177:[function(require,module,exports){
var toInteger = require('./_to-integer');
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

},{"./_to-integer":179}],178:[function(require,module,exports){
// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};

},{"./_to-integer":179,"./_to-length":181}],179:[function(require,module,exports){
// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

},{}],180:[function(require,module,exports){
// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = require('./_iobject');
var defined = require('./_defined');
module.exports = function (it) {
  return IObject(defined(it));
};

},{"./_defined":94,"./_iobject":113}],181:[function(require,module,exports){
// 7.1.15 ToLength
var toInteger = require('./_to-integer');
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

},{"./_to-integer":179}],182:[function(require,module,exports){
// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};

},{"./_defined":94}],183:[function(require,module,exports){
// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = require('./_is-object');
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

},{"./_is-object":117}],184:[function(require,module,exports){
'use strict';
if (require('./_descriptors')) {
  var LIBRARY = require('./_library');
  var global = require('./_global');
  var fails = require('./_fails');
  var $export = require('./_export');
  var $typed = require('./_typed');
  var $buffer = require('./_typed-buffer');
  var ctx = require('./_ctx');
  var anInstance = require('./_an-instance');
  var propertyDesc = require('./_property-desc');
  var hide = require('./_hide');
  var redefineAll = require('./_redefine-all');
  var toInteger = require('./_to-integer');
  var toLength = require('./_to-length');
  var toIndex = require('./_to-index');
  var toAbsoluteIndex = require('./_to-absolute-index');
  var toPrimitive = require('./_to-primitive');
  var has = require('./_has');
  var classof = require('./_classof');
  var isObject = require('./_is-object');
  var toObject = require('./_to-object');
  var isArrayIter = require('./_is-array-iter');
  var create = require('./_object-create');
  var getPrototypeOf = require('./_object-gpo');
  var gOPN = require('./_object-gopn').f;
  var getIterFn = require('./core.get-iterator-method');
  var uid = require('./_uid');
  var wks = require('./_wks');
  var createArrayMethod = require('./_array-methods');
  var createArrayIncludes = require('./_array-includes');
  var speciesConstructor = require('./_species-constructor');
  var ArrayIterators = require('./es6.array.iterator');
  var Iterators = require('./_iterators');
  var $iterDetect = require('./_iter-detect');
  var setSpecies = require('./_set-species');
  var arrayFill = require('./_array-fill');
  var arrayCopyWithin = require('./_array-copy-within');
  var $DP = require('./_object-dp');
  var $GOPD = require('./_object-gopd');
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };

},{"./_an-instance":72,"./_array-copy-within":74,"./_array-fill":75,"./_array-includes":77,"./_array-methods":78,"./_classof":83,"./_ctx":91,"./_descriptors":95,"./_export":99,"./_fails":101,"./_global":106,"./_has":107,"./_hide":108,"./_is-array-iter":114,"./_is-object":117,"./_iter-detect":122,"./_iterators":124,"./_library":125,"./_object-create":136,"./_object-dp":137,"./_object-gopd":140,"./_object-gopn":142,"./_object-gpo":144,"./_property-desc":155,"./_redefine-all":156,"./_set-species":163,"./_species-constructor":167,"./_to-absolute-index":177,"./_to-index":178,"./_to-integer":179,"./_to-length":181,"./_to-object":182,"./_to-primitive":183,"./_typed":186,"./_typed-buffer":185,"./_uid":187,"./_wks":192,"./core.get-iterator-method":193,"./es6.array.iterator":205}],185:[function(require,module,exports){
'use strict';
var global = require('./_global');
var DESCRIPTORS = require('./_descriptors');
var LIBRARY = require('./_library');
var $typed = require('./_typed');
var hide = require('./_hide');
var redefineAll = require('./_redefine-all');
var fails = require('./_fails');
var anInstance = require('./_an-instance');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var toIndex = require('./_to-index');
var gOPN = require('./_object-gopn').f;
var dP = require('./_object-dp').f;
var arrayFill = require('./_array-fill');
var setToStringTag = require('./_set-to-string-tag');
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;

},{"./_an-instance":72,"./_array-fill":75,"./_descriptors":95,"./_fails":101,"./_global":106,"./_hide":108,"./_library":125,"./_object-dp":137,"./_object-gopn":142,"./_redefine-all":156,"./_set-to-string-tag":164,"./_to-index":178,"./_to-integer":179,"./_to-length":181,"./_typed":186}],186:[function(require,module,exports){
var global = require('./_global');
var hide = require('./_hide');
var uid = require('./_uid');
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};

},{"./_global":106,"./_hide":108,"./_uid":187}],187:[function(require,module,exports){
var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

},{}],188:[function(require,module,exports){
var global = require('./_global');
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';

},{"./_global":106}],189:[function(require,module,exports){
var isObject = require('./_is-object');
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};

},{"./_is-object":117}],190:[function(require,module,exports){
var global = require('./_global');
var core = require('./_core');
var LIBRARY = require('./_library');
var wksExt = require('./_wks-ext');
var defineProperty = require('./_object-dp').f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

},{"./_core":89,"./_global":106,"./_library":125,"./_object-dp":137,"./_wks-ext":191}],191:[function(require,module,exports){
exports.f = require('./_wks');

},{"./_wks":192}],192:[function(require,module,exports){
var store = require('./_shared')('wks');
var uid = require('./_uid');
var Symbol = require('./_global').Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

},{"./_global":106,"./_shared":166,"./_uid":187}],193:[function(require,module,exports){
var classof = require('./_classof');
var ITERATOR = require('./_wks')('iterator');
var Iterators = require('./_iterators');
module.exports = require('./_core').getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

},{"./_classof":83,"./_core":89,"./_iterators":124,"./_wks":192}],194:[function(require,module,exports){
// https://github.com/benjamingr/RexExp.escape
var $export = require('./_export');
var $re = require('./_replacer')(/[\\^$*+?.()|[\]{}]/g, '\\$&');

$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });

},{"./_export":99,"./_replacer":158}],195:[function(require,module,exports){
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { copyWithin: require('./_array-copy-within') });

require('./_add-to-unscopables')('copyWithin');

},{"./_add-to-unscopables":71,"./_array-copy-within":74,"./_export":99}],196:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $every = require('./_array-methods')(4);

$export($export.P + $export.F * !require('./_strict-method')([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":78,"./_export":99,"./_strict-method":168}],197:[function(require,module,exports){
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = require('./_export');

$export($export.P, 'Array', { fill: require('./_array-fill') });

require('./_add-to-unscopables')('fill');

},{"./_add-to-unscopables":71,"./_array-fill":75,"./_export":99}],198:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $filter = require('./_array-methods')(2);

$export($export.P + $export.F * !require('./_strict-method')([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":78,"./_export":99,"./_strict-method":168}],199:[function(require,module,exports){
'use strict';
// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":71,"./_array-methods":78,"./_export":99}],200:[function(require,module,exports){
'use strict';
// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = require('./_export');
var $find = require('./_array-methods')(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
require('./_add-to-unscopables')(KEY);

},{"./_add-to-unscopables":71,"./_array-methods":78,"./_export":99}],201:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $forEach = require('./_array-methods')(0);
var STRICT = require('./_strict-method')([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":78,"./_export":99,"./_strict-method":168}],202:[function(require,module,exports){
'use strict';
var ctx = require('./_ctx');
var $export = require('./_export');
var toObject = require('./_to-object');
var call = require('./_iter-call');
var isArrayIter = require('./_is-array-iter');
var toLength = require('./_to-length');
var createProperty = require('./_create-property');
var getIterFn = require('./core.get-iterator-method');

$export($export.S + $export.F * !require('./_iter-detect')(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});

},{"./_create-property":90,"./_ctx":91,"./_export":99,"./_is-array-iter":114,"./_iter-call":119,"./_iter-detect":122,"./_to-length":181,"./_to-object":182,"./core.get-iterator-method":193}],203:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $indexOf = require('./_array-includes')(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});

},{"./_array-includes":77,"./_export":99,"./_strict-method":168}],204:[function(require,module,exports){
// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = require('./_export');

$export($export.S, 'Array', { isArray: require('./_is-array') });

},{"./_export":99,"./_is-array":115}],205:[function(require,module,exports){
'use strict';
var addToUnscopables = require('./_add-to-unscopables');
var step = require('./_iter-step');
var Iterators = require('./_iterators');
var toIObject = require('./_to-iobject');

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = require('./_iter-define')(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

},{"./_add-to-unscopables":71,"./_iter-define":121,"./_iter-step":123,"./_iterators":124,"./_to-iobject":180}],206:[function(require,module,exports){
'use strict';
// 22.1.3.13 Array.prototype.join(separator)
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (require('./_iobject') != Object || !require('./_strict-method')(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});

},{"./_export":99,"./_iobject":113,"./_strict-method":168,"./_to-iobject":180}],207:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toInteger = require('./_to-integer');
var toLength = require('./_to-length');
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !require('./_strict-method')($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});

},{"./_export":99,"./_strict-method":168,"./_to-integer":179,"./_to-iobject":180,"./_to-length":181}],208:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $map = require('./_array-methods')(1);

$export($export.P + $export.F * !require('./_strict-method')([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":78,"./_export":99,"./_strict-method":168}],209:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var createProperty = require('./_create-property');

// WebKit Array.of isn't generic
$export($export.S + $export.F * require('./_fails')(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});

},{"./_create-property":90,"./_export":99,"./_fails":101}],210:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});

},{"./_array-reduce":79,"./_export":99,"./_strict-method":168}],211:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $reduce = require('./_array-reduce');

$export($export.P + $export.F * !require('./_strict-method')([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});

},{"./_array-reduce":79,"./_export":99,"./_strict-method":168}],212:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var html = require('./_html');
var cof = require('./_cof');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * require('./_fails')(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});

},{"./_cof":84,"./_export":99,"./_fails":101,"./_html":109,"./_to-absolute-index":177,"./_to-length":181}],213:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $some = require('./_array-methods')(3);

$export($export.P + $export.F * !require('./_strict-method')([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});

},{"./_array-methods":78,"./_export":99,"./_strict-method":168}],214:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var aFunction = require('./_a-function');
var toObject = require('./_to-object');
var fails = require('./_fails');
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !require('./_strict-method')($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});

},{"./_a-function":69,"./_export":99,"./_fails":101,"./_strict-method":168,"./_to-object":182}],215:[function(require,module,exports){
require('./_set-species')('Array');

},{"./_set-species":163}],216:[function(require,module,exports){
// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = require('./_export');

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });

},{"./_export":99}],217:[function(require,module,exports){
// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = require('./_export');
var toISOString = require('./_date-to-iso-string');

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});

},{"./_date-to-iso-string":92,"./_export":99}],218:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');

$export($export.P + $export.F * require('./_fails')(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});

},{"./_export":99,"./_fails":101,"./_to-object":182,"./_to-primitive":183}],219:[function(require,module,exports){
var TO_PRIMITIVE = require('./_wks')('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) require('./_hide')(proto, TO_PRIMITIVE, require('./_date-to-primitive'));

},{"./_date-to-primitive":93,"./_hide":108,"./_wks":192}],220:[function(require,module,exports){
var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  require('./_redefine')(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}

},{"./_redefine":157}],221:[function(require,module,exports){
// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = require('./_export');

$export($export.P, 'Function', { bind: require('./_bind') });

},{"./_bind":82,"./_export":99}],222:[function(require,module,exports){
'use strict';
var isObject = require('./_is-object');
var getPrototypeOf = require('./_object-gpo');
var HAS_INSTANCE = require('./_wks')('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) require('./_object-dp').f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });

},{"./_is-object":117,"./_object-dp":137,"./_object-gpo":144,"./_wks":192}],223:[function(require,module,exports){
var dP = require('./_object-dp').f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || require('./_descriptors') && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});

},{"./_descriptors":95,"./_object-dp":137}],224:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var MAP = 'Map';

// 23.1 Map Objects
module.exports = require('./_collection')(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);

},{"./_collection":88,"./_collection-strong":85,"./_validate-collection":189}],225:[function(require,module,exports){
// 20.2.2.3 Math.acosh(x)
var $export = require('./_export');
var log1p = require('./_math-log1p');
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});

},{"./_export":99,"./_math-log1p":128}],226:[function(require,module,exports){
// 20.2.2.5 Math.asinh(x)
var $export = require('./_export');
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });

},{"./_export":99}],227:[function(require,module,exports){
// 20.2.2.7 Math.atanh(x)
var $export = require('./_export');
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});

},{"./_export":99}],228:[function(require,module,exports){
// 20.2.2.9 Math.cbrt(x)
var $export = require('./_export');
var sign = require('./_math-sign');

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});

},{"./_export":99,"./_math-sign":130}],229:[function(require,module,exports){
// 20.2.2.11 Math.clz32(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});

},{"./_export":99}],230:[function(require,module,exports){
// 20.2.2.12 Math.cosh(x)
var $export = require('./_export');
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});

},{"./_export":99}],231:[function(require,module,exports){
// 20.2.2.14 Math.expm1(x)
var $export = require('./_export');
var $expm1 = require('./_math-expm1');

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });

},{"./_export":99,"./_math-expm1":126}],232:[function(require,module,exports){
// 20.2.2.16 Math.fround(x)
var $export = require('./_export');

$export($export.S, 'Math', { fround: require('./_math-fround') });

},{"./_export":99,"./_math-fround":127}],233:[function(require,module,exports){
// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = require('./_export');
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});

},{"./_export":99}],234:[function(require,module,exports){
// 20.2.2.18 Math.imul(x, y)
var $export = require('./_export');
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * require('./_fails')(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});

},{"./_export":99,"./_fails":101}],235:[function(require,module,exports){
// 20.2.2.21 Math.log10(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});

},{"./_export":99}],236:[function(require,module,exports){
// 20.2.2.20 Math.log1p(x)
var $export = require('./_export');

$export($export.S, 'Math', { log1p: require('./_math-log1p') });

},{"./_export":99,"./_math-log1p":128}],237:[function(require,module,exports){
// 20.2.2.22 Math.log2(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});

},{"./_export":99}],238:[function(require,module,exports){
// 20.2.2.28 Math.sign(x)
var $export = require('./_export');

$export($export.S, 'Math', { sign: require('./_math-sign') });

},{"./_export":99,"./_math-sign":130}],239:[function(require,module,exports){
// 20.2.2.30 Math.sinh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * require('./_fails')(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});

},{"./_export":99,"./_fails":101,"./_math-expm1":126}],240:[function(require,module,exports){
// 20.2.2.33 Math.tanh(x)
var $export = require('./_export');
var expm1 = require('./_math-expm1');
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});

},{"./_export":99,"./_math-expm1":126}],241:[function(require,module,exports){
// 20.2.2.34 Math.trunc(x)
var $export = require('./_export');

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});

},{"./_export":99}],242:[function(require,module,exports){
'use strict';
var global = require('./_global');
var has = require('./_has');
var cof = require('./_cof');
var inheritIfRequired = require('./_inherit-if-required');
var toPrimitive = require('./_to-primitive');
var fails = require('./_fails');
var gOPN = require('./_object-gopn').f;
var gOPD = require('./_object-gopd').f;
var dP = require('./_object-dp').f;
var $trim = require('./_string-trim').trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(require('./_object-create')(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = require('./_descriptors') ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  require('./_redefine')(global, NUMBER, $Number);
}

},{"./_cof":84,"./_descriptors":95,"./_fails":101,"./_global":106,"./_has":107,"./_inherit-if-required":111,"./_object-create":136,"./_object-dp":137,"./_object-gopd":140,"./_object-gopn":142,"./_redefine":157,"./_string-trim":174,"./_to-primitive":183}],243:[function(require,module,exports){
// 20.1.2.1 Number.EPSILON
var $export = require('./_export');

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });

},{"./_export":99}],244:[function(require,module,exports){
// 20.1.2.2 Number.isFinite(number)
var $export = require('./_export');
var _isFinite = require('./_global').isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});

},{"./_export":99,"./_global":106}],245:[function(require,module,exports){
// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });

},{"./_export":99,"./_is-integer":116}],246:[function(require,module,exports){
// 20.1.2.4 Number.isNaN(number)
var $export = require('./_export');

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});

},{"./_export":99}],247:[function(require,module,exports){
// 20.1.2.5 Number.isSafeInteger(number)
var $export = require('./_export');
var isInteger = require('./_is-integer');
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});

},{"./_export":99,"./_is-integer":116}],248:[function(require,module,exports){
// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });

},{"./_export":99}],249:[function(require,module,exports){
// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = require('./_export');

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });

},{"./_export":99}],250:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });

},{"./_export":99,"./_parse-float":151}],251:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });

},{"./_export":99,"./_parse-int":152}],252:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toInteger = require('./_to-integer');
var aNumberValue = require('./_a-number-value');
var repeat = require('./_string-repeat');
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !require('./_fails')(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});

},{"./_a-number-value":70,"./_export":99,"./_fails":101,"./_string-repeat":173,"./_to-integer":179}],253:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $fails = require('./_fails');
var aNumberValue = require('./_a-number-value');
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});

},{"./_a-number-value":70,"./_export":99,"./_fails":101}],254:[function(require,module,exports){
// 19.1.3.1 Object.assign(target, source)
var $export = require('./_export');

$export($export.S + $export.F, 'Object', { assign: require('./_object-assign') });

},{"./_export":99,"./_object-assign":135}],255:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: require('./_object-create') });

},{"./_export":99,"./_object-create":136}],256:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperties: require('./_object-dps') });

},{"./_descriptors":95,"./_export":99,"./_object-dps":138}],257:[function(require,module,exports){
var $export = require('./_export');
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !require('./_descriptors'), 'Object', { defineProperty: require('./_object-dp').f });

},{"./_descriptors":95,"./_export":99,"./_object-dp":137}],258:[function(require,module,exports){
// 19.1.2.5 Object.freeze(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});

},{"./_is-object":117,"./_meta":131,"./_object-sap":148}],259:[function(require,module,exports){
// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = require('./_to-iobject');
var $getOwnPropertyDescriptor = require('./_object-gopd').f;

require('./_object-sap')('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

},{"./_object-gopd":140,"./_object-sap":148,"./_to-iobject":180}],260:[function(require,module,exports){
// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});

},{"./_object-gopn-ext":141,"./_object-sap":148}],261:[function(require,module,exports){
// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = require('./_to-object');
var $getPrototypeOf = require('./_object-gpo');

require('./_object-sap')('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

},{"./_object-gpo":144,"./_object-sap":148,"./_to-object":182}],262:[function(require,module,exports){
// 19.1.2.11 Object.isExtensible(O)
var isObject = require('./_is-object');

require('./_object-sap')('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});

},{"./_is-object":117,"./_object-sap":148}],263:[function(require,module,exports){
// 19.1.2.12 Object.isFrozen(O)
var isObject = require('./_is-object');

require('./_object-sap')('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});

},{"./_is-object":117,"./_object-sap":148}],264:[function(require,module,exports){
// 19.1.2.13 Object.isSealed(O)
var isObject = require('./_is-object');

require('./_object-sap')('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});

},{"./_is-object":117,"./_object-sap":148}],265:[function(require,module,exports){
// 19.1.3.10 Object.is(value1, value2)
var $export = require('./_export');
$export($export.S, 'Object', { is: require('./_same-value') });

},{"./_export":99,"./_same-value":159}],266:[function(require,module,exports){
// 19.1.2.14 Object.keys(O)
var toObject = require('./_to-object');
var $keys = require('./_object-keys');

require('./_object-sap')('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});

},{"./_object-keys":146,"./_object-sap":148,"./_to-object":182}],267:[function(require,module,exports){
// 19.1.2.15 Object.preventExtensions(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});

},{"./_is-object":117,"./_meta":131,"./_object-sap":148}],268:[function(require,module,exports){
// 19.1.2.17 Object.seal(O)
var isObject = require('./_is-object');
var meta = require('./_meta').onFreeze;

require('./_object-sap')('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});

},{"./_is-object":117,"./_meta":131,"./_object-sap":148}],269:[function(require,module,exports){
// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = require('./_export');
$export($export.S, 'Object', { setPrototypeOf: require('./_set-proto').set });

},{"./_export":99,"./_set-proto":162}],270:[function(require,module,exports){
'use strict';
// 19.1.3.6 Object.prototype.toString()
var classof = require('./_classof');
var test = {};
test[require('./_wks')('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  require('./_redefine')(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}

},{"./_classof":83,"./_redefine":157,"./_wks":192}],271:[function(require,module,exports){
var $export = require('./_export');
var $parseFloat = require('./_parse-float');
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });

},{"./_export":99,"./_parse-float":151}],272:[function(require,module,exports){
var $export = require('./_export');
var $parseInt = require('./_parse-int');
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });

},{"./_export":99,"./_parse-int":152}],273:[function(require,module,exports){
'use strict';
var LIBRARY = require('./_library');
var global = require('./_global');
var ctx = require('./_ctx');
var classof = require('./_classof');
var $export = require('./_export');
var isObject = require('./_is-object');
var aFunction = require('./_a-function');
var anInstance = require('./_an-instance');
var forOf = require('./_for-of');
var speciesConstructor = require('./_species-constructor');
var task = require('./_task').set;
var microtask = require('./_microtask')();
var newPromiseCapabilityModule = require('./_new-promise-capability');
var perform = require('./_perform');
var promiseResolve = require('./_promise-resolve');
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[require('./_wks')('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value);
            if (domain) domain.exit();
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = require('./_redefine-all')($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
require('./_set-to-string-tag')($Promise, PROMISE);
require('./_set-species')(PROMISE);
Wrapper = require('./_core')[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && require('./_iter-detect')(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});

},{"./_a-function":69,"./_an-instance":72,"./_classof":83,"./_core":89,"./_ctx":91,"./_export":99,"./_for-of":105,"./_global":106,"./_is-object":117,"./_iter-detect":122,"./_library":125,"./_microtask":133,"./_new-promise-capability":134,"./_perform":153,"./_promise-resolve":154,"./_redefine-all":156,"./_set-species":163,"./_set-to-string-tag":164,"./_species-constructor":167,"./_task":176,"./_wks":192}],274:[function(require,module,exports){
// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = require('./_export');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var rApply = (require('./_global').Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !require('./_fails')(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});

},{"./_a-function":69,"./_an-object":73,"./_export":99,"./_fails":101,"./_global":106}],275:[function(require,module,exports){
// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = require('./_export');
var create = require('./_object-create');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var fails = require('./_fails');
var bind = require('./_bind');
var rConstruct = (require('./_global').Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});

},{"./_a-function":69,"./_an-object":73,"./_bind":82,"./_export":99,"./_fails":101,"./_global":106,"./_is-object":117,"./_object-create":136}],276:[function(require,module,exports){
// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = require('./_object-dp');
var $export = require('./_export');
var anObject = require('./_an-object');
var toPrimitive = require('./_to-primitive');

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * require('./_fails')(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":73,"./_export":99,"./_fails":101,"./_object-dp":137,"./_to-primitive":183}],277:[function(require,module,exports){
// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = require('./_export');
var gOPD = require('./_object-gopd').f;
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});

},{"./_an-object":73,"./_export":99,"./_object-gopd":140}],278:[function(require,module,exports){
'use strict';
// 26.1.5 Reflect.enumerate(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
require('./_iter-create')(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});

},{"./_an-object":73,"./_export":99,"./_iter-create":120}],279:[function(require,module,exports){
// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = require('./_object-gopd');
var $export = require('./_export');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});

},{"./_an-object":73,"./_export":99,"./_object-gopd":140}],280:[function(require,module,exports){
// 26.1.8 Reflect.getPrototypeOf(target)
var $export = require('./_export');
var getProto = require('./_object-gpo');
var anObject = require('./_an-object');

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});

},{"./_an-object":73,"./_export":99,"./_object-gpo":144}],281:[function(require,module,exports){
// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var isObject = require('./_is-object');
var anObject = require('./_an-object');

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });

},{"./_an-object":73,"./_export":99,"./_has":107,"./_is-object":117,"./_object-gopd":140,"./_object-gpo":144}],282:[function(require,module,exports){
// 26.1.9 Reflect.has(target, propertyKey)
var $export = require('./_export');

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});

},{"./_export":99}],283:[function(require,module,exports){
// 26.1.10 Reflect.isExtensible(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});

},{"./_an-object":73,"./_export":99}],284:[function(require,module,exports){
// 26.1.11 Reflect.ownKeys(target)
var $export = require('./_export');

$export($export.S, 'Reflect', { ownKeys: require('./_own-keys') });

},{"./_export":99,"./_own-keys":150}],285:[function(require,module,exports){
// 26.1.12 Reflect.preventExtensions(target)
var $export = require('./_export');
var anObject = require('./_an-object');
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_an-object":73,"./_export":99}],286:[function(require,module,exports){
// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = require('./_export');
var setProto = require('./_set-proto');

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});

},{"./_export":99,"./_set-proto":162}],287:[function(require,module,exports){
// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = require('./_object-dp');
var gOPD = require('./_object-gopd');
var getPrototypeOf = require('./_object-gpo');
var has = require('./_has');
var $export = require('./_export');
var createDesc = require('./_property-desc');
var anObject = require('./_an-object');
var isObject = require('./_is-object');

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
    existingDescriptor.value = V;
    dP.f(receiver, propertyKey, existingDescriptor);
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });

},{"./_an-object":73,"./_export":99,"./_has":107,"./_is-object":117,"./_object-dp":137,"./_object-gopd":140,"./_object-gpo":144,"./_property-desc":155}],288:[function(require,module,exports){
var global = require('./_global');
var inheritIfRequired = require('./_inherit-if-required');
var dP = require('./_object-dp').f;
var gOPN = require('./_object-gopn').f;
var isRegExp = require('./_is-regexp');
var $flags = require('./_flags');
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (require('./_descriptors') && (!CORRECT_NEW || require('./_fails')(function () {
  re2[require('./_wks')('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  require('./_redefine')(global, 'RegExp', $RegExp);
}

require('./_set-species')('RegExp');

},{"./_descriptors":95,"./_fails":101,"./_flags":103,"./_global":106,"./_inherit-if-required":111,"./_is-regexp":118,"./_object-dp":137,"./_object-gopn":142,"./_redefine":157,"./_set-species":163,"./_wks":192}],289:[function(require,module,exports){
// 21.2.5.3 get RegExp.prototype.flags()
if (require('./_descriptors') && /./g.flags != 'g') require('./_object-dp').f(RegExp.prototype, 'flags', {
  configurable: true,
  get: require('./_flags')
});

},{"./_descriptors":95,"./_flags":103,"./_object-dp":137}],290:[function(require,module,exports){
// @@match logic
require('./_fix-re-wks')('match', 1, function (defined, MATCH, $match) {
  // 21.1.3.11 String.prototype.match(regexp)
  return [function match(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[MATCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
  }, $match];
});

},{"./_fix-re-wks":102}],291:[function(require,module,exports){
// @@replace logic
require('./_fix-re-wks')('replace', 2, function (defined, REPLACE, $replace) {
  // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
  return [function replace(searchValue, replaceValue) {
    'use strict';
    var O = defined(this);
    var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
    return fn !== undefined
      ? fn.call(searchValue, O, replaceValue)
      : $replace.call(String(O), searchValue, replaceValue);
  }, $replace];
});

},{"./_fix-re-wks":102}],292:[function(require,module,exports){
// @@search logic
require('./_fix-re-wks')('search', 1, function (defined, SEARCH, $search) {
  // 21.1.3.15 String.prototype.search(regexp)
  return [function search(regexp) {
    'use strict';
    var O = defined(this);
    var fn = regexp == undefined ? undefined : regexp[SEARCH];
    return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
  }, $search];
});

},{"./_fix-re-wks":102}],293:[function(require,module,exports){
// @@split logic
require('./_fix-re-wks')('split', 2, function (defined, SPLIT, $split) {
  'use strict';
  var isRegExp = require('./_is-regexp');
  var _split = $split;
  var $push = [].push;
  var $SPLIT = 'split';
  var LENGTH = 'length';
  var LAST_INDEX = 'lastIndex';
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
    // based on es5-shim implementation, need to rework it
    $split = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return _split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var separator2, match, lastIndex, lastLength, i;
      // Doesn't need flags gy, but they don't hurt
      if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
      while (match = separatorCopy.exec(string)) {
        // `separatorCopy.lastIndex` is not reliable cross-browser
        lastIndex = match.index + match[0][LENGTH];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
          // eslint-disable-next-line no-loop-func
          if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
            for (i = 1; i < arguments[LENGTH] - 2; i++) if (arguments[i] === undefined) match[i] = undefined;
          });
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    $split = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
    };
  }
  // 21.1.3.17 String.prototype.split(separator, limit)
  return [function split(separator, limit) {
    var O = defined(this);
    var fn = separator == undefined ? undefined : separator[SPLIT];
    return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
  }, $split];
});

},{"./_fix-re-wks":102,"./_is-regexp":118}],294:[function(require,module,exports){
'use strict';
require('./es6.regexp.flags');
var anObject = require('./_an-object');
var $flags = require('./_flags');
var DESCRIPTORS = require('./_descriptors');
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  require('./_redefine')(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (require('./_fails')(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}

},{"./_an-object":73,"./_descriptors":95,"./_fails":101,"./_flags":103,"./_redefine":157,"./es6.regexp.flags":289}],295:[function(require,module,exports){
'use strict';
var strong = require('./_collection-strong');
var validate = require('./_validate-collection');
var SET = 'Set';

// 23.2 Set Objects
module.exports = require('./_collection')(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);

},{"./_collection":88,"./_collection-strong":85,"./_validate-collection":189}],296:[function(require,module,exports){
'use strict';
// B.2.3.2 String.prototype.anchor(name)
require('./_string-html')('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});

},{"./_string-html":171}],297:[function(require,module,exports){
'use strict';
// B.2.3.3 String.prototype.big()
require('./_string-html')('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});

},{"./_string-html":171}],298:[function(require,module,exports){
'use strict';
// B.2.3.4 String.prototype.blink()
require('./_string-html')('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});

},{"./_string-html":171}],299:[function(require,module,exports){
'use strict';
// B.2.3.5 String.prototype.bold()
require('./_string-html')('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});

},{"./_string-html":171}],300:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $at = require('./_string-at')(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});

},{"./_export":99,"./_string-at":169}],301:[function(require,module,exports){
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});

},{"./_export":99,"./_fails-is-regexp":100,"./_string-context":170,"./_to-length":181}],302:[function(require,module,exports){
'use strict';
// B.2.3.6 String.prototype.fixed()
require('./_string-html')('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});

},{"./_string-html":171}],303:[function(require,module,exports){
'use strict';
// B.2.3.7 String.prototype.fontcolor(color)
require('./_string-html')('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});

},{"./_string-html":171}],304:[function(require,module,exports){
'use strict';
// B.2.3.8 String.prototype.fontsize(size)
require('./_string-html')('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});

},{"./_string-html":171}],305:[function(require,module,exports){
var $export = require('./_export');
var toAbsoluteIndex = require('./_to-absolute-index');
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});

},{"./_export":99,"./_to-absolute-index":177}],306:[function(require,module,exports){
// 21.1.3.7 String.prototype.includes(searchString, position = 0)
'use strict';
var $export = require('./_export');
var context = require('./_string-context');
var INCLUDES = 'includes';

$export($export.P + $export.F * require('./_fails-is-regexp')(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});

},{"./_export":99,"./_fails-is-regexp":100,"./_string-context":170}],307:[function(require,module,exports){
'use strict';
// B.2.3.9 String.prototype.italics()
require('./_string-html')('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});

},{"./_string-html":171}],308:[function(require,module,exports){
'use strict';
var $at = require('./_string-at')(true);

// 21.1.3.27 String.prototype[@@iterator]()
require('./_iter-define')(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

},{"./_iter-define":121,"./_string-at":169}],309:[function(require,module,exports){
'use strict';
// B.2.3.10 String.prototype.link(url)
require('./_string-html')('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});

},{"./_string-html":171}],310:[function(require,module,exports){
var $export = require('./_export');
var toIObject = require('./_to-iobject');
var toLength = require('./_to-length');

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});

},{"./_export":99,"./_to-iobject":180,"./_to-length":181}],311:[function(require,module,exports){
var $export = require('./_export');

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: require('./_string-repeat')
});

},{"./_export":99,"./_string-repeat":173}],312:[function(require,module,exports){
'use strict';
// B.2.3.11 String.prototype.small()
require('./_string-html')('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});

},{"./_string-html":171}],313:[function(require,module,exports){
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
'use strict';
var $export = require('./_export');
var toLength = require('./_to-length');
var context = require('./_string-context');
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * require('./_fails-is-regexp')(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});

},{"./_export":99,"./_fails-is-regexp":100,"./_string-context":170,"./_to-length":181}],314:[function(require,module,exports){
'use strict';
// B.2.3.12 String.prototype.strike()
require('./_string-html')('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});

},{"./_string-html":171}],315:[function(require,module,exports){
'use strict';
// B.2.3.13 String.prototype.sub()
require('./_string-html')('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});

},{"./_string-html":171}],316:[function(require,module,exports){
'use strict';
// B.2.3.14 String.prototype.sup()
require('./_string-html')('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});

},{"./_string-html":171}],317:[function(require,module,exports){
'use strict';
// 21.1.3.25 String.prototype.trim()
require('./_string-trim')('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});

},{"./_string-trim":174}],318:[function(require,module,exports){
'use strict';
// ECMAScript 6 symbols shim
var global = require('./_global');
var has = require('./_has');
var DESCRIPTORS = require('./_descriptors');
var $export = require('./_export');
var redefine = require('./_redefine');
var META = require('./_meta').KEY;
var $fails = require('./_fails');
var shared = require('./_shared');
var setToStringTag = require('./_set-to-string-tag');
var uid = require('./_uid');
var wks = require('./_wks');
var wksExt = require('./_wks-ext');
var wksDefine = require('./_wks-define');
var enumKeys = require('./_enum-keys');
var isArray = require('./_is-array');
var anObject = require('./_an-object');
var isObject = require('./_is-object');
var toIObject = require('./_to-iobject');
var toPrimitive = require('./_to-primitive');
var createDesc = require('./_property-desc');
var _create = require('./_object-create');
var gOPNExt = require('./_object-gopn-ext');
var $GOPD = require('./_object-gopd');
var $DP = require('./_object-dp');
var $keys = require('./_object-keys');
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  require('./_object-gopn').f = gOPNExt.f = $getOwnPropertyNames;
  require('./_object-pie').f = $propertyIsEnumerable;
  require('./_object-gops').f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !require('./_library')) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || require('./_hide')($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

},{"./_an-object":73,"./_descriptors":95,"./_enum-keys":98,"./_export":99,"./_fails":101,"./_global":106,"./_has":107,"./_hide":108,"./_is-array":115,"./_is-object":117,"./_library":125,"./_meta":131,"./_object-create":136,"./_object-dp":137,"./_object-gopd":140,"./_object-gopn":142,"./_object-gopn-ext":141,"./_object-gops":143,"./_object-keys":146,"./_object-pie":147,"./_property-desc":155,"./_redefine":157,"./_set-to-string-tag":164,"./_shared":166,"./_to-iobject":180,"./_to-primitive":183,"./_uid":187,"./_wks":192,"./_wks-define":190,"./_wks-ext":191}],319:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var $typed = require('./_typed');
var buffer = require('./_typed-buffer');
var anObject = require('./_an-object');
var toAbsoluteIndex = require('./_to-absolute-index');
var toLength = require('./_to-length');
var isObject = require('./_is-object');
var ArrayBuffer = require('./_global').ArrayBuffer;
var speciesConstructor = require('./_species-constructor');
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * require('./_fails')(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var final = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < final) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

require('./_set-species')(ARRAY_BUFFER);

},{"./_an-object":73,"./_export":99,"./_fails":101,"./_global":106,"./_is-object":117,"./_set-species":163,"./_species-constructor":167,"./_to-absolute-index":177,"./_to-length":181,"./_typed":186,"./_typed-buffer":185}],320:[function(require,module,exports){
var $export = require('./_export');
$export($export.G + $export.W + $export.F * !require('./_typed').ABV, {
  DataView: require('./_typed-buffer').DataView
});

},{"./_export":99,"./_typed":186,"./_typed-buffer":185}],321:[function(require,module,exports){
require('./_typed-array')('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":184}],322:[function(require,module,exports){
require('./_typed-array')('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":184}],323:[function(require,module,exports){
require('./_typed-array')('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":184}],324:[function(require,module,exports){
require('./_typed-array')('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":184}],325:[function(require,module,exports){
require('./_typed-array')('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":184}],326:[function(require,module,exports){
require('./_typed-array')('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":184}],327:[function(require,module,exports){
require('./_typed-array')('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":184}],328:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});

},{"./_typed-array":184}],329:[function(require,module,exports){
require('./_typed-array')('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);

},{"./_typed-array":184}],330:[function(require,module,exports){
'use strict';
var each = require('./_array-methods')(0);
var redefine = require('./_redefine');
var meta = require('./_meta');
var assign = require('./_object-assign');
var weak = require('./_collection-weak');
var isObject = require('./_is-object');
var fails = require('./_fails');
var validate = require('./_validate-collection');
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var tmp = {};
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = require('./_collection')(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (fails(function () { return new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7; })) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}

},{"./_array-methods":78,"./_collection":88,"./_collection-weak":87,"./_fails":101,"./_is-object":117,"./_meta":131,"./_object-assign":135,"./_redefine":157,"./_validate-collection":189}],331:[function(require,module,exports){
'use strict';
var weak = require('./_collection-weak');
var validate = require('./_validate-collection');
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
require('./_collection')(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);

},{"./_collection":88,"./_collection-weak":87,"./_validate-collection":189}],332:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var aFunction = require('./_a-function');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

require('./_add-to-unscopables')('flatMap');

},{"./_a-function":69,"./_add-to-unscopables":71,"./_array-species-create":81,"./_export":99,"./_flatten-into-array":104,"./_to-length":181,"./_to-object":182}],333:[function(require,module,exports){
'use strict';
// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
var $export = require('./_export');
var flattenIntoArray = require('./_flatten-into-array');
var toObject = require('./_to-object');
var toLength = require('./_to-length');
var toInteger = require('./_to-integer');
var arraySpeciesCreate = require('./_array-species-create');

$export($export.P, 'Array', {
  flatten: function flatten(/* depthArg = 1 */) {
    var depthArg = arguments[0];
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

require('./_add-to-unscopables')('flatten');

},{"./_add-to-unscopables":71,"./_array-species-create":81,"./_export":99,"./_flatten-into-array":104,"./_to-integer":179,"./_to-length":181,"./_to-object":182}],334:[function(require,module,exports){
'use strict';
// https://github.com/tc39/Array.prototype.includes
var $export = require('./_export');
var $includes = require('./_array-includes')(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

require('./_add-to-unscopables')('includes');

},{"./_add-to-unscopables":71,"./_array-includes":77,"./_export":99}],335:[function(require,module,exports){
// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
var $export = require('./_export');
var microtask = require('./_microtask')();
var process = require('./_global').process;
var isNode = require('./_cof')(process) == 'process';

$export($export.G, {
  asap: function asap(fn) {
    var domain = isNode && process.domain;
    microtask(domain ? domain.bind(fn) : fn);
  }
});

},{"./_cof":84,"./_export":99,"./_global":106,"./_microtask":133}],336:[function(require,module,exports){
// https://github.com/ljharb/proposal-is-error
var $export = require('./_export');
var cof = require('./_cof');

$export($export.S, 'Error', {
  isError: function isError(it) {
    return cof(it) === 'Error';
  }
});

},{"./_cof":84,"./_export":99}],337:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });

},{"./_export":99,"./_global":106}],338:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
require('./_set-collection-from')('Map');

},{"./_set-collection-from":160}],339:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
require('./_set-collection-of')('Map');

},{"./_set-collection-of":161}],340:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Map', { toJSON: require('./_collection-to-json')('Map') });

},{"./_collection-to-json":86,"./_export":99}],341:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', {
  clamp: function clamp(x, lower, upper) {
    return Math.min(upper, Math.max(lower, x));
  }
});

},{"./_export":99}],342:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });

},{"./_export":99}],343:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var RAD_PER_DEG = 180 / Math.PI;

$export($export.S, 'Math', {
  degrees: function degrees(radians) {
    return radians * RAD_PER_DEG;
  }
});

},{"./_export":99}],344:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var scale = require('./_math-scale');
var fround = require('./_math-fround');

$export($export.S, 'Math', {
  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
    return fround(scale(x, inLow, inHigh, outLow, outHigh));
  }
});

},{"./_export":99,"./_math-fround":127,"./_math-scale":129}],345:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  iaddh: function iaddh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
  }
});

},{"./_export":99}],346:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  imulh: function imulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >> 16;
    var v1 = $v >> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
  }
});

},{"./_export":99}],347:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  isubh: function isubh(x0, x1, y0, y1) {
    var $x0 = x0 >>> 0;
    var $x1 = x1 >>> 0;
    var $y0 = y0 >>> 0;
    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
  }
});

},{"./_export":99}],348:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });

},{"./_export":99}],349:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');
var DEG_PER_RAD = Math.PI / 180;

$export($export.S, 'Math', {
  radians: function radians(degrees) {
    return degrees * DEG_PER_RAD;
  }
});

},{"./_export":99}],350:[function(require,module,exports){
// https://rwaldron.github.io/proposal-math-extensions/
var $export = require('./_export');

$export($export.S, 'Math', { scale: require('./_math-scale') });

},{"./_export":99,"./_math-scale":129}],351:[function(require,module,exports){
// http://jfbastien.github.io/papers/Math.signbit.html
var $export = require('./_export');

$export($export.S, 'Math', { signbit: function signbit(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
} });

},{"./_export":99}],352:[function(require,module,exports){
// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
var $export = require('./_export');

$export($export.S, 'Math', {
  umulh: function umulh(u, v) {
    var UINT16 = 0xffff;
    var $u = +u;
    var $v = +v;
    var u0 = $u & UINT16;
    var v0 = $v & UINT16;
    var u1 = $u >>> 16;
    var v1 = $v >>> 16;
    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
  }
});

},{"./_export":99}],353:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineGetter__: function __defineGetter__(P, getter) {
    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":69,"./_descriptors":95,"./_export":99,"./_object-dp":137,"./_object-forced-pam":139,"./_to-object":182}],354:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var aFunction = require('./_a-function');
var $defineProperty = require('./_object-dp');

// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __defineSetter__: function __defineSetter__(P, setter) {
    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
  }
});

},{"./_a-function":69,"./_descriptors":95,"./_export":99,"./_object-dp":137,"./_object-forced-pam":139,"./_to-object":182}],355:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $entries = require('./_object-to-array')(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});

},{"./_export":99,"./_object-to-array":149}],356:[function(require,module,exports){
// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = require('./_export');
var ownKeys = require('./_own-keys');
var toIObject = require('./_to-iobject');
var gOPD = require('./_object-gopd');
var createProperty = require('./_create-property');

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});

},{"./_create-property":90,"./_export":99,"./_object-gopd":140,"./_own-keys":150,"./_to-iobject":180}],357:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.4 Object.prototype.__lookupGetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupGetter__: function __lookupGetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":95,"./_export":99,"./_object-forced-pam":139,"./_object-gopd":140,"./_object-gpo":144,"./_to-object":182,"./_to-primitive":183}],358:[function(require,module,exports){
'use strict';
var $export = require('./_export');
var toObject = require('./_to-object');
var toPrimitive = require('./_to-primitive');
var getPrototypeOf = require('./_object-gpo');
var getOwnPropertyDescriptor = require('./_object-gopd').f;

// B.2.2.5 Object.prototype.__lookupSetter__(P)
require('./_descriptors') && $export($export.P + require('./_object-forced-pam'), 'Object', {
  __lookupSetter__: function __lookupSetter__(P) {
    var O = toObject(this);
    var K = toPrimitive(P, true);
    var D;
    do {
      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
    } while (O = getPrototypeOf(O));
  }
});

},{"./_descriptors":95,"./_export":99,"./_object-forced-pam":139,"./_object-gopd":140,"./_object-gpo":144,"./_to-object":182,"./_to-primitive":183}],359:[function(require,module,exports){
// https://github.com/tc39/proposal-object-values-entries
var $export = require('./_export');
var $values = require('./_object-to-array')(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});

},{"./_export":99,"./_object-to-array":149}],360:[function(require,module,exports){
'use strict';
// https://github.com/zenparsing/es-observable
var $export = require('./_export');
var global = require('./_global');
var core = require('./_core');
var microtask = require('./_microtask')();
var OBSERVABLE = require('./_wks')('observable');
var aFunction = require('./_a-function');
var anObject = require('./_an-object');
var anInstance = require('./_an-instance');
var redefineAll = require('./_redefine-all');
var hide = require('./_hide');
var forOf = require('./_for-of');
var RETURN = forOf.RETURN;

var getMethod = function (fn) {
  return fn == null ? undefined : aFunction(fn);
};

var cleanupSubscription = function (subscription) {
  var cleanup = subscription._c;
  if (cleanup) {
    subscription._c = undefined;
    cleanup();
  }
};

var subscriptionClosed = function (subscription) {
  return subscription._o === undefined;
};

var closeSubscription = function (subscription) {
  if (!subscriptionClosed(subscription)) {
    subscription._o = undefined;
    cleanupSubscription(subscription);
  }
};

var Subscription = function (observer, subscriber) {
  anObject(observer);
  this._c = undefined;
  this._o = observer;
  observer = new SubscriptionObserver(this);
  try {
    var cleanup = subscriber(observer);
    var subscription = cleanup;
    if (cleanup != null) {
      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
      else aFunction(cleanup);
      this._c = cleanup;
    }
  } catch (e) {
    observer.error(e);
    return;
  } if (subscriptionClosed(this)) cleanupSubscription(this);
};

Subscription.prototype = redefineAll({}, {
  unsubscribe: function unsubscribe() { closeSubscription(this); }
});

var SubscriptionObserver = function (subscription) {
  this._s = subscription;
};

SubscriptionObserver.prototype = redefineAll({}, {
  next: function next(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      try {
        var m = getMethod(observer.next);
        if (m) return m.call(observer, value);
      } catch (e) {
        try {
          closeSubscription(subscription);
        } finally {
          throw e;
        }
      }
    }
  },
  error: function error(value) {
    var subscription = this._s;
    if (subscriptionClosed(subscription)) throw value;
    var observer = subscription._o;
    subscription._o = undefined;
    try {
      var m = getMethod(observer.error);
      if (!m) throw value;
      value = m.call(observer, value);
    } catch (e) {
      try {
        cleanupSubscription(subscription);
      } finally {
        throw e;
      }
    } cleanupSubscription(subscription);
    return value;
  },
  complete: function complete(value) {
    var subscription = this._s;
    if (!subscriptionClosed(subscription)) {
      var observer = subscription._o;
      subscription._o = undefined;
      try {
        var m = getMethod(observer.complete);
        value = m ? m.call(observer, value) : undefined;
      } catch (e) {
        try {
          cleanupSubscription(subscription);
        } finally {
          throw e;
        }
      } cleanupSubscription(subscription);
      return value;
    }
  }
});

var $Observable = function Observable(subscriber) {
  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
};

redefineAll($Observable.prototype, {
  subscribe: function subscribe(observer) {
    return new Subscription(observer, this._f);
  },
  forEach: function forEach(fn) {
    var that = this;
    return new (core.Promise || global.Promise)(function (resolve, reject) {
      aFunction(fn);
      var subscription = that.subscribe({
        next: function (value) {
          try {
            return fn(value);
          } catch (e) {
            reject(e);
            subscription.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
    });
  }
});

redefineAll($Observable, {
  from: function from(x) {
    var C = typeof this === 'function' ? this : $Observable;
    var method = getMethod(anObject(x)[OBSERVABLE]);
    if (method) {
      var observable = anObject(method.call(x));
      return observable.constructor === C ? observable : new C(function (observer) {
        return observable.subscribe(observer);
      });
    }
    return new C(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          try {
            if (forOf(x, false, function (it) {
              observer.next(it);
              if (done) return RETURN;
            }) === RETURN) return;
          } catch (e) {
            if (done) throw e;
            observer.error(e);
            return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  },
  of: function of() {
    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
      var done = false;
      microtask(function () {
        if (!done) {
          for (var j = 0; j < items.length; ++j) {
            observer.next(items[j]);
            if (done) return;
          } observer.complete();
        }
      });
      return function () { done = true; };
    });
  }
});

hide($Observable.prototype, OBSERVABLE, function () { return this; });

$export($export.G, { Observable: $Observable });

require('./_set-species')('Observable');

},{"./_a-function":69,"./_an-instance":72,"./_an-object":73,"./_core":89,"./_export":99,"./_for-of":105,"./_global":106,"./_hide":108,"./_microtask":133,"./_redefine-all":156,"./_set-species":163,"./_wks":192}],361:[function(require,module,exports){
// https://github.com/tc39/proposal-promise-finally
'use strict';
var $export = require('./_export');
var core = require('./_core');
var global = require('./_global');
var speciesConstructor = require('./_species-constructor');
var promiseResolve = require('./_promise-resolve');

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });

},{"./_core":89,"./_export":99,"./_global":106,"./_promise-resolve":154,"./_species-constructor":167}],362:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-promise-try
var $export = require('./_export');
var newPromiseCapability = require('./_new-promise-capability');
var perform = require('./_perform');

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });

},{"./_export":99,"./_new-promise-capability":134,"./_perform":153}],363:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var ordinaryDefineOwnMetadata = metadata.set;

metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
} });

},{"./_an-object":73,"./_metadata":132}],364:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var toMetaKey = metadata.key;
var getOrCreateMetadataMap = metadata.map;
var store = metadata.store;

metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
  if (metadataMap.size) return true;
  var targetMetadata = store.get(target);
  targetMetadata['delete'](targetKey);
  return !!targetMetadata.size || store['delete'](target);
} });

},{"./_an-object":73,"./_metadata":132}],365:[function(require,module,exports){
var Set = require('./es6.set');
var from = require('./_array-from-iterable');
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

var ordinaryMetadataKeys = function (O, P) {
  var oKeys = ordinaryOwnMetadataKeys(O, P);
  var parent = getPrototypeOf(O);
  if (parent === null) return oKeys;
  var pKeys = ordinaryMetadataKeys(parent, P);
  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
};

metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":73,"./_array-from-iterable":76,"./_metadata":132,"./_object-gpo":144,"./es6.set":295}],366:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

var ordinaryGetMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
};

metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":73,"./_metadata":132,"./_object-gpo":144}],367:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryOwnMetadataKeys = metadata.keys;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
} });

},{"./_an-object":73,"./_metadata":132}],368:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryGetOwnMetadata = metadata.get;
var toMetaKey = metadata.key;

metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":73,"./_metadata":132}],369:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var getPrototypeOf = require('./_object-gpo');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

var ordinaryHasMetadata = function (MetadataKey, O, P) {
  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
  if (hasOwn) return true;
  var parent = getPrototypeOf(O);
  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
};

metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":73,"./_metadata":132,"./_object-gpo":144}],370:[function(require,module,exports){
var metadata = require('./_metadata');
var anObject = require('./_an-object');
var ordinaryHasOwnMetadata = metadata.has;
var toMetaKey = metadata.key;

metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
} });

},{"./_an-object":73,"./_metadata":132}],371:[function(require,module,exports){
var $metadata = require('./_metadata');
var anObject = require('./_an-object');
var aFunction = require('./_a-function');
var toMetaKey = $metadata.key;
var ordinaryDefineOwnMetadata = $metadata.set;

$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
  return function decorator(target, targetKey) {
    ordinaryDefineOwnMetadata(
      metadataKey, metadataValue,
      (targetKey !== undefined ? anObject : aFunction)(target),
      toMetaKey(targetKey)
    );
  };
} });

},{"./_a-function":69,"./_an-object":73,"./_metadata":132}],372:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
require('./_set-collection-from')('Set');

},{"./_set-collection-from":160}],373:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
require('./_set-collection-of')('Set');

},{"./_set-collection-of":161}],374:[function(require,module,exports){
// https://github.com/DavidBruant/Map-Set.prototype.toJSON
var $export = require('./_export');

$export($export.P + $export.R, 'Set', { toJSON: require('./_collection-to-json')('Set') });

},{"./_collection-to-json":86,"./_export":99}],375:[function(require,module,exports){
'use strict';
// https://github.com/mathiasbynens/String.prototype.at
var $export = require('./_export');
var $at = require('./_string-at')(true);

$export($export.P, 'String', {
  at: function at(pos) {
    return $at(this, pos);
  }
});

},{"./_export":99,"./_string-at":169}],376:[function(require,module,exports){
'use strict';
// https://tc39.github.io/String.prototype.matchAll/
var $export = require('./_export');
var defined = require('./_defined');
var toLength = require('./_to-length');
var isRegExp = require('./_is-regexp');
var getFlags = require('./_flags');
var RegExpProto = RegExp.prototype;

var $RegExpStringIterator = function (regexp, string) {
  this._r = regexp;
  this._s = string;
};

require('./_iter-create')($RegExpStringIterator, 'RegExp String', function next() {
  var match = this._r.exec(this._s);
  return { value: match, done: match === null };
});

$export($export.P, 'String', {
  matchAll: function matchAll(regexp) {
    defined(this);
    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
    var S = String(this);
    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
    rx.lastIndex = toLength(regexp.lastIndex);
    return new $RegExpStringIterator(rx, S);
  }
});

},{"./_defined":94,"./_export":99,"./_flags":103,"./_is-regexp":118,"./_iter-create":120,"./_to-length":181}],377:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});

},{"./_export":99,"./_string-pad":172,"./_user-agent":188}],378:[function(require,module,exports){
'use strict';
// https://github.com/tc39/proposal-string-pad-start-end
var $export = require('./_export');
var $pad = require('./_string-pad');
var userAgent = require('./_user-agent');

// https://github.com/zloirock/core-js/issues/280
$export($export.P + $export.F * /Version\/10\.\d+(\.\d+)? Safari\//.test(userAgent), 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});

},{"./_export":99,"./_string-pad":172,"./_user-agent":188}],379:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');

},{"./_string-trim":174}],380:[function(require,module,exports){
'use strict';
// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
require('./_string-trim')('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');

},{"./_string-trim":174}],381:[function(require,module,exports){
require('./_wks-define')('asyncIterator');

},{"./_wks-define":190}],382:[function(require,module,exports){
require('./_wks-define')('observable');

},{"./_wks-define":190}],383:[function(require,module,exports){
// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.S, 'System', { global: require('./_global') });

},{"./_export":99,"./_global":106}],384:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
require('./_set-collection-from')('WeakMap');

},{"./_set-collection-from":160}],385:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
require('./_set-collection-of')('WeakMap');

},{"./_set-collection-of":161}],386:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
require('./_set-collection-from')('WeakSet');

},{"./_set-collection-from":160}],387:[function(require,module,exports){
// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
require('./_set-collection-of')('WeakSet');

},{"./_set-collection-of":161}],388:[function(require,module,exports){
var $iterators = require('./es6.array.iterator');
var getKeys = require('./_object-keys');
var redefine = require('./_redefine');
var global = require('./_global');
var hide = require('./_hide');
var Iterators = require('./_iterators');
var wks = require('./_wks');
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}

},{"./_global":106,"./_hide":108,"./_iterators":124,"./_object-keys":146,"./_redefine":157,"./_wks":192,"./es6.array.iterator":205}],389:[function(require,module,exports){
var $export = require('./_export');
var $task = require('./_task');
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});

},{"./_export":99,"./_task":176}],390:[function(require,module,exports){
// ie9- setTimeout & setInterval additional parameters fix
var global = require('./_global');
var $export = require('./_export');
var userAgent = require('./_user-agent');
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});

},{"./_export":99,"./_global":106,"./_user-agent":188}],391:[function(require,module,exports){
require('./modules/es6.symbol');
require('./modules/es6.object.create');
require('./modules/es6.object.define-property');
require('./modules/es6.object.define-properties');
require('./modules/es6.object.get-own-property-descriptor');
require('./modules/es6.object.get-prototype-of');
require('./modules/es6.object.keys');
require('./modules/es6.object.get-own-property-names');
require('./modules/es6.object.freeze');
require('./modules/es6.object.seal');
require('./modules/es6.object.prevent-extensions');
require('./modules/es6.object.is-frozen');
require('./modules/es6.object.is-sealed');
require('./modules/es6.object.is-extensible');
require('./modules/es6.object.assign');
require('./modules/es6.object.is');
require('./modules/es6.object.set-prototype-of');
require('./modules/es6.object.to-string');
require('./modules/es6.function.bind');
require('./modules/es6.function.name');
require('./modules/es6.function.has-instance');
require('./modules/es6.parse-int');
require('./modules/es6.parse-float');
require('./modules/es6.number.constructor');
require('./modules/es6.number.to-fixed');
require('./modules/es6.number.to-precision');
require('./modules/es6.number.epsilon');
require('./modules/es6.number.is-finite');
require('./modules/es6.number.is-integer');
require('./modules/es6.number.is-nan');
require('./modules/es6.number.is-safe-integer');
require('./modules/es6.number.max-safe-integer');
require('./modules/es6.number.min-safe-integer');
require('./modules/es6.number.parse-float');
require('./modules/es6.number.parse-int');
require('./modules/es6.math.acosh');
require('./modules/es6.math.asinh');
require('./modules/es6.math.atanh');
require('./modules/es6.math.cbrt');
require('./modules/es6.math.clz32');
require('./modules/es6.math.cosh');
require('./modules/es6.math.expm1');
require('./modules/es6.math.fround');
require('./modules/es6.math.hypot');
require('./modules/es6.math.imul');
require('./modules/es6.math.log10');
require('./modules/es6.math.log1p');
require('./modules/es6.math.log2');
require('./modules/es6.math.sign');
require('./modules/es6.math.sinh');
require('./modules/es6.math.tanh');
require('./modules/es6.math.trunc');
require('./modules/es6.string.from-code-point');
require('./modules/es6.string.raw');
require('./modules/es6.string.trim');
require('./modules/es6.string.iterator');
require('./modules/es6.string.code-point-at');
require('./modules/es6.string.ends-with');
require('./modules/es6.string.includes');
require('./modules/es6.string.repeat');
require('./modules/es6.string.starts-with');
require('./modules/es6.string.anchor');
require('./modules/es6.string.big');
require('./modules/es6.string.blink');
require('./modules/es6.string.bold');
require('./modules/es6.string.fixed');
require('./modules/es6.string.fontcolor');
require('./modules/es6.string.fontsize');
require('./modules/es6.string.italics');
require('./modules/es6.string.link');
require('./modules/es6.string.small');
require('./modules/es6.string.strike');
require('./modules/es6.string.sub');
require('./modules/es6.string.sup');
require('./modules/es6.date.now');
require('./modules/es6.date.to-json');
require('./modules/es6.date.to-iso-string');
require('./modules/es6.date.to-string');
require('./modules/es6.date.to-primitive');
require('./modules/es6.array.is-array');
require('./modules/es6.array.from');
require('./modules/es6.array.of');
require('./modules/es6.array.join');
require('./modules/es6.array.slice');
require('./modules/es6.array.sort');
require('./modules/es6.array.for-each');
require('./modules/es6.array.map');
require('./modules/es6.array.filter');
require('./modules/es6.array.some');
require('./modules/es6.array.every');
require('./modules/es6.array.reduce');
require('./modules/es6.array.reduce-right');
require('./modules/es6.array.index-of');
require('./modules/es6.array.last-index-of');
require('./modules/es6.array.copy-within');
require('./modules/es6.array.fill');
require('./modules/es6.array.find');
require('./modules/es6.array.find-index');
require('./modules/es6.array.species');
require('./modules/es6.array.iterator');
require('./modules/es6.regexp.constructor');
require('./modules/es6.regexp.to-string');
require('./modules/es6.regexp.flags');
require('./modules/es6.regexp.match');
require('./modules/es6.regexp.replace');
require('./modules/es6.regexp.search');
require('./modules/es6.regexp.split');
require('./modules/es6.promise');
require('./modules/es6.map');
require('./modules/es6.set');
require('./modules/es6.weak-map');
require('./modules/es6.weak-set');
require('./modules/es6.typed.array-buffer');
require('./modules/es6.typed.data-view');
require('./modules/es6.typed.int8-array');
require('./modules/es6.typed.uint8-array');
require('./modules/es6.typed.uint8-clamped-array');
require('./modules/es6.typed.int16-array');
require('./modules/es6.typed.uint16-array');
require('./modules/es6.typed.int32-array');
require('./modules/es6.typed.uint32-array');
require('./modules/es6.typed.float32-array');
require('./modules/es6.typed.float64-array');
require('./modules/es6.reflect.apply');
require('./modules/es6.reflect.construct');
require('./modules/es6.reflect.define-property');
require('./modules/es6.reflect.delete-property');
require('./modules/es6.reflect.enumerate');
require('./modules/es6.reflect.get');
require('./modules/es6.reflect.get-own-property-descriptor');
require('./modules/es6.reflect.get-prototype-of');
require('./modules/es6.reflect.has');
require('./modules/es6.reflect.is-extensible');
require('./modules/es6.reflect.own-keys');
require('./modules/es6.reflect.prevent-extensions');
require('./modules/es6.reflect.set');
require('./modules/es6.reflect.set-prototype-of');
require('./modules/es7.array.includes');
require('./modules/es7.array.flat-map');
require('./modules/es7.array.flatten');
require('./modules/es7.string.at');
require('./modules/es7.string.pad-start');
require('./modules/es7.string.pad-end');
require('./modules/es7.string.trim-left');
require('./modules/es7.string.trim-right');
require('./modules/es7.string.match-all');
require('./modules/es7.symbol.async-iterator');
require('./modules/es7.symbol.observable');
require('./modules/es7.object.get-own-property-descriptors');
require('./modules/es7.object.values');
require('./modules/es7.object.entries');
require('./modules/es7.object.define-getter');
require('./modules/es7.object.define-setter');
require('./modules/es7.object.lookup-getter');
require('./modules/es7.object.lookup-setter');
require('./modules/es7.map.to-json');
require('./modules/es7.set.to-json');
require('./modules/es7.map.of');
require('./modules/es7.set.of');
require('./modules/es7.weak-map.of');
require('./modules/es7.weak-set.of');
require('./modules/es7.map.from');
require('./modules/es7.set.from');
require('./modules/es7.weak-map.from');
require('./modules/es7.weak-set.from');
require('./modules/es7.global');
require('./modules/es7.system.global');
require('./modules/es7.error.is-error');
require('./modules/es7.math.clamp');
require('./modules/es7.math.deg-per-rad');
require('./modules/es7.math.degrees');
require('./modules/es7.math.fscale');
require('./modules/es7.math.iaddh');
require('./modules/es7.math.isubh');
require('./modules/es7.math.imulh');
require('./modules/es7.math.rad-per-deg');
require('./modules/es7.math.radians');
require('./modules/es7.math.scale');
require('./modules/es7.math.umulh');
require('./modules/es7.math.signbit');
require('./modules/es7.promise.finally');
require('./modules/es7.promise.try');
require('./modules/es7.reflect.define-metadata');
require('./modules/es7.reflect.delete-metadata');
require('./modules/es7.reflect.get-metadata');
require('./modules/es7.reflect.get-metadata-keys');
require('./modules/es7.reflect.get-own-metadata');
require('./modules/es7.reflect.get-own-metadata-keys');
require('./modules/es7.reflect.has-metadata');
require('./modules/es7.reflect.has-own-metadata');
require('./modules/es7.reflect.metadata');
require('./modules/es7.asap');
require('./modules/es7.observable');
require('./modules/web.timers');
require('./modules/web.immediate');
require('./modules/web.dom.iterable');
module.exports = require('./modules/_core');

},{"./modules/_core":89,"./modules/es6.array.copy-within":195,"./modules/es6.array.every":196,"./modules/es6.array.fill":197,"./modules/es6.array.filter":198,"./modules/es6.array.find":200,"./modules/es6.array.find-index":199,"./modules/es6.array.for-each":201,"./modules/es6.array.from":202,"./modules/es6.array.index-of":203,"./modules/es6.array.is-array":204,"./modules/es6.array.iterator":205,"./modules/es6.array.join":206,"./modules/es6.array.last-index-of":207,"./modules/es6.array.map":208,"./modules/es6.array.of":209,"./modules/es6.array.reduce":211,"./modules/es6.array.reduce-right":210,"./modules/es6.array.slice":212,"./modules/es6.array.some":213,"./modules/es6.array.sort":214,"./modules/es6.array.species":215,"./modules/es6.date.now":216,"./modules/es6.date.to-iso-string":217,"./modules/es6.date.to-json":218,"./modules/es6.date.to-primitive":219,"./modules/es6.date.to-string":220,"./modules/es6.function.bind":221,"./modules/es6.function.has-instance":222,"./modules/es6.function.name":223,"./modules/es6.map":224,"./modules/es6.math.acosh":225,"./modules/es6.math.asinh":226,"./modules/es6.math.atanh":227,"./modules/es6.math.cbrt":228,"./modules/es6.math.clz32":229,"./modules/es6.math.cosh":230,"./modules/es6.math.expm1":231,"./modules/es6.math.fround":232,"./modules/es6.math.hypot":233,"./modules/es6.math.imul":234,"./modules/es6.math.log10":235,"./modules/es6.math.log1p":236,"./modules/es6.math.log2":237,"./modules/es6.math.sign":238,"./modules/es6.math.sinh":239,"./modules/es6.math.tanh":240,"./modules/es6.math.trunc":241,"./modules/es6.number.constructor":242,"./modules/es6.number.epsilon":243,"./modules/es6.number.is-finite":244,"./modules/es6.number.is-integer":245,"./modules/es6.number.is-nan":246,"./modules/es6.number.is-safe-integer":247,"./modules/es6.number.max-safe-integer":248,"./modules/es6.number.min-safe-integer":249,"./modules/es6.number.parse-float":250,"./modules/es6.number.parse-int":251,"./modules/es6.number.to-fixed":252,"./modules/es6.number.to-precision":253,"./modules/es6.object.assign":254,"./modules/es6.object.create":255,"./modules/es6.object.define-properties":256,"./modules/es6.object.define-property":257,"./modules/es6.object.freeze":258,"./modules/es6.object.get-own-property-descriptor":259,"./modules/es6.object.get-own-property-names":260,"./modules/es6.object.get-prototype-of":261,"./modules/es6.object.is":265,"./modules/es6.object.is-extensible":262,"./modules/es6.object.is-frozen":263,"./modules/es6.object.is-sealed":264,"./modules/es6.object.keys":266,"./modules/es6.object.prevent-extensions":267,"./modules/es6.object.seal":268,"./modules/es6.object.set-prototype-of":269,"./modules/es6.object.to-string":270,"./modules/es6.parse-float":271,"./modules/es6.parse-int":272,"./modules/es6.promise":273,"./modules/es6.reflect.apply":274,"./modules/es6.reflect.construct":275,"./modules/es6.reflect.define-property":276,"./modules/es6.reflect.delete-property":277,"./modules/es6.reflect.enumerate":278,"./modules/es6.reflect.get":281,"./modules/es6.reflect.get-own-property-descriptor":279,"./modules/es6.reflect.get-prototype-of":280,"./modules/es6.reflect.has":282,"./modules/es6.reflect.is-extensible":283,"./modules/es6.reflect.own-keys":284,"./modules/es6.reflect.prevent-extensions":285,"./modules/es6.reflect.set":287,"./modules/es6.reflect.set-prototype-of":286,"./modules/es6.regexp.constructor":288,"./modules/es6.regexp.flags":289,"./modules/es6.regexp.match":290,"./modules/es6.regexp.replace":291,"./modules/es6.regexp.search":292,"./modules/es6.regexp.split":293,"./modules/es6.regexp.to-string":294,"./modules/es6.set":295,"./modules/es6.string.anchor":296,"./modules/es6.string.big":297,"./modules/es6.string.blink":298,"./modules/es6.string.bold":299,"./modules/es6.string.code-point-at":300,"./modules/es6.string.ends-with":301,"./modules/es6.string.fixed":302,"./modules/es6.string.fontcolor":303,"./modules/es6.string.fontsize":304,"./modules/es6.string.from-code-point":305,"./modules/es6.string.includes":306,"./modules/es6.string.italics":307,"./modules/es6.string.iterator":308,"./modules/es6.string.link":309,"./modules/es6.string.raw":310,"./modules/es6.string.repeat":311,"./modules/es6.string.small":312,"./modules/es6.string.starts-with":313,"./modules/es6.string.strike":314,"./modules/es6.string.sub":315,"./modules/es6.string.sup":316,"./modules/es6.string.trim":317,"./modules/es6.symbol":318,"./modules/es6.typed.array-buffer":319,"./modules/es6.typed.data-view":320,"./modules/es6.typed.float32-array":321,"./modules/es6.typed.float64-array":322,"./modules/es6.typed.int16-array":323,"./modules/es6.typed.int32-array":324,"./modules/es6.typed.int8-array":325,"./modules/es6.typed.uint16-array":326,"./modules/es6.typed.uint32-array":327,"./modules/es6.typed.uint8-array":328,"./modules/es6.typed.uint8-clamped-array":329,"./modules/es6.weak-map":330,"./modules/es6.weak-set":331,"./modules/es7.array.flat-map":332,"./modules/es7.array.flatten":333,"./modules/es7.array.includes":334,"./modules/es7.asap":335,"./modules/es7.error.is-error":336,"./modules/es7.global":337,"./modules/es7.map.from":338,"./modules/es7.map.of":339,"./modules/es7.map.to-json":340,"./modules/es7.math.clamp":341,"./modules/es7.math.deg-per-rad":342,"./modules/es7.math.degrees":343,"./modules/es7.math.fscale":344,"./modules/es7.math.iaddh":345,"./modules/es7.math.imulh":346,"./modules/es7.math.isubh":347,"./modules/es7.math.rad-per-deg":348,"./modules/es7.math.radians":349,"./modules/es7.math.scale":350,"./modules/es7.math.signbit":351,"./modules/es7.math.umulh":352,"./modules/es7.object.define-getter":353,"./modules/es7.object.define-setter":354,"./modules/es7.object.entries":355,"./modules/es7.object.get-own-property-descriptors":356,"./modules/es7.object.lookup-getter":357,"./modules/es7.object.lookup-setter":358,"./modules/es7.object.values":359,"./modules/es7.observable":360,"./modules/es7.promise.finally":361,"./modules/es7.promise.try":362,"./modules/es7.reflect.define-metadata":363,"./modules/es7.reflect.delete-metadata":364,"./modules/es7.reflect.get-metadata":366,"./modules/es7.reflect.get-metadata-keys":365,"./modules/es7.reflect.get-own-metadata":368,"./modules/es7.reflect.get-own-metadata-keys":367,"./modules/es7.reflect.has-metadata":369,"./modules/es7.reflect.has-own-metadata":370,"./modules/es7.reflect.metadata":371,"./modules/es7.set.from":372,"./modules/es7.set.of":373,"./modules/es7.set.to-json":374,"./modules/es7.string.at":375,"./modules/es7.string.match-all":376,"./modules/es7.string.pad-end":377,"./modules/es7.string.pad-start":378,"./modules/es7.string.trim-left":379,"./modules/es7.string.trim-right":380,"./modules/es7.symbol.async-iterator":381,"./modules/es7.symbol.observable":382,"./modules/es7.system.global":383,"./modules/es7.weak-map.from":384,"./modules/es7.weak-map.of":385,"./modules/es7.weak-set.from":386,"./modules/es7.weak-set.of":387,"./modules/web.dom.iterable":388,"./modules/web.immediate":389,"./modules/web.timers":390}],392:[function(require,module,exports){
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.dawaAutocomplete = {}));
}(this, function (exports) { 'use strict';

	function unwrapExports (x) {
		return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
	}

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var _global = createCommonjsModule(function (module) {
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	});

	var _core = createCommonjsModule(function (module) {
	var core = module.exports = { version: '2.6.5' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	});
	var _core_1 = _core.version;

	var _isObject = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

	var _anObject = function (it) {
	  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};

	var _fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};

	// Thank's IE8 for his funny defineProperty
	var _descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});

	var document$1 = _global.document;
	// typeof document.createElement is 'object' in old IE
	var is = _isObject(document$1) && _isObject(document$1.createElement);
	var _domCreate = function (it) {
	  return is ? document$1.createElement(it) : {};
	};

	var _ie8DomDefine = !_descriptors && !_fails(function () {
	  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
	});

	// 7.1.1 ToPrimitive(input [, PreferredType])

	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var _toPrimitive = function (it, S) {
	  if (!_isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

	var dP = Object.defineProperty;

	var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  _anObject(O);
	  P = _toPrimitive(P, true);
	  _anObject(Attributes);
	  if (_ie8DomDefine) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var _objectDp = {
		f: f
	};

	var _propertyDesc = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var _hide = _descriptors ? function (object, key, value) {
	  return _objectDp.f(object, key, _propertyDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var hasOwnProperty = {}.hasOwnProperty;
	var _has = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};

	var id = 0;
	var px = Math.random();
	var _uid = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

	var _shared = createCommonjsModule(function (module) {
	var SHARED = '__core-js_shared__';
	var store = _global[SHARED] || (_global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: _core.version,
	  mode: 'global',
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});
	});

	var _functionToString = _shared('native-function-to-string', Function.toString);

	var _redefine = createCommonjsModule(function (module) {
	var SRC = _uid('src');

	var TO_STRING = 'toString';
	var TPL = ('' + _functionToString).split(TO_STRING);

	_core.inspectSource = function (it) {
	  return _functionToString.call(it);
	};

	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) _has(val, 'name') || _hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) _has(val, SRC) || _hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === _global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    _hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    _hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || _functionToString.call(this);
	});
	});

	var _aFunction = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};

	// optional / simple context binding

	var _ctx = function (fn, that, length) {
	  _aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};

	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] || (_global[name] = {}) : (_global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? _ctx(out, _global) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
	    // extend global
	    if (target) _redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) _hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	_global.core = _core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	var _export = $export;

	var toString = {}.toString;

	var _cof = function (it) {
	  return toString.call(it).slice(8, -1);
	};

	// fallback for non-array-like ES3 and non-enumerable old V8 strings

	// eslint-disable-next-line no-prototype-builtins
	var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return _cof(it) == 'String' ? it.split('') : Object(it);
	};

	// 7.2.1 RequireObjectCoercible(argument)
	var _defined = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};

	// to indexed object, toObject with fallback for non-array-like ES3 strings


	var _toIobject = function (it) {
	  return _iobject(_defined(it));
	};

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	var _toInteger = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

	// 7.1.15 ToLength

	var min = Math.min;
	var _toLength = function (it) {
	  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

	var max = Math.max;
	var min$1 = Math.min;
	var _toAbsoluteIndex = function (index, length) {
	  index = _toInteger(index);
	  return index < 0 ? max(index + length, 0) : min$1(index, length);
	};

	// false -> Array#indexOf
	// true  -> Array#includes



	var _arrayIncludes = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = _toIobject($this);
	    var length = _toLength(O.length);
	    var index = _toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	var shared = _shared('keys');

	var _sharedKey = function (key) {
	  return shared[key] || (shared[key] = _uid(key));
	};

	var arrayIndexOf = _arrayIncludes(false);
	var IE_PROTO = _sharedKey('IE_PROTO');

	var _objectKeysInternal = function (object, names) {
	  var O = _toIobject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (_has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

	// IE 8- don't enum bug keys
	var _enumBugKeys = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)



	var _objectKeys = Object.keys || function keys(O) {
	  return _objectKeysInternal(O, _enumBugKeys);
	};

	var f$1 = Object.getOwnPropertySymbols;

	var _objectGops = {
		f: f$1
	};

	var f$2 = {}.propertyIsEnumerable;

	var _objectPie = {
		f: f$2
	};

	// 7.1.13 ToObject(argument)

	var _toObject = function (it) {
	  return Object(_defined(it));
	};

	// 19.1.2.1 Object.assign(target, source, ...)





	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	var _objectAssign = !$assign || _fails(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = _toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = _objectGops.f;
	  var isEnum = _objectPie.f;
	  while (aLen > index) {
	    var S = _iobject(arguments[index++]);
	    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;

	// 19.1.3.1 Object.assign(target, source)


	_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

	// true  -> String#at
	// false -> String#codePointAt
	var _stringAt = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(_defined(that));
	    var i = _toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

	var at = _stringAt(true);

	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	var _advanceStringIndex = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};

	var _wks = createCommonjsModule(function (module) {
	var store = _shared('wks');

	var Symbol = _global.Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
	};

	$exports.store = store;
	});

	// getting tag from 19.1.3.6 Object.prototype.toString()

	var TAG = _wks('toStringTag');
	// ES3 wrong here
	var ARG = _cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	var _classof = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? _cof(O)
	    // ES3 arguments fallback
	    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

	var builtinExec = RegExp.prototype.exec;

	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	var _regexpExecAbstract = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (_classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};

	// 21.2.5.3 get RegExp.prototype.flags

	var _flags = function () {
	  var that = _anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};

	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;

	var patchedExec = nativeExec;

	var LAST_INDEX = 'lastIndex';

	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();

	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;

	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', _flags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

	    match = nativeExec.call(re, str);

	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }

	    return match;
	  };
	}

	var _regexpExec = patchedExec;

	_export({
	  target: 'RegExp',
	  proto: true,
	  forced: _regexpExec !== /./.exec
	}, {
	  exec: _regexpExec
	});

	var SPECIES = _wks('species');

	var REPLACE_SUPPORTS_NAMED_GROUPS = !_fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});

	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();

	var _fixReWks = function (KEY, length, exec) {
	  var SYMBOL = _wks(KEY);

	  var DELEGATES_TO_SYMBOL = !_fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });

	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !_fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;

	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      _defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === _regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];

	    _redefine(String.prototype, KEY, strfn);
	    _hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};

	var max$1 = Math.max;
	var min$2 = Math.min;
	var floor$1 = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};

	// @@replace logic
	_fixReWks('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;

	      var rx = _anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = _regexpExecAbstract(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = _advanceStringIndex(S, _toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max$1(min$2(_toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];

	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = _toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor$1(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});

	// 7.2.8 IsRegExp(argument)


	var MATCH = _wks('match');
	var _isRegexp = function (it) {
	  var isRegExp;
	  return _isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : _cof(it) == 'RegExp');
	};

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)


	var SPECIES$1 = _wks('species');
	var _speciesConstructor = function (O, D) {
	  var C = _anObject(O).constructor;
	  var S;
	  return C === undefined || (S = _anObject(C)[SPECIES$1]) == undefined ? D : _aFunction(S);
	};

	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX$1 = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;

	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !_fails(function () { });

	// @@split logic
	_fixReWks('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!_isRegexp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = _regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX$1];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX$1] === match.index) separatorCopy[LAST_INDEX$1]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }

	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;

	      var rx = _anObject(regexp);
	      var S = String(this);
	      var C = _speciesConstructor(rx, RegExp);

	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');

	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return _regexpExecAbstract(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = _regexpExecAbstract(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(_toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = _advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});

	var incrementalDomCjs = createCommonjsModule(function (module, exports) {

	Object.defineProperty(exports, '__esModule', { value: true });

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var symbols = {
	  default: '__default'
	};

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A cached reference to the hasOwnProperty function.
	 */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	 * A constructor function that will create blank objects.
	 */
	function Blank() {}
	Blank.prototype = Object.create(null);
	/**
	 * Used to prevent property collisions between our "map" and its prototype.
	 * @param map The map to check.
	 * @param property The property to check.
	 * @return Whether map has property.
	 */
	function has(map, property) {
	  return hasOwnProperty.call(map, property);
	}
	/**
	 * Creates an map object without a prototype.
	 */
	// tslint:disable-next-line:no-any
	function createMap() {
	  // tslint:disable-next-line:no-any
	  return new Blank();
	}
	/**
	 * Truncates an array, removing items up until length.
	 * @param arr The array to truncate.
	 * @param length The new length of the array.
	 */
	function truncateArray(arr, length) {
	  while (arr.length > length) {
	    arr.pop();
	  }
	}

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Returns the namespace to use for the attribute.
	 */
	function getNamespace(name) {
	    if (name.lastIndexOf('xml:', 0) === 0) {
	        return 'http://www.w3.org/XML/1998/namespace';
	    }
	    if (name.lastIndexOf('xlink:', 0) === 0) {
	        return 'http://www.w3.org/1999/xlink';
	    }
	    return undefined;
	}
	/**
	 * Applies an attribute or property to a given Element. If the value is null
	 * or undefined, it is removed from the Element. Otherwise, the value is set
	 * as an attribute.
	 */
	// tslint:disable-next-line:no-any
	function applyAttr(el, name, value) {
	    if (value == null) {
	        el.removeAttribute(name);
	    } else {
	        var attrNS = getNamespace(name);
	        if (attrNS) {
	            el.setAttributeNS(attrNS, name, String(value));
	        } else {
	            el.setAttribute(name, String(value));
	        }
	    }
	}
	/**
	 * Applies a property to a given Element.
	 */
	// tslint:disable-next-line:no-any
	function applyProp(el, name, value) {
	    // tslint:disable-next-line:no-any
	    el[name] = value;
	}
	/**
	 * Applies a value to a style declaration. Supports CSS custom properties by
	 * setting properties containing a dash using CSSStyleDeclaration.setProperty.
	 */
	function setStyleValue(style, prop, value) {
	    if (prop.indexOf('-') >= 0) {
	        style.setProperty(prop, value);
	    } else {
	        // TODO(tomnguyen) Figure out why this is necessary.
	        // tslint:disable-next-line:no-any
	        style[prop] = value;
	    }
	}
	/**
	 * Applies a style to an Element. No vendor prefix expansion is done for
	 * property names/values.
	 * @param el
	 * @param name The attribute's name.
	 * @param  style The style to set. Either a string of css or an object
	 *     containing property-value pairs.
	 */
	function applyStyle(el, name, style) {
	    if (typeof style === 'string') {
	        el.style.cssText = style;
	    } else {
	        el.style.cssText = '';
	        var elStyle = el.style;
	        for (var prop in style) {
	            if (has(style, prop)) {
	                setStyleValue(elStyle, prop, style[prop]);
	            }
	        }
	    }
	}
	/**
	 * Updates a single attribute on an Element.
	 * @param el
	 * @param name The attribute's name.
	 * @param value The attribute's value. If the value is an object or
	 *     function it is set on the Element, otherwise, it is set as an HTML
	 *     attribute.
	 */
	function applyAttributeTyped(el, name, value) {
	    var type = typeof value;
	    if (type === 'object' || type === 'function') {
	        applyProp(el, name, value);
	    } else {
	        applyAttr(el, name, value);
	    }
	}
	/**
	 * A publicly mutable object to provide custom mutators for attributes.
	 * NB: The result of createMap() has to be recast since closure compiler
	 * will just assume attributes is "any" otherwise and throws away
	 * the type annotation set by tsickle.
	 */
	var attributes = createMap();
	// Special generic mutator that's called for any attribute that does not
	// have a specific mutator.
	attributes[symbols.default] = applyAttributeTyped;
	attributes['style'] = applyStyle;
	/**
	 * Calls the appropriate attribute mutator for this attribute.
	 */
	function updateAttribute(el, name, value) {
	    var mutator = attributes[name] || attributes[symbols.default];
	    mutator(el, name, value);
	}
	/**
	 * Asserts that a value exists and is not null or undefined. goog.asserts
	 * is not used in order to avoid dependencies on external code.
	 */
	function assert(val) {
	    return val;
	}

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var notifications = {
	  nodesCreated: null,
	  nodesDeleted: null
	};

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * A context object keeps track of the state of a patch.
	 */
	var Context = /** @class */function () {
	    function Context() {
	        this.created = [];
	        this.deleted = [];
	    }
	    Context.prototype.markCreated = function (node) {
	        this.created.push(node);
	    };
	    Context.prototype.markDeleted = function (node) {
	        this.deleted.push(node);
	    };
	    /**
	     * Notifies about nodes that were created during the patch operation.
	     */
	    Context.prototype.notifyChanges = function () {
	        if (notifications.nodesCreated && this.created.length > 0) {
	            notifications.nodesCreated(this.created);
	        }
	        if (notifications.nodesDeleted && this.deleted.length > 0) {
	            notifications.nodesDeleted(this.deleted);
	        }
	    };
	    return Context;
	}();

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Checks if the node is the root of a document. This is either a Document
	 * or ShadowRoot. DocumentFragments are included for simplicity of the
	 * implementation, though we only want to consider Documents or ShadowRoots.
	 * @param node The node to check.
	 * @return True if the node the root of a document, false otherwise.
	 */
	function isDocumentRoot(node) {
	    return node.nodeType === 11 || node.nodeType === 9;
	}
	/**
	 * Checks if the node is an Element. This is faster than an instanceof check.
	 * @param node The node to check.
	 * @return Whether or not the node is an Element.
	 */
	function isElement(node) {
	    return node.nodeType === 1;
	}
	/**
	 * Checks if the node is a text node. This is faster than an instanceof check.
	 * @param node The node to check.
	 * @return Whether or not the node is a Text.
	 */
	function isText(node) {
	    return node.nodeType === 3;
	}
	/**
	 * @param  node The node to start at, inclusive.
	 * @param  root The root ancestor to get until, exclusive.
	 * @return The ancestry of DOM nodes.
	 */
	function getAncestry(node, root) {
	    var ancestry = [];
	    var cur = node;
	    while (cur !== root) {
	        var n = cur;
	        ancestry.push(n);
	        cur = n.parentNode;
	    }
	    return ancestry;
	}
	/**
	 * return The root node of the DOM tree that contains this node.
	 */
	var getRootNode =
	// tslint:disable-next-line:no-any b/79476176
	Node.prototype.getRootNode || function () {
	    // tslint:disable-next-line:no-unnecessary-type-assertion b/77361044
	    var cur = this;
	    var prev = cur;
	    while (cur) {
	        prev = cur;
	        cur = cur.parentNode;
	    }
	    return prev;
	};
	/**
	 * @param node The node to get the activeElement for.
	 * @return The activeElement in the Document or ShadowRoot
	 *     corresponding to node, if present.
	 */
	function getActiveElement(node) {
	    var root = getRootNode.call(node);
	    return isDocumentRoot(root) ? root.activeElement : null;
	}
	/**
	 * Gets the path of nodes that contain the focused node in the same document as
	 * a reference node, up until the root.
	 * @param node The reference node to get the activeElement for.
	 * @param root The root to get the focused path until.
	 */
	function getFocusedPath(node, root) {
	    var activeElement = getActiveElement(node);
	    if (!activeElement || !node.contains(activeElement)) {
	        return [];
	    }
	    return getAncestry(activeElement, root);
	}
	/**
	 * Like insertBefore, but instead instead of moving the desired node, instead
	 * moves all the other nodes after.
	 * @param parentNode
	 * @param node
	 * @param referenceNode
	 */
	function moveBefore(parentNode, node, referenceNode) {
	    var insertReferenceNode = node.nextSibling;
	    var cur = referenceNode;
	    while (cur !== null && cur !== node) {
	        var next = cur.nextSibling;
	        parentNode.insertBefore(cur, insertReferenceNode);
	        cur = next;
	    }
	}

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Keeps track of information needed to perform diffs for a given DOM node.
	 */
	var NodeData = /** @class */function () {
	    function NodeData(nameOrCtor, key, text) {
	        /**
	         * An array of attribute name/value pairs, used for quickly diffing the
	         * incomming attributes to see if the DOM node's attributes need to be
	         * updated.
	         */
	        // tslint:disable-next-line:no-any
	        this._attrsArr = null;
	        /**
	         * Whether or not the statics have been applied for the node yet.
	         */
	        this.staticsApplied = false;
	        this.nameOrCtor = nameOrCtor;
	        this.key = key;
	        this.text = text;
	    }
	    NodeData.prototype.hasEmptyAttrsArr = function () {
	        var attrs = this._attrsArr;
	        return !attrs || !attrs.length;
	    };
	    NodeData.prototype.getAttrsArr = function (length) {
	        return this._attrsArr || (this._attrsArr = new Array(length));
	    };
	    return NodeData;
	}();
	/**
	 * Initializes a NodeData object for a Node.
	 */
	function initData(node, nameOrCtor, key, text) {
	    var data = new NodeData(nameOrCtor, key, text);
	    node['__incrementalDOMData'] = data;
	    return data;
	}
	/**
	 * Retrieves the NodeData object for a Node, creating it if necessary.
	 */
	function getData(node, key) {
	    return importSingleNode(node, key);
	}
	function isDataInitialized(node) {
	    return Boolean(node['__incrementalDOMData']);
	}
	function getKey(node) {
	    assert(node['__incrementalDOMData']);
	    return getData(node).key;
	}
	/**
	 * Imports single node and its subtree, initializing caches.
	 */
	function importSingleNode(node, fallbackKey) {
	    if (node['__incrementalDOMData']) {
	        return node['__incrementalDOMData'];
	    }
	    var nodeName = isElement(node) ? node.localName : node.nodeName;
	    var key = isElement(node) ? node.getAttribute('key') || fallbackKey : null;
	    var text = isText(node) ? node.data : undefined;
	    var data = initData(node, nodeName, key, text);
	    if (isElement(node)) {
	        recordAttributes(node, data);
	    }
	    return data;
	}
	/**
	 * Imports node and its subtree, initializing caches.
	 */
	function importNode(node) {
	    importSingleNode(node);
	    for (var child = node.firstChild; child; child = child.nextSibling) {
	        importNode(child);
	    }
	}
	/**
	 * Clears all caches from a node and all of its children.
	 */
	function clearCache(node) {
	    node['__incrementalDOMData'] = null;
	    for (var child = node.firstChild; child; child = child.nextSibling) {
	        clearCache(child);
	    }
	}
	/**
	 * Records the element's attributes.
	 * @param node The Element that may have attributes
	 * @param data The Element's data
	 */
	function recordAttributes(node, data) {
	    var attributes = node.attributes;
	    var length = attributes.length;
	    if (!length) {
	        return;
	    }
	    var attrsArr = data.getAttrsArr(length);
	    // Use a cached length. The attributes array is really a live NamedNodeMap,
	    // which exists as a DOM "Host Object" (probably as C++ code). This makes the
	    // usual constant length iteration very difficult to optimize in JITs.
	    for (var i = 0, j = 0; i < length; i += 1, j += 2) {
	        var attr = attributes[i];
	        var name = attr.name;
	        var value = attr.value;
	        attrsArr[j] = name;
	        attrsArr[j + 1] = value;
	    }
	}

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * Gets the namespace to create an element (of a given tag) in.
	 */
	function getNamespaceForTag(tag, parent) {
	    if (tag === 'svg') {
	        return 'http://www.w3.org/2000/svg';
	    }
	    if (tag === 'math') {
	        return 'http://www.w3.org/1998/Math/MathML';
	    }
	    if (parent == null) {
	        return null;
	    }
	    if (getData(parent).nameOrCtor === 'foreignObject') {
	        return null;
	    }
	    return parent.namespaceURI;
	}
	/**
	 * Creates an Element.
	 * @param doc The document with which to create the Element.
	 * @param nameOrCtor The tag or constructor for the Element.
	 * @param key A key to identify the Element.
	 * @param  typeId The type identifier for the Element.
	 */
	function createElement(doc, parent, nameOrCtor, key) {
	    var el;
	    if (typeof nameOrCtor === 'function') {
	        el = new nameOrCtor();
	    } else {
	        var namespace = getNamespaceForTag(nameOrCtor, parent);
	        if (namespace) {
	            el = doc.createElementNS(namespace, nameOrCtor);
	        } else {
	            el = doc.createElement(nameOrCtor);
	        }
	    }
	    initData(el, nameOrCtor, key);
	    return el;
	}
	/**
	 * Creates a Text Node.
	 * @param doc The document with which to create the Element.
	 * @return
	 */
	function createText(doc) {
	    var node = doc.createTextNode('');
	    initData(node, '#text', null);
	    return node;
	}

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	var context = null;
	var currentNode = null;
	var currentParent = null;
	var doc = null;
	var focusPath = [];
	/**
	 * Used to build up call arguments. Each patch call gets a separate copy, so
	 * this works with nested calls to patch.
	 */
	var argsBuilder = [];
	/**
	 * TODO(sparhami) We should just export argsBuilder directly when Closure
	 * Compiler supports ES6 directly.
	 */
	function getArgsBuilder() {
	    return argsBuilder;
	}
	/**
	 * Returns a patcher function that sets up and restores a patch context,
	 * running the run function with the provided data.
	 */
	function patchFactory(run) {
	    var f = function (node, fn, data) {
	        var prevContext = context;
	        var prevDoc = doc;
	        var prevFocusPath = focusPath;
	        var prevArgsBuilder = argsBuilder;
	        var prevCurrentNode = currentNode;
	        var prevCurrentParent = currentParent;
	        context = new Context();
	        doc = node.ownerDocument;
	        argsBuilder = [];
	        currentParent = node.parentNode;
	        focusPath = getFocusedPath(node, currentParent);
	        try {
	            var retVal = run(node, fn, data);
	            return retVal;
	        } finally {
	            doc = prevDoc;
	            argsBuilder = prevArgsBuilder;
	            currentNode = prevCurrentNode;
	            currentParent = prevCurrentParent;
	            focusPath = prevFocusPath;
	            context.notifyChanges();
	            context = prevContext;
	        }
	    };
	    return f;
	}
	/**
	 * Patches the document starting at node with the provided function. This
	 * function may be called during an existing patch operation.
	 */
	var patchInner = patchFactory(function (node, fn, data) {
	    currentNode = node;
	    enterNode();
	    fn(data);
	    exitNode();
	    return node;
	});
	/**
	 * Patches an Element with the the provided function. Exactly one top level
	 * element call should be made corresponding to `node`.
	 */
	var patchOuter = patchFactory(function (node, fn, data) {
	    // tslint:disable-next-line:no-any
	    var startNode = { nextSibling: node };
	    currentNode = startNode;
	    fn(data);
	    if (currentParent) {
	        clearUnvisitedDOM(currentParent, getNextNode(), node.nextSibling);
	    }
	    return startNode === currentNode ? null : currentNode;
	});
	/**
	 * Checks whether or not the current node matches the specified nameOrCtor and
	 * key.
	 * @param matchNode A node to match the data to.
	 * @param nameOrCtor The name or constructor to check for.
	 * @param key The key used to identify the Node.
	 * @return True if the node matches, false otherwise.
	 */
	function matches(matchNode, nameOrCtor, key) {
	    var data = getData(matchNode, key);
	    // Key check is done using double equals as we want to treat a null key the
	    // same as undefined. This should be okay as the only values allowed are
	    // strings, null and undefined so the == semantics are not too weird.
	    // tslint:disable-next-line:triple-equals
	    return nameOrCtor == data.nameOrCtor && key == data.key;
	}
	/**
	 * Finds the matching node, starting at `node` and looking at the subsequent
	 * siblings if a key is used.
	 * @param node The node to start looking at.
	 * @param nameOrCtor The name or constructor for the Node.
	 * @param key The key used to identify the Node.
	 */
	function getMatchingNode(matchNode, nameOrCtor, key) {
	    if (!matchNode) {
	        return null;
	    }
	    if (matches(matchNode, nameOrCtor, key)) {
	        return matchNode;
	    }
	    if (key) {
	        while (matchNode = matchNode.nextSibling) {
	            if (matches(matchNode, nameOrCtor, key)) {
	                return matchNode;
	            }
	        }
	    }
	    return null;
	}
	/**
	 * Creates a Node and marking it as created.
	 * @param nameOrCtor The name or constructor for the Node.
	 * @param key The key used to identify the Node.
	 * @return The newly created node.
	 */
	function createNode(nameOrCtor, key) {
	    var node;
	    if (nameOrCtor === '#text') {
	        node = createText(doc);
	    } else {
	        node = createElement(doc, currentParent, nameOrCtor, key);
	    }
	    context.markCreated(node);
	    return node;
	}
	/**
	 * Aligns the virtual Node definition with the actual DOM, moving the
	 * corresponding DOM node to the correct location or creating it if necessary.
	 * @param nameOrCtor The name or constructor for the Node.
	 * @param key The key used to identify the Node.
	 */
	function alignWithDOM(nameOrCtor, key) {
	    var existingNode = getMatchingNode(currentNode, nameOrCtor, key);
	    var node = existingNode || createNode(nameOrCtor, key);
	    // If we are at the matching node, then we are done.
	    if (node === currentNode) {
	        return;
	    }
	    // Re-order the node into the right position, preserving focus if either
	    // node or currentNode are focused by making sure that they are not detached
	    // from the DOM.
	    if (focusPath.indexOf(node) >= 0) {
	        // Move everything else before the node.
	        moveBefore(currentParent, node, currentNode);
	    } else {
	        currentParent.insertBefore(node, currentNode);
	    }
	    currentNode = node;
	}
	/**
	 * Clears out any unvisited Nodes in a given range.
	 * @param maybeParentNode
	 * @param startNode The node to start clearing from, inclusive.
	 * @param endNode The node to clear until, exclusive.
	 */
	function clearUnvisitedDOM(maybeParentNode, startNode, endNode) {
	    var parentNode = maybeParentNode;
	    var child = startNode;
	    while (child !== endNode) {
	        var next = child.nextSibling;
	        parentNode.removeChild(child);
	        context.markDeleted(child);
	        child = next;
	    }
	}
	/**
	 * Changes to the first child of the current node.
	 */
	function enterNode() {
	    currentParent = currentNode;
	    currentNode = null;
	}
	/**
	 * @return The next Node to be patched.
	 */
	function getNextNode() {
	    if (currentNode) {
	        return currentNode.nextSibling;
	    } else {
	        return currentParent.firstChild;
	    }
	}
	/**
	 * Changes to the next sibling of the current node.
	 */
	function nextNode() {
	    currentNode = getNextNode();
	}
	/**
	 * Changes to the parent of the current node, removing any unvisited children.
	 */
	function exitNode() {
	    clearUnvisitedDOM(currentParent, getNextNode(), null);
	    currentNode = currentParent;
	    currentParent = currentParent.parentNode;
	}
	/**
	 * Makes sure that the current node is an Element with a matching nameOrCtor and
	 * key.
	 *
	 * @param nameOrCtor The tag or constructor for the Element.
	 * @param key The key used to identify this element. This can be an
	 *     empty string, but performance may be better if a unique value is used
	 *     when iterating over an array of items.
	 * @return The corresponding Element.
	 */
	function open(nameOrCtor, key) {
	    nextNode();
	    alignWithDOM(nameOrCtor, key);
	    enterNode();
	    return currentParent;
	}
	/**
	 * Closes the currently open Element, removing any unvisited children if
	 * necessary.
	 */
	function close() {
	    exitNode();
	    return currentNode;
	}
	/**
	 * Makes sure the current node is a Text node and creates a Text node if it is
	 * not.
	 */
	function text() {
	    nextNode();
	    alignWithDOM('#text', null);
	    return currentNode;
	}
	/**
	 * Gets the current Element being patched.
	 */
	function currentElement() {
	    return currentParent;
	}
	/**
	 * @return The Node that will be evaluated for the next instruction.
	 */
	function currentPointer() {
	    // TODO(tomnguyen): assert that this is not null
	    return getNextNode();
	}
	/**
	 * Skips the children in a subtree, allowing an Element to be closed without
	 * clearing out the children.
	 */
	function skip() {
	    currentNode = currentParent.lastChild;
	}

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	/**
	 * The offset in the virtual element declaration where the attributes are
	 * specified.
	 */
	var ATTRIBUTES_OFFSET = 3;
	/**
	 * Used to keep track of the previous values when a 2-way diff is necessary.
	 * This object is reused.
	 * TODO(sparhamI) Scope this to a patch so you can call patch from an attribute
	 * update.
	 */
	var prevAttrsMap = createMap();
	/**
	 * Applies the statics. When importing an Element, any existing attributes that
	 * match a static are converted into a static attribute.
	 * @param node The Element to apply statics for.
	 * @param data The Element's data
	 * @param statics The statics array,
	 */
	function applyStatics(node, data, statics) {
	    data.staticsApplied = true;
	    if (!statics || !statics.length) {
	        return;
	    }
	    if (data.hasEmptyAttrsArr()) {
	        for (var i = 0; i < statics.length; i += 2) {
	            updateAttribute(node, statics[i], statics[i + 1]);
	        }
	        return;
	    }
	    for (var i = 0; i < statics.length; i += 2) {
	        prevAttrsMap[statics[i]] = i + 1;
	    }
	    var attrsArr = data.getAttrsArr(0);
	    var j = 0;
	    for (var i = 0; i < attrsArr.length; i += 2) {
	        var name = attrsArr[i];
	        var value = attrsArr[i + 1];
	        var staticsIndex = prevAttrsMap[name];
	        if (staticsIndex) {
	            // For any attrs that are static and have the same value, make sure we do
	            // not set them again.
	            if (statics[staticsIndex] === value) {
	                delete prevAttrsMap[name];
	            }
	            continue;
	        }
	        // For any attrs that are dynamic, move them up to the right place.
	        attrsArr[j] = name;
	        attrsArr[j + 1] = value;
	        j += 2;
	    }
	    // Anything after `j` was either moved up already or static.
	    truncateArray(attrsArr, j);
	    for (var name in prevAttrsMap) {
	        updateAttribute(node, name, statics[prevAttrsMap[name]]);
	        delete prevAttrsMap[name];
	    }
	}
	/**
	 * @param  nameOrCtor The Element's tag or constructor.
	 * @param  key The key used to identify this element. This can be an
	 *     empty string, but performance may be better if a unique value is used
	 *     when iterating over an array of items.
	 * @param statics An array of attribute name/value pairs of the static
	 *     attributes for the Element. Attributes will only be set once when the
	 *     Element is created.
	 * @param varArgs, Attribute name/value pairs of the dynamic attributes
	 *     for the Element.
	 * @return The corresponding Element.
	 */
	function elementOpen(nameOrCtor, key,
	// Ideally we could tag statics and varArgs as an array where every odd
	// element is a string and every even element is any, but this is hard.
	// tslint:disable-next-line:no-any
	statics) {
	    var varArgs = [];
	    for (var _i = 3; _i < arguments.length; _i++) {
	        varArgs[_i - 3] = arguments[_i];
	    }
	    var node = open(nameOrCtor, key);
	    var data = getData(node);
	    if (!data.staticsApplied) {
	        applyStatics(node, data, statics);
	    }
	    var attrsLength = Math.max(0, arguments.length - ATTRIBUTES_OFFSET);
	    var hadNoAttrs = data.hasEmptyAttrsArr();
	    if (!attrsLength && hadNoAttrs) {
	        return node;
	    }
	    var attrsArr = data.getAttrsArr(attrsLength);
	    /*
	     * Checks to see if one or more attributes have changed for a given Element.
	     * When no attributes have changed, this is much faster than checking each
	     * individual argument. When attributes have changed, the overhead of this is
	     * minimal.
	     */
	    var i = ATTRIBUTES_OFFSET;
	    var j = 0;
	    for (; i < arguments.length; i += 2, j += 2) {
	        var name = arguments[i];
	        if (hadNoAttrs) {
	            attrsArr[j] = name;
	        } else if (attrsArr[j] !== name) {
	            break;
	        }
	        var value = arguments[i + 1];
	        if (hadNoAttrs || attrsArr[j + 1] !== value) {
	            attrsArr[j + 1] = value;
	            updateAttribute(node, name, value);
	        }
	    }
	    /*
	     * Items did not line up exactly as before, need to make sure old items are
	     * removed. This can happen if using conditional logic when declaring
	     * attrs through the elementOpenStart flow or if one element is reused in
	     * the place of another.
	     */
	    if (i < arguments.length || j < attrsArr.length) {
	        var attrsStart = j;
	        for (; j < attrsArr.length; j += 2) {
	            prevAttrsMap[attrsArr[j]] = attrsArr[j + 1];
	        }
	        for (j = attrsStart; i < arguments.length; i += 2, j += 2) {
	            var name = arguments[i];
	            var value = arguments[i + 1];
	            if (prevAttrsMap[name] !== value) {
	                updateAttribute(node, name, value);
	            }
	            attrsArr[j] = name;
	            attrsArr[j + 1] = value;
	            delete prevAttrsMap[name];
	        }
	        truncateArray(attrsArr, j);
	        /*
	         * At this point, only have attributes that were present before, but have
	         * been removed.
	         */
	        for (var name in prevAttrsMap) {
	            updateAttribute(node, name, undefined);
	            delete prevAttrsMap[name];
	        }
	    }
	    return node;
	}
	/**
	 * Declares a virtual Element at the current location in the document. This
	 * corresponds to an opening tag and a elementClose tag is required. This is
	 * like elementOpen, but the attributes are defined using the attr function
	 * rather than being passed as arguments. Must be folllowed by 0 or more calls
	 * to attr, then a call to elementOpenEnd.
	 * @param nameOrCtor The Element's tag or constructor.
	 * @param key The key used to identify this element. This can be an
	 *     empty string, but performance may be better if a unique value is used
	 *     when iterating over an array of items.
	 * @param statics An array of attribute name/value pairs of the static
	 *     attributes for the Element. Attributes will only be set once when the
	 *     Element is created.
	 */
	function elementOpenStart(nameOrCtor, key, statics) {
	    var argsBuilder = getArgsBuilder();
	    argsBuilder[0] = nameOrCtor;
	    argsBuilder[1] = key;
	    argsBuilder[2] = statics;
	}
	/**
	 * Allows you to define a key after an elementOpenStart. This is useful in
	 * templates that define key after an element has been opened ie
	 * `<div key('foo')></div>`.
	 */
	function key(key) {
	    var argsBuilder = getArgsBuilder();
	    argsBuilder[1] = key;
	}
	/***
	 * Defines a virtual attribute at this point of the DOM. This is only valid
	 * when called between elementOpenStart and elementOpenEnd.
	 */
	// tslint:disable-next-line:no-any
	function attr(name, value) {
	    var argsBuilder = getArgsBuilder();
	    argsBuilder.push(name);
	    argsBuilder.push(value);
	}
	/**
	 * Closes an open tag started with elementOpenStart.
	 * @return The corresponding Element.
	 */
	function elementOpenEnd() {
	    var argsBuilder = getArgsBuilder();
	    var node = elementOpen.apply(null, argsBuilder);
	    truncateArray(argsBuilder, 0);
	    return node;
	}
	/**
	 * Closes an open virtual Element.
	 *
	 * @param nameOrCtor The Element's tag or constructor.
	 * @return The corresponding Element.
	 */
	function elementClose(nameOrCtor) {
	    var node = close();
	    return node;
	}
	/**
	 * Declares a virtual Element at the current location in the document that has
	 * no children.
	 * @param nameOrCtor The Element's tag or constructor.
	 * @param key The key used to identify this element. This can be an
	 *     empty string, but performance may be better if a unique value is used
	 *     when iterating over an array of items.
	 * @param statics An array of attribute name/value pairs of the static
	 *     attributes for the Element. Attributes will only be set once when the
	 *     Element is created.
	 * @param varArgs Attribute name/value pairs of the dynamic attributes
	 *     for the Element.
	 * @return The corresponding Element.
	 */
	function elementVoid(nameOrCtor, key,
	// Ideally we could tag statics and varArgs as an array where every odd
	// element is a string and every even element is any, but this is hard.
	// tslint:disable-next-line:no-any
	statics) {
	    var varArgs = [];
	    for (var _i = 3; _i < arguments.length; _i++) {
	        varArgs[_i - 3] = arguments[_i];
	    }
	    elementOpen.apply(null, arguments);
	    return elementClose(nameOrCtor);
	}
	/**
	 * Declares a virtual Text at this point in the document.
	 *
	 * @param value The value of the Text.
	 * @param varArgs
	 *     Functions to format the value which are called only when the value has
	 *     changed.
	 * @return The corresponding text node.
	 */
	function text$1(value) {
	    var varArgs = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        varArgs[_i - 1] = arguments[_i];
	    }
	    var node = text();
	    var data = getData(node);
	    if (data.text !== value) {
	        data.text = value;
	        var formatted = value;
	        for (var i = 1; i < arguments.length; i += 1) {
	            /*
	             * Call the formatter function directly to prevent leaking arguments.
	             * https://github.com/google/incremental-dom/pull/204#issuecomment-178223574
	             */
	            var fn = arguments[i];
	            formatted = fn(formatted);
	        }
	        node.data = formatted;
	    }
	    return node;
	}

	/**
	 * @license
	 * Copyright 2018 The Incremental DOM Authors. All Rights Reserved.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *      http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS-IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */

	exports.applyAttr = applyAttr;
	exports.applyProp = applyProp;
	exports.attributes = attributes;
	exports.close = close;
	exports.currentElement = currentElement;
	exports.currentPointer = currentPointer;
	exports.open = open;
	exports.patch = patchInner;
	exports.patchInner = patchInner;
	exports.patchOuter = patchOuter;
	exports.skip = skip;
	exports.skipNode = nextNode;
	exports.getKey = getKey;
	exports.clearCache = clearCache;
	exports.importNode = importNode;
	exports.isDataInitialized = isDataInitialized;
	exports.notifications = notifications;
	exports.symbols = symbols;
	exports.attr = attr;
	exports.elementClose = elementClose;
	exports.elementOpen = elementOpen;
	exports.elementOpenEnd = elementOpenEnd;
	exports.elementOpenStart = elementOpenStart;
	exports.elementVoid = elementVoid;
	exports.text = text$1;
	exports.key = key;


	});

	unwrapExports(incrementalDomCjs);
	var incrementalDomCjs_1 = incrementalDomCjs.applyAttr;
	var incrementalDomCjs_2 = incrementalDomCjs.applyProp;
	var incrementalDomCjs_3 = incrementalDomCjs.attributes;
	var incrementalDomCjs_4 = incrementalDomCjs.close;
	var incrementalDomCjs_5 = incrementalDomCjs.currentElement;
	var incrementalDomCjs_6 = incrementalDomCjs.currentPointer;
	var incrementalDomCjs_7 = incrementalDomCjs.open;
	var incrementalDomCjs_8 = incrementalDomCjs.patch;
	var incrementalDomCjs_9 = incrementalDomCjs.patchInner;
	var incrementalDomCjs_10 = incrementalDomCjs.patchOuter;
	var incrementalDomCjs_11 = incrementalDomCjs.skip;
	var incrementalDomCjs_12 = incrementalDomCjs.skipNode;
	var incrementalDomCjs_13 = incrementalDomCjs.getKey;
	var incrementalDomCjs_14 = incrementalDomCjs.clearCache;
	var incrementalDomCjs_15 = incrementalDomCjs.importNode;
	var incrementalDomCjs_16 = incrementalDomCjs.isDataInitialized;
	var incrementalDomCjs_17 = incrementalDomCjs.notifications;
	var incrementalDomCjs_18 = incrementalDomCjs.symbols;
	var incrementalDomCjs_19 = incrementalDomCjs.attr;
	var incrementalDomCjs_20 = incrementalDomCjs.elementClose;
	var incrementalDomCjs_21 = incrementalDomCjs.elementOpen;
	var incrementalDomCjs_22 = incrementalDomCjs.elementOpenEnd;
	var incrementalDomCjs_23 = incrementalDomCjs.elementOpenStart;
	var incrementalDomCjs_24 = incrementalDomCjs.elementVoid;
	var incrementalDomCjs_25 = incrementalDomCjs.text;
	var incrementalDomCjs_26 = incrementalDomCjs.key;

	incrementalDomCjs_3.caretpos = function (element, name, value) {
	  element.setSelectionRange(value, value);
	};

	incrementalDomCjs_3.value = incrementalDomCjs_2;

	var renderIncrementalDOM = function renderIncrementalDOM(data, onSelect, multiline) {
	  if (data.suggestions.length > 0 && data.focused) {
	    // unselectable=on is a IE11 workaround,
	    // which makes it possible to use an eventual scroll bar on suggestions list.
	    incrementalDomCjs_21('ul', '', ['class', 'dawa-autocomplete-suggestions', 'role', 'listbox', 'unselectable', 'on']);

	    var _loop = function _loop(i) {
	      var suggestion = data.suggestions[i];
	      var className = 'dawa-autocomplete-suggestion';

	      if (data.selected === i) {
	        className += ' dawa-selected';
	      }

	      incrementalDomCjs_21('li', '', ['role', 'option'], 'class', className, 'onmousedown', function (e) {
	        onSelect(i);
	        e.preventDefault();
	      });
	      var rows = suggestion.forslagstekst.split('\n');
	      rows = rows.map(function (row) {
	        return row.replace(/ /g, "\xA0");
	      });

	      if (multiline) {
	        incrementalDomCjs_25(rows[0]);

	        for (var _i = 1; _i < rows.length; ++_i) {
	          incrementalDomCjs_24('br');
	          incrementalDomCjs_25(rows[_i]);
	        }
	      } else {
	        incrementalDomCjs_25(rows.join(', '));
	      }

	      incrementalDomCjs_20('li');
	    };

	    for (var i = 0; i < data.suggestions.length; ++i) {
	      _loop(i);
	    }

	    incrementalDomCjs_20('ul');
	  }
	};

	var defaultRender = function defaultRender(containerElm, data, onSelect, multiline) {
	  incrementalDomCjs_8(containerElm, function () {
	    renderIncrementalDOM(data, onSelect, multiline);
	  });
	};

	var autocompleteUi = function autocompleteUi(inputElm, options) {
	  var onSelect = options.onSelect;
	  var onTextChange = options.onTextChange;
	  var render = options.render || defaultRender;
	  var destroyed = false;
	  var lastEmittedText = '';
	  var lastEmittedCaretpos = 0;
	  var suggestionContainerElm = document.createElement('div');
	  inputElm.parentNode.insertBefore(suggestionContainerElm, inputElm.nextSibling);

	  var emitTextChange = function emitTextChange(newText, newCaretpos) {
	    if (lastEmittedText !== newText || lastEmittedCaretpos !== newCaretpos) {
	      onTextChange(newText, newCaretpos);
	      lastEmittedText = newText;
	      lastEmittedCaretpos = newCaretpos;
	    }
	  };

	  var data = {
	    caretpos: 2,
	    inputText: '',
	    selected: 0,
	    focused: document.activeElement === inputElm,
	    suggestions: []
	  };

	  var handleInputChanged = function handleInputChanged(inputElm) {
	    var newText = inputElm.value;
	    var newCaretPos = inputElm.selectionStart;
	    data.caretpos = newCaretPos;
	    data.inputText = newText;
	    emitTextChange(newText, newCaretPos);
	  };

	  var update;

	  var selectSuggestion = function selectSuggestion(index) {
	    var selectedSuggestion = data.suggestions[index];
	    data.inputText = selectedSuggestion.tekst;
	    data.caretpos = selectedSuggestion.caretpos;
	    data.suggestions = [];
	    onSelect(selectedSuggestion);
	    update(true);
	  };

	  var keydownHandler = function keydownHandler(e) {
	    var key = window.event ? e.keyCode : e.which;

	    if (data.suggestions.length > 0 && data.focused) {
	      // down (40)
	      if (key === 40) {
	        data.selected = (data.selected + 1) % data.suggestions.length;
	        update();
	      } //up (38)
	      else if (key === 38) {
	          data.selected = (data.selected - 1 + data.suggestions.length) % data.suggestions.length;
	          update();
	        } // enter
	        else if (key === 13 || key === 9) {
	            selectSuggestion(data.selected);
	          } else {
	            return true;
	          }

	      e.preventDefault();
	      return false;
	    }
	  };

	  var focusHandler = function focusHandler() {
	    data.focused = true;
	    update();
	  };

	  var blurHandler = function blurHandler() {
	    data.focused = false;
	    update();
	    return false;
	  };

	  var inputChangeHandler = function inputChangeHandler(e) {
	    handleInputChanged(e.target);
	  };

	  var inputMouseUpHandler = function inputMouseUpHandler(e) {
	    return handleInputChanged(e.target);
	  };

	  var updateScheduled = false;
	  var updateInput = false;

	  update = function update(shouldUpdateInput) {
	    if (shouldUpdateInput) {
	      updateInput = true;
	    }

	    if (!updateScheduled) {
	      updateScheduled = true;
	      requestAnimationFrame(function () {
	        if (destroyed) {
	          return;
	        }

	        updateScheduled = false;

	        if (updateInput) {
	          inputElm.value = data.inputText;
	          inputElm.setSelectionRange(data.caretpos, data.caretpos);
	        }

	        updateInput = false;
	        render(suggestionContainerElm, data, function (i) {
	          return selectSuggestion(i);
	        }, options.multiline);
	      });
	    }
	  };

	  update();

	  var destroy = function destroy() {
	    destroyed = true;
	    inputElm.removeEventListener('keydown', keydownHandler);
	    inputElm.removeEventListener('blur', blurHandler);
	    inputElm.removeEventListener('focus', focusHandler);
	    inputElm.removeEventListener('input', inputChangeHandler);
	    inputElm.removeEventListener('mouseup', inputMouseUpHandler);
	    incrementalDomCjs_8(suggestionContainerElm, function () {});
	    suggestionContainerElm.remove();
	  };

	  var setSuggestions = function setSuggestions(suggestions) {
	    data.suggestions = suggestions;
	    data.selected = 0;
	    update();
	  };

	  var selectAndClose = function selectAndClose(text) {
	    data.inputText = text;
	    data.caretpos = text.length;
	    data.suggestions = [];
	    data.selected = 0;
	    update(true);
	  };

	  inputElm.addEventListener('keydown', keydownHandler);
	  inputElm.addEventListener('blur', blurHandler);
	  inputElm.addEventListener('focus', focusHandler);
	  inputElm.addEventListener('input', inputChangeHandler);
	  inputElm.addEventListener('mouseup', inputMouseUpHandler);
	  inputElm.setAttribute('aria-autocomplete', 'list');
	  inputElm.setAttribute('autocomplete', 'off');
	  return {
	    destroy: destroy,
	    setSuggestions: setSuggestions,
	    selectAndClose: selectAndClose
	  };
	};

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}

	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}

	var _anInstance = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

	// call something on iterator step with safe closing on error

	var _iterCall = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) _anObject(ret.call(iterator));
	    throw e;
	  }
	};

	var _iterators = {};

	// check on default Array iterator

	var ITERATOR = _wks('iterator');
	var ArrayProto = Array.prototype;

	var _isArrayIter = function (it) {
	  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR] === it);
	};

	var ITERATOR$1 = _wks('iterator');

	var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR$1]
	    || it['@@iterator']
	    || _iterators[_classof(it)];
	};

	var _forOf = createCommonjsModule(function (module) {
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
	  var f = _ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
	    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = _iterCall(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;
	});

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	var _invoke = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};

	var document$2 = _global.document;
	var _html = document$2 && document$2.documentElement;

	var process = _global.process;
	var setTask = _global.setImmediate;
	var clearTask = _global.clearImmediate;
	var MessageChannel = _global.MessageChannel;
	var Dispatch = _global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (_cof(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(_ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(_ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = _ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
	    defer = function (id) {
	      _global.postMessage(id + '', '*');
	    };
	    _global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in _domCreate('script')) {
	    defer = function (id) {
	      _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
	        _html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(_ctx(run, id, 1), 0);
	    };
	  }
	}
	var _task = {
	  set: setTask,
	  clear: clearTask
	};

	var macrotask = _task.set;
	var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
	var process$1 = _global.process;
	var Promise$1 = _global.Promise;
	var isNode = _cof(process$1) == 'process';

	var _microtask = function () {
	  var head, last, notify;

	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process$1.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };

	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process$1.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise$1 && Promise$1.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise$1.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(_global, flush);
	    };
	  }

	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};

	// 25.4.1.5 NewPromiseCapability(C)


	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = _aFunction(resolve);
	  this.reject = _aFunction(reject);
	}

	var f$3 = function (C) {
	  return new PromiseCapability(C);
	};

	var _newPromiseCapability = {
		f: f$3
	};

	var _perform = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};

	var navigator = _global.navigator;

	var _userAgent = navigator && navigator.userAgent || '';

	var _promiseResolve = function (C, x) {
	  _anObject(C);
	  if (_isObject(x) && x.constructor === C) return x;
	  var promiseCapability = _newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};

	var _redefineAll = function (target, src, safe) {
	  for (var key in src) _redefine(target, key, src[key], safe);
	  return target;
	};

	var def = _objectDp.f;

	var TAG$1 = _wks('toStringTag');

	var _setToStringTag = function (it, tag, stat) {
	  if (it && !_has(it = stat ? it : it.prototype, TAG$1)) def(it, TAG$1, { configurable: true, value: tag });
	};

	var SPECIES$2 = _wks('species');

	var _setSpecies = function (KEY) {
	  var C = _global[KEY];
	  if (_descriptors && C && !C[SPECIES$2]) _objectDp.f(C, SPECIES$2, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};

	var ITERATOR$2 = _wks('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR$2]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	} catch (e) { /* empty */ }

	var _iterDetect = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR$2]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR$2] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};

	var task = _task.set;
	var microtask = _microtask();




	var PROMISE = 'Promise';
	var TypeError$1 = _global.TypeError;
	var process$2 = _global.process;
	var versions = process$2 && process$2.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = _global[PROMISE];
	var isNode$1 = _classof(process$2) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && _userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();

	// helpers
	var isThenable = function (it) {
	  var then;
	  return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError$1('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(_global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = _perform(function () {
	        if (isNode$1) {
	          process$2.emit('unhandledRejection', value, promise);
	        } else if (handler = _global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = _global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(_global, function () {
	    var handler;
	    if (isNode$1) {
	      process$2.emit('rejectionHandled', promise);
	    } else if (handler = _global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};

	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    _anInstance(this, $Promise, PROMISE, '_h');
	    _aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = _redefineAll($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode$1 ? process$2.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = _ctx($resolve, promise, 1);
	    this.reject = _ctx($reject, promise, 1);
	  };
	  _newPromiseCapability.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}

	_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Promise: $Promise });
	_setToStringTag($Promise, PROMISE);
	_setSpecies(PROMISE);
	Wrapper = _core[PROMISE];

	// statics
	_export(_export.S + _export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	_export(_export.S + _export.F * (!USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return _promiseResolve(this, x);
	  }
	});
	_export(_export.S + _export.F * !(USE_NATIVE && _iterDetect(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = _perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      _forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = _perform(function () {
	      _forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = _wks('unscopables');
	var ArrayProto$1 = Array.prototype;
	if (ArrayProto$1[UNSCOPABLES] == undefined) _hide(ArrayProto$1, UNSCOPABLES, {});
	var _addToUnscopables = function (key) {
	  ArrayProto$1[UNSCOPABLES][key] = true;
	};

	var _iterStep = function (done, value) {
	  return { value: value, done: !!done };
	};

	var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
	  _anObject(O);
	  var keys = _objectKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



	var IE_PROTO$1 = _sharedKey('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE$1 = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = _domCreate('iframe');
	  var i = _enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  _html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
	  return createDict();
	};

	var _objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE$1] = _anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE$1] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO$1] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : _objectDps(result, Properties);
	};

	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

	var _iterCreate = function (Constructor, NAME, next) {
	  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
	  _setToStringTag(Constructor, NAME + ' Iterator');
	};

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


	var IE_PROTO$2 = _sharedKey('IE_PROTO');
	var ObjectProto = Object.prototype;

	var _objectGpo = Object.getPrototypeOf || function (O) {
	  O = _toObject(O);
	  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};

	var ITERATOR$3 = _wks('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  _iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR$3] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      _setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (typeof IteratorPrototype[ITERATOR$3] != 'function') _hide(IteratorPrototype, ITERATOR$3, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if (BUGGY || VALUES_BUG || !proto[ITERATOR$3]) {
	    _hide(proto, ITERATOR$3, $default);
	  }
	  // Plug for library
	  _iterators[NAME] = $default;
	  _iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) _redefine(proto, key, methods[key]);
	    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
	  this._t = _toIobject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return _iterStep(1);
	  }
	  if (kind == 'keys') return _iterStep(0, index);
	  if (kind == 'values') return _iterStep(0, O[index]);
	  return _iterStep(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	_iterators.Arguments = _iterators.Array;

	_addToUnscopables('keys');
	_addToUnscopables('values');
	_addToUnscopables('entries');

	var ITERATOR$4 = _wks('iterator');
	var TO_STRING_TAG = _wks('toStringTag');
	var ArrayValues = _iterators.Array;

	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};

	for (var collections = _objectKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = _global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR$4]) _hide(proto, ITERATOR$4, ArrayValues);
	    if (!proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
	    _iterators[NAME] = ArrayValues;
	    if (explicit) for (key in es6_array_iterator) if (!proto[key]) _redefine(proto, key, es6_array_iterator[key], true);
	  }
	}

	// 19.1.3.6 Object.prototype.toString()

	var test = {};
	test[_wks('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  _redefine(Object.prototype, 'toString', function toString() {
	    return '[object ' + _classof(this) + ']';
	  }, true);
	}

	// most Object methods by ES6 should accept primitives



	var _objectSap = function (KEY, exec) {
	  var fn = (_core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
	};

	// 19.1.2.14 Object.keys(O)



	_objectSap('keys', function () {
	  return function keys(it) {
	    return _objectKeys(_toObject(it));
	  };
	});

	function fetch(e,n){return n=n||{},new Promise(function(t,r){var s=new XMLHttpRequest,o=[],u=[],i={},a=function(){return {ok:2==(s.status/100|0),statusText:s.statusText,status:s.status,url:s.responseURL,text:function(){return Promise.resolve(s.responseText)},json:function(){return Promise.resolve(JSON.parse(s.responseText))},blob:function(){return Promise.resolve(new Blob([s.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var l in s.open(n.method||"get",e,!0),s.onload=function(){s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t;}),t(a());},s.onerror=r,s.withCredentials="include"==n.credentials,n.headers)s.setRequestHeader(l,n.headers[l]);s.send(n.body||null);})}

	var formatParams = function formatParams(params) {
	  return Object.keys(params).map(function (paramName) {
	    var paramValue = params[paramName];
	    return "".concat(paramName, "=").concat(encodeURIComponent(paramValue));
	  }).join('&');
	};

	var delay = function delay(ms) {
	  return new Promise(function (resolve) {
	    return setTimeout(resolve, ms);
	  });
	};

	var defaultOptions = {
	  params: {},
	  minLength: 2,
	  retryDelay: 500,
	  renderCallback: function renderCallback() {
	    /*eslint no-console: 0*/
	    console.error('No renderCallback supplied');
	  },
	  initialRenderCallback: function initialRenderCallback() {
	    /*eslint no-console: 0*/
	    console.error('No initialRenderCallback supplied');
	  },
	  type: 'adresse',
	  baseUrl: 'https://dawa.aws.dk',
	  adgangsadresserOnly: false,
	  stormodtagerpostnumre: true,
	  supplerendebynavn: true,
	  fuzzy: true,
	  fetchImpl: function fetchImpl(url, params) {
	    return fetch("".concat(url, "?").concat(formatParams(params)), {
	      mode: 'cors'
	    }).then(function (result) {
	      return result.json();
	    });
	  }
	};
	var AutocompleteController =
	/*#__PURE__*/
	function () {
	  function AutocompleteController(options) {
	    _classCallCheck(this, AutocompleteController);

	    options = Object.assign({}, defaultOptions, options || {});
	    this.options = options;
	    this.state = {
	      currentRequest: null,
	      pendingRequest: null
	    };
	    this.selected = null;
	  }

	  _createClass(AutocompleteController, [{
	    key: "_getAutocompleteResponse",
	    value: function _getAutocompleteResponse(text, caretpos, skipVejnavn, adgangsadresseid, supplerendebynavn, stormodtagerpostnumre) {
	      var params = Object.assign({}, this.options.params, {
	        q: text,
	        type: this.options.type,
	        caretpos: caretpos,
	        supplerendebynavn: supplerendebynavn,
	        stormodtagerpostnumre: stormodtagerpostnumre,
	        multilinje: true
	      });

	      if (this.options.fuzzy) {
	        params.fuzzy = '';
	      }

	      if (adgangsadresseid) {
	        params.adgangsadresseid = adgangsadresseid;
	      }

	      if (skipVejnavn) {
	        params.startfra = 'adgangsadresse';
	      }

	      return this.options.fetchImpl("".concat(this.options.baseUrl, "/autocomplete"), params);
	    }
	  }, {
	    key: "_scheduleRequest",
	    value: function _scheduleRequest(request) {
	      if (this.state.currentRequest !== null) {
	        this.state.pendingRequest = request;
	      } else {
	        this.state.currentRequest = request;

	        this._executeRequest();
	      }
	    }
	  }, {
	    key: "_executeRequest",
	    value: function _executeRequest() {
	      var _this = this;

	      var request = this.state.currentRequest;
	      var adgangsadresseid = null;
	      var skipVejnavn = false;
	      var text, caretpos;

	      if (request.selected) {
	        var item = request.selected;

	        if (item.type !== this.options.type) {
	          adgangsadresseid = item.type === 'adgangsadresse' ? item.data.id : null;
	          skipVejnavn = item.type === 'vejnavn';
	          text = item.tekst;
	          caretpos = item.caretpos;
	        } else {
	          this.options.selectCallback(item);
	          this.selected = item;

	          this._requestCompleted();

	          return;
	        }
	      } else {
	        text = request.text;
	        caretpos = request.caretpos;
	      }

	      if (request.selectedId) {
	        var params = {
	          id: request.selectedId,
	          type: this.options.type
	        };
	        return this.options.fetchImpl("".concat(this.options.baseUrl, "/autocomplete"), params).then(function (result) {
	          return _this._handleResponse(request, result);
	        }, function (error) {
	          return _this._handleFailedRequest(request, error);
	        });
	      } else if (request.selected || request.text.length >= this.options.minLength) {
	        this._getAutocompleteResponse(text, caretpos, skipVejnavn, adgangsadresseid, this.options.supplerendebynavn, this.options.stormodtagerpostnumre).then(function (result) {
	          return _this._handleResponse(request, result);
	        }, function (error) {
	          return _this._handleFailedRequest(request, error);
	        });
	      } else {
	        this._handleResponse(request, []);
	      }
	    }
	  }, {
	    key: "_handleFailedRequest",
	    value: function _handleFailedRequest(request, error) {
	      var _this2 = this;

	      console.error('DAWA request failed', error);
	      return delay(this.options.retryDelay).then(function () {
	        if (!_this2.state.pendingRequest) {
	          _this2._scheduleRequest(request);
	        }

	        _this2._requestCompleted();
	      });
	    }
	  }, {
	    key: "_handleResponse",
	    value: function _handleResponse(request, result) {
	      if (request.selected) {
	        if (result.length === 1) {
	          var item = result[0];

	          if (item.type === this.options.type) {
	            this.options.selectCallback(item);
	          } else {
	            if (!this.state.pendingRequest) {
	              this.state.pendingRequest = {
	                selected: item
	              };
	            }
	          }
	        } else if (this.options.renderCallback) {
	          this.options.renderCallback(result);
	        }
	      } else if (request.selectedId) {
	        if (result.length === 1) {
	          this.selected = result[0];
	          this.options.initialRenderCallback(result[0].tekst);
	        }
	      } else {
	        if (this.options.renderCallback) {
	          this.options.renderCallback(result);
	        }
	      }

	      this._requestCompleted();
	    }
	  }, {
	    key: "_requestCompleted",
	    value: function _requestCompleted() {
	      this.state.currentRequest = this.state.pendingRequest;
	      this.state.pendingRequest = null;

	      if (this.state.currentRequest) {
	        this._executeRequest();
	      }
	    }
	  }, {
	    key: "setRenderCallback",
	    value: function setRenderCallback(renderCallback) {
	      this.options.renderCallback = renderCallback;
	    }
	  }, {
	    key: "setInitialRenderCallback",
	    value: function setInitialRenderCallback(renderCallback) {
	      this.options.initialRenderCallback = renderCallback;
	    }
	  }, {
	    key: "setSelectCallback",
	    value: function setSelectCallback(selectCallback) {
	      this.options.selectCallback = selectCallback;
	    }
	  }, {
	    key: "update",
	    value: function update(text, caretpos) {
	      var request = {
	        text: text,
	        caretpos: caretpos
	      };

	      this._scheduleRequest(request);
	    }
	  }, {
	    key: "select",
	    value: function select(item) {
	      var request = {
	        selected: item
	      };

	      this._scheduleRequest(request);
	    }
	  }, {
	    key: "selectInitial",
	    value: function selectInitial(id) {
	      var request = {
	        selectedId: id
	      };

	      this._scheduleRequest(request);
	    }
	  }, {
	    key: "destroy",
	    value: function destroy() {}
	  }]);

	  return AutocompleteController;
	}();

	function dawaAutocomplete(inputElm, options) {
	  options = Object.assign({
	    select: function select() {
	      return null;
	    }
	  }, options);
	  var controllerOptions = ['baseUrl', 'minLength', 'params', 'fuzzy', 'stormodtagerpostnumre', 'supplerendebynavn', 'type'].reduce(function (memo, optionName) {
	    if (options.hasOwnProperty(optionName)) {
	      memo[optionName] = options[optionName];
	    }

	    return memo;
	  }, {});

	  if (!controllerOptions.type) {
	    if (options.adgangsadresserOnly) {
	      controllerOptions.type = 'adgangsadresse';
	    } else {
	      controllerOptions.type = 'adresse';
	    }
	  }

	  var controller = new AutocompleteController(controllerOptions);
	  var ui = autocompleteUi(inputElm, {
	    onSelect: function onSelect(suggestion) {
	      controller.select(suggestion);
	    },
	    onTextChange: function onTextChange(newText, newCaretpos) {
	      controller.update(newText, newCaretpos);
	    },
	    render: options.render,
	    multiline: options.multiline || false
	  });
	  controller.setRenderCallback(function (suggestions) {
	    return ui.setSuggestions(suggestions);
	  });
	  controller.setSelectCallback(function (selected) {
	    ui.selectAndClose(selected.tekst);
	    options.select(selected);
	  });
	  controller.setInitialRenderCallback(function (text) {
	    return ui.selectAndClose(text);
	  });

	  if (options.id) {
	    controller.selectInitial(options.id);
	  }

	  return {
	    id: function id(_id) {
	      return controller.selectInitial(_id);
	    },
	    destroy: function destroy() {
	      return ui.destroy();
	    },
	    selected: function selected() {
	      return controller.selected;
	    }
	  };
	}

	exports.dawaAutocomplete = dawaAutocomplete;

	Object.defineProperty(exports, '__esModule', { value: true });

}));

},{}],393:[function(require,module,exports){
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (typeof define === 'function' && define.amd) {
    define(function() {
        return Hammer;
    });
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');

},{}],394:[function(require,module,exports){
(function (global){
/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],395:[function(require,module,exports){
module.exports={
  "code": "da",
  "messages": {
    "alpha": "{_field_} må kun indeholde bogstaver",
    "alpha_num": "{_field_} må kun indeholde tal og bogstaver",
    "alpha_dash": "{_field_} må kun indeholde tal, bogstaver, bindestreger og underscores",
    "alpha_spaces": "{_field_} må kun indeholde bogstaver og mellemrum",
    "between": "{_field_} skal være mellem {min} og {max}",
    "confirmed": "{_field_} skal matche {target}",
    "digits": "{_field_} skal være et tal på {length} cifre",
    "dimensions": "{_field_} skal være {width} pixels gange {height} pixels",
    "email": "{_field_} skal være en gyldig email",
    "excluded": "{_field_} skal være en gyldig værdi",
    "ext": "{_field_} skal være en gyldig filtype",
    "image": "{_field_} skal være et billede",
    "integer": "{_field_} skal være en numerisk værdi",
    "length": "{_field_} må maksimalt være {length} tegn langt",
    "max_value": "{_field_} må maksimalt være {max} eller mindre",
    "max": "{_field_} må maksimalt være {length} karakterer",
    "mimes": "{_field_} skal være en gyldig filtype",
    "min_value": "{_field_} skal være minimum {min} eller mere",
    "min": "{_field_} skal minimum være {length} karakterer",
    "numeric": "{_field_} skal være numerisk",
    "oneOf": "{_field_} skal være en gyldig værdi",
    "regex": "{_field_} skal have et gyldigt format",
    "required": "{_field_} skal udfyldes",
    "required_if": "{_field_} skal udfyldes",
    "size": "{_field_} må maksimalt have en størrelse på {size}KB"
  }
}

},{}],396:[function(require,module,exports){
module.exports={
  "code": "en",
  "messages": {
    "alpha": "The {_field_} field may only contain alphabetic characters",
    "alpha_num": "The {_field_} field may only contain alpha-numeric characters",
    "alpha_dash": "The {_field_} field may contain alpha-numeric characters as well as dashes and underscores",
    "alpha_spaces": "The {_field_} field may only contain alphabetic characters as well as spaces",
    "between": "The {_field_} field must be between {min} and {max}",
    "confirmed": "The {_field_} field confirmation does not match",
    "digits": "The {_field_} field must be numeric and exactly contain {length} digits",
    "dimensions": "The {_field_} field must be {width} pixels by {height} pixels",
    "email": "The {_field_} field must be a valid email",
    "excluded": "The {_field_} field is not a valid value",
    "ext": "The {_field_} field is not a valid file",
    "image": "The {_field_} field must be an image",
    "integer": "The {_field_} field must be an integer",
    "length": "The {_field_} field must be {length} long",
    "max_value": "The {_field_} field must be {max} or less",
    "max": "The {_field_} field may not be greater than {length} characters",
    "mimes": "The {_field_} field must have a valid file type",
    "min_value": "The {_field_} field must be {min} or more",
    "min": "The {_field_} field must be at least {length} characters",
    "numeric": "The {_field_} field may only contain numeric characters",
    "oneOf": "The {_field_} field is not a valid value",
    "regex": "The {_field_} field format is invalid",
    "required_if": "The {_field_} field is required",
    "required": "The {_field_} field is required",
    "size": "The {_field_} field size must be less than {size}KB"
  }
}

},{}],397:[function(require,module,exports){
module.exports={
  "code": "pl",
  "messages": {
    "alpha": "Pole {_field_} może zawierać tylko litery",
    "alpha_dash": "Pole {_field_} może zawierać litery, cyfry oraz myślnik lub podkreślnik",
    "alpha_num": "Pole {_field_} może zawierać tylko litery i cyfry",
    "alpha_spaces": "Pole {_field_} może zawierać tylko litery oraz spacje",
    "between": "Pole {_field_} musi być pomiędzy {min} oraz {max}",
    "confirmed": "Pole {_field_} nie zgadza się z polem potwierdzającym {target}",
    "digits": "Pole {_field_} musi być liczbą i dokładnie {length} cyfr",
    "dimensions": "Obraz {_field_} musi być szeroki na {width} pikseli i wysoki na {height} pikseli",
    "email": "Pole {_field_} musi być poprawnym adresem email",
    "excluded": "Pole {_field_} musi być poprawną wartością",
    "ext": "Plik {_field_} musi być poprawnym plikiem",
    "image": "Pole {_field_} musi być obrazem",
    "oneOf": "Pole {_field_} musi być poprawną wartością",
    "integer": "Pole {_field_} musi być liczbą całkowitą",
    "length": "Pole {_field_} musi mieć długość {length}",
    "max": "Pole {_field_} nie może być dłuższe niż {length}",
    "max_value": "Pole {_field_} musi mieć maksymalną wartość {max}",
    "mimes": "Plik {_field_} musi posiadać poprawne rozszerzenie",
    "min": "Pole {_field_} musi być długie na co najmniej {length}",
    "min_value": "Pole {_field_} musi mieć minimalną wartość {min}",
    "numeric": "Pole {_field_} może zawierać tylko cyfry",
    "regex": "Format pola {_field_} jest nieodpowiedni",
    "required": "Pole {_field_} jest wymagane",
    "required_if": "Pole {_field_} jest wymagane",
    "size": "Plik {_field_} musi być mniejszy niż {size}KB"
  }
}

},{}],398:[function(require,module,exports){
/**
  * vee-validate v3.4.0
  * (c) 2020 Abdelrahman Awad
  * @license MIT
  */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.VeeValidateRules = {}));
}(this, (function (exports) { 'use strict';

  /**
   * Some Alpha Regex helpers.
   * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
   */
  /* eslint-disable no-misleading-character-class */
  var alpha = {
      en: /^[A-Z]*$/i,
      cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
      da: /^[A-ZÆØÅ]*$/i,
      de: /^[A-ZÄÖÜß]*$/i,
      es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
      fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
      fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
      it: /^[A-Z\xC0-\xFF]*$/i,
      lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
      nl: /^[A-ZÉËÏÓÖÜ]*$/i,
      hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
      pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
      pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
      ro: /^[A-ZĂÂÎŞŢ]*$/i,
      ru: /^[А-ЯЁ]*$/i,
      sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
      sr: /^[A-ZČĆŽŠĐ]*$/i,
      sv: /^[A-ZÅÄÖ]*$/i,
      tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
      uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
      ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
      az: /^[A-ZÇƏĞİıÖŞÜ]*$/i,
      el: /^[Α-ώ]*$/i
  };
  var alphaSpaces = {
      en: /^[A-Z\s]*$/i,
      cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
      da: /^[A-ZÆØÅ\s]*$/i,
      de: /^[A-ZÄÖÜß\s]*$/i,
      es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
      fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
      fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
      it: /^[A-Z\xC0-\xFF\s]*$/i,
      lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
      nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
      hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
      pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
      pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
      ro: /^[A-ZĂÂÎŞŢ\s]*$/i,
      ru: /^[А-ЯЁ\s]*$/i,
      sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
      sr: /^[A-ZČĆŽŠĐ\s]*$/i,
      sv: /^[A-ZÅÄÖ\s]*$/i,
      tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
      uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
      ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,
      az: /^[A-ZÇƏĞİıÖŞÜ\s]*$/i,
      el: /^[Α-ώ\s]*$/i
  };
  var alphanumeric = {
      en: /^[0-9A-Z]*$/i,
      cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
      da: /^[0-9A-ZÆØÅ]$/i,
      de: /^[0-9A-ZÄÖÜß]*$/i,
      es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
      fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
      fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
      it: /^[0-9A-Z\xC0-\xFF]*$/i,
      lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
      hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
      nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
      pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
      pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
      ro: /^[0-9A-ZĂÂÎŞŢ]*$/i,
      ru: /^[0-9А-ЯЁ]*$/i,
      sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
      sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
      sv: /^[0-9A-ZÅÄÖ]*$/i,
      tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
      uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
      ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
      az: /^[0-9A-ZÇƏĞİıÖŞÜ]*$/i,
      el: /^[0-9Α-ώ]*$/i
  };
  var alphaDash = {
      en: /^[0-9A-Z_-]*$/i,
      cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
      da: /^[0-9A-ZÆØÅ_-]*$/i,
      de: /^[0-9A-ZÄÖÜß_-]*$/i,
      es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
      fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
      fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
      it: /^[0-9A-Z\xC0-\xFF_-]*$/i,
      lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
      nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
      hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
      pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
      pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
      ro: /^[0-9A-ZĂÂÎŞŢ_-]*$/i,
      ru: /^[0-9А-ЯЁ_-]*$/i,
      sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
      sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
      sv: /^[0-9A-ZÅÄÖ_-]*$/i,
      tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
      uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
      ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/,
      az: /^[0-9A-ZÇƏĞİıÖŞÜ_-]*$/i,
      el: /^[0-9Α-ώ_-]*$/i
  };

  var validate = function (value, _a) {
      var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate(val, { locale: locale }); });
      }
      // Match at least one locale.
      if (!locale) {
          return Object.keys(alpha).some(function (loc) { return alpha[loc].test(value); });
      }
      return (alpha[locale] || alpha.en).test(value);
  };
  var params = [
      {
          name: 'locale'
      }
  ];
  var alpha$1 = {
      validate: validate,
      params: params
  };

  var validate$1 = function (value, _a) {
      var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$1(val, { locale: locale }); });
      }
      // Match at least one locale.
      if (!locale) {
          return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
      }
      return (alphaDash[locale] || alphaDash.en).test(value);
  };
  var params$1 = [
      {
          name: 'locale'
      }
  ];
  var alpha_dash = {
      validate: validate$1,
      params: params$1
  };

  var validate$2 = function (value, _a) {
      var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$2(val, { locale: locale }); });
      }
      // Match at least one locale.
      if (!locale) {
          return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
      }
      return (alphanumeric[locale] || alphanumeric.en).test(value);
  };
  var params$2 = [
      {
          name: 'locale'
      }
  ];
  var alpha_num = {
      validate: validate$2,
      params: params$2
  };

  var validate$3 = function (value, _a) {
      var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$3(val, { locale: locale }); });
      }
      // Match at least one locale.
      if (!locale) {
          return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
      }
      return (alphaSpaces[locale] || alphaSpaces.en).test(value);
  };
  var params$3 = [
      {
          name: 'locale'
      }
  ];
  var alpha_spaces = {
      validate: validate$3,
      params: params$3
  };

  var validate$4 = function (value, _a) {
      var _b = _a === void 0 ? {} : _a, min = _b.min, max = _b.max;
      if (Array.isArray(value)) {
          return value.every(function (val) { return !!validate$4(val, { min: min, max: max }); });
      }
      return Number(min) <= value && Number(max) >= value;
  };
  var params$4 = [
      {
          name: 'min'
      },
      {
          name: 'max'
      }
  ];
  var between = {
      validate: validate$4,
      params: params$4
  };

  var validate$5 = function (value, _a) {
      var target = _a.target;
      return String(value) === String(target);
  };
  var params$5 = [
      {
          name: 'target',
          isTarget: true
      }
  ];
  var confirmed = {
      validate: validate$5,
      params: params$5
  };

  var validate$6 = function (value, _a) {
      var length = _a.length;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$6(val, { length: length }); });
      }
      var strVal = String(value);
      return /^[0-9]*$/.test(strVal) && strVal.length === length;
  };
  var params$6 = [
      {
          name: 'length',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var digits = {
      validate: validate$6,
      params: params$6
  };

  var validateImage = function (file, width, height) {
      var URL = window.URL || window.webkitURL;
      return new Promise(function (resolve) {
          var image = new Image();
          image.onerror = function () { return resolve(false); };
          image.onload = function () { return resolve(image.width === width && image.height === height); };
          image.src = URL.createObjectURL(file);
      });
  };
  var validate$7 = function (files, _a) {
      var width = _a.width, height = _a.height;
      var list = [];
      files = Array.isArray(files) ? files : [files];
      for (var i = 0; i < files.length; i++) {
          // if file is not an image, reject.
          if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
              return Promise.resolve(false);
          }
          list.push(files[i]);
      }
      return Promise.all(list.map(function (file) { return validateImage(file, width, height); })).then(function (values) {
          return values.every(function (v) { return v; });
      });
  };
  var params$7 = [
      {
          name: 'width',
          cast: function (value) {
              return Number(value);
          }
      },
      {
          name: 'height',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var dimensions = {
      validate: validate$7,
      params: params$7
  };

  var validate$8 = function (value, _a) {
      var multiple = (_a === void 0 ? {} : _a).multiple;
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (multiple && !Array.isArray(value)) {
          value = String(value)
              .split(',')
              .map(function (emailStr) { return emailStr.trim(); });
      }
      if (Array.isArray(value)) {
          return value.every(function (val) { return re.test(String(val)); });
      }
      return re.test(String(value));
  };
  var params$8 = [
      {
          name: 'multiple',
          default: false
      }
  ];
  var email = {
      validate: validate$8,
      params: params$8
  };

  function isNullOrUndefined(value) {
      return value === null || value === undefined;
  }
  function isEmptyArray(arr) {
      return Array.isArray(arr) && arr.length === 0;
  }
  function isCallable(fn) {
      return typeof fn === 'function';
  }

  function includes(collection, item) {
      return collection.indexOf(item) !== -1;
  }
  /**
   * Converts an array-like object to array, provides a simple polyfill for Array.from
   */
  function toArray(arrayLike) {
      if (isCallable(Array.from)) {
          return Array.from(arrayLike);
      }
      /* istanbul ignore next */
      return _copyArray(arrayLike);
  }
  /* istanbul ignore next */
  function _copyArray(arrayLike) {
      var array = [];
      var length = arrayLike.length;
      for (var i = 0; i < length; i++) {
          array.push(arrayLike[i]);
      }
      return array;
  }

  var validate$9 = function (value, options) {
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$9(val, options); });
      }
      return toArray(options).some(function (item) {
          // eslint-disable-next-line
          return item == value;
      });
  };
  var oneOf = {
      validate: validate$9
  };

  var validate$a = function (value, args) {
      return !validate$9(value, args);
  };
  var excluded = {
      validate: validate$a
  };

  var validate$b = function (files, extensions) {
      var regex = new RegExp(".(" + extensions.join('|') + ")$", 'i');
      if (Array.isArray(files)) {
          return files.every(function (file) { return regex.test(file.name); });
      }
      return regex.test(files.name);
  };
  var ext = {
      validate: validate$b
  };

  var validate$c = function (files) {
      var regex = /\.(jpg|svg|jpeg|png|bmp|gif|webp)$/i;
      if (Array.isArray(files)) {
          return files.every(function (file) { return regex.test(file.name); });
      }
      return regex.test(files.name);
  };
  var image = {
      validate: validate$c
  };

  var validate$d = function (value) {
      if (Array.isArray(value)) {
          return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
      }
      return /^-?[0-9]+$/.test(String(value));
  };
  var integer = {
      validate: validate$d
  };

  var validate$e = function (value, _a) {
      var other = _a.other;
      return value === other;
  };
  var params$9 = [
      {
          name: 'other'
      }
  ];
  var is = {
      validate: validate$e,
      params: params$9
  };

  var validate$f = function (value, _a) {
      var other = _a.other;
      return value !== other;
  };
  var params$a = [
      {
          name: 'other'
      }
  ];
  var is_not = {
      validate: validate$f,
      params: params$a
  };

  var validate$g = function (value, _a) {
      var length = _a.length;
      if (isNullOrUndefined(value)) {
          return false;
      }
      if (typeof value === 'string') {
          value = toArray(value);
      }
      if (typeof value === 'number') {
          value = String(value);
      }
      if (!value.length) {
          value = toArray(value);
      }
      return value.length === length;
  };
  var params$b = [
      {
          name: 'length',
          cast: function (value) { return Number(value); }
      }
  ];
  var length = {
      validate: validate$g,
      params: params$b
  };

  var validate$h = function (value, _a) {
      var length = _a.length;
      if (isNullOrUndefined(value)) {
          return length >= 0;
      }
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$h(val, { length: length }); });
      }
      return String(value).length <= length;
  };
  var params$c = [
      {
          name: 'length',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var max = {
      validate: validate$h,
      params: params$c
  };

  var validate$i = function (value, _a) {
      var max = _a.max;
      if (isNullOrUndefined(value) || value === '') {
          return false;
      }
      if (Array.isArray(value)) {
          return value.length > 0 && value.every(function (val) { return validate$i(val, { max: max }); });
      }
      return Number(value) <= max;
  };
  var params$d = [
      {
          name: 'max',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var max_value = {
      validate: validate$i,
      params: params$d
  };

  var validate$j = function (files, mimes) {
      var regex = new RegExp(mimes.join('|').replace('*', '.+') + "$", 'i');
      if (Array.isArray(files)) {
          return files.every(function (file) { return regex.test(file.type); });
      }
      return regex.test(files.type);
  };
  var mimes = {
      validate: validate$j
  };

  var validate$k = function (value, _a) {
      var length = _a.length;
      if (isNullOrUndefined(value)) {
          return false;
      }
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$k(val, { length: length }); });
      }
      return String(value).length >= length;
  };
  var params$e = [
      {
          name: 'length',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var min = {
      validate: validate$k,
      params: params$e
  };

  var validate$l = function (value, _a) {
      var min = _a.min;
      if (isNullOrUndefined(value) || value === '') {
          return false;
      }
      if (Array.isArray(value)) {
          return value.length > 0 && value.every(function (val) { return validate$l(val, { min: min }); });
      }
      return Number(value) >= min;
  };
  var params$f = [
      {
          name: 'min',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var min_value = {
      validate: validate$l,
      params: params$f
  };

  var ar = /^[٠١٢٣٤٥٦٧٨٩]+$/;
  var en = /^[0-9]+$/;
  var validate$m = function (value) {
      var testValue = function (val) {
          var strValue = String(val);
          return en.test(strValue) || ar.test(strValue);
      };
      if (Array.isArray(value)) {
          return value.every(testValue);
      }
      return testValue(value);
  };
  var numeric = {
      validate: validate$m
  };

  var validate$n = function (value, _a) {
      var regex = _a.regex;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$n(val, { regex: regex }); });
      }
      return regex.test(String(value));
  };
  var params$g = [
      {
          name: 'regex',
          cast: function (value) {
              if (typeof value === 'string') {
                  return new RegExp(value);
              }
              return value;
          }
      }
  ];
  var regex = {
      validate: validate$n,
      params: params$g
  };

  var validate$o = function (value, _a) {
      var allowFalse = (_a === void 0 ? { allowFalse: true } : _a).allowFalse;
      var result = {
          valid: false,
          required: true
      };
      if (isNullOrUndefined(value) || isEmptyArray(value)) {
          return result;
      }
      // incase a field considers `false` as an empty value like checkboxes.
      if (value === false && !allowFalse) {
          return result;
      }
      result.valid = !!String(value).trim().length;
      return result;
  };
  var computesRequired = true;
  var params$h = [
      {
          name: 'allowFalse',
          default: true
      }
  ];
  var required = {
      validate: validate$o,
      params: params$h,
      computesRequired: computesRequired
  };

  var testEmpty = function (value) {
      return isEmptyArray(value) || includes([false, null, undefined], value) || !String(value).trim().length;
  };
  var validate$p = function (value, _a) {
      var target = _a.target, values = _a.values;
      var required;
      if (values && values.length) {
          if (!Array.isArray(values) && typeof values === 'string') {
              values = [values];
          }
          // eslint-disable-next-line
          required = values.some(function (val) { return val == String(target).trim(); });
      }
      else {
          required = !testEmpty(target);
      }
      if (!required) {
          return {
              valid: true,
              required: required
          };
      }
      return {
          valid: !testEmpty(value),
          required: required
      };
  };
  var params$i = [
      {
          name: 'target',
          isTarget: true
      },
      {
          name: 'values'
      }
  ];
  var computesRequired$1 = true;
  var required_if = {
      validate: validate$p,
      params: params$i,
      computesRequired: computesRequired$1
  };

  var validate$q = function (files, _a) {
      var size = _a.size;
      if (isNaN(size)) {
          return false;
      }
      var nSize = size * 1024;
      if (!Array.isArray(files)) {
          return files.size <= nSize;
      }
      for (var i = 0; i < files.length; i++) {
          if (files[i].size > nSize) {
              return false;
          }
      }
      return true;
  };
  var params$j = [
      {
          name: 'size',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var size = {
      validate: validate$q,
      params: params$j
  };

  exports.alpha = alpha$1;
  exports.alpha_dash = alpha_dash;
  exports.alpha_num = alpha_num;
  exports.alpha_spaces = alpha_spaces;
  exports.between = between;
  exports.confirmed = confirmed;
  exports.digits = digits;
  exports.dimensions = dimensions;
  exports.email = email;
  exports.excluded = excluded;
  exports.ext = ext;
  exports.image = image;
  exports.integer = integer;
  exports.is = is;
  exports.is_not = is_not;
  exports.length = length;
  exports.max = max;
  exports.max_value = max_value;
  exports.mimes = mimes;
  exports.min = min;
  exports.min_value = min_value;
  exports.numeric = numeric;
  exports.oneOf = oneOf;
  exports.regex = regex;
  exports.required = required;
  exports.required_if = required_if;
  exports.size = size;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

},{}],399:[function(require,module,exports){
/**
  * vee-validate v3.4.0
  * (c) 2020 Abdelrahman Awad
  * @license MIT
  */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('vue')) :
  typeof define === 'function' && define.amd ? define(['exports', 'vue'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.VeeValidate = {}, global.Vue));
}(this, (function (exports, Vue) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

  var code = "en";
  var messages = {
  	alpha: "The {_field_} field may only contain alphabetic characters",
  	alpha_num: "The {_field_} field may only contain alpha-numeric characters",
  	alpha_dash: "The {_field_} field may contain alpha-numeric characters as well as dashes and underscores",
  	alpha_spaces: "The {_field_} field may only contain alphabetic characters as well as spaces",
  	between: "The {_field_} field must be between {min} and {max}",
  	confirmed: "The {_field_} field confirmation does not match",
  	digits: "The {_field_} field must be numeric and exactly contain {length} digits",
  	dimensions: "The {_field_} field must be {width} pixels by {height} pixels",
  	email: "The {_field_} field must be a valid email",
  	excluded: "The {_field_} field is not a valid value",
  	ext: "The {_field_} field is not a valid file",
  	image: "The {_field_} field must be an image",
  	integer: "The {_field_} field must be an integer",
  	length: "The {_field_} field must be {length} long",
  	max_value: "The {_field_} field must be {max} or less",
  	max: "The {_field_} field may not be greater than {length} characters",
  	mimes: "The {_field_} field must have a valid file type",
  	min_value: "The {_field_} field must be {min} or more",
  	min: "The {_field_} field must be at least {length} characters",
  	numeric: "The {_field_} field may only contain numeric characters",
  	oneOf: "The {_field_} field is not a valid value",
  	regex: "The {_field_} field format is invalid",
  	required_if: "The {_field_} field is required",
  	required: "The {_field_} field is required",
  	size: "The {_field_} field size must be less than {size}KB"
  };
  var en = {
  	code: code,
  	messages: messages
  };

  /**
   * Some Alpha Regex helpers.
   * https://github.com/chriso/validator.js/blob/master/src/lib/alpha.js
   */
  /* eslint-disable no-misleading-character-class */
  var alpha = {
      en: /^[A-Z]*$/i,
      cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
      da: /^[A-ZÆØÅ]*$/i,
      de: /^[A-ZÄÖÜß]*$/i,
      es: /^[A-ZÁÉÍÑÓÚÜ]*$/i,
      fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
      fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
      it: /^[A-Z\xC0-\xFF]*$/i,
      lt: /^[A-ZĄČĘĖĮŠŲŪŽ]*$/i,
      nl: /^[A-ZÉËÏÓÖÜ]*$/i,
      hu: /^[A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
      pl: /^[A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
      pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
      ro: /^[A-ZĂÂÎŞŢ]*$/i,
      ru: /^[А-ЯЁ]*$/i,
      sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
      sr: /^[A-ZČĆŽŠĐ]*$/i,
      sv: /^[A-ZÅÄÖ]*$/i,
      tr: /^[A-ZÇĞİıÖŞÜ]*$/i,
      uk: /^[А-ЩЬЮЯЄІЇҐ]*$/i,
      ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
      az: /^[A-ZÇƏĞİıÖŞÜ]*$/i,
      el: /^[Α-ώ]*$/i
  };
  var alphaSpaces = {
      en: /^[A-Z\s]*$/i,
      cs: /^[A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ\s]*$/i,
      da: /^[A-ZÆØÅ\s]*$/i,
      de: /^[A-ZÄÖÜß\s]*$/i,
      es: /^[A-ZÁÉÍÑÓÚÜ\s]*$/i,
      fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
      fr: /^[A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ\s]*$/i,
      it: /^[A-Z\xC0-\xFF\s]*$/i,
      lt: /^[A-ZĄČĘĖĮŠŲŪŽ\s]*$/i,
      nl: /^[A-ZÉËÏÓÖÜ\s]*$/i,
      hu: /^[A-ZÁÉÍÓÖŐÚÜŰ\s]*$/i,
      pl: /^[A-ZĄĆĘŚŁŃÓŻŹ\s]*$/i,
      pt: /^[A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ\s]*$/i,
      ro: /^[A-ZĂÂÎŞŢ\s]*$/i,
      ru: /^[А-ЯЁ\s]*$/i,
      sk: /^[A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ\s]*$/i,
      sr: /^[A-ZČĆŽŠĐ\s]*$/i,
      sv: /^[A-ZÅÄÖ\s]*$/i,
      tr: /^[A-ZÇĞİıÖŞÜ\s]*$/i,
      uk: /^[А-ЩЬЮЯЄІЇҐ\s]*$/i,
      ar: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ\s]*$/,
      az: /^[A-ZÇƏĞİıÖŞÜ\s]*$/i,
      el: /^[Α-ώ\s]*$/i
  };
  var alphanumeric = {
      en: /^[0-9A-Z]*$/i,
      cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ]*$/i,
      da: /^[0-9A-ZÆØÅ]$/i,
      de: /^[0-9A-ZÄÖÜß]*$/i,
      es: /^[0-9A-ZÁÉÍÑÓÚÜ]*$/i,
      fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
      fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ]*$/i,
      it: /^[0-9A-Z\xC0-\xFF]*$/i,
      lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ]*$/i,
      hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ]*$/i,
      nl: /^[0-9A-ZÉËÏÓÖÜ]*$/i,
      pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ]*$/i,
      pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ]*$/i,
      ro: /^[0-9A-ZĂÂÎŞŢ]*$/i,
      ru: /^[0-9А-ЯЁ]*$/i,
      sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ]*$/i,
      sr: /^[0-9A-ZČĆŽŠĐ]*$/i,
      sv: /^[0-9A-ZÅÄÖ]*$/i,
      tr: /^[0-9A-ZÇĞİıÖŞÜ]*$/i,
      uk: /^[0-9А-ЩЬЮЯЄІЇҐ]*$/i,
      ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ]*$/,
      az: /^[0-9A-ZÇƏĞİıÖŞÜ]*$/i,
      el: /^[0-9Α-ώ]*$/i
  };
  var alphaDash = {
      en: /^[0-9A-Z_-]*$/i,
      cs: /^[0-9A-ZÁČĎÉĚÍŇÓŘŠŤÚŮÝŽ_-]*$/i,
      da: /^[0-9A-ZÆØÅ_-]*$/i,
      de: /^[0-9A-ZÄÖÜß_-]*$/i,
      es: /^[0-9A-ZÁÉÍÑÓÚÜ_-]*$/i,
      fa: /^[ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰپژگچکی]*$/,
      fr: /^[0-9A-ZÀÂÆÇÉÈÊËÏÎÔŒÙÛÜŸ_-]*$/i,
      it: /^[0-9A-Z\xC0-\xFF_-]*$/i,
      lt: /^[0-9A-ZĄČĘĖĮŠŲŪŽ_-]*$/i,
      nl: /^[0-9A-ZÉËÏÓÖÜ_-]*$/i,
      hu: /^[0-9A-ZÁÉÍÓÖŐÚÜŰ_-]*$/i,
      pl: /^[0-9A-ZĄĆĘŚŁŃÓŻŹ_-]*$/i,
      pt: /^[0-9A-ZÃÁÀÂÇÉÊÍÕÓÔÚÜ_-]*$/i,
      ro: /^[0-9A-ZĂÂÎŞŢ_-]*$/i,
      ru: /^[0-9А-ЯЁ_-]*$/i,
      sk: /^[0-9A-ZÁÄČĎÉÍĹĽŇÓŔŠŤÚÝŽ_-]*$/i,
      sr: /^[0-9A-ZČĆŽŠĐ_-]*$/i,
      sv: /^[0-9A-ZÅÄÖ_-]*$/i,
      tr: /^[0-9A-ZÇĞİıÖŞÜ_-]*$/i,
      uk: /^[0-9А-ЩЬЮЯЄІЇҐ_-]*$/i,
      ar: /^[٠١٢٣٤٥٦٧٨٩0-9ءآأؤإئابةتثجحخدذرزسشصضطظعغفقكلمنهوىيًٌٍَُِّْٰ_-]*$/,
      az: /^[0-9A-ZÇƏĞİıÖŞÜ_-]*$/i,
      el: /^[0-9Α-ώ_-]*$/i
  };

  var validate = function (value, _a) {
      var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate(val, { locale: locale }); });
      }
      // Match at least one locale.
      if (!locale) {
          return Object.keys(alpha).some(function (loc) { return alpha[loc].test(value); });
      }
      return (alpha[locale] || alpha.en).test(value);
  };
  var params = [
      {
          name: 'locale'
      }
  ];
  var alpha$1 = {
      validate: validate,
      params: params
  };

  var validate$1 = function (value, _a) {
      var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$1(val, { locale: locale }); });
      }
      // Match at least one locale.
      if (!locale) {
          return Object.keys(alphaDash).some(function (loc) { return alphaDash[loc].test(value); });
      }
      return (alphaDash[locale] || alphaDash.en).test(value);
  };
  var params$1 = [
      {
          name: 'locale'
      }
  ];
  var alpha_dash = {
      validate: validate$1,
      params: params$1
  };

  var validate$2 = function (value, _a) {
      var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$2(val, { locale: locale }); });
      }
      // Match at least one locale.
      if (!locale) {
          return Object.keys(alphanumeric).some(function (loc) { return alphanumeric[loc].test(value); });
      }
      return (alphanumeric[locale] || alphanumeric.en).test(value);
  };
  var params$2 = [
      {
          name: 'locale'
      }
  ];
  var alpha_num = {
      validate: validate$2,
      params: params$2
  };

  var validate$3 = function (value, _a) {
      var _b = (_a === void 0 ? {} : _a).locale, locale = _b === void 0 ? '' : _b;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$3(val, { locale: locale }); });
      }
      // Match at least one locale.
      if (!locale) {
          return Object.keys(alphaSpaces).some(function (loc) { return alphaSpaces[loc].test(value); });
      }
      return (alphaSpaces[locale] || alphaSpaces.en).test(value);
  };
  var params$3 = [
      {
          name: 'locale'
      }
  ];
  var alpha_spaces = {
      validate: validate$3,
      params: params$3
  };

  var validate$4 = function (value, _a) {
      var _b = _a === void 0 ? {} : _a, min = _b.min, max = _b.max;
      if (Array.isArray(value)) {
          return value.every(function (val) { return !!validate$4(val, { min: min, max: max }); });
      }
      return Number(min) <= value && Number(max) >= value;
  };
  var params$4 = [
      {
          name: 'min'
      },
      {
          name: 'max'
      }
  ];
  var between = {
      validate: validate$4,
      params: params$4
  };

  var validate$5 = function (value, _a) {
      var target = _a.target;
      return String(value) === String(target);
  };
  var params$5 = [
      {
          name: 'target',
          isTarget: true
      }
  ];
  var confirmed = {
      validate: validate$5,
      params: params$5
  };

  var validate$6 = function (value, _a) {
      var length = _a.length;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$6(val, { length: length }); });
      }
      var strVal = String(value);
      return /^[0-9]*$/.test(strVal) && strVal.length === length;
  };
  var params$6 = [
      {
          name: 'length',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var digits = {
      validate: validate$6,
      params: params$6
  };

  var validateImage = function (file, width, height) {
      var URL = window.URL || window.webkitURL;
      return new Promise(function (resolve) {
          var image = new Image();
          image.onerror = function () { return resolve(false); };
          image.onload = function () { return resolve(image.width === width && image.height === height); };
          image.src = URL.createObjectURL(file);
      });
  };
  var validate$7 = function (files, _a) {
      var width = _a.width, height = _a.height;
      var list = [];
      files = Array.isArray(files) ? files : [files];
      for (var i = 0; i < files.length; i++) {
          // if file is not an image, reject.
          if (!/\.(jpg|svg|jpeg|png|bmp|gif)$/i.test(files[i].name)) {
              return Promise.resolve(false);
          }
          list.push(files[i]);
      }
      return Promise.all(list.map(function (file) { return validateImage(file, width, height); })).then(function (values) {
          return values.every(function (v) { return v; });
      });
  };
  var params$7 = [
      {
          name: 'width',
          cast: function (value) {
              return Number(value);
          }
      },
      {
          name: 'height',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var dimensions = {
      validate: validate$7,
      params: params$7
  };

  var validate$8 = function (value, _a) {
      var multiple = (_a === void 0 ? {} : _a).multiple;
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (multiple && !Array.isArray(value)) {
          value = String(value)
              .split(',')
              .map(function (emailStr) { return emailStr.trim(); });
      }
      if (Array.isArray(value)) {
          return value.every(function (val) { return re.test(String(val)); });
      }
      return re.test(String(value));
  };
  var params$8 = [
      {
          name: 'multiple',
          default: false
      }
  ];
  var email = {
      validate: validate$8,
      params: params$8
  };

  function isNaN$1(value) {
      // NaN is the one value that does not equal itself.
      // eslint-disable-next-line
      return value !== value;
  }
  function isNullOrUndefined(value) {
      return value === null || value === undefined;
  }
  function isEmptyArray(arr) {
      return Array.isArray(arr) && arr.length === 0;
  }
  var isObject = function (obj) {
      return obj !== null && obj && typeof obj === 'object' && !Array.isArray(obj);
  };
  /**
   * A reference comparison function with NaN support
   */
  function isRefEqual(lhs, rhs) {
      if (isNaN$1(lhs) && isNaN$1(rhs)) {
          return true;
      }
      return lhs === rhs;
  }
  /**
   * Shallow object comparison.
   */
  function isEqual(lhs, rhs) {
      if (lhs instanceof RegExp && rhs instanceof RegExp) {
          return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
      }
      if (Array.isArray(lhs) && Array.isArray(rhs)) {
          if (lhs.length !== rhs.length)
              return false;
          for (var i = 0; i < lhs.length; i++) {
              if (!isEqual(lhs[i], rhs[i])) {
                  return false;
              }
          }
          return true;
      }
      // if both are objects, compare each key recursively.
      if (isObject(lhs) && isObject(rhs)) {
          return (Object.keys(lhs).every(function (key) {
              return isEqual(lhs[key], rhs[key]);
          }) &&
              Object.keys(rhs).every(function (key) {
                  return isEqual(lhs[key], rhs[key]);
              }));
      }
      return isRefEqual(lhs, rhs);
  }
  // Checks if a given value is not an empty string or null or undefined.
  function isSpecified(val) {
      if (val === '') {
          return false;
      }
      return !isNullOrUndefined(val);
  }
  function isCallable(fn) {
      return typeof fn === 'function';
  }
  function isLocator(value) {
      return isCallable(value) && !!value.__locatorRef;
  }

  function findIndex(arrayLike, predicate) {
      var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
      if (isCallable(array.findIndex)) {
          return array.findIndex(predicate);
      }
      /* istanbul ignore next */
      for (var i = 0; i < array.length; i++) {
          if (predicate(array[i], i)) {
              return i;
          }
      }
      /* istanbul ignore next */
      return -1;
  }
  /**
   * finds the first element that satisfies the predicate callback, polyfills array.find
   */
  function find(arrayLike, predicate) {
      var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
      var idx = findIndex(array, predicate);
      return idx === -1 ? undefined : array[idx];
  }
  function includes(collection, item) {
      return collection.indexOf(item) !== -1;
  }
  /**
   * Converts an array-like object to array, provides a simple polyfill for Array.from
   */
  function toArray(arrayLike) {
      if (isCallable(Array.from)) {
          return Array.from(arrayLike);
      }
      /* istanbul ignore next */
      return _copyArray(arrayLike);
  }
  /* istanbul ignore next */
  function _copyArray(arrayLike) {
      var array = [];
      var length = arrayLike.length;
      for (var i = 0; i < length; i++) {
          array.push(arrayLike[i]);
      }
      return array;
  }
  function values(obj) {
      if (isCallable(Object.values)) {
          return Object.values(obj);
      }
      // fallback to keys()
      /* istanbul ignore next */
      return Object.keys(obj).map(function (k) { return obj[k]; });
  }
  function merge(target, source) {
      Object.keys(source).forEach(function (key) {
          if (isObject(source[key])) {
              if (!target[key]) {
                  target[key] = {};
              }
              merge(target[key], source[key]);
              return;
          }
          target[key] = source[key];
      });
      return target;
  }

  function createFlags() {
      return {
          untouched: true,
          touched: false,
          dirty: false,
          pristine: true,
          valid: false,
          invalid: false,
          validated: false,
          pending: false,
          required: false,
          changed: false,
          passed: false,
          failed: false
      };
  }

  function identity(x) {
      return x;
  }
  function debounce(fn, wait, token) {
      if (wait === void 0) { wait = 0; }
      if (token === void 0) { token = { cancelled: false }; }
      if (wait === 0) {
          return fn;
      }
      var timeout;
      return function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
          }
          var later = function () {
              timeout = undefined;
              // check if the fn call was cancelled.
              if (!token.cancelled)
                  fn.apply(void 0, args);
          };
          // because we might want to use Node.js setTimout for SSR.
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
      };
  }

  /**
   * Emits a warning to the console
   */
  function warn(message) {
      console.warn("[vee-validate] " + message);
  }
  /**
   * Replaces placeholder values in a string with their actual values
   */
  function interpolate(template, values) {
      return template.replace(/{([^}]+)}/g, function (_, p) {
          return p in values ? values[p] : "{" + p + "}";
      });
  }

  var validate$9 = function (value, options) {
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$9(val, options); });
      }
      return toArray(options).some(function (item) {
          // eslint-disable-next-line
          return item == value;
      });
  };
  var oneOf = {
      validate: validate$9
  };

  var validate$a = function (value, args) {
      return !validate$9(value, args);
  };
  var excluded = {
      validate: validate$a
  };

  var validate$b = function (files, extensions) {
      var regex = new RegExp(".(" + extensions.join('|') + ")$", 'i');
      if (Array.isArray(files)) {
          return files.every(function (file) { return regex.test(file.name); });
      }
      return regex.test(files.name);
  };
  var ext = {
      validate: validate$b
  };

  var validate$c = function (files) {
      var regex = /\.(jpg|svg|jpeg|png|bmp|gif|webp)$/i;
      if (Array.isArray(files)) {
          return files.every(function (file) { return regex.test(file.name); });
      }
      return regex.test(files.name);
  };
  var image = {
      validate: validate$c
  };

  var validate$d = function (value) {
      if (Array.isArray(value)) {
          return value.every(function (val) { return /^-?[0-9]+$/.test(String(val)); });
      }
      return /^-?[0-9]+$/.test(String(value));
  };
  var integer = {
      validate: validate$d
  };

  var validate$e = function (value, _a) {
      var other = _a.other;
      return value === other;
  };
  var params$9 = [
      {
          name: 'other'
      }
  ];
  var is = {
      validate: validate$e,
      params: params$9
  };

  var validate$f = function (value, _a) {
      var other = _a.other;
      return value !== other;
  };
  var params$a = [
      {
          name: 'other'
      }
  ];
  var is_not = {
      validate: validate$f,
      params: params$a
  };

  var validate$g = function (value, _a) {
      var length = _a.length;
      if (isNullOrUndefined(value)) {
          return false;
      }
      if (typeof value === 'string') {
          value = toArray(value);
      }
      if (typeof value === 'number') {
          value = String(value);
      }
      if (!value.length) {
          value = toArray(value);
      }
      return value.length === length;
  };
  var params$b = [
      {
          name: 'length',
          cast: function (value) { return Number(value); }
      }
  ];
  var length = {
      validate: validate$g,
      params: params$b
  };

  var validate$h = function (value, _a) {
      var length = _a.length;
      if (isNullOrUndefined(value)) {
          return length >= 0;
      }
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$h(val, { length: length }); });
      }
      return String(value).length <= length;
  };
  var params$c = [
      {
          name: 'length',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var max = {
      validate: validate$h,
      params: params$c
  };

  var validate$i = function (value, _a) {
      var max = _a.max;
      if (isNullOrUndefined(value) || value === '') {
          return false;
      }
      if (Array.isArray(value)) {
          return value.length > 0 && value.every(function (val) { return validate$i(val, { max: max }); });
      }
      return Number(value) <= max;
  };
  var params$d = [
      {
          name: 'max',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var max_value = {
      validate: validate$i,
      params: params$d
  };

  var validate$j = function (files, mimes) {
      var regex = new RegExp(mimes.join('|').replace('*', '.+') + "$", 'i');
      if (Array.isArray(files)) {
          return files.every(function (file) { return regex.test(file.type); });
      }
      return regex.test(files.type);
  };
  var mimes = {
      validate: validate$j
  };

  var validate$k = function (value, _a) {
      var length = _a.length;
      if (isNullOrUndefined(value)) {
          return false;
      }
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$k(val, { length: length }); });
      }
      return String(value).length >= length;
  };
  var params$e = [
      {
          name: 'length',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var min = {
      validate: validate$k,
      params: params$e
  };

  var validate$l = function (value, _a) {
      var min = _a.min;
      if (isNullOrUndefined(value) || value === '') {
          return false;
      }
      if (Array.isArray(value)) {
          return value.length > 0 && value.every(function (val) { return validate$l(val, { min: min }); });
      }
      return Number(value) >= min;
  };
  var params$f = [
      {
          name: 'min',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var min_value = {
      validate: validate$l,
      params: params$f
  };

  var ar = /^[٠١٢٣٤٥٦٧٨٩]+$/;
  var en$1 = /^[0-9]+$/;
  var validate$m = function (value) {
      var testValue = function (val) {
          var strValue = String(val);
          return en$1.test(strValue) || ar.test(strValue);
      };
      if (Array.isArray(value)) {
          return value.every(testValue);
      }
      return testValue(value);
  };
  var numeric = {
      validate: validate$m
  };

  var validate$n = function (value, _a) {
      var regex = _a.regex;
      if (Array.isArray(value)) {
          return value.every(function (val) { return validate$n(val, { regex: regex }); });
      }
      return regex.test(String(value));
  };
  var params$g = [
      {
          name: 'regex',
          cast: function (value) {
              if (typeof value === 'string') {
                  return new RegExp(value);
              }
              return value;
          }
      }
  ];
  var regex = {
      validate: validate$n,
      params: params$g
  };

  var validate$o = function (value, _a) {
      var allowFalse = (_a === void 0 ? { allowFalse: true } : _a).allowFalse;
      var result = {
          valid: false,
          required: true
      };
      if (isNullOrUndefined(value) || isEmptyArray(value)) {
          return result;
      }
      // incase a field considers `false` as an empty value like checkboxes.
      if (value === false && !allowFalse) {
          return result;
      }
      result.valid = !!String(value).trim().length;
      return result;
  };
  var computesRequired = true;
  var params$h = [
      {
          name: 'allowFalse',
          default: true
      }
  ];
  var required = {
      validate: validate$o,
      params: params$h,
      computesRequired: computesRequired
  };

  var testEmpty = function (value) {
      return isEmptyArray(value) || includes([false, null, undefined], value) || !String(value).trim().length;
  };
  var validate$p = function (value, _a) {
      var target = _a.target, values = _a.values;
      var required;
      if (values && values.length) {
          if (!Array.isArray(values) && typeof values === 'string') {
              values = [values];
          }
          // eslint-disable-next-line
          required = values.some(function (val) { return val == String(target).trim(); });
      }
      else {
          required = !testEmpty(target);
      }
      if (!required) {
          return {
              valid: true,
              required: required
          };
      }
      return {
          valid: !testEmpty(value),
          required: required
      };
  };
  var params$i = [
      {
          name: 'target',
          isTarget: true
      },
      {
          name: 'values'
      }
  ];
  var computesRequired$1 = true;
  var required_if = {
      validate: validate$p,
      params: params$i,
      computesRequired: computesRequired$1
  };

  var validate$q = function (files, _a) {
      var size = _a.size;
      if (isNaN(size)) {
          return false;
      }
      var nSize = size * 1024;
      if (!Array.isArray(files)) {
          return files.size <= nSize;
      }
      for (var i = 0; i < files.length; i++) {
          if (files[i].size > nSize) {
              return false;
          }
      }
      return true;
  };
  var params$j = [
      {
          name: 'size',
          cast: function (value) {
              return Number(value);
          }
      }
  ];
  var size = {
      validate: validate$q,
      params: params$j
  };

  var Rules = /*#__PURE__*/Object.freeze({
    __proto__: null,
    alpha_dash: alpha_dash,
    alpha_num: alpha_num,
    alpha_spaces: alpha_spaces,
    alpha: alpha$1,
    between: between,
    confirmed: confirmed,
    digits: digits,
    dimensions: dimensions,
    email: email,
    ext: ext,
    image: image,
    oneOf: oneOf,
    integer: integer,
    length: length,
    is_not: is_not,
    is: is,
    max: max,
    max_value: max_value,
    mimes: mimes,
    min: min,
    min_value: min_value,
    excluded: excluded,
    numeric: numeric,
    regex: regex,
    required: required,
    required_if: required_if,
    size: size
  });

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
      return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
  }

  function __generator(thisArg, body) {
      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
      function verb(n) { return function (v) { return step([n, v]); }; }
      function step(op) {
          if (f) throw new TypeError("Generator is already executing.");
          while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                  case 0: case 1: t = op; break;
                  case 4: _.label++; return { value: op[1], done: false };
                  case 5: _.label++; y = op[1]; op = [0]; continue;
                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
                  default:
                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                      if (t[2]) _.ops.pop();
                      _.trys.pop(); continue;
              }
              op = body.call(thisArg, _);
          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
      }
  }

  function __spreadArrays() {
      for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
      for (var r = Array(s), k = 0, i = 0; i < il; i++)
          for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
              r[k] = a[j];
      return r;
  }

  var DEFAULT_CONFIG = {
      defaultMessage: "{_field_} is not valid.",
      skipOptional: true,
      classes: {
          touched: 'touched',
          untouched: 'untouched',
          valid: 'valid',
          invalid: 'invalid',
          pristine: 'pristine',
          dirty: 'dirty' // control has been interacted with
      },
      bails: true,
      mode: 'aggressive',
      useConstraintAttrs: true
  };
  var currentConfig = __assign({}, DEFAULT_CONFIG);
  var getConfig = function () { return currentConfig; };
  var setConfig = function (newConf) {
      currentConfig = __assign(__assign({}, currentConfig), newConf);
  };
  var configure = function (cfg) {
      setConfig(cfg);
  };

  var EVENT_BUS = new Vue__default['default']();
  function localeChanged() {
      EVENT_BUS.$emit('change:locale');
  }

  var Dictionary = /** @class */ (function () {
      function Dictionary(locale, dictionary) {
          this.container = {};
          this.locale = locale;
          this.merge(dictionary);
      }
      Dictionary.prototype.resolve = function (field, rule, values) {
          return this.format(this.locale, field, rule, values);
      };
      Dictionary.prototype.format = function (locale, field, rule, values) {
          var _a, _b, _c, _d, _e, _f, _g, _h;
          var message;
          // find if specific message for that field was specified.
          message = ((_c = (_b = (_a = this.container[locale]) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b[field]) === null || _c === void 0 ? void 0 : _c[rule]) || ((_e = (_d = this.container[locale]) === null || _d === void 0 ? void 0 : _d.messages) === null || _e === void 0 ? void 0 : _e[rule]);
          if (!message) {
              message = '{_field_} is not valid';
          }
          field = (_h = (_g = (_f = this.container[locale]) === null || _f === void 0 ? void 0 : _f.names) === null || _g === void 0 ? void 0 : _g[field]) !== null && _h !== void 0 ? _h : field;
          return isCallable(message) ? message(field, values) : interpolate(message, __assign(__assign({}, values), { _field_: field }));
      };
      Dictionary.prototype.merge = function (dictionary) {
          merge(this.container, dictionary);
      };
      Dictionary.prototype.hasRule = function (name) {
          var _a, _b;
          return !!((_b = (_a = this.container[this.locale]) === null || _a === void 0 ? void 0 : _a.messages) === null || _b === void 0 ? void 0 : _b[name]);
      };
      return Dictionary;
  }());
  var DICTIONARY;
  function localize(locale, dictionary) {
      var _a;
      if (!DICTIONARY) {
          DICTIONARY = new Dictionary('en', {});
          setConfig({
              defaultMessage: function (field, values) {
                  return DICTIONARY.resolve(field, values === null || values === void 0 ? void 0 : values._rule_, values || {});
              }
          });
      }
      if (typeof locale === 'string') {
          DICTIONARY.locale = locale;
          if (dictionary) {
              DICTIONARY.merge((_a = {}, _a[locale] = dictionary, _a));
          }
          localeChanged();
          return;
      }
      DICTIONARY.merge(locale);
  }

  var RULES = {};
  function normalizeSchema(schema) {
      var _a;
      if ((_a = schema.params) === null || _a === void 0 ? void 0 : _a.length) {
          schema.params = schema.params.map(function (param) {
              if (typeof param === 'string') {
                  return { name: param };
              }
              return param;
          });
      }
      return schema;
  }
  var RuleContainer = /** @class */ (function () {
      function RuleContainer() {
      }
      RuleContainer.extend = function (name, schema) {
          // if rule already exists, overwrite it.
          var rule = normalizeSchema(schema);
          if (RULES[name]) {
              RULES[name] = merge(RULES[name], schema);
              return;
          }
          RULES[name] = __assign({ lazy: false, computesRequired: false }, rule);
      };
      RuleContainer.isLazy = function (name) {
          var _a;
          return !!((_a = RULES[name]) === null || _a === void 0 ? void 0 : _a.lazy);
      };
      RuleContainer.isRequireRule = function (name) {
          var _a;
          return !!((_a = RULES[name]) === null || _a === void 0 ? void 0 : _a.computesRequired);
      };
      RuleContainer.getRuleDefinition = function (ruleName) {
          return RULES[ruleName];
      };
      return RuleContainer;
  }());
  /**
   * Adds a custom validator to the list of validation rules.
   */
  function extend(name, schema) {
      // makes sure new rules are properly formatted.
      guardExtend(name, schema);
      // Full schema object.
      if (typeof schema === 'object') {
          RuleContainer.extend(name, schema);
          return;
      }
      RuleContainer.extend(name, {
          validate: schema
      });
  }
  /**
   * Guards from extension violations.
   */
  function guardExtend(name, validator) {
      if (isCallable(validator)) {
          return;
      }
      if (isCallable(validator.validate)) {
          return;
      }
      if (RuleContainer.getRuleDefinition(name)) {
          return;
      }
      throw new Error("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.");
  }

  var aggressive = function () { return ({
      on: ['input', 'blur']
  }); };
  var lazy = function () { return ({
      on: ['change', 'blur']
  }); };
  var eager = function (_a) {
      var errors = _a.errors;
      if (errors.length) {
          return {
              on: ['input', 'change']
          };
      }
      return {
          on: ['change', 'blur']
      };
  };
  var passive = function () { return ({
      on: []
  }); };
  var modes = {
      aggressive: aggressive,
      eager: eager,
      passive: passive,
      lazy: lazy
  };
  var setInteractionMode = function (mode, implementation) {
      setConfig({ mode: mode });
      if (!implementation) {
          return;
      }
      if (!isCallable(implementation)) {
          throw new Error('A mode implementation must be a function');
      }
      modes[mode] = implementation;
  };

  /**
   * Normalizes the given rules expression.
   */
  function normalizeRules(rules) {
      // if falsy value return an empty object.
      var acc = {};
      Object.defineProperty(acc, '_$$isNormalized', {
          value: true,
          writable: false,
          enumerable: false,
          configurable: false
      });
      if (!rules) {
          return acc;
      }
      // Object is already normalized, skip.
      if (isObject(rules) && rules._$$isNormalized) {
          return rules;
      }
      if (isObject(rules)) {
          return Object.keys(rules).reduce(function (prev, curr) {
              var params = [];
              if (rules[curr] === true) {
                  params = [];
              }
              else if (Array.isArray(rules[curr])) {
                  params = rules[curr];
              }
              else if (isObject(rules[curr])) {
                  params = rules[curr];
              }
              else {
                  params = [rules[curr]];
              }
              if (rules[curr] !== false) {
                  prev[curr] = buildParams(curr, params);
              }
              return prev;
          }, acc);
      }
      /* istanbul ignore if */
      if (typeof rules !== 'string') {
          warn('rules must be either a string or an object.');
          return acc;
      }
      return rules.split('|').reduce(function (prev, rule) {
          var parsedRule = parseRule(rule);
          if (!parsedRule.name) {
              return prev;
          }
          prev[parsedRule.name] = buildParams(parsedRule.name, parsedRule.params);
          return prev;
      }, acc);
  }
  function buildParams(ruleName, provided) {
      var ruleSchema = RuleContainer.getRuleDefinition(ruleName);
      if (!ruleSchema) {
          return provided;
      }
      var params = {};
      if (!ruleSchema.params && !Array.isArray(provided)) {
          throw new Error('You provided an object params to a rule that has no defined schema.');
      }
      // Rule probably uses an array for their args, keep it as is.
      if (Array.isArray(provided) && !ruleSchema.params) {
          return provided;
      }
      var definedParams;
      // collect the params schema.
      if (!ruleSchema.params || (ruleSchema.params.length < provided.length && Array.isArray(provided))) {
          var lastDefinedParam_1;
          // collect any additional parameters in the last item.
          definedParams = provided.map(function (_, idx) {
              var _a;
              var param = (_a = ruleSchema.params) === null || _a === void 0 ? void 0 : _a[idx];
              lastDefinedParam_1 = param || lastDefinedParam_1;
              if (!param) {
                  param = lastDefinedParam_1;
              }
              return param;
          });
      }
      else {
          definedParams = ruleSchema.params;
      }
      // Match the provided array length with a temporary schema.
      for (var i = 0; i < definedParams.length; i++) {
          var options = definedParams[i];
          var value = options.default;
          // if the provided is an array, map element value.
          if (Array.isArray(provided)) {
              if (i in provided) {
                  value = provided[i];
              }
          }
          else {
              // If the param exists in the provided object.
              if (options.name in provided) {
                  value = provided[options.name];
                  // if the provided is the first param value.
              }
              else if (definedParams.length === 1) {
                  value = provided;
              }
          }
          // if the param is a target, resolve the target value.
          if (options.isTarget) {
              value = createLocator(value, options.cast);
          }
          // A target param using interpolation
          if (typeof value === 'string' && value[0] === '@') {
              value = createLocator(value.slice(1), options.cast);
          }
          // If there is a transformer defined.
          if (!isLocator(value) && options.cast) {
              value = options.cast(value);
          }
          // already been set, probably multiple values.
          if (params[options.name]) {
              params[options.name] = Array.isArray(params[options.name]) ? params[options.name] : [params[options.name]];
              params[options.name].push(value);
          }
          else {
              // set the value.
              params[options.name] = value;
          }
      }
      return params;
  }
  /**
   * Parses a rule string expression.
   */
  var parseRule = function (rule) {
      var params = [];
      var name = rule.split(':')[0];
      if (includes(rule, ':')) {
          params = rule
              .split(':')
              .slice(1)
              .join(':')
              .split(',');
      }
      return { name: name, params: params };
  };
  function createLocator(value, castFn) {
      var locator = function (crossTable) {
          var val = crossTable[value];
          return castFn ? castFn(val) : val;
      };
      locator.__locatorRef = value;
      return locator;
  }
  function extractLocators(params) {
      if (Array.isArray(params)) {
          return params.filter(function (param) {
              return isLocator(param) || (typeof param === 'string' && param[0] === '@');
          });
      }
      return Object.keys(params)
          .filter(function (key) { return isLocator(params[key]); })
          .map(function (key) { return params[key]; });
  }

  /**
   * Validates a value against the rules.
   */
  function validate$r(value, rules, options) {
      if (options === void 0) { options = {}; }
      return __awaiter(this, void 0, void 0, function () {
          var shouldBail, skipIfEmpty, field, result, errors, failedRules, regenerateMap;
          return __generator(this, function (_a) {
              switch (_a.label) {
                  case 0:
                      shouldBail = options === null || options === void 0 ? void 0 : options.bails;
                      skipIfEmpty = options === null || options === void 0 ? void 0 : options.skipIfEmpty;
                      field = {
                          name: (options === null || options === void 0 ? void 0 : options.name) || '{field}',
                          rules: normalizeRules(rules),
                          bails: shouldBail !== null && shouldBail !== void 0 ? shouldBail : true,
                          skipIfEmpty: skipIfEmpty !== null && skipIfEmpty !== void 0 ? skipIfEmpty : true,
                          forceRequired: false,
                          crossTable: (options === null || options === void 0 ? void 0 : options.values) || {},
                          names: (options === null || options === void 0 ? void 0 : options.names) || {},
                          customMessages: (options === null || options === void 0 ? void 0 : options.customMessages) || {}
                      };
                      return [4 /*yield*/, _validate(field, value, options)];
                  case 1:
                      result = _a.sent();
                      errors = [];
                      failedRules = {};
                      regenerateMap = {};
                      result.errors.forEach(function (e) {
                          var msg = e.msg();
                          errors.push(msg);
                          failedRules[e.rule] = msg;
                          regenerateMap[e.rule] = e.msg;
                      });
                      return [2 /*return*/, {
                              valid: result.valid,
                              errors: errors,
                              failedRules: failedRules,
                              regenerateMap: regenerateMap
                          }];
              }
          });
      });
  }
  /**
   * Starts the validation process.
   */
  function _validate(field, value, _a) {
      var _b = (_a === void 0 ? {} : _a).isInitial, isInitial = _b === void 0 ? false : _b;
      return __awaiter(this, void 0, void 0, function () {
          var _c, shouldSkip, errors, rules, length, i, rule, result;
          return __generator(this, function (_d) {
              switch (_d.label) {
                  case 0: return [4 /*yield*/, _shouldSkip(field, value)];
                  case 1:
                      _c = _d.sent(), shouldSkip = _c.shouldSkip, errors = _c.errors;
                      if (shouldSkip) {
                          return [2 /*return*/, {
                                  valid: !errors.length,
                                  errors: errors
                              }];
                      }
                      rules = Object.keys(field.rules).filter(function (rule) { return !RuleContainer.isRequireRule(rule); });
                      length = rules.length;
                      i = 0;
                      _d.label = 2;
                  case 2:
                      if (!(i < length)) return [3 /*break*/, 5];
                      if (isInitial && RuleContainer.isLazy(rules[i])) {
                          return [3 /*break*/, 4];
                      }
                      rule = rules[i];
                      return [4 /*yield*/, _test(field, value, {
                              name: rule,
                              params: field.rules[rule]
                          })];
                  case 3:
                      result = _d.sent();
                      if (!result.valid && result.error) {
                          errors.push(result.error);
                          if (field.bails) {
                              return [2 /*return*/, {
                                      valid: false,
                                      errors: errors
                                  }];
                          }
                      }
                      _d.label = 4;
                  case 4:
                      i++;
                      return [3 /*break*/, 2];
                  case 5: return [2 /*return*/, {
                          valid: !errors.length,
                          errors: errors
                      }];
              }
          });
      });
  }
  function _shouldSkip(field, value) {
      return __awaiter(this, void 0, void 0, function () {
          var requireRules, length, errors, isEmpty, isEmptyAndOptional, isRequired, i, rule, result;
          return __generator(this, function (_a) {
              switch (_a.label) {
                  case 0:
                      requireRules = Object.keys(field.rules).filter(RuleContainer.isRequireRule);
                      length = requireRules.length;
                      errors = [];
                      isEmpty = isNullOrUndefined(value) || value === '' || isEmptyArray(value);
                      isEmptyAndOptional = isEmpty && field.skipIfEmpty;
                      isRequired = false;
                      i = 0;
                      _a.label = 1;
                  case 1:
                      if (!(i < length)) return [3 /*break*/, 4];
                      rule = requireRules[i];
                      return [4 /*yield*/, _test(field, value, {
                              name: rule,
                              params: field.rules[rule]
                          })];
                  case 2:
                      result = _a.sent();
                      if (!isObject(result)) {
                          throw new Error('Require rules has to return an object (see docs)');
                      }
                      if (result.required) {
                          isRequired = true;
                      }
                      if (!result.valid && result.error) {
                          errors.push(result.error);
                          // Exit early as the field is required and failed validation.
                          if (field.bails) {
                              return [2 /*return*/, {
                                      shouldSkip: true,
                                      errors: errors
                                  }];
                          }
                      }
                      _a.label = 3;
                  case 3:
                      i++;
                      return [3 /*break*/, 1];
                  case 4:
                      if (isEmpty && !isRequired && !field.skipIfEmpty) {
                          return [2 /*return*/, {
                                  shouldSkip: false,
                                  errors: errors
                              }];
                      }
                      // field is configured to run through the pipeline regardless
                      if (!field.bails && !isEmptyAndOptional) {
                          return [2 /*return*/, {
                                  shouldSkip: false,
                                  errors: errors
                              }];
                      }
                      // skip if the field is not required and has an empty value.
                      return [2 /*return*/, {
                              shouldSkip: !isRequired && isEmpty,
                              errors: errors
                          }];
              }
          });
      });
  }
  /**
   * Tests a single input value against a rule.
   */
  function _test(field, value, rule) {
      return __awaiter(this, void 0, void 0, function () {
          var ruleSchema, normalizedValue, params, result, values_1;
          return __generator(this, function (_a) {
              switch (_a.label) {
                  case 0:
                      ruleSchema = RuleContainer.getRuleDefinition(rule.name);
                      if (!ruleSchema || !ruleSchema.validate) {
                          throw new Error("No such validator '" + rule.name + "' exists.");
                      }
                      normalizedValue = ruleSchema.castValue ? ruleSchema.castValue(value) : value;
                      params = fillTargetValues(rule.params, field.crossTable);
                      return [4 /*yield*/, ruleSchema.validate(normalizedValue, params)];
                  case 1:
                      result = _a.sent();
                      if (typeof result === 'string') {
                          values_1 = __assign(__assign({}, (params || {})), { _field_: field.name, _value_: value, _rule_: rule.name });
                          return [2 /*return*/, {
                                  valid: false,
                                  error: { rule: rule.name, msg: function () { return interpolate(result, values_1); } }
                              }];
                      }
                      if (!isObject(result)) {
                          result = { valid: result };
                      }
                      return [2 /*return*/, {
                              valid: result.valid,
                              required: result.required,
                              error: result.valid ? undefined : _generateFieldError(field, value, ruleSchema, rule.name, params)
                          }];
              }
          });
      });
  }
  /**
   * Generates error messages.
   */
  function _generateFieldError(field, value, ruleSchema, ruleName, params) {
      var _a;
      var message = (_a = field.customMessages[ruleName]) !== null && _a !== void 0 ? _a : ruleSchema.message;
      var ruleTargets = _getRuleTargets(field, ruleSchema, ruleName);
      var _b = _getUserTargets(field, ruleSchema, ruleName, message), userTargets = _b.userTargets, userMessage = _b.userMessage;
      var values = __assign(__assign(__assign(__assign({}, (params || {})), { _field_: field.name, _value_: value, _rule_: ruleName }), ruleTargets), userTargets);
      return {
          msg: function () { return _normalizeMessage(userMessage || getConfig().defaultMessage, field.name, values); },
          rule: ruleName
      };
  }
  function _getRuleTargets(field, ruleSchema, ruleName) {
      var params = ruleSchema.params;
      if (!params) {
          return {};
      }
      var numTargets = params.filter(function (param) { return param.isTarget; }).length;
      if (numTargets <= 0) {
          return {};
      }
      var names = {};
      var ruleConfig = field.rules[ruleName];
      if (!Array.isArray(ruleConfig) && isObject(ruleConfig)) {
          ruleConfig = params.map(function (param) {
              return ruleConfig[param.name];
          });
      }
      for (var index = 0; index < params.length; index++) {
          var param = params[index];
          var key = ruleConfig[index];
          if (!isLocator(key)) {
              continue;
          }
          key = key.__locatorRef;
          var name_1 = field.names[key] || key;
          names[param.name] = name_1;
          names["_" + param.name + "_"] = field.crossTable[key];
      }
      return names;
  }
  function _getUserTargets(field, ruleSchema, ruleName, userMessage) {
      var userTargets = {};
      var rules = field.rules[ruleName];
      var params = ruleSchema.params || [];
      // early return if no rules
      if (!rules) {
          return {};
      }
      // check all rules to convert targets
      Object.keys(rules).forEach(function (key, index) {
          // get the rule
          var rule = rules[key];
          if (!isLocator(rule)) {
              return {};
          }
          // get associated parameter
          var param = params[index];
          if (!param) {
              return {};
          }
          // grab the name of the target
          var name = rule.__locatorRef;
          userTargets[param.name] = field.names[name] || name;
          userTargets["_" + param.name + "_"] = field.crossTable[name];
      });
      return {
          userTargets: userTargets,
          userMessage: userMessage
      };
  }
  function _normalizeMessage(template, field, values) {
      if (typeof template === 'function') {
          return template(field, values);
      }
      return interpolate(template, __assign(__assign({}, values), { _field_: field }));
  }
  function fillTargetValues(params, crossTable) {
      if (Array.isArray(params)) {
          return params.map(function (param) {
              var targetPart = typeof param === 'string' && param[0] === '@' ? param.slice(1) : param;
              if (targetPart in crossTable) {
                  return crossTable[targetPart];
              }
              return param;
          });
      }
      var values = {};
      var normalize = function (value) {
          if (isLocator(value)) {
              return value(crossTable);
          }
          return value;
      };
      Object.keys(params).forEach(function (param) {
          values[param] = normalize(params[param]);
      });
      return values;
  }

  var isEvent = function (evt) {
      if (!evt) {
          return false;
      }
      if (typeof Event !== 'undefined' && isCallable(Event) && evt instanceof Event) {
          return true;
      }
      // this is for IE
      /* istanbul ignore next */
      if (evt && evt.srcElement) {
          return true;
      }
      return false;
  };
  function normalizeEventValue(value) {
      var _a, _b;
      if (!isEvent(value)) {
          return value;
      }
      var input = value.target;
      if (input.type === 'file' && input.files) {
          return toArray(input.files);
      }
      // If the input has a `v-model.number` modifier applied.
      if ((_a = input._vModifiers) === null || _a === void 0 ? void 0 : _a.number) {
          // as per the spec the v-model.number uses parseFloat
          var valueAsNumber = parseFloat(input.value);
          if (isNaN$1(valueAsNumber)) {
              return input.value;
          }
          return valueAsNumber;
      }
      if ((_b = input._vModifiers) === null || _b === void 0 ? void 0 : _b.trim) {
          var trimmedValue = typeof input.value === 'string' ? input.value.trim() : input.value;
          return trimmedValue;
      }
      return input.value;
  }

  var isTextInput = function (vnode) {
      var _a;
      var attrs = ((_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs) || vnode.elm;
      // it will fallback to being a text input per browsers spec.
      if (vnode.tag === 'input' && (!attrs || !attrs.type)) {
          return true;
      }
      if (vnode.tag === 'textarea') {
          return true;
      }
      return includes(['text', 'password', 'search', 'email', 'tel', 'url', 'number'], attrs === null || attrs === void 0 ? void 0 : attrs.type);
  };
  // export const isCheckboxOrRadioInput = (vnode: VNode): boolean => {
  //   const attrs = (vnode.data && vnode.data.attrs) || vnode.elm;
  //   return includes(['radio', 'checkbox'], attrs && attrs.type);
  // };
  // Gets the model object on the vnode.
  function findModel(vnode) {
      if (!vnode.data) {
          return undefined;
      }
      // Component Model
      // THIS IS NOT TYPED IN OFFICIAL VUE TYPINGS
      // eslint-disable-next-line
      var nonStandardVNodeData = vnode.data;
      if ('model' in nonStandardVNodeData) {
          return nonStandardVNodeData.model;
      }
      if (!vnode.data.directives) {
          return undefined;
      }
      return find(vnode.data.directives, function (d) { return d.name === 'model'; });
  }
  function findValue(vnode) {
      var _a, _b;
      var model = findModel(vnode);
      if (model) {
          return { value: model.value };
      }
      var config = findModelConfig(vnode);
      var prop = (config === null || config === void 0 ? void 0 : config.prop) || 'value';
      if (((_a = vnode.componentOptions) === null || _a === void 0 ? void 0 : _a.propsData) && prop in vnode.componentOptions.propsData) {
          var propsDataWithValue = vnode.componentOptions.propsData;
          return { value: propsDataWithValue[prop] };
      }
      if (((_b = vnode.data) === null || _b === void 0 ? void 0 : _b.domProps) && 'value' in vnode.data.domProps) {
          return { value: vnode.data.domProps.value };
      }
      return undefined;
  }
  function extractChildren(vnode) {
      if (Array.isArray(vnode)) {
          return vnode;
      }
      if (Array.isArray(vnode.children)) {
          return vnode.children;
      }
      /* istanbul ignore next */
      if (vnode.componentOptions && Array.isArray(vnode.componentOptions.children)) {
          return vnode.componentOptions.children;
      }
      return [];
  }
  function findInputNodes(vnode) {
      if (!Array.isArray(vnode) && findValue(vnode) !== undefined) {
          return [vnode];
      }
      var children = extractChildren(vnode);
      return children.reduce(function (nodes, node) {
          var candidates = findInputNodes(node);
          if (candidates.length) {
              nodes.push.apply(nodes, candidates);
          }
          return nodes;
      }, []);
  }
  // Resolves v-model config if exists.
  function findModelConfig(vnode) {
      /* istanbul ignore next */
      if (!vnode.componentOptions)
          return null;
      // This is also not typed in the standard Vue TS.
      return vnode.componentOptions.Ctor.options.model;
  }
  // Adds a listener to vnode listener object.
  function mergeVNodeListeners(obj, eventName, handler) {
      // no listener at all.
      if (isNullOrUndefined(obj[eventName])) {
          obj[eventName] = [handler];
          return;
      }
      // Is an invoker.
      if (isCallable(obj[eventName]) && obj[eventName].fns) {
          var invoker = obj[eventName];
          invoker.fns = Array.isArray(invoker.fns) ? invoker.fns : [invoker.fns];
          if (!includes(invoker.fns, handler)) {
              invoker.fns.push(handler);
          }
          return;
      }
      if (isCallable(obj[eventName])) {
          var prev = obj[eventName];
          obj[eventName] = [prev];
      }
      if (Array.isArray(obj[eventName]) && !includes(obj[eventName], handler)) {
          obj[eventName].push(handler);
      }
  }
  // Adds a listener to a native HTML vnode.
  function addNativeNodeListener(node, eventName, handler) {
      /* istanbul ignore next */
      if (!node.data) {
          node.data = {};
      }
      if (isNullOrUndefined(node.data.on)) {
          node.data.on = {};
      }
      mergeVNodeListeners(node.data.on, eventName, handler);
  }
  // Adds a listener to a Vue component vnode.
  function addComponentNodeListener(node, eventName, handler) {
      /* istanbul ignore next */
      if (!node.componentOptions) {
          return;
      }
      /* istanbul ignore next */
      if (!node.componentOptions.listeners) {
          node.componentOptions.listeners = {};
      }
      mergeVNodeListeners(node.componentOptions.listeners, eventName, handler);
  }
  function addVNodeListener(vnode, eventName, handler) {
      if (vnode.componentOptions) {
          addComponentNodeListener(vnode, eventName, handler);
          return;
      }
      addNativeNodeListener(vnode, eventName, handler);
  }
  // Determines if `change` should be used over `input` for listeners.
  function getInputEventName(vnode, model) {
      var _a;
      // Is a component.
      if (vnode.componentOptions) {
          var event_1 = (findModelConfig(vnode) || { event: 'input' }).event;
          return event_1;
      }
      // Lazy Models typically use change event
      if ((_a = model === null || model === void 0 ? void 0 : model.modifiers) === null || _a === void 0 ? void 0 : _a.lazy) {
          return 'change';
      }
      // is a textual-type input.
      if (isTextInput(vnode)) {
          return 'input';
      }
      return 'change';
  }
  function isHTMLNode(node) {
      return includes(['input', 'select', 'textarea'], node.tag);
  }
  // TODO: Type this one properly.
  function normalizeSlots(slots, ctx) {
      var acc = [];
      return Object.keys(slots).reduce(function (arr, key) {
          slots[key].forEach(function (vnode) {
              if (!vnode.context) {
                  slots[key].context = ctx;
                  if (!vnode.data) {
                      vnode.data = {};
                  }
                  vnode.data.slot = key;
              }
          });
          return arr.concat(slots[key]);
      }, acc);
  }
  function resolveTextualRules(vnode) {
      var _a;
      var attrs = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs;
      var rules = {};
      if (!attrs)
          return rules;
      if (attrs.type === 'email' && RuleContainer.getRuleDefinition('email')) {
          rules.email = ['multiple' in attrs];
      }
      if (attrs.pattern && RuleContainer.getRuleDefinition('regex')) {
          rules.regex = attrs.pattern;
      }
      if (attrs.maxlength >= 0 && RuleContainer.getRuleDefinition('max')) {
          rules.max = attrs.maxlength;
      }
      if (attrs.minlength >= 0 && RuleContainer.getRuleDefinition('min')) {
          rules.min = attrs.minlength;
      }
      if (attrs.type === 'number') {
          if (isSpecified(attrs.min) && RuleContainer.getRuleDefinition('min_value')) {
              rules.min_value = Number(attrs.min);
          }
          if (isSpecified(attrs.max) && RuleContainer.getRuleDefinition('max_value')) {
              rules.max_value = Number(attrs.max);
          }
      }
      return rules;
  }
  function resolveRules(vnode) {
      var _a;
      var htmlTags = ['input', 'select', 'textarea'];
      var attrs = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs;
      if (!includes(htmlTags, vnode.tag) || !attrs) {
          return {};
      }
      var rules = {};
      if ('required' in attrs && attrs.required !== false && RuleContainer.getRuleDefinition('required')) {
          rules.required = attrs.type === 'checkbox' ? [true] : true;
      }
      if (isTextInput(vnode)) {
          return normalizeRules(__assign(__assign({}, rules), resolveTextualRules(vnode)));
      }
      return normalizeRules(rules);
  }
  function normalizeChildren(context, slotProps) {
      if (context.$scopedSlots.default) {
          return context.$scopedSlots.default(slotProps) || [];
      }
      return context.$slots.default || [];
  }

  /**
   * Determines if a provider needs to run validation.
   */
  function shouldValidate(ctx, value) {
      // when an immediate/initial validation is needed and wasn't done before.
      if (!ctx._ignoreImmediate && ctx.immediate) {
          return true;
      }
      // when the value changes for whatever reason.
      if (!isRefEqual(ctx.value, value) && ctx.normalizedEvents.length) {
          return true;
      }
      // when it needs validation due to props/cross-fields changes.
      if (ctx._needsValidation) {
          return true;
      }
      // when the initial value is undefined and the field wasn't rendered yet.
      if (!ctx.initialized && value === undefined) {
          return true;
      }
      return false;
  }
  function createValidationCtx(ctx) {
      return __assign(__assign({}, ctx.flags), { errors: ctx.errors, classes: ctx.classes, failedRules: ctx.failedRules, reset: function () { return ctx.reset(); }, validate: function () {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
              }
              return ctx.validate.apply(ctx, args);
          }, ariaInput: {
              'aria-invalid': ctx.flags.invalid ? 'true' : 'false',
              'aria-required': ctx.isRequired ? 'true' : 'false',
              'aria-errormessage': "vee_" + ctx.id
          }, ariaMsg: {
              id: "vee_" + ctx.id,
              'aria-live': ctx.errors.length ? 'assertive' : 'off'
          } });
  }
  function onRenderUpdate(vm, value) {
      if (!vm.initialized) {
          vm.initialValue = value;
      }
      var validateNow = shouldValidate(vm, value);
      vm._needsValidation = false;
      vm.value = value;
      vm._ignoreImmediate = true;
      if (!validateNow) {
          return;
      }
      var validate = function () {
          if (vm.immediate || vm.flags.validated) {
              return triggerThreadSafeValidation(vm);
          }
          vm.validateSilent();
      };
      if (vm.initialized) {
          validate();
          return;
      }
      vm.$once('hook:mounted', function () { return validate(); });
  }
  function computeModeSetting(ctx) {
      var compute = (isCallable(ctx.mode) ? ctx.mode : modes[ctx.mode]);
      return compute(ctx);
  }
  function triggerThreadSafeValidation(vm) {
      var pendingPromise = vm.validateSilent();
      // avoids race conditions between successive validations.
      vm._pendingValidation = pendingPromise;
      return pendingPromise.then(function (result) {
          if (pendingPromise === vm._pendingValidation) {
              vm.applyResult(result);
              vm._pendingValidation = undefined;
          }
          return result;
      });
  }
  // Creates the common handlers for a validatable context.
  function createCommonHandlers(vm) {
      if (!vm.$veeOnInput) {
          vm.$veeOnInput = function (e) {
              vm.syncValue(e); // track and keep the value updated.
              vm.setFlags({ dirty: true, pristine: false });
          };
      }
      var onInput = vm.$veeOnInput;
      if (!vm.$veeOnBlur) {
          vm.$veeOnBlur = function () {
              vm.setFlags({ touched: true, untouched: false });
          };
      }
      // Blur event listener.
      var onBlur = vm.$veeOnBlur;
      var onValidate = vm.$veeHandler;
      var mode = computeModeSetting(vm);
      // Handle debounce changes.
      if (!onValidate || vm.$veeDebounce !== vm.debounce) {
          onValidate = debounce(function () {
              vm.$nextTick(function () {
                  if (!vm._pendingReset) {
                      triggerThreadSafeValidation(vm);
                  }
                  vm._pendingReset = false;
              });
          }, mode.debounce || vm.debounce);
          // Cache the handler so we don't create it each time.
          vm.$veeHandler = onValidate;
          // cache the debounce value so we detect if it was changed.
          vm.$veeDebounce = vm.debounce;
      }
      return { onInput: onInput, onBlur: onBlur, onValidate: onValidate };
  }
  // Adds all plugin listeners to the vnode.
  function addListeners(vm, node) {
      var value = findValue(node);
      // cache the input eventName.
      vm._inputEventName = vm._inputEventName || getInputEventName(node, findModel(node));
      onRenderUpdate(vm, value === null || value === void 0 ? void 0 : value.value);
      var _a = createCommonHandlers(vm), onInput = _a.onInput, onBlur = _a.onBlur, onValidate = _a.onValidate;
      addVNodeListener(node, vm._inputEventName, onInput);
      addVNodeListener(node, 'blur', onBlur);
      // add the validation listeners.
      vm.normalizedEvents.forEach(function (evt) {
          addVNodeListener(node, evt, onValidate);
      });
      vm.initialized = true;
  }

  var PROVIDER_COUNTER = 0;
  function data() {
      var errors = [];
      var fieldName = '';
      var defaultValues = {
          errors: errors,
          value: undefined,
          initialized: false,
          initialValue: undefined,
          flags: createFlags(),
          failedRules: {},
          isActive: true,
          fieldName: fieldName,
          id: ''
      };
      return defaultValues;
  }
  var ValidationProvider = Vue__default['default'].extend({
      inject: {
          $_veeObserver: {
              from: '$_veeObserver',
              default: function () {
                  if (!this.$vnode.context.$_veeObserver) {
                      this.$vnode.context.$_veeObserver = createObserver();
                  }
                  return this.$vnode.context.$_veeObserver;
              }
          }
      },
      props: {
          vid: {
              type: String,
              default: ''
          },
          name: {
              type: String,
              default: null
          },
          mode: {
              type: [String, Function],
              default: function () {
                  return getConfig().mode;
              }
          },
          rules: {
              type: [Object, String],
              default: null
          },
          immediate: {
              type: Boolean,
              default: false
          },
          bails: {
              type: Boolean,
              default: function () { return getConfig().bails; }
          },
          skipIfEmpty: {
              type: Boolean,
              default: function () { return getConfig().skipOptional; }
          },
          debounce: {
              type: Number,
              default: 0
          },
          tag: {
              type: String,
              default: 'span'
          },
          slim: {
              type: Boolean,
              default: false
          },
          disabled: {
              type: Boolean,
              default: false
          },
          customMessages: {
              type: Object,
              default: function () {
                  return {};
              }
          }
      },
      watch: {
          rules: {
              deep: true,
              handler: function (val, oldVal) {
                  this._needsValidation = !isEqual(val, oldVal);
              }
          }
      },
      data: data,
      computed: {
          fieldDeps: function () {
              var _this = this;
              return Object.keys(this.normalizedRules).reduce(function (acc, rule) {
                  var deps = extractLocators(_this.normalizedRules[rule]).map(function (dep) {
                      return isLocator(dep) ? dep.__locatorRef : dep.slice(1);
                  });
                  acc.push.apply(acc, deps);
                  deps.forEach(function (depName) {
                      watchCrossFieldDep(_this, depName);
                  });
                  return acc;
              }, []);
          },
          normalizedEvents: function () {
              var _this = this;
              var on = computeModeSetting(this).on;
              return (on || []).map(function (e) {
                  if (e === 'input') {
                      return _this._inputEventName;
                  }
                  return e;
              });
          },
          isRequired: function () {
              var rules = __assign(__assign({}, this._resolvedRules), this.normalizedRules);
              var isRequired = Object.keys(rules).some(RuleContainer.isRequireRule);
              this.flags.required = !!isRequired;
              return isRequired;
          },
          classes: function () {
              var names = getConfig().classes;
              return computeClassObj(names, this.flags);
          },
          normalizedRules: function () {
              return normalizeRules(this.rules);
          }
      },
      mounted: function () {
          var _this = this;
          var onLocaleChanged = function () {
              if (!_this.flags.validated) {
                  return;
              }
              var regenerateMap = _this._regenerateMap;
              if (regenerateMap) {
                  var errors_1 = [];
                  var failedRules_1 = {};
                  Object.keys(regenerateMap).forEach(function (rule) {
                      var msg = regenerateMap[rule]();
                      errors_1.push(msg);
                      failedRules_1[rule] = msg;
                  });
                  _this.applyResult({ errors: errors_1, failedRules: failedRules_1, regenerateMap: regenerateMap });
                  return;
              }
              _this.validate();
          };
          EVENT_BUS.$on('change:locale', onLocaleChanged);
          this.$on('hook:beforeDestroy', function () {
              EVENT_BUS.$off('change:locale', onLocaleChanged);
          });
      },
      render: function (h) {
          var _this = this;
          this.registerField();
          var ctx = createValidationCtx(this);
          var children = normalizeChildren(this, ctx);
          var inputs = findInputNodes(children);
          if (!inputs.length) {
              // Silent exit if no input was found.
              return this.slim && children.length <= 1 ? children[0] : h(this.tag, children);
          }
          inputs.forEach(function (input, idx) {
              var _a, _b, _c, _d, _e, _f;
              // If the elements are not checkboxes and there are more input nodes
              if (!includes(['checkbox', 'radio'], (_b = (_a = input.data) === null || _a === void 0 ? void 0 : _a.attrs) === null || _b === void 0 ? void 0 : _b.type) && idx > 0) {
                  return;
              }
              var resolved = getConfig().useConstraintAttrs ? resolveRules(input) : {};
              if (!isEqual(_this._resolvedRules, resolved)) {
                  _this._needsValidation = true;
              }
              if (isHTMLNode(input)) {
                  _this.fieldName = ((_d = (_c = input.data) === null || _c === void 0 ? void 0 : _c.attrs) === null || _d === void 0 ? void 0 : _d.name) || ((_f = (_e = input.data) === null || _e === void 0 ? void 0 : _e.attrs) === null || _f === void 0 ? void 0 : _f.id);
              }
              _this._resolvedRules = resolved;
              addListeners(_this, input);
          });
          return this.slim && children.length <= 1 ? children[0] : h(this.tag, children);
      },
      beforeDestroy: function () {
          // cleanup reference.
          this.$_veeObserver.unobserve(this.id);
      },
      activated: function () {
          this.isActive = true;
      },
      deactivated: function () {
          this.isActive = false;
      },
      methods: {
          setFlags: function (flags) {
              var _this = this;
              Object.keys(flags).forEach(function (flag) {
                  _this.flags[flag] = flags[flag];
              });
          },
          syncValue: function (v) {
              var value = normalizeEventValue(v);
              this.value = value;
              this.flags.changed = this.initialValue !== value;
          },
          reset: function () {
              var _this = this;
              this.errors = [];
              this.initialValue = this.value;
              var flags = createFlags();
              flags.required = this.isRequired;
              this.setFlags(flags);
              this.failedRules = {};
              this.validateSilent();
              this._pendingValidation = undefined;
              this._pendingReset = true;
              setTimeout(function () {
                  _this._pendingReset = false;
              }, this.debounce);
          },
          validate: function () {
              var args = [];
              for (var _i = 0; _i < arguments.length; _i++) {
                  args[_i] = arguments[_i];
              }
              return __awaiter(this, void 0, void 0, function () {
                  return __generator(this, function (_a) {
                      if (args.length > 0) {
                          this.syncValue(args[0]);
                      }
                      return [2 /*return*/, triggerThreadSafeValidation(this)];
                  });
              });
          },
          validateSilent: function () {
              return __awaiter(this, void 0, void 0, function () {
                  var rules, result;
                  return __generator(this, function (_a) {
                      switch (_a.label) {
                          case 0:
                              this.setFlags({ pending: true });
                              rules = __assign(__assign({}, this._resolvedRules), this.normalizedRules);
                              Object.defineProperty(rules, '_$$isNormalized', {
                                  value: true,
                                  writable: false,
                                  enumerable: false,
                                  configurable: false
                              });
                              return [4 /*yield*/, validate$r(this.value, rules, __assign(__assign({ name: this.name || this.fieldName }, createLookup(this)), { bails: this.bails, skipIfEmpty: this.skipIfEmpty, isInitial: !this.initialized, customMessages: this.customMessages }))];
                          case 1:
                              result = _a.sent();
                              this.setFlags({
                                  pending: false,
                                  valid: result.valid,
                                  invalid: !result.valid
                              });
                              return [2 /*return*/, result];
                      }
                  });
              });
          },
          setErrors: function (errors) {
              this.applyResult({ errors: errors, failedRules: {} });
          },
          applyResult: function (_a) {
              var errors = _a.errors, failedRules = _a.failedRules, regenerateMap = _a.regenerateMap;
              this.errors = errors;
              this._regenerateMap = regenerateMap;
              this.failedRules = __assign({}, (failedRules || {}));
              this.setFlags({
                  valid: !errors.length,
                  passed: !errors.length,
                  invalid: !!errors.length,
                  failed: !!errors.length,
                  validated: true,
                  changed: this.value !== this.initialValue
              });
          },
          registerField: function () {
              updateRenderingContextRefs(this);
          }
      }
  });
  function computeClassObj(names, flags) {
      var acc = {};
      var keys = Object.keys(flags);
      var length = keys.length;
      var _loop_1 = function (i) {
          var flag = keys[i];
          var className = (names && names[flag]) || flag;
          var value = flags[flag];
          if (isNullOrUndefined(value)) {
              return "continue";
          }
          if ((flag === 'valid' || flag === 'invalid') && !flags.validated) {
              return "continue";
          }
          if (typeof className === 'string') {
              acc[className] = value;
          }
          else if (Array.isArray(className)) {
              className.forEach(function (cls) {
                  acc[cls] = value;
              });
          }
      };
      for (var i = 0; i < length; i++) {
          _loop_1(i);
      }
      return acc;
  }
  function createLookup(vm) {
      var providers = vm.$_veeObserver.refs;
      var reduced = {
          names: {},
          values: {}
      };
      return vm.fieldDeps.reduce(function (acc, depName) {
          if (!providers[depName]) {
              return acc;
          }
          acc.values[depName] = providers[depName].value;
          acc.names[depName] = providers[depName].name;
          return acc;
      }, reduced);
  }
  function extractId(vm) {
      if (vm.vid) {
          return vm.vid;
      }
      if (vm.name) {
          return vm.name;
      }
      if (vm.id) {
          return vm.id;
      }
      if (vm.fieldName) {
          return vm.fieldName;
      }
      PROVIDER_COUNTER++;
      return "_vee_" + PROVIDER_COUNTER;
  }
  function updateRenderingContextRefs(vm) {
      var providedId = extractId(vm);
      var id = vm.id;
      // Nothing has changed.
      if (!vm.isActive || (id === providedId && vm.$_veeObserver.refs[id])) {
          return;
      }
      // vid was changed.
      if (id !== providedId && vm.$_veeObserver.refs[id] === vm) {
          vm.$_veeObserver.unobserve(id);
      }
      vm.id = providedId;
      vm.$_veeObserver.observe(vm);
  }
  function createObserver() {
      return {
          refs: {},
          observe: function (vm) {
              this.refs[vm.id] = vm;
          },
          unobserve: function (id) {
              delete this.refs[id];
          }
      };
  }
  function watchCrossFieldDep(ctx, depName, withHooks) {
      if (withHooks === void 0) { withHooks = true; }
      var providers = ctx.$_veeObserver.refs;
      if (!ctx._veeWatchers) {
          ctx._veeWatchers = {};
      }
      if (!providers[depName] && withHooks) {
          return ctx.$once('hook:mounted', function () {
              watchCrossFieldDep(ctx, depName, false);
          });
      }
      if (!isCallable(ctx._veeWatchers[depName]) && providers[depName]) {
          ctx._veeWatchers[depName] = providers[depName].$watch('value', function () {
              if (ctx.flags.validated) {
                  ctx._needsValidation = true;
                  ctx.validate();
              }
          });
      }
  }

  var FLAGS_STRATEGIES = [
      ['pristine', 'every'],
      ['dirty', 'some'],
      ['touched', 'some'],
      ['untouched', 'every'],
      ['valid', 'every'],
      ['invalid', 'some'],
      ['pending', 'some'],
      ['validated', 'every'],
      ['changed', 'some'],
      ['passed', 'every'],
      ['failed', 'some']
  ];
  var OBSERVER_COUNTER = 0;
  function data$1() {
      var refs = {};
      var errors = {};
      var flags = createObserverFlags();
      var fields = {};
      // FIXME: Not sure of this one can be typed, circular type reference.
      var observers = [];
      return {
          id: '',
          refs: refs,
          observers: observers,
          errors: errors,
          flags: flags,
          fields: fields
      };
  }
  function provideSelf() {
      return {
          $_veeObserver: this
      };
  }
  var ValidationObserver = Vue__default['default'].extend({
      name: 'ValidationObserver',
      provide: provideSelf,
      inject: {
          $_veeObserver: {
              from: '$_veeObserver',
              default: function () {
                  if (!this.$vnode.context.$_veeObserver) {
                      return null;
                  }
                  return this.$vnode.context.$_veeObserver;
              }
          }
      },
      props: {
          tag: {
              type: String,
              default: 'span'
          },
          vid: {
              type: String,
              default: function () {
                  return "obs_" + OBSERVER_COUNTER++;
              }
          },
          slim: {
              type: Boolean,
              default: false
          },
          disabled: {
              type: Boolean,
              default: false
          }
      },
      data: data$1,
      created: function () {
          var _this = this;
          this.id = this.vid;
          register(this);
          var onChange = debounce(function (_a) {
              var errors = _a.errors, flags = _a.flags, fields = _a.fields;
              _this.errors = errors;
              _this.flags = flags;
              _this.fields = fields;
          }, 16);
          this.$watch(computeObserverState, onChange);
      },
      activated: function () {
          register(this);
      },
      deactivated: function () {
          unregister(this);
      },
      beforeDestroy: function () {
          unregister(this);
      },
      render: function (h) {
          var children = normalizeChildren(this, prepareSlotProps(this));
          return this.slim && children.length <= 1 ? children[0] : h(this.tag, { on: this.$listeners }, children);
      },
      methods: {
          observe: function (subscriber, kind) {
              var _a;
              if (kind === void 0) { kind = 'provider'; }
              if (kind === 'observer') {
                  this.observers.push(subscriber);
                  return;
              }
              this.refs = __assign(__assign({}, this.refs), (_a = {}, _a[subscriber.id] = subscriber, _a));
          },
          unobserve: function (id, kind) {
              if (kind === void 0) { kind = 'provider'; }
              if (kind === 'provider') {
                  var provider = this.refs[id];
                  if (!provider) {
                      return;
                  }
                  this.$delete(this.refs, id);
                  return;
              }
              var idx = findIndex(this.observers, function (o) { return o.id === id; });
              if (idx !== -1) {
                  this.observers.splice(idx, 1);
              }
          },
          validateWithInfo: function (_a) {
              var _b = (_a === void 0 ? {} : _a).silent, silent = _b === void 0 ? false : _b;
              return __awaiter(this, void 0, void 0, function () {
                  var results, isValid, _c, errors, flags, fields;
                  return __generator(this, function (_d) {
                      switch (_d.label) {
                          case 0: return [4 /*yield*/, Promise.all(__spreadArrays(values(this.refs)
                                  .filter(function (r) { return !r.disabled; })
                                  .map(function (ref) { return ref[silent ? 'validateSilent' : 'validate']().then(function (r) { return r.valid; }); }), this.observers.filter(function (o) { return !o.disabled; }).map(function (obs) { return obs.validate({ silent: silent }); })))];
                          case 1:
                              results = _d.sent();
                              isValid = results.every(function (r) { return r; });
                              _c = computeObserverState.call(this), errors = _c.errors, flags = _c.flags, fields = _c.fields;
                              this.errors = errors;
                              this.flags = flags;
                              this.fields = fields;
                              return [2 /*return*/, {
                                      errors: errors,
                                      flags: flags,
                                      fields: fields,
                                      isValid: isValid
                                  }];
                      }
                  });
              });
          },
          validate: function (_a) {
              var _b = (_a === void 0 ? {} : _a).silent, silent = _b === void 0 ? false : _b;
              return __awaiter(this, void 0, void 0, function () {
                  var isValid;
                  return __generator(this, function (_c) {
                      switch (_c.label) {
                          case 0: return [4 /*yield*/, this.validateWithInfo({ silent: silent })];
                          case 1:
                              isValid = (_c.sent()).isValid;
                              return [2 /*return*/, isValid];
                      }
                  });
              });
          },
          handleSubmit: function (cb) {
              return __awaiter(this, void 0, void 0, function () {
                  var isValid;
                  return __generator(this, function (_a) {
                      switch (_a.label) {
                          case 0: return [4 /*yield*/, this.validate()];
                          case 1:
                              isValid = _a.sent();
                              if (!isValid || !cb) {
                                  return [2 /*return*/];
                              }
                              return [2 /*return*/, cb()];
                      }
                  });
              });
          },
          reset: function () {
              return __spreadArrays(values(this.refs), this.observers).forEach(function (ref) { return ref.reset(); });
          },
          setErrors: function (errors) {
              var _this = this;
              Object.keys(errors).forEach(function (key) {
                  var provider = _this.refs[key];
                  if (!provider)
                      return;
                  var errorArr = errors[key] || [];
                  errorArr = typeof errorArr === 'string' ? [errorArr] : errorArr;
                  provider.setErrors(errorArr);
              });
              this.observers.forEach(function (observer) {
                  observer.setErrors(errors);
              });
          }
      }
  });
  function unregister(vm) {
      if (vm.$_veeObserver) {
          vm.$_veeObserver.unobserve(vm.id, 'observer');
      }
  }
  function register(vm) {
      if (vm.$_veeObserver) {
          vm.$_veeObserver.observe(vm, 'observer');
      }
  }
  function prepareSlotProps(vm) {
      return __assign(__assign({}, vm.flags), { errors: vm.errors, fields: vm.fields, validate: vm.validate, passes: vm.handleSubmit, handleSubmit: vm.handleSubmit, reset: vm.reset });
  }
  // Creates a modified version of validation flags
  function createObserverFlags() {
      return __assign(__assign({}, createFlags()), { valid: true, invalid: false });
  }
  function computeObserverState() {
      var vms = __spreadArrays(values(this.refs), this.observers);
      var errors = {};
      var flags = createObserverFlags();
      var fields = {};
      var length = vms.length;
      for (var i = 0; i < length; i++) {
          var vm = vms[i];
          // validation provider
          if (Array.isArray(vm.errors)) {
              errors[vm.id] = vm.errors;
              fields[vm.id] = __assign({ id: vm.id, name: vm.name, failedRules: vm.failedRules }, vm.flags);
              continue;
          }
          // Nested observer, merge errors and fields
          errors = __assign(__assign({}, errors), vm.errors);
          fields = __assign(__assign({}, fields), vm.fields);
      }
      FLAGS_STRATEGIES.forEach(function (_a) {
          var flag = _a[0], method = _a[1];
          flags[flag] = vms[method](function (vm) { return vm.flags[flag]; });
      });
      return { errors: errors, flags: flags, fields: fields };
  }

  function withValidation(component, mapProps) {
      var _a;
      if (mapProps === void 0) { mapProps = identity; }
      var options = 'options' in component ? component.options : component;
      var providerOpts = ValidationProvider.options;
      var hoc = {
          name: (options.name || 'AnonymousHoc') + "WithValidation",
          props: __assign({}, providerOpts.props),
          data: providerOpts.data,
          computed: __assign({}, providerOpts.computed),
          methods: __assign({}, providerOpts.methods),
          beforeDestroy: providerOpts.beforeDestroy,
          inject: providerOpts.inject
      };
      var eventName = ((_a = options === null || options === void 0 ? void 0 : options.model) === null || _a === void 0 ? void 0 : _a.event) || 'input';
      hoc.render = function (h) {
          var _a;
          this.registerField();
          var vctx = createValidationCtx(this);
          var listeners = __assign({}, this.$listeners);
          var model = findModel(this.$vnode);
          this._inputEventName = this._inputEventName || getInputEventName(this.$vnode, model);
          var value = findValue(this.$vnode);
          onRenderUpdate(this, value === null || value === void 0 ? void 0 : value.value);
          var _b = createCommonHandlers(this), onInput = _b.onInput, onBlur = _b.onBlur, onValidate = _b.onValidate;
          mergeVNodeListeners(listeners, eventName, onInput);
          mergeVNodeListeners(listeners, 'blur', onBlur);
          this.normalizedEvents.forEach(function (evt) {
              mergeVNodeListeners(listeners, evt, onValidate);
          });
          // Props are any attrs not associated with ValidationProvider Plus the model prop.
          // WARNING: Accidental prop overwrite will probably happen.
          var prop = (findModelConfig(this.$vnode) || { prop: 'value' }).prop;
          var props = __assign(__assign(__assign({}, this.$attrs), (_a = {}, _a[prop] = model === null || model === void 0 ? void 0 : model.value, _a)), mapProps(vctx));
          return h(options, {
              attrs: this.$attrs,
              props: props,
              on: listeners,
              scopedSlots: this.$scopedSlots
          }, normalizeSlots(this.$slots, this.$vnode.context));
      };
      return hoc;
  }

  var version = '3.4.0';
  // Install all rules.
  var RulesAsList = Object.keys(Rules).map(function (key) { return ({ schema: Rules[key], name: key }); });
  RulesAsList.forEach(function (_a) {
      var name = _a.name, schema = _a.schema;
      extend(name, schema);
  });
  // Install locale
  localize('en', en);

  exports.Rules = Rules;
  exports.ValidationObserver = ValidationObserver;
  exports.ValidationProvider = ValidationProvider;
  exports.configure = configure;
  exports.extend = extend;
  exports.localeChanged = localeChanged;
  exports.localize = localize;
  exports.normalizeRules = normalizeRules;
  exports.setInteractionMode = setInteractionMode;
  exports.validate = validate$r;
  exports.version = version;
  exports.withValidation = withValidation;

  Object.defineProperty(exports, '__esModule', { value: true });

})));

},{"vue":"vue"}],400:[function(require,module,exports){
/**
  * vee-validate v3.4.0
  * (c) 2020 Abdelrahman Awad
  * @license MIT
  */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('vue')) :
    typeof define === 'function' && define.amd ? define(['exports', 'vue'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.VeeValidate = {}, global.Vue));
}(this, (function (exports, Vue) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var Vue__default = /*#__PURE__*/_interopDefaultLegacy(Vue);

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    }

    function isNaN(value) {
        // NaN is the one value that does not equal itself.
        // eslint-disable-next-line
        return value !== value;
    }
    function isNullOrUndefined(value) {
        return value === null || value === undefined;
    }
    function isEmptyArray(arr) {
        return Array.isArray(arr) && arr.length === 0;
    }
    var isObject = function (obj) {
        return obj !== null && obj && typeof obj === 'object' && !Array.isArray(obj);
    };
    /**
     * A reference comparison function with NaN support
     */
    function isRefEqual(lhs, rhs) {
        if (isNaN(lhs) && isNaN(rhs)) {
            return true;
        }
        return lhs === rhs;
    }
    /**
     * Shallow object comparison.
     */
    function isEqual(lhs, rhs) {
        if (lhs instanceof RegExp && rhs instanceof RegExp) {
            return isEqual(lhs.source, rhs.source) && isEqual(lhs.flags, rhs.flags);
        }
        if (Array.isArray(lhs) && Array.isArray(rhs)) {
            if (lhs.length !== rhs.length)
                return false;
            for (var i = 0; i < lhs.length; i++) {
                if (!isEqual(lhs[i], rhs[i])) {
                    return false;
                }
            }
            return true;
        }
        // if both are objects, compare each key recursively.
        if (isObject(lhs) && isObject(rhs)) {
            return (Object.keys(lhs).every(function (key) {
                return isEqual(lhs[key], rhs[key]);
            }) &&
                Object.keys(rhs).every(function (key) {
                    return isEqual(lhs[key], rhs[key]);
                }));
        }
        return isRefEqual(lhs, rhs);
    }
    // Checks if a given value is not an empty string or null or undefined.
    function isSpecified(val) {
        if (val === '') {
            return false;
        }
        return !isNullOrUndefined(val);
    }
    function isCallable(fn) {
        return typeof fn === 'function';
    }
    function isLocator(value) {
        return isCallable(value) && !!value.__locatorRef;
    }

    function findIndex(arrayLike, predicate) {
        var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
        if (isCallable(array.findIndex)) {
            return array.findIndex(predicate);
        }
        /* istanbul ignore next */
        for (var i = 0; i < array.length; i++) {
            if (predicate(array[i], i)) {
                return i;
            }
        }
        /* istanbul ignore next */
        return -1;
    }
    /**
     * finds the first element that satisfies the predicate callback, polyfills array.find
     */
    function find(arrayLike, predicate) {
        var array = Array.isArray(arrayLike) ? arrayLike : toArray(arrayLike);
        var idx = findIndex(array, predicate);
        return idx === -1 ? undefined : array[idx];
    }
    function includes(collection, item) {
        return collection.indexOf(item) !== -1;
    }
    /**
     * Converts an array-like object to array, provides a simple polyfill for Array.from
     */
    function toArray(arrayLike) {
        if (isCallable(Array.from)) {
            return Array.from(arrayLike);
        }
        /* istanbul ignore next */
        return _copyArray(arrayLike);
    }
    /* istanbul ignore next */
    function _copyArray(arrayLike) {
        var array = [];
        var length = arrayLike.length;
        for (var i = 0; i < length; i++) {
            array.push(arrayLike[i]);
        }
        return array;
    }
    function values(obj) {
        if (isCallable(Object.values)) {
            return Object.values(obj);
        }
        // fallback to keys()
        /* istanbul ignore next */
        return Object.keys(obj).map(function (k) { return obj[k]; });
    }
    function merge(target, source) {
        Object.keys(source).forEach(function (key) {
            if (isObject(source[key])) {
                if (!target[key]) {
                    target[key] = {};
                }
                merge(target[key], source[key]);
                return;
            }
            target[key] = source[key];
        });
        return target;
    }

    function createFlags() {
        return {
            untouched: true,
            touched: false,
            dirty: false,
            pristine: true,
            valid: false,
            invalid: false,
            validated: false,
            pending: false,
            required: false,
            changed: false,
            passed: false,
            failed: false
        };
    }

    function identity(x) {
        return x;
    }
    function debounce(fn, wait, token) {
        if (wait === void 0) { wait = 0; }
        if (token === void 0) { token = { cancelled: false }; }
        if (wait === 0) {
            return fn;
        }
        var timeout;
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var later = function () {
                timeout = undefined;
                // check if the fn call was cancelled.
                if (!token.cancelled)
                    fn.apply(void 0, args);
            };
            // because we might want to use Node.js setTimout for SSR.
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }

    /**
     * Emits a warning to the console
     */
    function warn(message) {
        console.warn("[vee-validate] " + message);
    }
    /**
     * Replaces placeholder values in a string with their actual values
     */
    function interpolate(template, values) {
        return template.replace(/{([^}]+)}/g, function (_, p) {
            return p in values ? values[p] : "{" + p + "}";
        });
    }

    var RULES = {};
    function normalizeSchema(schema) {
        var _a;
        if ((_a = schema.params) === null || _a === void 0 ? void 0 : _a.length) {
            schema.params = schema.params.map(function (param) {
                if (typeof param === 'string') {
                    return { name: param };
                }
                return param;
            });
        }
        return schema;
    }
    var RuleContainer = /** @class */ (function () {
        function RuleContainer() {
        }
        RuleContainer.extend = function (name, schema) {
            // if rule already exists, overwrite it.
            var rule = normalizeSchema(schema);
            if (RULES[name]) {
                RULES[name] = merge(RULES[name], schema);
                return;
            }
            RULES[name] = __assign({ lazy: false, computesRequired: false }, rule);
        };
        RuleContainer.isLazy = function (name) {
            var _a;
            return !!((_a = RULES[name]) === null || _a === void 0 ? void 0 : _a.lazy);
        };
        RuleContainer.isRequireRule = function (name) {
            var _a;
            return !!((_a = RULES[name]) === null || _a === void 0 ? void 0 : _a.computesRequired);
        };
        RuleContainer.getRuleDefinition = function (ruleName) {
            return RULES[ruleName];
        };
        return RuleContainer;
    }());
    /**
     * Adds a custom validator to the list of validation rules.
     */
    function extend(name, schema) {
        // makes sure new rules are properly formatted.
        guardExtend(name, schema);
        // Full schema object.
        if (typeof schema === 'object') {
            RuleContainer.extend(name, schema);
            return;
        }
        RuleContainer.extend(name, {
            validate: schema
        });
    }
    /**
     * Guards from extension violations.
     */
    function guardExtend(name, validator) {
        if (isCallable(validator)) {
            return;
        }
        if (isCallable(validator.validate)) {
            return;
        }
        if (RuleContainer.getRuleDefinition(name)) {
            return;
        }
        throw new Error("Extension Error: The validator '" + name + "' must be a function or have a 'validate' method.");
    }

    var DEFAULT_CONFIG = {
        defaultMessage: "{_field_} is not valid.",
        skipOptional: true,
        classes: {
            touched: 'touched',
            untouched: 'untouched',
            valid: 'valid',
            invalid: 'invalid',
            pristine: 'pristine',
            dirty: 'dirty' // control has been interacted with
        },
        bails: true,
        mode: 'aggressive',
        useConstraintAttrs: true
    };
    var currentConfig = __assign({}, DEFAULT_CONFIG);
    var getConfig = function () { return currentConfig; };
    var setConfig = function (newConf) {
        currentConfig = __assign(__assign({}, currentConfig), newConf);
    };
    var configure = function (cfg) {
        setConfig(cfg);
    };

    /**
     * Normalizes the given rules expression.
     */
    function normalizeRules(rules) {
        // if falsy value return an empty object.
        var acc = {};
        Object.defineProperty(acc, '_$$isNormalized', {
            value: true,
            writable: false,
            enumerable: false,
            configurable: false
        });
        if (!rules) {
            return acc;
        }
        // Object is already normalized, skip.
        if (isObject(rules) && rules._$$isNormalized) {
            return rules;
        }
        if (isObject(rules)) {
            return Object.keys(rules).reduce(function (prev, curr) {
                var params = [];
                if (rules[curr] === true) {
                    params = [];
                }
                else if (Array.isArray(rules[curr])) {
                    params = rules[curr];
                }
                else if (isObject(rules[curr])) {
                    params = rules[curr];
                }
                else {
                    params = [rules[curr]];
                }
                if (rules[curr] !== false) {
                    prev[curr] = buildParams(curr, params);
                }
                return prev;
            }, acc);
        }
        /* istanbul ignore if */
        if (typeof rules !== 'string') {
            warn('rules must be either a string or an object.');
            return acc;
        }
        return rules.split('|').reduce(function (prev, rule) {
            var parsedRule = parseRule(rule);
            if (!parsedRule.name) {
                return prev;
            }
            prev[parsedRule.name] = buildParams(parsedRule.name, parsedRule.params);
            return prev;
        }, acc);
    }
    function buildParams(ruleName, provided) {
        var ruleSchema = RuleContainer.getRuleDefinition(ruleName);
        if (!ruleSchema) {
            return provided;
        }
        var params = {};
        if (!ruleSchema.params && !Array.isArray(provided)) {
            throw new Error('You provided an object params to a rule that has no defined schema.');
        }
        // Rule probably uses an array for their args, keep it as is.
        if (Array.isArray(provided) && !ruleSchema.params) {
            return provided;
        }
        var definedParams;
        // collect the params schema.
        if (!ruleSchema.params || (ruleSchema.params.length < provided.length && Array.isArray(provided))) {
            var lastDefinedParam_1;
            // collect any additional parameters in the last item.
            definedParams = provided.map(function (_, idx) {
                var _a;
                var param = (_a = ruleSchema.params) === null || _a === void 0 ? void 0 : _a[idx];
                lastDefinedParam_1 = param || lastDefinedParam_1;
                if (!param) {
                    param = lastDefinedParam_1;
                }
                return param;
            });
        }
        else {
            definedParams = ruleSchema.params;
        }
        // Match the provided array length with a temporary schema.
        for (var i = 0; i < definedParams.length; i++) {
            var options = definedParams[i];
            var value = options.default;
            // if the provided is an array, map element value.
            if (Array.isArray(provided)) {
                if (i in provided) {
                    value = provided[i];
                }
            }
            else {
                // If the param exists in the provided object.
                if (options.name in provided) {
                    value = provided[options.name];
                    // if the provided is the first param value.
                }
                else if (definedParams.length === 1) {
                    value = provided;
                }
            }
            // if the param is a target, resolve the target value.
            if (options.isTarget) {
                value = createLocator(value, options.cast);
            }
            // A target param using interpolation
            if (typeof value === 'string' && value[0] === '@') {
                value = createLocator(value.slice(1), options.cast);
            }
            // If there is a transformer defined.
            if (!isLocator(value) && options.cast) {
                value = options.cast(value);
            }
            // already been set, probably multiple values.
            if (params[options.name]) {
                params[options.name] = Array.isArray(params[options.name]) ? params[options.name] : [params[options.name]];
                params[options.name].push(value);
            }
            else {
                // set the value.
                params[options.name] = value;
            }
        }
        return params;
    }
    /**
     * Parses a rule string expression.
     */
    var parseRule = function (rule) {
        var params = [];
        var name = rule.split(':')[0];
        if (includes(rule, ':')) {
            params = rule
                .split(':')
                .slice(1)
                .join(':')
                .split(',');
        }
        return { name: name, params: params };
    };
    function createLocator(value, castFn) {
        var locator = function (crossTable) {
            var val = crossTable[value];
            return castFn ? castFn(val) : val;
        };
        locator.__locatorRef = value;
        return locator;
    }
    function extractLocators(params) {
        if (Array.isArray(params)) {
            return params.filter(function (param) {
                return isLocator(param) || (typeof param === 'string' && param[0] === '@');
            });
        }
        return Object.keys(params)
            .filter(function (key) { return isLocator(params[key]); })
            .map(function (key) { return params[key]; });
    }

    /**
     * Validates a value against the rules.
     */
    function validate(value, rules, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var shouldBail, skipIfEmpty, field, result, errors, failedRules, regenerateMap;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shouldBail = options === null || options === void 0 ? void 0 : options.bails;
                        skipIfEmpty = options === null || options === void 0 ? void 0 : options.skipIfEmpty;
                        field = {
                            name: (options === null || options === void 0 ? void 0 : options.name) || '{field}',
                            rules: normalizeRules(rules),
                            bails: shouldBail !== null && shouldBail !== void 0 ? shouldBail : true,
                            skipIfEmpty: skipIfEmpty !== null && skipIfEmpty !== void 0 ? skipIfEmpty : true,
                            forceRequired: false,
                            crossTable: (options === null || options === void 0 ? void 0 : options.values) || {},
                            names: (options === null || options === void 0 ? void 0 : options.names) || {},
                            customMessages: (options === null || options === void 0 ? void 0 : options.customMessages) || {}
                        };
                        return [4 /*yield*/, _validate(field, value, options)];
                    case 1:
                        result = _a.sent();
                        errors = [];
                        failedRules = {};
                        regenerateMap = {};
                        result.errors.forEach(function (e) {
                            var msg = e.msg();
                            errors.push(msg);
                            failedRules[e.rule] = msg;
                            regenerateMap[e.rule] = e.msg;
                        });
                        return [2 /*return*/, {
                                valid: result.valid,
                                errors: errors,
                                failedRules: failedRules,
                                regenerateMap: regenerateMap
                            }];
                }
            });
        });
    }
    /**
     * Starts the validation process.
     */
    function _validate(field, value, _a) {
        var _b = (_a === void 0 ? {} : _a).isInitial, isInitial = _b === void 0 ? false : _b;
        return __awaiter(this, void 0, void 0, function () {
            var _c, shouldSkip, errors, rules, length, i, rule, result;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, _shouldSkip(field, value)];
                    case 1:
                        _c = _d.sent(), shouldSkip = _c.shouldSkip, errors = _c.errors;
                        if (shouldSkip) {
                            return [2 /*return*/, {
                                    valid: !errors.length,
                                    errors: errors
                                }];
                        }
                        rules = Object.keys(field.rules).filter(function (rule) { return !RuleContainer.isRequireRule(rule); });
                        length = rules.length;
                        i = 0;
                        _d.label = 2;
                    case 2:
                        if (!(i < length)) return [3 /*break*/, 5];
                        if (isInitial && RuleContainer.isLazy(rules[i])) {
                            return [3 /*break*/, 4];
                        }
                        rule = rules[i];
                        return [4 /*yield*/, _test(field, value, {
                                name: rule,
                                params: field.rules[rule]
                            })];
                    case 3:
                        result = _d.sent();
                        if (!result.valid && result.error) {
                            errors.push(result.error);
                            if (field.bails) {
                                return [2 /*return*/, {
                                        valid: false,
                                        errors: errors
                                    }];
                            }
                        }
                        _d.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5: return [2 /*return*/, {
                            valid: !errors.length,
                            errors: errors
                        }];
                }
            });
        });
    }
    function _shouldSkip(field, value) {
        return __awaiter(this, void 0, void 0, function () {
            var requireRules, length, errors, isEmpty, isEmptyAndOptional, isRequired, i, rule, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requireRules = Object.keys(field.rules).filter(RuleContainer.isRequireRule);
                        length = requireRules.length;
                        errors = [];
                        isEmpty = isNullOrUndefined(value) || value === '' || isEmptyArray(value);
                        isEmptyAndOptional = isEmpty && field.skipIfEmpty;
                        isRequired = false;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < length)) return [3 /*break*/, 4];
                        rule = requireRules[i];
                        return [4 /*yield*/, _test(field, value, {
                                name: rule,
                                params: field.rules[rule]
                            })];
                    case 2:
                        result = _a.sent();
                        if (!isObject(result)) {
                            throw new Error('Require rules has to return an object (see docs)');
                        }
                        if (result.required) {
                            isRequired = true;
                        }
                        if (!result.valid && result.error) {
                            errors.push(result.error);
                            // Exit early as the field is required and failed validation.
                            if (field.bails) {
                                return [2 /*return*/, {
                                        shouldSkip: true,
                                        errors: errors
                                    }];
                            }
                        }
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        if (isEmpty && !isRequired && !field.skipIfEmpty) {
                            return [2 /*return*/, {
                                    shouldSkip: false,
                                    errors: errors
                                }];
                        }
                        // field is configured to run through the pipeline regardless
                        if (!field.bails && !isEmptyAndOptional) {
                            return [2 /*return*/, {
                                    shouldSkip: false,
                                    errors: errors
                                }];
                        }
                        // skip if the field is not required and has an empty value.
                        return [2 /*return*/, {
                                shouldSkip: !isRequired && isEmpty,
                                errors: errors
                            }];
                }
            });
        });
    }
    /**
     * Tests a single input value against a rule.
     */
    function _test(field, value, rule) {
        return __awaiter(this, void 0, void 0, function () {
            var ruleSchema, normalizedValue, params, result, values_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ruleSchema = RuleContainer.getRuleDefinition(rule.name);
                        if (!ruleSchema || !ruleSchema.validate) {
                            throw new Error("No such validator '" + rule.name + "' exists.");
                        }
                        normalizedValue = ruleSchema.castValue ? ruleSchema.castValue(value) : value;
                        params = fillTargetValues(rule.params, field.crossTable);
                        return [4 /*yield*/, ruleSchema.validate(normalizedValue, params)];
                    case 1:
                        result = _a.sent();
                        if (typeof result === 'string') {
                            values_1 = __assign(__assign({}, (params || {})), { _field_: field.name, _value_: value, _rule_: rule.name });
                            return [2 /*return*/, {
                                    valid: false,
                                    error: { rule: rule.name, msg: function () { return interpolate(result, values_1); } }
                                }];
                        }
                        if (!isObject(result)) {
                            result = { valid: result };
                        }
                        return [2 /*return*/, {
                                valid: result.valid,
                                required: result.required,
                                error: result.valid ? undefined : _generateFieldError(field, value, ruleSchema, rule.name, params)
                            }];
                }
            });
        });
    }
    /**
     * Generates error messages.
     */
    function _generateFieldError(field, value, ruleSchema, ruleName, params) {
        var _a;
        var message = (_a = field.customMessages[ruleName]) !== null && _a !== void 0 ? _a : ruleSchema.message;
        var ruleTargets = _getRuleTargets(field, ruleSchema, ruleName);
        var _b = _getUserTargets(field, ruleSchema, ruleName, message), userTargets = _b.userTargets, userMessage = _b.userMessage;
        var values = __assign(__assign(__assign(__assign({}, (params || {})), { _field_: field.name, _value_: value, _rule_: ruleName }), ruleTargets), userTargets);
        return {
            msg: function () { return _normalizeMessage(userMessage || getConfig().defaultMessage, field.name, values); },
            rule: ruleName
        };
    }
    function _getRuleTargets(field, ruleSchema, ruleName) {
        var params = ruleSchema.params;
        if (!params) {
            return {};
        }
        var numTargets = params.filter(function (param) { return param.isTarget; }).length;
        if (numTargets <= 0) {
            return {};
        }
        var names = {};
        var ruleConfig = field.rules[ruleName];
        if (!Array.isArray(ruleConfig) && isObject(ruleConfig)) {
            ruleConfig = params.map(function (param) {
                return ruleConfig[param.name];
            });
        }
        for (var index = 0; index < params.length; index++) {
            var param = params[index];
            var key = ruleConfig[index];
            if (!isLocator(key)) {
                continue;
            }
            key = key.__locatorRef;
            var name_1 = field.names[key] || key;
            names[param.name] = name_1;
            names["_" + param.name + "_"] = field.crossTable[key];
        }
        return names;
    }
    function _getUserTargets(field, ruleSchema, ruleName, userMessage) {
        var userTargets = {};
        var rules = field.rules[ruleName];
        var params = ruleSchema.params || [];
        // early return if no rules
        if (!rules) {
            return {};
        }
        // check all rules to convert targets
        Object.keys(rules).forEach(function (key, index) {
            // get the rule
            var rule = rules[key];
            if (!isLocator(rule)) {
                return {};
            }
            // get associated parameter
            var param = params[index];
            if (!param) {
                return {};
            }
            // grab the name of the target
            var name = rule.__locatorRef;
            userTargets[param.name] = field.names[name] || name;
            userTargets["_" + param.name + "_"] = field.crossTable[name];
        });
        return {
            userTargets: userTargets,
            userMessage: userMessage
        };
    }
    function _normalizeMessage(template, field, values) {
        if (typeof template === 'function') {
            return template(field, values);
        }
        return interpolate(template, __assign(__assign({}, values), { _field_: field }));
    }
    function fillTargetValues(params, crossTable) {
        if (Array.isArray(params)) {
            return params.map(function (param) {
                var targetPart = typeof param === 'string' && param[0] === '@' ? param.slice(1) : param;
                if (targetPart in crossTable) {
                    return crossTable[targetPart];
                }
                return param;
            });
        }
        var values = {};
        var normalize = function (value) {
            if (isLocator(value)) {
                return value(crossTable);
            }
            return value;
        };
        Object.keys(params).forEach(function (param) {
            values[param] = normalize(params[param]);
        });
        return values;
    }

    var aggressive = function () { return ({
        on: ['input', 'blur']
    }); };
    var lazy = function () { return ({
        on: ['change', 'blur']
    }); };
    var eager = function (_a) {
        var errors = _a.errors;
        if (errors.length) {
            return {
                on: ['input', 'change']
            };
        }
        return {
            on: ['change', 'blur']
        };
    };
    var passive = function () { return ({
        on: []
    }); };
    var modes = {
        aggressive: aggressive,
        eager: eager,
        passive: passive,
        lazy: lazy
    };
    var setInteractionMode = function (mode, implementation) {
        setConfig({ mode: mode });
        if (!implementation) {
            return;
        }
        if (!isCallable(implementation)) {
            throw new Error('A mode implementation must be a function');
        }
        modes[mode] = implementation;
    };

    var EVENT_BUS = new Vue__default['default']();
    function localeChanged() {
        EVENT_BUS.$emit('change:locale');
    }

    var Dictionary = /** @class */ (function () {
        function Dictionary(locale, dictionary) {
            this.container = {};
            this.locale = locale;
            this.merge(dictionary);
        }
        Dictionary.prototype.resolve = function (field, rule, values) {
            return this.format(this.locale, field, rule, values);
        };
        Dictionary.prototype.format = function (locale, field, rule, values) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            var message;
            // find if specific message for that field was specified.
            message = ((_c = (_b = (_a = this.container[locale]) === null || _a === void 0 ? void 0 : _a.fields) === null || _b === void 0 ? void 0 : _b[field]) === null || _c === void 0 ? void 0 : _c[rule]) || ((_e = (_d = this.container[locale]) === null || _d === void 0 ? void 0 : _d.messages) === null || _e === void 0 ? void 0 : _e[rule]);
            if (!message) {
                message = '{_field_} is not valid';
            }
            field = (_h = (_g = (_f = this.container[locale]) === null || _f === void 0 ? void 0 : _f.names) === null || _g === void 0 ? void 0 : _g[field]) !== null && _h !== void 0 ? _h : field;
            return isCallable(message) ? message(field, values) : interpolate(message, __assign(__assign({}, values), { _field_: field }));
        };
        Dictionary.prototype.merge = function (dictionary) {
            merge(this.container, dictionary);
        };
        Dictionary.prototype.hasRule = function (name) {
            var _a, _b;
            return !!((_b = (_a = this.container[this.locale]) === null || _a === void 0 ? void 0 : _a.messages) === null || _b === void 0 ? void 0 : _b[name]);
        };
        return Dictionary;
    }());
    var DICTIONARY;
    function localize(locale, dictionary) {
        var _a;
        if (!DICTIONARY) {
            DICTIONARY = new Dictionary('en', {});
            setConfig({
                defaultMessage: function (field, values) {
                    return DICTIONARY.resolve(field, values === null || values === void 0 ? void 0 : values._rule_, values || {});
                }
            });
        }
        if (typeof locale === 'string') {
            DICTIONARY.locale = locale;
            if (dictionary) {
                DICTIONARY.merge((_a = {}, _a[locale] = dictionary, _a));
            }
            localeChanged();
            return;
        }
        DICTIONARY.merge(locale);
    }

    var isEvent = function (evt) {
        if (!evt) {
            return false;
        }
        if (typeof Event !== 'undefined' && isCallable(Event) && evt instanceof Event) {
            return true;
        }
        // this is for IE
        /* istanbul ignore next */
        if (evt && evt.srcElement) {
            return true;
        }
        return false;
    };
    function normalizeEventValue(value) {
        var _a, _b;
        if (!isEvent(value)) {
            return value;
        }
        var input = value.target;
        if (input.type === 'file' && input.files) {
            return toArray(input.files);
        }
        // If the input has a `v-model.number` modifier applied.
        if ((_a = input._vModifiers) === null || _a === void 0 ? void 0 : _a.number) {
            // as per the spec the v-model.number uses parseFloat
            var valueAsNumber = parseFloat(input.value);
            if (isNaN(valueAsNumber)) {
                return input.value;
            }
            return valueAsNumber;
        }
        if ((_b = input._vModifiers) === null || _b === void 0 ? void 0 : _b.trim) {
            var trimmedValue = typeof input.value === 'string' ? input.value.trim() : input.value;
            return trimmedValue;
        }
        return input.value;
    }

    var isTextInput = function (vnode) {
        var _a;
        var attrs = ((_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs) || vnode.elm;
        // it will fallback to being a text input per browsers spec.
        if (vnode.tag === 'input' && (!attrs || !attrs.type)) {
            return true;
        }
        if (vnode.tag === 'textarea') {
            return true;
        }
        return includes(['text', 'password', 'search', 'email', 'tel', 'url', 'number'], attrs === null || attrs === void 0 ? void 0 : attrs.type);
    };
    // export const isCheckboxOrRadioInput = (vnode: VNode): boolean => {
    //   const attrs = (vnode.data && vnode.data.attrs) || vnode.elm;
    //   return includes(['radio', 'checkbox'], attrs && attrs.type);
    // };
    // Gets the model object on the vnode.
    function findModel(vnode) {
        if (!vnode.data) {
            return undefined;
        }
        // Component Model
        // THIS IS NOT TYPED IN OFFICIAL VUE TYPINGS
        // eslint-disable-next-line
        var nonStandardVNodeData = vnode.data;
        if ('model' in nonStandardVNodeData) {
            return nonStandardVNodeData.model;
        }
        if (!vnode.data.directives) {
            return undefined;
        }
        return find(vnode.data.directives, function (d) { return d.name === 'model'; });
    }
    function findValue(vnode) {
        var _a, _b;
        var model = findModel(vnode);
        if (model) {
            return { value: model.value };
        }
        var config = findModelConfig(vnode);
        var prop = (config === null || config === void 0 ? void 0 : config.prop) || 'value';
        if (((_a = vnode.componentOptions) === null || _a === void 0 ? void 0 : _a.propsData) && prop in vnode.componentOptions.propsData) {
            var propsDataWithValue = vnode.componentOptions.propsData;
            return { value: propsDataWithValue[prop] };
        }
        if (((_b = vnode.data) === null || _b === void 0 ? void 0 : _b.domProps) && 'value' in vnode.data.domProps) {
            return { value: vnode.data.domProps.value };
        }
        return undefined;
    }
    function extractChildren(vnode) {
        if (Array.isArray(vnode)) {
            return vnode;
        }
        if (Array.isArray(vnode.children)) {
            return vnode.children;
        }
        /* istanbul ignore next */
        if (vnode.componentOptions && Array.isArray(vnode.componentOptions.children)) {
            return vnode.componentOptions.children;
        }
        return [];
    }
    function findInputNodes(vnode) {
        if (!Array.isArray(vnode) && findValue(vnode) !== undefined) {
            return [vnode];
        }
        var children = extractChildren(vnode);
        return children.reduce(function (nodes, node) {
            var candidates = findInputNodes(node);
            if (candidates.length) {
                nodes.push.apply(nodes, candidates);
            }
            return nodes;
        }, []);
    }
    // Resolves v-model config if exists.
    function findModelConfig(vnode) {
        /* istanbul ignore next */
        if (!vnode.componentOptions)
            return null;
        // This is also not typed in the standard Vue TS.
        return vnode.componentOptions.Ctor.options.model;
    }
    // Adds a listener to vnode listener object.
    function mergeVNodeListeners(obj, eventName, handler) {
        // no listener at all.
        if (isNullOrUndefined(obj[eventName])) {
            obj[eventName] = [handler];
            return;
        }
        // Is an invoker.
        if (isCallable(obj[eventName]) && obj[eventName].fns) {
            var invoker = obj[eventName];
            invoker.fns = Array.isArray(invoker.fns) ? invoker.fns : [invoker.fns];
            if (!includes(invoker.fns, handler)) {
                invoker.fns.push(handler);
            }
            return;
        }
        if (isCallable(obj[eventName])) {
            var prev = obj[eventName];
            obj[eventName] = [prev];
        }
        if (Array.isArray(obj[eventName]) && !includes(obj[eventName], handler)) {
            obj[eventName].push(handler);
        }
    }
    // Adds a listener to a native HTML vnode.
    function addNativeNodeListener(node, eventName, handler) {
        /* istanbul ignore next */
        if (!node.data) {
            node.data = {};
        }
        if (isNullOrUndefined(node.data.on)) {
            node.data.on = {};
        }
        mergeVNodeListeners(node.data.on, eventName, handler);
    }
    // Adds a listener to a Vue component vnode.
    function addComponentNodeListener(node, eventName, handler) {
        /* istanbul ignore next */
        if (!node.componentOptions) {
            return;
        }
        /* istanbul ignore next */
        if (!node.componentOptions.listeners) {
            node.componentOptions.listeners = {};
        }
        mergeVNodeListeners(node.componentOptions.listeners, eventName, handler);
    }
    function addVNodeListener(vnode, eventName, handler) {
        if (vnode.componentOptions) {
            addComponentNodeListener(vnode, eventName, handler);
            return;
        }
        addNativeNodeListener(vnode, eventName, handler);
    }
    // Determines if `change` should be used over `input` for listeners.
    function getInputEventName(vnode, model) {
        var _a;
        // Is a component.
        if (vnode.componentOptions) {
            var event_1 = (findModelConfig(vnode) || { event: 'input' }).event;
            return event_1;
        }
        // Lazy Models typically use change event
        if ((_a = model === null || model === void 0 ? void 0 : model.modifiers) === null || _a === void 0 ? void 0 : _a.lazy) {
            return 'change';
        }
        // is a textual-type input.
        if (isTextInput(vnode)) {
            return 'input';
        }
        return 'change';
    }
    function isHTMLNode(node) {
        return includes(['input', 'select', 'textarea'], node.tag);
    }
    // TODO: Type this one properly.
    function normalizeSlots(slots, ctx) {
        var acc = [];
        return Object.keys(slots).reduce(function (arr, key) {
            slots[key].forEach(function (vnode) {
                if (!vnode.context) {
                    slots[key].context = ctx;
                    if (!vnode.data) {
                        vnode.data = {};
                    }
                    vnode.data.slot = key;
                }
            });
            return arr.concat(slots[key]);
        }, acc);
    }
    function resolveTextualRules(vnode) {
        var _a;
        var attrs = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs;
        var rules = {};
        if (!attrs)
            return rules;
        if (attrs.type === 'email' && RuleContainer.getRuleDefinition('email')) {
            rules.email = ['multiple' in attrs];
        }
        if (attrs.pattern && RuleContainer.getRuleDefinition('regex')) {
            rules.regex = attrs.pattern;
        }
        if (attrs.maxlength >= 0 && RuleContainer.getRuleDefinition('max')) {
            rules.max = attrs.maxlength;
        }
        if (attrs.minlength >= 0 && RuleContainer.getRuleDefinition('min')) {
            rules.min = attrs.minlength;
        }
        if (attrs.type === 'number') {
            if (isSpecified(attrs.min) && RuleContainer.getRuleDefinition('min_value')) {
                rules.min_value = Number(attrs.min);
            }
            if (isSpecified(attrs.max) && RuleContainer.getRuleDefinition('max_value')) {
                rules.max_value = Number(attrs.max);
            }
        }
        return rules;
    }
    function resolveRules(vnode) {
        var _a;
        var htmlTags = ['input', 'select', 'textarea'];
        var attrs = (_a = vnode.data) === null || _a === void 0 ? void 0 : _a.attrs;
        if (!includes(htmlTags, vnode.tag) || !attrs) {
            return {};
        }
        var rules = {};
        if ('required' in attrs && attrs.required !== false && RuleContainer.getRuleDefinition('required')) {
            rules.required = attrs.type === 'checkbox' ? [true] : true;
        }
        if (isTextInput(vnode)) {
            return normalizeRules(__assign(__assign({}, rules), resolveTextualRules(vnode)));
        }
        return normalizeRules(rules);
    }
    function normalizeChildren(context, slotProps) {
        if (context.$scopedSlots.default) {
            return context.$scopedSlots.default(slotProps) || [];
        }
        return context.$slots.default || [];
    }

    /**
     * Determines if a provider needs to run validation.
     */
    function shouldValidate(ctx, value) {
        // when an immediate/initial validation is needed and wasn't done before.
        if (!ctx._ignoreImmediate && ctx.immediate) {
            return true;
        }
        // when the value changes for whatever reason.
        if (!isRefEqual(ctx.value, value) && ctx.normalizedEvents.length) {
            return true;
        }
        // when it needs validation due to props/cross-fields changes.
        if (ctx._needsValidation) {
            return true;
        }
        // when the initial value is undefined and the field wasn't rendered yet.
        if (!ctx.initialized && value === undefined) {
            return true;
        }
        return false;
    }
    function createValidationCtx(ctx) {
        return __assign(__assign({}, ctx.flags), { errors: ctx.errors, classes: ctx.classes, failedRules: ctx.failedRules, reset: function () { return ctx.reset(); }, validate: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return ctx.validate.apply(ctx, args);
            }, ariaInput: {
                'aria-invalid': ctx.flags.invalid ? 'true' : 'false',
                'aria-required': ctx.isRequired ? 'true' : 'false',
                'aria-errormessage': "vee_" + ctx.id
            }, ariaMsg: {
                id: "vee_" + ctx.id,
                'aria-live': ctx.errors.length ? 'assertive' : 'off'
            } });
    }
    function onRenderUpdate(vm, value) {
        if (!vm.initialized) {
            vm.initialValue = value;
        }
        var validateNow = shouldValidate(vm, value);
        vm._needsValidation = false;
        vm.value = value;
        vm._ignoreImmediate = true;
        if (!validateNow) {
            return;
        }
        var validate = function () {
            if (vm.immediate || vm.flags.validated) {
                return triggerThreadSafeValidation(vm);
            }
            vm.validateSilent();
        };
        if (vm.initialized) {
            validate();
            return;
        }
        vm.$once('hook:mounted', function () { return validate(); });
    }
    function computeModeSetting(ctx) {
        var compute = (isCallable(ctx.mode) ? ctx.mode : modes[ctx.mode]);
        return compute(ctx);
    }
    function triggerThreadSafeValidation(vm) {
        var pendingPromise = vm.validateSilent();
        // avoids race conditions between successive validations.
        vm._pendingValidation = pendingPromise;
        return pendingPromise.then(function (result) {
            if (pendingPromise === vm._pendingValidation) {
                vm.applyResult(result);
                vm._pendingValidation = undefined;
            }
            return result;
        });
    }
    // Creates the common handlers for a validatable context.
    function createCommonHandlers(vm) {
        if (!vm.$veeOnInput) {
            vm.$veeOnInput = function (e) {
                vm.syncValue(e); // track and keep the value updated.
                vm.setFlags({ dirty: true, pristine: false });
            };
        }
        var onInput = vm.$veeOnInput;
        if (!vm.$veeOnBlur) {
            vm.$veeOnBlur = function () {
                vm.setFlags({ touched: true, untouched: false });
            };
        }
        // Blur event listener.
        var onBlur = vm.$veeOnBlur;
        var onValidate = vm.$veeHandler;
        var mode = computeModeSetting(vm);
        // Handle debounce changes.
        if (!onValidate || vm.$veeDebounce !== vm.debounce) {
            onValidate = debounce(function () {
                vm.$nextTick(function () {
                    if (!vm._pendingReset) {
                        triggerThreadSafeValidation(vm);
                    }
                    vm._pendingReset = false;
                });
            }, mode.debounce || vm.debounce);
            // Cache the handler so we don't create it each time.
            vm.$veeHandler = onValidate;
            // cache the debounce value so we detect if it was changed.
            vm.$veeDebounce = vm.debounce;
        }
        return { onInput: onInput, onBlur: onBlur, onValidate: onValidate };
    }
    // Adds all plugin listeners to the vnode.
    function addListeners(vm, node) {
        var value = findValue(node);
        // cache the input eventName.
        vm._inputEventName = vm._inputEventName || getInputEventName(node, findModel(node));
        onRenderUpdate(vm, value === null || value === void 0 ? void 0 : value.value);
        var _a = createCommonHandlers(vm), onInput = _a.onInput, onBlur = _a.onBlur, onValidate = _a.onValidate;
        addVNodeListener(node, vm._inputEventName, onInput);
        addVNodeListener(node, 'blur', onBlur);
        // add the validation listeners.
        vm.normalizedEvents.forEach(function (evt) {
            addVNodeListener(node, evt, onValidate);
        });
        vm.initialized = true;
    }

    var PROVIDER_COUNTER = 0;
    function data() {
        var errors = [];
        var fieldName = '';
        var defaultValues = {
            errors: errors,
            value: undefined,
            initialized: false,
            initialValue: undefined,
            flags: createFlags(),
            failedRules: {},
            isActive: true,
            fieldName: fieldName,
            id: ''
        };
        return defaultValues;
    }
    var ValidationProvider = Vue__default['default'].extend({
        inject: {
            $_veeObserver: {
                from: '$_veeObserver',
                default: function () {
                    if (!this.$vnode.context.$_veeObserver) {
                        this.$vnode.context.$_veeObserver = createObserver();
                    }
                    return this.$vnode.context.$_veeObserver;
                }
            }
        },
        props: {
            vid: {
                type: String,
                default: ''
            },
            name: {
                type: String,
                default: null
            },
            mode: {
                type: [String, Function],
                default: function () {
                    return getConfig().mode;
                }
            },
            rules: {
                type: [Object, String],
                default: null
            },
            immediate: {
                type: Boolean,
                default: false
            },
            bails: {
                type: Boolean,
                default: function () { return getConfig().bails; }
            },
            skipIfEmpty: {
                type: Boolean,
                default: function () { return getConfig().skipOptional; }
            },
            debounce: {
                type: Number,
                default: 0
            },
            tag: {
                type: String,
                default: 'span'
            },
            slim: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            },
            customMessages: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        watch: {
            rules: {
                deep: true,
                handler: function (val, oldVal) {
                    this._needsValidation = !isEqual(val, oldVal);
                }
            }
        },
        data: data,
        computed: {
            fieldDeps: function () {
                var _this = this;
                return Object.keys(this.normalizedRules).reduce(function (acc, rule) {
                    var deps = extractLocators(_this.normalizedRules[rule]).map(function (dep) {
                        return isLocator(dep) ? dep.__locatorRef : dep.slice(1);
                    });
                    acc.push.apply(acc, deps);
                    deps.forEach(function (depName) {
                        watchCrossFieldDep(_this, depName);
                    });
                    return acc;
                }, []);
            },
            normalizedEvents: function () {
                var _this = this;
                var on = computeModeSetting(this).on;
                return (on || []).map(function (e) {
                    if (e === 'input') {
                        return _this._inputEventName;
                    }
                    return e;
                });
            },
            isRequired: function () {
                var rules = __assign(__assign({}, this._resolvedRules), this.normalizedRules);
                var isRequired = Object.keys(rules).some(RuleContainer.isRequireRule);
                this.flags.required = !!isRequired;
                return isRequired;
            },
            classes: function () {
                var names = getConfig().classes;
                return computeClassObj(names, this.flags);
            },
            normalizedRules: function () {
                return normalizeRules(this.rules);
            }
        },
        mounted: function () {
            var _this = this;
            var onLocaleChanged = function () {
                if (!_this.flags.validated) {
                    return;
                }
                var regenerateMap = _this._regenerateMap;
                if (regenerateMap) {
                    var errors_1 = [];
                    var failedRules_1 = {};
                    Object.keys(regenerateMap).forEach(function (rule) {
                        var msg = regenerateMap[rule]();
                        errors_1.push(msg);
                        failedRules_1[rule] = msg;
                    });
                    _this.applyResult({ errors: errors_1, failedRules: failedRules_1, regenerateMap: regenerateMap });
                    return;
                }
                _this.validate();
            };
            EVENT_BUS.$on('change:locale', onLocaleChanged);
            this.$on('hook:beforeDestroy', function () {
                EVENT_BUS.$off('change:locale', onLocaleChanged);
            });
        },
        render: function (h) {
            var _this = this;
            this.registerField();
            var ctx = createValidationCtx(this);
            var children = normalizeChildren(this, ctx);
            var inputs = findInputNodes(children);
            if (!inputs.length) {
                // Silent exit if no input was found.
                return this.slim && children.length <= 1 ? children[0] : h(this.tag, children);
            }
            inputs.forEach(function (input, idx) {
                var _a, _b, _c, _d, _e, _f;
                // If the elements are not checkboxes and there are more input nodes
                if (!includes(['checkbox', 'radio'], (_b = (_a = input.data) === null || _a === void 0 ? void 0 : _a.attrs) === null || _b === void 0 ? void 0 : _b.type) && idx > 0) {
                    return;
                }
                var resolved = getConfig().useConstraintAttrs ? resolveRules(input) : {};
                if (!isEqual(_this._resolvedRules, resolved)) {
                    _this._needsValidation = true;
                }
                if (isHTMLNode(input)) {
                    _this.fieldName = ((_d = (_c = input.data) === null || _c === void 0 ? void 0 : _c.attrs) === null || _d === void 0 ? void 0 : _d.name) || ((_f = (_e = input.data) === null || _e === void 0 ? void 0 : _e.attrs) === null || _f === void 0 ? void 0 : _f.id);
                }
                _this._resolvedRules = resolved;
                addListeners(_this, input);
            });
            return this.slim && children.length <= 1 ? children[0] : h(this.tag, children);
        },
        beforeDestroy: function () {
            // cleanup reference.
            this.$_veeObserver.unobserve(this.id);
        },
        activated: function () {
            this.isActive = true;
        },
        deactivated: function () {
            this.isActive = false;
        },
        methods: {
            setFlags: function (flags) {
                var _this = this;
                Object.keys(flags).forEach(function (flag) {
                    _this.flags[flag] = flags[flag];
                });
            },
            syncValue: function (v) {
                var value = normalizeEventValue(v);
                this.value = value;
                this.flags.changed = this.initialValue !== value;
            },
            reset: function () {
                var _this = this;
                this.errors = [];
                this.initialValue = this.value;
                var flags = createFlags();
                flags.required = this.isRequired;
                this.setFlags(flags);
                this.failedRules = {};
                this.validateSilent();
                this._pendingValidation = undefined;
                this._pendingReset = true;
                setTimeout(function () {
                    _this._pendingReset = false;
                }, this.debounce);
            },
            validate: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        if (args.length > 0) {
                            this.syncValue(args[0]);
                        }
                        return [2 /*return*/, triggerThreadSafeValidation(this)];
                    });
                });
            },
            validateSilent: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var rules, result;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.setFlags({ pending: true });
                                rules = __assign(__assign({}, this._resolvedRules), this.normalizedRules);
                                Object.defineProperty(rules, '_$$isNormalized', {
                                    value: true,
                                    writable: false,
                                    enumerable: false,
                                    configurable: false
                                });
                                return [4 /*yield*/, validate(this.value, rules, __assign(__assign({ name: this.name || this.fieldName }, createLookup(this)), { bails: this.bails, skipIfEmpty: this.skipIfEmpty, isInitial: !this.initialized, customMessages: this.customMessages }))];
                            case 1:
                                result = _a.sent();
                                this.setFlags({
                                    pending: false,
                                    valid: result.valid,
                                    invalid: !result.valid
                                });
                                return [2 /*return*/, result];
                        }
                    });
                });
            },
            setErrors: function (errors) {
                this.applyResult({ errors: errors, failedRules: {} });
            },
            applyResult: function (_a) {
                var errors = _a.errors, failedRules = _a.failedRules, regenerateMap = _a.regenerateMap;
                this.errors = errors;
                this._regenerateMap = regenerateMap;
                this.failedRules = __assign({}, (failedRules || {}));
                this.setFlags({
                    valid: !errors.length,
                    passed: !errors.length,
                    invalid: !!errors.length,
                    failed: !!errors.length,
                    validated: true,
                    changed: this.value !== this.initialValue
                });
            },
            registerField: function () {
                updateRenderingContextRefs(this);
            }
        }
    });
    function computeClassObj(names, flags) {
        var acc = {};
        var keys = Object.keys(flags);
        var length = keys.length;
        var _loop_1 = function (i) {
            var flag = keys[i];
            var className = (names && names[flag]) || flag;
            var value = flags[flag];
            if (isNullOrUndefined(value)) {
                return "continue";
            }
            if ((flag === 'valid' || flag === 'invalid') && !flags.validated) {
                return "continue";
            }
            if (typeof className === 'string') {
                acc[className] = value;
            }
            else if (Array.isArray(className)) {
                className.forEach(function (cls) {
                    acc[cls] = value;
                });
            }
        };
        for (var i = 0; i < length; i++) {
            _loop_1(i);
        }
        return acc;
    }
    function createLookup(vm) {
        var providers = vm.$_veeObserver.refs;
        var reduced = {
            names: {},
            values: {}
        };
        return vm.fieldDeps.reduce(function (acc, depName) {
            if (!providers[depName]) {
                return acc;
            }
            acc.values[depName] = providers[depName].value;
            acc.names[depName] = providers[depName].name;
            return acc;
        }, reduced);
    }
    function extractId(vm) {
        if (vm.vid) {
            return vm.vid;
        }
        if (vm.name) {
            return vm.name;
        }
        if (vm.id) {
            return vm.id;
        }
        if (vm.fieldName) {
            return vm.fieldName;
        }
        PROVIDER_COUNTER++;
        return "_vee_" + PROVIDER_COUNTER;
    }
    function updateRenderingContextRefs(vm) {
        var providedId = extractId(vm);
        var id = vm.id;
        // Nothing has changed.
        if (!vm.isActive || (id === providedId && vm.$_veeObserver.refs[id])) {
            return;
        }
        // vid was changed.
        if (id !== providedId && vm.$_veeObserver.refs[id] === vm) {
            vm.$_veeObserver.unobserve(id);
        }
        vm.id = providedId;
        vm.$_veeObserver.observe(vm);
    }
    function createObserver() {
        return {
            refs: {},
            observe: function (vm) {
                this.refs[vm.id] = vm;
            },
            unobserve: function (id) {
                delete this.refs[id];
            }
        };
    }
    function watchCrossFieldDep(ctx, depName, withHooks) {
        if (withHooks === void 0) { withHooks = true; }
        var providers = ctx.$_veeObserver.refs;
        if (!ctx._veeWatchers) {
            ctx._veeWatchers = {};
        }
        if (!providers[depName] && withHooks) {
            return ctx.$once('hook:mounted', function () {
                watchCrossFieldDep(ctx, depName, false);
            });
        }
        if (!isCallable(ctx._veeWatchers[depName]) && providers[depName]) {
            ctx._veeWatchers[depName] = providers[depName].$watch('value', function () {
                if (ctx.flags.validated) {
                    ctx._needsValidation = true;
                    ctx.validate();
                }
            });
        }
    }

    var FLAGS_STRATEGIES = [
        ['pristine', 'every'],
        ['dirty', 'some'],
        ['touched', 'some'],
        ['untouched', 'every'],
        ['valid', 'every'],
        ['invalid', 'some'],
        ['pending', 'some'],
        ['validated', 'every'],
        ['changed', 'some'],
        ['passed', 'every'],
        ['failed', 'some']
    ];
    var OBSERVER_COUNTER = 0;
    function data$1() {
        var refs = {};
        var errors = {};
        var flags = createObserverFlags();
        var fields = {};
        // FIXME: Not sure of this one can be typed, circular type reference.
        var observers = [];
        return {
            id: '',
            refs: refs,
            observers: observers,
            errors: errors,
            flags: flags,
            fields: fields
        };
    }
    function provideSelf() {
        return {
            $_veeObserver: this
        };
    }
    var ValidationObserver = Vue__default['default'].extend({
        name: 'ValidationObserver',
        provide: provideSelf,
        inject: {
            $_veeObserver: {
                from: '$_veeObserver',
                default: function () {
                    if (!this.$vnode.context.$_veeObserver) {
                        return null;
                    }
                    return this.$vnode.context.$_veeObserver;
                }
            }
        },
        props: {
            tag: {
                type: String,
                default: 'span'
            },
            vid: {
                type: String,
                default: function () {
                    return "obs_" + OBSERVER_COUNTER++;
                }
            },
            slim: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data: data$1,
        created: function () {
            var _this = this;
            this.id = this.vid;
            register(this);
            var onChange = debounce(function (_a) {
                var errors = _a.errors, flags = _a.flags, fields = _a.fields;
                _this.errors = errors;
                _this.flags = flags;
                _this.fields = fields;
            }, 16);
            this.$watch(computeObserverState, onChange);
        },
        activated: function () {
            register(this);
        },
        deactivated: function () {
            unregister(this);
        },
        beforeDestroy: function () {
            unregister(this);
        },
        render: function (h) {
            var children = normalizeChildren(this, prepareSlotProps(this));
            return this.slim && children.length <= 1 ? children[0] : h(this.tag, { on: this.$listeners }, children);
        },
        methods: {
            observe: function (subscriber, kind) {
                var _a;
                if (kind === void 0) { kind = 'provider'; }
                if (kind === 'observer') {
                    this.observers.push(subscriber);
                    return;
                }
                this.refs = __assign(__assign({}, this.refs), (_a = {}, _a[subscriber.id] = subscriber, _a));
            },
            unobserve: function (id, kind) {
                if (kind === void 0) { kind = 'provider'; }
                if (kind === 'provider') {
                    var provider = this.refs[id];
                    if (!provider) {
                        return;
                    }
                    this.$delete(this.refs, id);
                    return;
                }
                var idx = findIndex(this.observers, function (o) { return o.id === id; });
                if (idx !== -1) {
                    this.observers.splice(idx, 1);
                }
            },
            validateWithInfo: function (_a) {
                var _b = (_a === void 0 ? {} : _a).silent, silent = _b === void 0 ? false : _b;
                return __awaiter(this, void 0, void 0, function () {
                    var results, isValid, _c, errors, flags, fields;
                    return __generator(this, function (_d) {
                        switch (_d.label) {
                            case 0: return [4 /*yield*/, Promise.all(__spreadArrays(values(this.refs)
                                    .filter(function (r) { return !r.disabled; })
                                    .map(function (ref) { return ref[silent ? 'validateSilent' : 'validate']().then(function (r) { return r.valid; }); }), this.observers.filter(function (o) { return !o.disabled; }).map(function (obs) { return obs.validate({ silent: silent }); })))];
                            case 1:
                                results = _d.sent();
                                isValid = results.every(function (r) { return r; });
                                _c = computeObserverState.call(this), errors = _c.errors, flags = _c.flags, fields = _c.fields;
                                this.errors = errors;
                                this.flags = flags;
                                this.fields = fields;
                                return [2 /*return*/, {
                                        errors: errors,
                                        flags: flags,
                                        fields: fields,
                                        isValid: isValid
                                    }];
                        }
                    });
                });
            },
            validate: function (_a) {
                var _b = (_a === void 0 ? {} : _a).silent, silent = _b === void 0 ? false : _b;
                return __awaiter(this, void 0, void 0, function () {
                    var isValid;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, this.validateWithInfo({ silent: silent })];
                            case 1:
                                isValid = (_c.sent()).isValid;
                                return [2 /*return*/, isValid];
                        }
                    });
                });
            },
            handleSubmit: function (cb) {
                return __awaiter(this, void 0, void 0, function () {
                    var isValid;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, this.validate()];
                            case 1:
                                isValid = _a.sent();
                                if (!isValid || !cb) {
                                    return [2 /*return*/];
                                }
                                return [2 /*return*/, cb()];
                        }
                    });
                });
            },
            reset: function () {
                return __spreadArrays(values(this.refs), this.observers).forEach(function (ref) { return ref.reset(); });
            },
            setErrors: function (errors) {
                var _this = this;
                Object.keys(errors).forEach(function (key) {
                    var provider = _this.refs[key];
                    if (!provider)
                        return;
                    var errorArr = errors[key] || [];
                    errorArr = typeof errorArr === 'string' ? [errorArr] : errorArr;
                    provider.setErrors(errorArr);
                });
                this.observers.forEach(function (observer) {
                    observer.setErrors(errors);
                });
            }
        }
    });
    function unregister(vm) {
        if (vm.$_veeObserver) {
            vm.$_veeObserver.unobserve(vm.id, 'observer');
        }
    }
    function register(vm) {
        if (vm.$_veeObserver) {
            vm.$_veeObserver.observe(vm, 'observer');
        }
    }
    function prepareSlotProps(vm) {
        return __assign(__assign({}, vm.flags), { errors: vm.errors, fields: vm.fields, validate: vm.validate, passes: vm.handleSubmit, handleSubmit: vm.handleSubmit, reset: vm.reset });
    }
    // Creates a modified version of validation flags
    function createObserverFlags() {
        return __assign(__assign({}, createFlags()), { valid: true, invalid: false });
    }
    function computeObserverState() {
        var vms = __spreadArrays(values(this.refs), this.observers);
        var errors = {};
        var flags = createObserverFlags();
        var fields = {};
        var length = vms.length;
        for (var i = 0; i < length; i++) {
            var vm = vms[i];
            // validation provider
            if (Array.isArray(vm.errors)) {
                errors[vm.id] = vm.errors;
                fields[vm.id] = __assign({ id: vm.id, name: vm.name, failedRules: vm.failedRules }, vm.flags);
                continue;
            }
            // Nested observer, merge errors and fields
            errors = __assign(__assign({}, errors), vm.errors);
            fields = __assign(__assign({}, fields), vm.fields);
        }
        FLAGS_STRATEGIES.forEach(function (_a) {
            var flag = _a[0], method = _a[1];
            flags[flag] = vms[method](function (vm) { return vm.flags[flag]; });
        });
        return { errors: errors, flags: flags, fields: fields };
    }

    function withValidation(component, mapProps) {
        var _a;
        if (mapProps === void 0) { mapProps = identity; }
        var options = 'options' in component ? component.options : component;
        var providerOpts = ValidationProvider.options;
        var hoc = {
            name: (options.name || 'AnonymousHoc') + "WithValidation",
            props: __assign({}, providerOpts.props),
            data: providerOpts.data,
            computed: __assign({}, providerOpts.computed),
            methods: __assign({}, providerOpts.methods),
            beforeDestroy: providerOpts.beforeDestroy,
            inject: providerOpts.inject
        };
        var eventName = ((_a = options === null || options === void 0 ? void 0 : options.model) === null || _a === void 0 ? void 0 : _a.event) || 'input';
        hoc.render = function (h) {
            var _a;
            this.registerField();
            var vctx = createValidationCtx(this);
            var listeners = __assign({}, this.$listeners);
            var model = findModel(this.$vnode);
            this._inputEventName = this._inputEventName || getInputEventName(this.$vnode, model);
            var value = findValue(this.$vnode);
            onRenderUpdate(this, value === null || value === void 0 ? void 0 : value.value);
            var _b = createCommonHandlers(this), onInput = _b.onInput, onBlur = _b.onBlur, onValidate = _b.onValidate;
            mergeVNodeListeners(listeners, eventName, onInput);
            mergeVNodeListeners(listeners, 'blur', onBlur);
            this.normalizedEvents.forEach(function (evt) {
                mergeVNodeListeners(listeners, evt, onValidate);
            });
            // Props are any attrs not associated with ValidationProvider Plus the model prop.
            // WARNING: Accidental prop overwrite will probably happen.
            var prop = (findModelConfig(this.$vnode) || { prop: 'value' }).prop;
            var props = __assign(__assign(__assign({}, this.$attrs), (_a = {}, _a[prop] = model === null || model === void 0 ? void 0 : model.value, _a)), mapProps(vctx));
            return h(options, {
                attrs: this.$attrs,
                props: props,
                on: listeners,
                scopedSlots: this.$scopedSlots
            }, normalizeSlots(this.$slots, this.$vnode.context));
        };
        return hoc;
    }

    var version = '3.4.0';

    exports.ValidationObserver = ValidationObserver;
    exports.ValidationProvider = ValidationProvider;
    exports.configure = configure;
    exports.extend = extend;
    exports.localeChanged = localeChanged;
    exports.localize = localize;
    exports.normalizeRules = normalizeRules;
    exports.setInteractionMode = setInteractionMode;
    exports.validate = validate;
    exports.version = version;
    exports.withValidation = withValidation;

    Object.defineProperty(exports, '__esModule', { value: true });

})));

},{"vue":"vue"}]},{},[46]);
